/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

const typename = Symbol("typename");
export type Nominal<T, N extends string> = T & {readonly [typename]: N};
export function nominate<T, const N extends string>(_name: N, arg: T): Nominal<T, N> {
  return arg as Nominal<T, N>;
}
export type Date = Nominal<string, "date">;
export type DateTime = Nominal<string, "datetime">;
export type Tz = Nominal<string, "tz">;
export type ConfluenceDocumentSourceLabels = {
  [category in DocumentCategory]?: ConfluenceLabel;
};
export type IObject = {readonly [key: string]: IValue};
export type IValue = null | boolean | number | string | readonly IValue[] | IObject;
export type GraphOperationEntityRef = string | number;
export type ApiDate = Nominal<string, "date">;
export type ApiDateTime = Nominal<string, "datetime">;
export type WhoAmI = WhoAmIResponse;
export type WhoAmIOnAccount = WhoAmIOnAccountResponse;
export type Uuid = string;
export type WatcherPreferences = {
  [key in WatcherTrigger]?: boolean;
};
export type Never = never;
export type AiModelType = "Fast" | "Thinking";
export type AiDefaultModels = {default_fast: AiModel; default_thinking: AiModel};
export type AiModelConfig = {
  features: {
    [key in AiFeature]?: AiModel;
  };
  default_models: AiDefaultModels;
};
export type Paginated<T> = {
  items: T[];
  limit: number;
  offset: number;
  total: number;
  facets?: {[key: string]: FacetCount[]};
};
export type Reviewable = {
  overall_status: ReviewStatus;
  reviewable_id: ReviewableId;
  reviews: {
    [key in OwnerId]: ReviewAction;
  };
};
export type ReviewableMin = {
  overall_status: ReviewStatus;
  reviewable_id: ReviewableId;
  reviews: {
    [key in OwnerId]: ReviewActionMin;
  };
};
export const GLOBAL_SCOPE_ID = "global";
export class UnauthorizedError extends Error {
  data: ErrorResponse;
  constructor(data: ErrorResponse) {
    super("UnauthorizedError");
    this.data = data;
  }
}
// More specific assessment node types
export interface TypedAssessmentNode<
  T extends AssessmentDecisionNodeType = AssessmentDecisionNodeType,
> extends AssessmentNode {
  node: AssessmentDecisionNode & {type: T};
  latest_decision?: TypedAssessmentDecision<T>;
  suggested_change?: TypedAssessmentDecision<T>;
}
export type TypedAssessmentDecision<T extends AssessmentDecisionNodeType = AssessmentDecisionNodeType> =
  AssessmentDecision & {type: T};
export type Risk = {
  accepted: TypedAssessmentNode<"RiskAcceptance">;
  activity_stream: ActivityStream;
  assessment: AssessmentMin;
  audit_plan_page_id?: AuditPlanPageId | null;
  identified: TypedAssessmentNode<"IdentifiedRisk">;
  inherent_risk: TypedAssessmentNode<"InherentRisk">;
  owner?: Owner | null;
  relevant_controls: TypedAssessmentNode<"RiskRelevantControls">;
  residual_risk: TypedAssessmentNode<"ResidualRisk">;
  reviewable?: Reviewable | null;
  risk_id: RiskId;
  risk_number: string;
  /** Format: int32 */
  risk_ordinal?: number | null;
};
export type AssessedControl = {
  activity_stream: ActivityStream;
  assess?: TypedAssessmentNode<"ControlAssessment"> | null;
  assessment_control_id: AssessmentControlId;
  audit_plan_page_id?: AuditPlanPageId | null;
  assessment_id: AssessmentId;
  process_step_ids: ProcessStepId[];
  identification: TypedAssessmentNode<"ControlIdentification">;
  representation?: TypedAssessmentNode<"ControlRepresentation"> | null;
  design_evaluation?: TypedAssessmentNode<"ControlDesignEvaluation"> | null;
  implementation_evaluation?: TypedAssessmentNode<"ControlImplementationEvaluation"> | null;
  relevant_risks: TypedAssessmentNode<"RiskRelevantControls">[];
  reviewable?: Reviewable | null;
  scope_representations: TypedAssessmentNode<"ControlScopeRepresentation">[];
  scope_design_evaluations: TypedAssessmentNode<"ControlScopeDesignEvaluation">[];
  scope_designs: TypedAssessmentNode<"ControlScopeDesign">[];
  scope_implementation_evaluations: TypedAssessmentNode<"ControlScopeImplementationEvaluation">[];
  scope_implementations: TypedAssessmentNode<"ControlScopeImplementation">[];
  scope_selection: TypedAssessmentNode<"ControlScopeSelection">;
  scopes: TypedAssessmentNode<"ControlScopeAssessment">[];
};
export type Finding = {
  finding_id: FindingId;
  audit_plan_page_id?: AuditPlanPageId | null;
  assessment_control_id?: AssessmentControlId | null;
  assessment: AssessmentMin;
  activity_stream: ActivityStream;
  finding: TypedAssessmentNode<"Finding">;
  control_findings?: TypedAssessmentNode<"ControlFindings">;
  include_internal: boolean;
  include_client_facing: boolean;
};
// The frontend knows about the existence of some properties on entities.
export type Relationship = GraphPropertyValueRelationship;
export type GetGraphQuery = {
  filter_entity_ids?: EntityId[] | null;
  filter_properties?: string[] | null;
  recursion_depth?: number | null;
  selected_properties?: string[] | null;
};
export const KNOWN_ENTITY_PROPERTIES = {
  name: "String",
  country_of_registration: "String",
  companies_house_number: "String",
  duns_number: "String",
  vat_number: "String",
  ico_registration: "String",
  registered_address: "String",
  website_url: "String",
  job_title: "String",
  legal_entity_type: "String",
  trust_center_url: "String",
  description: "String",
  shared_data: "String",
  iso_country_code: "String",
  incorporation_date: "String",
  industry_type: "String",
  growth_plan: "String",
  official_legal_entity_type: "String",
  number_of_employees: "Integer",
  is_root_legal_entity: "Boolean",
  gdpr_sccs: "Boolean",
  gdpr_based_in_europe: "Boolean",
  gdpr_equivalence: "Boolean",
  photo: "Asset",
  beneficial_owner: "Relationship",
  senior_leadership: "Relationship",
  board_member: "Relationship",
  subprocessor: "Relationship",
} as const satisfies {[k: string]: GraphComponentType};
type KnownPropertyMap = {String: string; Integer: number; Boolean: boolean; Asset: AssetId; Relationship: Relationship};
export type KnownEntityPropertyOfType<V extends GraphComponentType> = {
  [K in keyof typeof KNOWN_ENTITY_PROPERTIES]: (typeof KNOWN_ENTITY_PROPERTIES)[K] extends V ? K : never;
}[keyof typeof KNOWN_ENTITY_PROPERTIES];
export type KnownEntityProperty = keyof typeof KNOWN_ENTITY_PROPERTIES;
export type KnownEntityProperties = {
  [K in KnownEntityProperty]: KnownPropertyMap[(typeof KNOWN_ENTITY_PROPERTIES)[K]];
};
export type GraphEntity = {
  id: EntityId;
  link_ids: EntityId[];
  properties: {[key: string]: unknown} & Partial<KnownEntityProperties>;
};
type KnownEntityPropertiesByType = {
  [K in GraphComponentType]: KnownEntityPropertyOfType<K>[];
};
function groupEntityPropertiesByType(): KnownEntityPropertiesByType {
  const res: Partial<KnownEntityPropertiesByType> = {};
  for (const [k, v] of Object.entries(KNOWN_ENTITY_PROPERTIES)) {
    if (!Object.hasOwn(res, v)) {
      res[v] = [];
    }
    res[v]!.push(k as never);
  }
  return res as KnownEntityPropertiesByType;
}
export const KNOWN_ENTITY_PROPERTIES_BY_TYPE = groupEntityPropertiesByType();
export interface paths {
  "/health": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/favicon": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get favicon
     * @description Get favicon redirect for the domain
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/static/favicon": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get favicon (static)
     * @description Get favicon redirect for the domain (static path)
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/pre_login": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Pre-login check
     * @description Check user registration status before login
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PreLoginResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods/{login_method_id}/login": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Login with method
     * @description Login using a specific authentication method
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["LoginRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["LoginResponse"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods/{login_method_id}/update": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update login method
     * @description Update an existing login method
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateLoginMethodRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UpdateLoginMethodResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods/{login_method_id}/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset login method
     * @description Reset a login method using a one-time token
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AddLoginMethod"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ResetLoginMethodResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/validate_password_complexity": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Validate password complexity
     * @description Check a password against the complexity requirements without setting it, using a one-time token
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/method": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get selected login method
     * @description Get the currently selected login method for the user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LoginMethodMin"] | null};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Set login method
     * @description Set the active login method for the user
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["LoginMethodId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List login methods
     * @description List all available login methods for the user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UserLoginMethod"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods/{login_method_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete login method
     * @description Delete a login method
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/methods/{login_method_id}/redirect": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Get login redirect URL
     * @description Get redirect URL for external authentication
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["LoginRedirectRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/accounts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List user accounts
     * @description List all accounts accessible to the user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AccountWithRestriction"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set user name
     * @description Update the user's display name
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/language": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set user language
     * @description Update the user's language preference
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/invite": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Validate invite token
     * @description Validate an invite token
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["InviteInfo"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Validate reset login token
     * @description Validate a password reset token
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ResetLoginInfo"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/request_reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Request password reset
     * @description Request a password reset link
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["RequestLoginReset"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/2fa/totp": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Generate 2FA TOTP
     * @description Generate a new TOTP secret for 2FA setup
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["GenerateTotpResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/2fa/totp_ott": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Generate 2FA TOTP from OTT
     * @description Generate a new TOTP secret for 2FA setup during the user invite flow.
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["GenerateTotpResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/2fa": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update 2FA settings
     * @description Enable or disable two-factor authentication
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateTwoFa"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/login/internal_mode": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update internal mode
     * @description Toggle internal mode for Platformed employees
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/register": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Register user
     * @description Register a new user account
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["RequestRegistration"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/logout": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Logout
     * @description Log out the current user
     */
    post: {
      parameters: {
        query?: {
          /**
           * @description End every session the user holds on every device, and the access
           *     tokens issued from them.
           */
          all_devices?: boolean;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/refresh_session": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Refresh session
     * @description Report user activity, extending the session's idle deadline once it is near
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/whoami": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get current user
     * @description Get information about the currently authenticated user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Contains information about the user. Does not contain account-specific information. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["WhoAmIResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/session": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Log session
     * @description Log user session activity
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SessionLog"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/consent": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * OAuth consent
     * @description Handle OAuth consent for external redirects
     */
    get: {
      parameters: {query: {external_redirect: string}; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ConsentResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/reminder_schedule": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get reminder schedule
     * @description Get user reminder schedule settings
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ReminderSchedule"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Update reminder schedule
     * @description Update user reminder schedule settings
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ReminderSchedule"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/portal_discovery/regions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List portal regions for the user
     * @description Get a list of regions where the user has portal access
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Region"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/notification_preferences": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get notification preferences
     * @description Get user notification preferences
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationPreferencesConfig"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/notification_preferences/update": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update notification preferences
     * @description Update user notification preferences
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateNotificationPreference"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/notification_preferences/bulk-update": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk update notification preferences
     * @description Update multiple notification preferences in a single request
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["BulkUpdateNotificationPreferences"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/accounts/{account_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get account by ID
     * @description Get account information by account ID
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccountMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/accounts_by_slug/{account_slug}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get account by slug
     * @description Get account information by account slug
     */
    get: {
      parameters: {query?: never; header?: never; path: {account_slug: string}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccountMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/media_assets/company_logo/{key}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get company logo
     * @description Get company logo image
     */
    get: {
      parameters: {query?: never; header?: never; path: {key: string}; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/media_assets/company_logo/{key}/2x": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get company logo (2x)
     * @description Get high-resolution company logo image
     */
    get: {
      parameters: {query?: never; header?: never; path: {key: string}; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/support_emails/register_interest": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Register interest
     * @description Register interest in Platformed
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["RegisterInterestRecord"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/support_emails/contact_us": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Contact us
     * @description Send a message to the support team
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["ContactUsRecord"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/support_emails/newsletter_subscribe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Subscribe to newsletter
     * @description Subscribe to the Platformed newsletter
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["SubscribeRecord"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/external_api/mail_subscription/unsubscribe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unsubscribe from emails
     * @description Unsubscribe from mailing list
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["UnsubscribeRequest"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/pusher/user-auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Pusher user authentication
     * @description Authenticate a user for Pusher real-time messaging
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["UserAuthBody"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/pusher/auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Pusher channel authentication
     * @description Authenticate access to a private Pusher channel
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["ChannelAuthBody"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/redirect/{provider}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * OAuth callback
     * @description Handle OAuth provider callbacks
     */
    get: {
      parameters: {query: {code: string; state: string}; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/saml/metadata": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * SAML metadata
     * @description Get SAML service provider metadata
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/saml/acs": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * SAML ACS redirect
     * @description Handle GET requests to the ACS endpoint
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * SAML assertion consumer service
     * @description Handle SAML authentication responses
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["AcsPayload"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create a new account
     * @description Creates a new account with an optional preset configuration. This operation may take up to 2 minutes.
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["CreateAccount"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["NewAccount"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete an account
     * @description Schedules an account for deletion. This action is irreversible.
     */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Rename an account
     * @description Updates the name of an existing account
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}/users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create user on account
     * @description Creates a new user and adds them as an admin to the specified account
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateRegisteredUser"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RegisteredUser"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}/analyze": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Analyze account
     * @description Schedules analysis for all documents, questionnaires, and entities in the account
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}/cluster": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Cluster account facts
     * @description Schedules fact clustering for the specified account
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/accounts/{account_id}/detect_conflicts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Detect conflicts
     * @description Schedules conflict detection for the specified account
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/analyze_all_accounts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Analyze all accounts
     * @description Schedules analysis for all accounts in the system
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/migrate_services": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Migrate services
     * @description Schedules service migration for the system
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/presets": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List available presets
     * @description Returns a list of available account presets
     */
    get: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PresetOption"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/account_name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update account name
     * @description Update the display name for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/language_code": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update language code
     * @description Update the language code for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/plan_features/{feature}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update plan features
     * @description Update plan features for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {feature: components["schemas"]["AccountFeature"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/enabled_features/{feature}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update enabled features
     * @description Update enabled features for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {feature: components["schemas"]["AccountFeature"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/prompt_modifiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update prompt modifiers
     * @description Update AI prompt modifiers for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PromptModifiers"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/ai_model_config": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update AI model config
     * @description Update AI model configuration for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AiModelConfig"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/config/default_qa_mode": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update default QA mode
     * @description Update the default QA mode for the account (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QAMode"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/custom_prompt_categories": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List custom prompt categories
     * @description Get all AI prompt categories with labels
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PromptCategoryInfo"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/custom_prompts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List custom prompts
     * @description Get all AI prompts with any custom overrides
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AiPromptInfo"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Reset all custom prompts
     * @description Reset all AI prompts to their default templates
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/custom_prompts/{prompt}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Update custom prompt
     * @description Set a custom template for an AI prompt
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {prompt: components["schemas"]["AiPromptKind"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateCustomPrompt"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AiPromptInfo"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Reset custom prompt
     * @description Reset an AI prompt to its default template
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {prompt: components["schemas"]["AiPromptKind"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AiPromptInfo"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/whoami_on_account": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get current user information
     * @description Returns information about the currently authenticated user on the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["WhoAmIOnAccountResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/external_authorizations": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create external authorization
     * @description Create a new external authorization for third-party integrations
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateExternalAuthorization"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CreatedExternalAuthorization"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/external_authorizations/{external_authorization_id}/nonce": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Request nonce
     * @description Request a nonce for an external authorization
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateExternalNonce"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CreatedExternalNonce"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List users
     * @description Get all users in the account
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          /**
           * @description When set to a specific product, only users with access to that product
           *     are returned. Used by in-app user pickers so you can only select people
           *     who can actually use the application.
           */
          product?: components["schemas"]["ProductType"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccountUser"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/users/{user_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get user
     * @description Get a specific user by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["UserMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Remove user from account
     * @description Remove a user from the account (admin only)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/users/{user_id}/teams": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get user teams
     * @description Get teams that a user belongs to
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TeamMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/registered_users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create user
     * @description Create a new registered user (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PopulateRegisteredUser"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RegisteredUser"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/registered_users/invite": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Invite user
     * @description Invite a new user with email notification
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["InviteUser"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RegisteredUser"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/service_users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create service user
     * @description Create a new service user for API access (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateServiceUser"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ServiceUser"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/service_users/{user_id}/apikeys": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List service user API keys
     * @description Get all API keys for a service user (admin only)
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ServiceUserApikeyMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create service user API key
     * @description Create a new API key for a service user (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ServiceUserApikey"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/service_users/{user_id}/apikeys/{user_apikey_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete service user API key
     * @description Delete an API key for a service user (admin only)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          user_apikey_id: components["schemas"]["UserApikeyId"];
          user_id: components["schemas"]["UserId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/user_emails/{email}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Record user email
     * @description Record a user email (internal only)
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {email: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["UserMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/roles": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List roles
     * @description Get all roles in the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Role"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/roles/{role_id}/members": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List role members
     * @description Get all users assigned to a specific role
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {role_id: components["schemas"]["RoleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccountUser"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Add user to role
     * @description Assign a user to a role (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {role_id: components["schemas"]["RoleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UserId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/roles/{role_id}/members/{user_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove user from role
     * @description Remove a user from a role (admin only)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          role_id: components["schemas"]["RoleId"];
          user_id: components["schemas"]["UserId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List teams
     * @description Get all teams in the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; deleted?: boolean | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Team"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create team
     * @description Create a new team (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTeam"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TeamMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get team
     * @description Get a specific team by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TeamMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete team
     * @description Delete a team
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/restore": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Restore team
     * @description Restore a deleted team (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update team name
     * @description Update a team's name (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update team description
     * @description Update a team's description (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/members": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get team members
     * @description Get all members of a team
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RegisteredUser"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Add user to team
     * @description Add a user to a team (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UserId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/members/{user_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove user from team
     * @description Remove a user from a team (admin only)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          team_id: components["schemas"]["TeamId"];
          user_id: components["schemas"]["UserId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/permissions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get team permissions
     * @description Get all roles/permissions assigned to a team
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["RoleMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Add role to team
     * @description Add a role/permission to a team (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {team_id: components["schemas"]["TeamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RoleId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/teams/{team_id}/permissions/{permission_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove role from team
     * @description Remove a role/permission from a team (admin only)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          permission_id: components["schemas"]["RoleId"];
          team_id: components["schemas"]["TeamId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/system_agents/domain/{domain}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List system agents by domain
     * @description Retrieve system agents for a specific domain
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {domain: components["schemas"]["SystemAgentDomain"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["SystemAgentUser"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/system_agents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List system agents
     * @description Retrieve all system agents for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["SystemAgentUser"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create system agent
     * @description Create a new system agent
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateEditSystemAgent"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/system_agents/default": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List default system agents
     * @description Retrieve default system agents
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["SystemAgentUser"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/system_agents/{user_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update system agent
     * @description Update a system agent by user ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateEditSystemAgent"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete system agent
     * @description Delete a system agent by user ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {user_id: components["schemas"]["UserId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/owners/resolve": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Resolve owners
     * @description Resolve owner information by user IDs and team IDs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ResolveOwner"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Owner"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/owners/{owner_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get owner
     * @description Retrieve owner information by owner ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {owner_id: components["schemas"]["OwnerId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Owner"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/owners/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load owners
     * @description Retrieve owner information by owner IDs in bulk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["Owner"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/owners": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List owners for the account
     * @description Retrieve all owners in an acount
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          /**
           * @description When set to a specific product, only owners (users) with access to that
           *     product are returned. Teams are always included.
           */
          product?: components["schemas"]["ProductType"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Owner"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/standalone_files": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create standalone file
     * @description Create a standalone file reference
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateStandaloneFile"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["StandaloneFile"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/files": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Upload file
     * @description Upload a file to the system
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; system_wide?: boolean};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description File upload */
      requestBody: {
        content: {
          "multipart/form-data": {
            /**
             * Format: binary
             * @description The file to upload
             */
            file: string;
          };
        };
      };
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["File"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/files/upload_session/create": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create upload session
     * @description Create a large file upload session
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFileUploadSession"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FileUploadSessionResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/files/upload_session/complete": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Complete upload session
     * @description Complete a large file upload session
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileUploadSessionId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["File"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/files/{file_id}/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download file
     * @description Download a file from the system
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; override_name?: string | null};
        header?: never;
        path: {file_id: components["schemas"]["FileId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/support_emails/send": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Send support email
     * @description Send an email to the support team
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SendSupportEmail"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channel_connectors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List notification channel connectors
     * @description List all available notification channel connectors
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSinkConnector"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channel_connectors/{notification_channel_connector_type}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get notification channel connector
     * @description Get a specific notification channel connector by type
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_channel_connector_type: components["schemas"]["NotificationSinkConnectorType"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSinkConnector"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channel_connectors/{notification_channel_connector_type}/default_config": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Get default notification sink config
     * @description Get default configuration for a notification sink connector
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_channel_connector_type: components["schemas"]["NotificationSinkConnectorType"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ExternalAuthorizationId"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSinkConfig"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channels": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List notification channels
     * @description List all notification channels for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSinkMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create notification channel
     * @description Create a new notification channel
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateNotificationSink"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSink"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channels/{notification_sink_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get notification channel
     * @description Get a specific notification channel by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_sink_id: components["schemas"]["NotificationSinkId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSink"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update notification channel
     * @description Update an existing notification channel
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_sink_id: components["schemas"]["NotificationSinkId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateNotificationSink"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete notification channel
     * @description Delete a notification channel by ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_sink_id: components["schemas"]["NotificationSinkId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notification_channels/{notification_sink_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update notification channel name
     * @description Update the name of a notification channel
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_sink_id: components["schemas"]["NotificationSinkId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/user_notification_channels": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List user notification channels
     * @description List all notification channels linked to the current user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LinkedNotificationSinkMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Link notification channel
     * @description Link a notification channel to the current user
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["LinkNotificationSink"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LinkedNotificationSinkMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/available_notification_channels": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List available notification channels
     * @description List all notification channels available to the current user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["NotificationSinkMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/user_notification_channels/{notification_sink_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Unlink notification channel
     * @description Unlink a notification channel from the current user
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          notification_sink_id: components["schemas"]["NotificationSinkId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/activity_streams/{activity_stream_id}/activities": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get stream activities
     * @description Get activities for a specific activity stream
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; before?: number | null; since?: number | null};
        header?: never;
        path: {activity_stream_id: components["schemas"]["ActivityStreamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Activity"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/activity_streams/{activity_stream_id}/comment": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add stream comment
     * @description Add a comment to an activity stream
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {activity_stream_id: components["schemas"]["ActivityStreamId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComment"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List background tasks
     * @description Retrieve pending background tasks for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/noop": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create a noop background task
     * @description Create a background task that completes immediately with no side effects. Used in integration tests to exercise queue infrastructure.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["BackgroundTaskId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/{background_task_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get background task
     * @description Retrieve a background task by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {background_task_id: components["schemas"]["BackgroundTaskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The frontend defines its own types for these so we can use typebox to parse the task result */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["BackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/{background_task_id}/queue": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Queue background task
     * @description Queue a background task for execution
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {background_task_id: components["schemas"]["BackgroundTaskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/{background_task_id}/requeue": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Requeue background task
     * @description Requeue a background task for execution
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {background_task_id: components["schemas"]["BackgroundTaskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/test": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Test background tasks
     * @description Create a test background task
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/schedule_missed": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule missed background tasks
     * @description Schedule any missed background tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/sync_documents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule document sync
     * @description Schedule document synchronization tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/detect_conflicts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule conflict detection
     * @description Schedule conflict detection tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/sync_postmark_suppressions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule Postmark suppressions sync
     * @description Schedule Postmark suppressions synchronization
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/refresh_external_authorization": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule external authorization refresh
     * @description Schedule external authorization refresh tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/send_reminder_notifications": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule reminder notifications
     * @description Schedule reminder notification tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/cleanup_file_upload_sessions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule file upload sessions cleanup
     * @description Schedule cleanup of expired file upload sessions
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/cleanup_notifications": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule notifications cleanup
     * @description Schedule notification cleanup tasks
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/background_tasks/reconcile_account_features": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Schedule account feature reconciliation
     * @description Purge unknown feature strings from account feature arrays
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/access_tokens": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create access token
     * @description Create a new access token for API authentication
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAccessToken"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccessToken"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/reported_error_catalogs/{catalog_id}/errors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List reported errors
     * @description List all reported errors in a catalog
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {catalog_id: components["schemas"]["ErrorCatalogId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ReportedError"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/{product_type}/{status}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List notifications
     * @description List notifications by product type and status
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          before?: number | null;
          limit?: number | null;
          since?: number | null;
        };
        header?: never;
        path: {
          product_type: components["schemas"]["ProductType"];
          status: components["schemas"]["NotificationStatus"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InAppNotification"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/channel_stream/{product_type}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get notification channel stream
     * @description Get the channel stream for notifications
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {product_type: components["schemas"]["ProductType"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InAppNotificationStream"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/mark_as_read": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Mark notifications as read
     * @description Mark specific notifications as read
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["InAppNotificationId"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/mark_all_read": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Mark all notifications as read
     * @description Mark all notifications as read
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ProductType"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/{user_notification_id}/archive": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Archive notification
     * @description Archive a specific notification
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          user_notification_id: components["schemas"]["InAppNotificationId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/notifications/all": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Archive all notifications
     * @description Archive all notifications
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/scim_configs": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List SCIM configs
     * @description Get all SCIM configurations for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ScimConfigList"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create SCIM config
     * @description Create a new SCIM configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateScimConfig"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ScimConfigId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/scim_configs/{scim_config_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete SCIM config
     * @description Delete a SCIM configuration
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scim_config_id: components["schemas"]["ScimConfigId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/scim_configs/{scim_config_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update SCIM config name
     * @description Update the name of a SCIM configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scim_config_id: components["schemas"]["ScimConfigId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/scim_configs/{scim_config_id}/send_invitations": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update invitation settings
     * @description Update whether SCIM config sends invitations
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scim_config_id: components["schemas"]["ScimConfigId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/scim_configs/{scim_config_id}/auth_token": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Regenerate auth token
     * @description Regenerate the authentication token for a SCIM config
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scim_config_id: components["schemas"]["ScimConfigId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/verified_domains": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get verified domains
     * @description Get all verified domains for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["VerifiedDomain"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create verified domain
     * @description Create a new verified domain
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateVerifiedDomain"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["VerifiedDomainId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/verified_domains/{verified_domain_id}/verify": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Verify domain
     * @description Verify a domain by ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {verified_domain_id: components["schemas"]["VerifiedDomainId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/verified_domains/{verified_domain_id}/enable_self_enrollment": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Enable self-enrollment
     * @description Enable or disable self-enrollment for a verified domain
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {verified_domain_id: components["schemas"]["VerifiedDomainId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/verified_domains/{verified_domain_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete verified domain
     * @description Delete a verified domain
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {verified_domain_id: components["schemas"]["VerifiedDomainId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/login_methods": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List login methods
     * @description List all login methods for the authenticated account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["LoginMethod"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create login method
     * @description Create a new login method for the account
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ValidateLoginMethod"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["LoginMethodId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/login_methods/{login_method_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update login method
     * @description Update an existing login method
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ValidateLoginMethod"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete login method
     * @description Delete a login method by ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {login_method_id: components["schemas"]["LoginMethodId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/search/stats": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get search statistics
     * @description Retrieve search indexing statistics from Meilisearch
     */
    get: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        /** @description Statistics for the Meilisearch instance. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SearchStats"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/search/enqueue_all_facts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Enqueue all facts for indexing
     * @description Queue all facts for search indexing (system only)
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/watcher_preferences": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get user watcher preferences
     * @description Get notification preferences for the current user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of actions which will cause the user to become a "watcher" of a resource */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["WatcherPreferences"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update user watcher preferences
     * @description Update notification preferences for the current user
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateWatcherTrigger"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/watcher_preferences/account": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get account watcher preferences
     * @description Get notification preferences for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of actions which will cause the user to become a "watcher" of a resource */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["WatcherPreferences"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update account watcher preferences
     * @description Update notification preferences for the account
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateWatcherTrigger"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/reviewables/{reviewable_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get reviewable
     * @description Get a specific reviewable by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {reviewable_id: components["schemas"]["ReviewableId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Reviewable"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/agent_sessions/{agent_session_id}/messages": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List messages
     * @description List messages in the agent session
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          after_ordinal?: number | null;
          before_ordinal?: number | null;
          committed?: boolean | null;
          limit?: number | null;
        };
        header?: never;
        path: {agent_session_id: components["schemas"]["AgentSessionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AgentSessionMessage"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Send message
     * @description Send a message to the agent session
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {agent_session_id: components["schemas"]["AgentSessionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAgentSessionUserMessage"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/private_resources/{private_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /** Get private resource */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {private_id: components["schemas"]["PrivateResourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PrivateResource"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /** Unprivate resource */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {private_id: components["schemas"]["PrivateResourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/private_resources/{private_id}/access_grants": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /** Update access grants for private resource */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {private_id: components["schemas"]["PrivateResourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreatePrivateResourceAccessGrant"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List saved views
     * @description Get all saved views for this user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {view_key: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SavedViewList"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create saved view
     * @description Create a new saved view
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {view_key: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateSavedView"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SavedViewId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}/{view_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update saved view name
     * @description Update the name of a saved view by ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          view_id: components["schemas"]["SavedViewId"];
          view_key: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}/{view_id}/group": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update saved view group
     * @description Update the group of a saved view by ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          view_id: components["schemas"]["SavedViewId"];
          view_key: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SavedViewGroup"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}/{view_id}/make_default": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Make saved view the default
     * @description Make a saved view the default for the user
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          view_id: components["schemas"]["SavedViewId"];
          view_key: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}/{view_id}/payload": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update saved view payload
     * @description Update the payload of a saved view by ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          view_id: components["schemas"]["SavedViewId"];
          view_key: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": {[key: string]: IValue}}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/saved_views/{view_key}/{view_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete saved view
     * @description Delete a saved view by ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          view_id: components["schemas"]["SavedViewId"];
          view_key: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/test_sentry": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Test Sentry error reporting
     * @description Test endpoint that generates an error to verify Sentry integration
     */
    get: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/test_sentry_503": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Test 503 error handling
     * @description Test endpoint that returns a 503 status code
     */
    get: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question
     * @description Get a specific question by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Question"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign question
     * @description Assign a question to a user for a specific layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/due_date": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question due date
     * @description Update the due date for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/status": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question status
     * @description Update the status of a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QuestionStatus"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question text
     * @description Update the text content of a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/number": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question number
     * @description Update the number/order of a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/guidance": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question guidance
     * @description Update the guidance text for a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/prompt_modifiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question prompt modifiers
     * @description Update the AI prompt modifiers for a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PromptModifiers"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/response_text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question text response
     * @description Update the text response for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/response_yes_no": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question yes/no response
     * @description Update the yes/no response for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/response_select": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question select response
     * @description Update the select response for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ResponseOption"][] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/core_response": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question linked core response
     * @description Link a core response to a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CoreResponseId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/copy_back": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Copy back question response
     * @description Copy a response back from one layer to another
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/parts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question parts
     * @description Update the answer parts for a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AnswerParts"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/auto_complete": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Auto-answer question
     * @description Automatically answer a question using AI
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAutoComplete"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/used_facts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List question used facts
     * @description Get facts used by this question
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RelevantFact"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/generated_facts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List question generated facts
     * @description Get facts generated by this question
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SourcedFact"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/documentation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List question documentation
     * @description List documentation for a question layer
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["Documentation"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create question documentation
     * @description Create documentation for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateQuestionDocumentation"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentationId"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete all question documentation
     * @description Delete all documentation for a question layer
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/documentation/{documentation_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete question documentation
     * @description Delete specific documentation for a question layer
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          documentation_id: components["schemas"]["DocumentationId"];
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/watching": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question watching status
     * @description Check if user is watching this question
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": boolean}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update question watching
     * @description Start or stop watching a question for notifications
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/override_limited_to_scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update override limited to scopes
     * @description Override scope limitations for a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/limited_to_scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update limited to scopes
     * @description Update scope limitations for a question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopeId"][] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk update questions
     * @description Update multiple questions at once
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["BulkQuestionUpdate"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load questions
     * @description Load multiple questions by their IDs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QuestionId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["Question"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questions/{question_id}/response_layers/{layer_type}/reviews": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create question reviews
     * @description Create reviews for a question layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          question_id: components["schemas"]["QuestionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateReviewAction"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get questionnaire
     * @description Get a specific questionnaire by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Questionnaire"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete questionnaire
     * @description Delete a questionnaire
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List questionnaires
     * @description Get all accessible questionnaires for the current account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionnaireMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create questionnaire
     * @description Create a new questionnaire with sections and questions
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateQuestionnaire"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Questionnaire"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/historical_questionnaires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List historical questionnaires
     * @description Get all historical questionnaires for the current account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionnaireMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign questionnaire
     * @description Assign a questionnaire to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/due_date": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire due date
     * @description Update the due date for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/questionnaire_date": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire date
     * @description Update the questionnaire date
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire name
     * @description Update the name of a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/internal_language_code": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update internal language code
     * @description Update the internal language code for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/external_language_code": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update external language code
     * @description Update the external language code for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/counterparty": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire counterparty
     * @description Update the counterparty associated with a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CounterpartyId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/scope_matrix": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire scope matrix
     * @description Update the scope matrix for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopeMatrix"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/deal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire deal
     * @description Update the deal associated with a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DealId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/archived": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire archived status
     * @description Archive or unarchive a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/prompt_modifiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update questionnaire prompt modifiers
     * @description Update AI prompt modifiers for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PromptModifiers"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/copy_back": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Copy questionnaire back
     * @description Copy questionnaire responses from internal to external layer
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/auto_complete": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get queued automation tasks
     * @description Get pending automation tasks for a questionnaire
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Auto-complete questionnaire
     * @description Automatically answer questionnaire questions using AI
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/original_files/{original_file_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Add original file
     * @description Add an original file to a questionnaire
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          original_file_id: components["schemas"]["FileId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete original file
     * @description Remove an original file from a questionnaire
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          original_file_id: components["schemas"]["FileId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/original_files/{original_file_id}/imported_at": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update original file import time
     * @description Update when an original file was imported
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          original_file_id: components["schemas"]["FileId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/original_sources/{source_url}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Add original source
     * @description Add an original source URL to a questionnaire
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          source_url: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete original source
     * @description Remove an original source URL from a questionnaire
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          source_url: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/original_sources/{source_url}/imported_at": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update original source import time
     * @description Update when an original source was imported
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          source_url: string;
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/documentation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create documentation
     * @description Create documentation for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateQuestionnaireDocumentation"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentationId"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/questionnaire_layer/{layer_type}/documentation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List documentation
     * @description List documentation for a questionnaire layer
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["Documentation"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/download_documentation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download documentation
     * @description Download all documentation for a questionnaire as a ZIP file
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/questionnaire_layer/{layer_type}/download_csv": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download CSV
     * @description Download questionnaire data as CSV file
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          layer_type: components["schemas"]["LayerType"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/questionnaire_layer/{layer_type}/documentation/{documentation_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete documentation
     * @description Delete documentation from a questionnaire layer
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          documentation_id: components["schemas"]["DocumentationId"];
          layer_type: components["schemas"]["LayerType"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/documentation/{documentation_id}/linked_to_questionnaire": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update documentation link
     * @description Update whether documentation is linked to questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          documentation_id: components["schemas"]["DocumentationId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/import": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Import questions
     * @description Import questions into a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ImportQuestions"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/trust_center_visibility": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update trust center visibility
     * @description Update trust center visibility settings for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TrustCenterAccess"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/sections/{section_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update section title
     * @description Update the title of a questionnaire section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          section_id: components["schemas"]["SectionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/qa_mode": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set QA mode
     * @description Set the QA mode for a questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {questionnaire_id: components["schemas"]["QuestionnaireId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QAMode"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/sections/{section_id}/question_groups": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create question group
     * @description Create a new question group within a section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          section_id: components["schemas"]["SectionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateQuestionGroup2"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionGroupMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/sections/{section_id}/question_groups/{question_group_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question group name
     * @description Update the name of a question group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          question_group_id: components["schemas"]["QuestionGroupId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          section_id: components["schemas"]["SectionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/sections/{section_id}/question_groups/{question_group_id}/questions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Attach questions to group
     * @description Attach questions to a question group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          question_group_id: components["schemas"]["QuestionGroupId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          section_id: components["schemas"]["SectionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AttachQuestions"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Detach questions from group
     * @description Detach questions from a question group
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          question_group_id: components["schemas"]["QuestionGroupId"];
          questionnaire_id: components["schemas"]["QuestionnaireId"];
          section_id: components["schemas"]["SectionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DetachQuestions"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/adhoc_questions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List adhoc questions
     * @description List all adhoc questions
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AdHocQuestion"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create adhoc question
     * @description Create a new adhoc question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAdHocQuestion"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AdHocQuestion"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/adhoc_questions/{question_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get adhoc question
     * @description Get a specific adhoc question by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AdHocQuestion"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/adhoc_questions/{question_id}/asker_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update adhoc question asker
     * @description Update the asker ID for an adhoc question
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_id: components["schemas"]["QuestionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UserId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/tasks/{layer_type}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get tasks
     * @description Get paginated tasks for a layer
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {layer_type: components["schemas"]["LayerType"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/tasks/{layer_type}/count": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Count tasks
     * @description Get task count for a layer
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {layer_type: components["schemas"]["LayerType"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": number}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/getting_started_checklist": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get getting started checklist
     * @description Get the getting started checklist for a user
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["GettingStartedChecklist"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/counterparties": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List counterparties
     * @description Get all counterparties
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["Counterparty"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create counterparty
     * @description Create a new counterparty
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateCounterparty"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Counterparty"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get counterparty
     * @description Get a specific counterparty by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {counterparty_id: components["schemas"]["CounterpartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Counterparty"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update counterparty name
     * @description Update the name of a counterparty
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {counterparty_id: components["schemas"]["CounterpartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/url": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update counterparty URL
     * @description Update the URL of a counterparty
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {counterparty_id: components["schemas"]["CounterpartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/language_code": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update counterparty language code
     * @description Update the language code of a counterparty
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {counterparty_id: components["schemas"]["CounterpartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List scopes
     * @description Get all scopes with full information
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Scope"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create scope
     * @description Create a new scope
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateScope"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ScopeMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/min": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List scopes (minimal)
     * @description Get minimal scope information for all scopes
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ScopeMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/{scope_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get scope owner
     * @description Get the owner of a specific scope
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["ScopeIdOrGlobal"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Owner"] | null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/{scope_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update scope name
     * @description Update the name of a scope
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["ScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/{scope_id}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign scope
     * @description Assign a scope to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["ScopeIdOrGlobal"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/{scope_id}/access": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update scope access controls
     * @description Update access controls for a scope
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["ScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateScopeAccess"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Disable scope access control
     * @description Disable access controls for a scope
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["ScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scope_axes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List scope axes
     * @description Get all scope axes
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ScopeAxisMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create scope axis
     * @description Create a new scope axis
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateScopeAxis"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ScopeAxisMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scope_axes/{axis_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update scope axis name
     * @description Update the name of a scope axis
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {axis_id: components["schemas"]["ScopeAxisId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scope_axes/{axis_id}/color": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update scope axis color
     * @description Update the color of a scope axis
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {axis_id: components["schemas"]["ScopeAxisId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/scopes/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load scopes
     * @description Load multiple scopes in bulk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopeId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["Scope"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/deals": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get deals
     * @description List all deals
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Deal"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List documents
     * @description Get a list of all documents
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["DocumentMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create document
     * @description Create a new document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateDocument"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Document"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document
     * @description Get a specific document by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Document"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update document content
     * @description Update the content of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateDocumentContent"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete document
     * @description Delete a specific document by ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/facts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document facts
     * @description Get all facts associated with a document
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SourcedFact"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document name
     * @description Update the name of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/review_period": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document review period
     * @description Update the review period for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ReviewPeriod"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/non_authoritative_markdown": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document non-authoritative markdown
     * @description Update the non-authoritative markdown content of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/sharing_classification": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document sharing classification
     * @description Update the sharing classification of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SharingClassification"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/category": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document category
     * @description Update the category of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DocumentCategory"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/limited_to_scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document limited to scopes
     * @description Update the scope limitations for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopeId"][] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign document
     * @description Assign a document to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/trust_center_visibility": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document trust center visibility
     * @description Update the trust center visibility settings for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TrustCenterAccess"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/trust_center_readability": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document trust center readability
     * @description Update the trust center readability settings for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TrustCenterAccess"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/trust_center_esignature_template": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document trust center esignature template
     * @description Update the esignature template for a document in trust center
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["EsignatureTemplateId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/certification_type": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document certification type
     * @description Update the certification type for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CertificationType"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/certification_date_granted": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document certification date granted
     * @description Update the certification date granted for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/certification_date_expires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document certification date expires
     * @description Update the certification expiration date for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/certification_auditor_url": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document certification auditor URL
     * @description Update the certification auditor URL for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/certification_audit_report": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document certification audit report
     * @description Update the certification audit report for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DocumentId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/prompt": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document fact generation prompt
     * @description Update the fact generation prompt for a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/prompt/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset document fact generation prompt
     * @description Reset the fact generation prompt for a document to default
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/documents/{document_id}/reanalyze": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reanalyze document
     * @description Trigger reanalysis of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_id: components["schemas"]["DocumentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/document_source_connectors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document source connectors
     * @description List all available document source connectors
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentSourceConnector"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/document_source_connectors/{document_source_connector_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document source connector
     * @description Get a specific document source connector by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_source_connector_id: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentSourceConnector"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/document_sources": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document sources
     * @description List all document sources
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentSourceMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create document source
     * @description Create a new document source
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateDocumentSource"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentSource"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get document source
     * @description Get a specific document source by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_source_id: components["schemas"]["DocumentSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentSource"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update document source
     * @description Update a document source configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_source_id: components["schemas"]["DocumentSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateDocumentSource"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete document source
     * @description Delete a document source and optionally its documents
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; retain_documents?: boolean};
        header?: never;
        path: {document_source_id: components["schemas"]["DocumentSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}/sync": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Sync document source
     * @description Trigger synchronization of a document source
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {document_source_id: components["schemas"]["DocumentSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connectors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get CRM connectors
     * @description List all available CRM connectors
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CrmConnector"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connectors/{crm_connector_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get CRM connector
     * @description Get a specific CRM connector by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connector_id: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["CrmConnector"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connectors/{crm_connector_id}/account_info": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Get CRM account info
     * @description Get account information for a CRM connector
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connector_id: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ExternalAuthorizationId"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CrmAccountInfo"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connections": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get CRM connections
     * @description List all CRM connections
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CrmConnectionMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create CRM connection
     * @description Create a new CRM connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateCrmConnection"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["CrmConnection"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get CRM connection
     * @description Get a specific CRM connection by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connection_id: components["schemas"]["CrmConnectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["CrmConnection"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update CRM connection
     * @description Update a CRM connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connection_id: components["schemas"]["CrmConnectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateCrmConnection"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete CRM connection
     * @description Delete a CRM connection
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connection_id: components["schemas"]["CrmConnectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update CRM connection name
     * @description Update the name of a CRM connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connection_id: components["schemas"]["CrmConnectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}/sync": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Sync CRM connection
     * @description Trigger synchronization of a CRM connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {crm_connection_id: components["schemas"]["CrmConnectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_source_connectors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question source connectors
     * @description List all available question source connectors
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSourceConnector"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_source_connectors/{question_source_connector_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question source connector
     * @description Get a specific question source connector by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_connector_id: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSourceConnector"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_source_connectors/{question_source_connector_id}/account_info": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Get question source account info
     * @description Get account information for a question source connector
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_connector_id: string; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ExternalAuthorizationId"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSourceAccountInfo"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_sources": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question sources
     * @description List all question source connections
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSourceMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create question source
     * @description Create a new question source connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateQuestionSource"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSource"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_sources/{question_source_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get question source
     * @description Get a specific question source by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_id: components["schemas"]["QuestionSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["QuestionSource"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update question source
     * @description Update a question source connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_id: components["schemas"]["QuestionSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateQuestionSource"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete question source
     * @description Delete a question source connection
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_id: components["schemas"]["QuestionSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/question_sources/{question_source_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update question source name
     * @description Update the name of a question source connection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {question_source_id: components["schemas"]["QuestionSourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_provider_connectors": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get esignature provider connectors
     * @description List all available esignature provider connectors
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureProviderConnector"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_provider_connectors/{esignature_provider_connector_type}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get esignature provider connector
     * @description Get a specific esignature provider connector by type
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_connector_type: components["schemas"]["EsignatureProviderConnectorType"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureProviderConnector"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_providers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List esignature providers
     * @description List all esignature providers
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureProviderMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create esignature provider
     * @description Create a new esignature provider
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateEsignatureProvider"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureProvider"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get esignature provider
     * @description Get a specific esignature provider by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_id: components["schemas"]["EsignatureProviderId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureProvider"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update esignature provider
     * @description Update an esignature provider configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_id: components["schemas"]["EsignatureProviderId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateEsignatureProvider"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete esignature provider
     * @description Delete an esignature provider
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_id: components["schemas"]["EsignatureProviderId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update esignature provider name
     * @description Update the name of an esignature provider
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_id: components["schemas"]["EsignatureProviderId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}/sync": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Sync esignature provider
     * @description Sync templates and data from an esignature provider
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          esignature_provider_id: components["schemas"]["EsignatureProviderId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/esignature_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List esignature templates
     * @description List all available esignature templates
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EsignatureTemplate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/facts/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Search facts
     * @description Search for facts using text or vector search
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FactSearchArgs"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated2"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/facts/counts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Count facts
     * @description Get fact counts grouped by scope
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FactCounts"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/facts/{fact_id}/disabled": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update fact disabled status
     * @description Enable or disable a fact
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {fact_id: components["schemas"]["FactId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/facts/{fact_id}/library_section": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update fact library section
     * @description Move a fact to a different library section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {fact_id: components["schemas"]["FactId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopedLibrarySectionId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/fact_clusters": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List fact clusters
     * @description Get all top-level fact clusters
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FactCluster"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/fact_clusters/{cluster_id}/equivalences": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List fact equivalences
     * @description Get all facts that are equivalent to the given cluster
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {cluster_id: components["schemas"]["FactClusterId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FactMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List resolutions
     * @description Get paginated list of fact resolutions
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          assigned_to_me?: boolean;
          limit?: number | null;
          offset?: number | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated3"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/count": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Count resolutions
     * @description Get total count of resolutions
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; assigned_to_me?: boolean};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": number}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolved_resolutions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List resolved resolutions
     * @description Get all resolutions that have been resolved
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ResolutionMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/ignored_resolutions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List ignored resolutions
     * @description Get all resolutions that have been ignored
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ResolutionMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get resolution
     * @description Get a specific resolution by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Resolution"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}/resolve": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Resolve resolution
     * @description Mark a resolution as resolved
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}/ignore": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Ignore resolution
     * @description Mark a resolution as ignored
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}/revert": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Revert resolution
     * @description Revert a resolution back to pending state
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign resolution
     * @description Assign a resolution to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/resolutions/{resolution_id}/is_internal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update resolution internal status
     * @description Mark a resolution as internal or external
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {resolution_id: components["schemas"]["ResolutionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/config": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get trust center config
     * @description Get trust center configuration
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterConfig"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get trust center auth
     * @description Get trust center authentication settings
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterAuth"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/auth/is_public": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update trust center public access
     * @description Update whether trust center is publicly accessible
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/auth/password": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update trust center password
     * @description Update trust center password protection
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/config/document_request_email": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document request email
     * @description Update trust center document request email
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/config/theme": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update trust center theme
     * @description Update trust center visual theme
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": {[key: string]: IValue}}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/config/meta": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update trust center metadata
     * @description Update trust center configuration metadata
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TrustCenterConfigMeta"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/contents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List trust center contents
     * @description Get all trust center content sections
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterContentMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create trust center content
     * @description Create a new trust center content section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTrustCenterContent"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterContent"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/contents/{content_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get trust center content
     * @description Get a specific trust center content section
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {content_id: components["schemas"]["ContentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterContent"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete trust center content
     * @description Delete a trust center content section
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {content_id: components["schemas"]["ContentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/contents/{content_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update content title
     * @description Update the title of a trust center content section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {content_id: components["schemas"]["ContentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/contents/{content_id}/content": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update content body
     * @description Update the content body of a trust center section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {content_id: components["schemas"]["ContentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/mailing_list": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get mailing list
     * @description Get trust center mailing list information
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["MailingList"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/notification_center/messages": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create showcase message
     * @description Create a new showcase update message
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateOrUpdateShowcaseUpdateMessage"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ShowcaseUpdateMessageId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/notification_center/messages/{message_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get showcase message
     * @description Get a specific showcase message
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ShowcaseUpdateMessage"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update showcase message
     * @description Update an existing showcase message
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateOrUpdateShowcaseUpdateMessage"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete showcase message
     * @description Delete a showcase message
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/notification_center/messages/{message_id}/send": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Send showcase message
     * @description Send a showcase message to mailing list
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/notification_center/messages/{message_id}/read": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Mark message as read
     * @description Mark a showcase message as read
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/trust_center/notification_center/messages/list": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List showcase messages
     * @description List all showcase messages
     */
    get: {
      parameters: {
        query: {
          account_id?: components["schemas"]["AccountId"] | null;
          status: components["schemas"]["UpdateNotificationStatus"];
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ShowcaseMessageIds"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/assets": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List assets
     * @description Get all assets with optional owner filtering
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          owner?: components["schemas"]["AssetOwner"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AssetMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create asset
     * @description Create a new asset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAsset"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Asset"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/assets/{asset_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get asset
     * @description Get a specific asset by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["AssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Asset"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete asset
     * @description Delete an asset
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["AssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/assets/{asset_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update asset title
     * @description Update the title of an asset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["AssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/assets/{asset_id}/file": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update asset file
     * @description Update the file associated with an asset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["AssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/schema": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get graph schema
     * @description Get the schema definition for the graph
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": {[key: string]: components["schemas"]["GraphProperty"]}};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/graph": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get graph
     * @description Get a subgraph based on query parameters
     */
    get: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          filter_entity_ids?: components["schemas"]["EntityId"][] | null;
          filter_properties?: string[] | null;
          recursion_depth?: number | null;
          selected_properties?: string[] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SubGraph"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Update graph
     * @description Perform operations on the graph (create, delete, upsert)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["GraphOperation"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/library_sections": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List library sections
     * @description Get all library sections
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LibrarySectionMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create library section
     * @description Create a new library section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateLibrarySection"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LibrarySectionMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/library_sections/{id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get library section
     * @description Get a specific library section by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["LibrarySectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["LibrarySectionMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete library section
     * @description Delete a library section
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["LibrarySectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    /**
     * Update library section
     * @description Update a library section
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["LibrarySectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateLibrarySection"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/library_sections/{id}/assign": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign library section
     * @description Assign a library section to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["LibrarySectionId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/core_responses": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List core responses
     * @description List all core responses
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CoreResponse"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create core response
     * @description Create a new core response with AI embedding
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateCoreResponse"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["CoreResponse"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/core_responses/{id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get core response
     * @description Get a specific core response by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["CoreResponseId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["CoreResponse"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete core response
     * @description Delete a core response
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["CoreResponseId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/core_responses/{id}/question_text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update core response question text
     * @description Update the question text of a core response and recompute embeddings
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["CoreResponseId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/core_responses/{id}/response_text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update core response response text
     * @description Update the response text of a core response
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["CoreResponseId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/core_responses/{id}/limited_to_scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update core response scope limitations
     * @description Update the scope limitations of a core response
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {id: components["schemas"]["CoreResponseId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ScopeId"][] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/ai/identify_sheet_sections": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Identify sheet sections
     * @description Use AI to identify sections in a spreadsheet
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"text/plain; charset=utf-8": IValue}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["IdentifiedSheetSection"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/vendor_toolkit/ai/extract_section_questions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Extract section questions
     * @description Use AI to extract questions from a section
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"text/plain; charset=utf-8": IValue}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CreateQuestion"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/audit_area_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /** List audit area templates */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditAreaTemplate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /** Replace audit area templates */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpsertAuditAreaTemplate"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get audit plan
     * @description Get the audit plan for an engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AuditPlan"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create audit plan
     * @description Create a new audit plan for an engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/reviewables": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List audit plan reviewables
     * @description List every reviewable across the engagement's audit plan pages
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": {[key: string]: components["schemas"]["Reviewable"][]}};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/audit_plan/migrate_legacy": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Migrate legacy engagements
     * @description Queue a background task moving every engagement's legacy risk & control assessments onto an audit plan (internal only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["MigrateLegacyEngagements"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/audit_areas": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List audit areas
     * @description List every audit area in the account, across engagements
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditAreaOverview"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List audit areas
     * @description List all audit areas for an engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AuditArea"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create audit area
     * @description Create a new audit area with Understanding, Complexity, and Assessment sub-pages
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Request body for creating a new audit area with all its sub-pages. */
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditArea"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditPlanPageId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas/{audit_area_id}/assessment": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create audit area assessment
     * @description Add an assessment to an existing audit area that does not yet have one, creating its RisksAndControls sub-pages under the area page
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          audit_area_id: components["schemas"]["AuditAreaId"];
          engagement_id: components["schemas"]["EngagementId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditAreaAssessment"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AssessmentId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas/{audit_area_id}/understanding": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create audit area understanding
     * @description Add an understanding to an existing audit area that does not yet have one, creating its Understanding sub-page under the area page
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          audit_area_id: components["schemas"]["AuditAreaId"];
          engagement_id: components["schemas"]["EngagementId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditAreaUnderstanding"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UnderstandingId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas/{audit_area_id}/complexity": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create audit area complexity assessment
     * @description Add a complexity assessment to an existing audit area that does not yet have one, creating its Complexity sub-page under the area page. The model's latest published version is used.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          audit_area_id: components["schemas"]["AuditAreaId"];
          engagement_id: components["schemas"]["EngagementId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditAreaComplexity"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityAssessmentId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas/from_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create audit areas from templates
     * @description Create one audit area per supplied template under the given section page, in a single transaction. Templates supply name, pre-expanded context, and an optional framework.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditAreasFromTemplates"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditPlanPageId"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/process_candidates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List process candidates
     * @description List the process-step Table questions filled out across the engagement's submitted questionnaires, each offered as a process to instantiate on the add-process dialog's "From questionnaires" tab.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ProcessCandidate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/audit_areas/from_questionnaire_tables": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create audit areas from questionnaire tables
     * @description Create one process audit area per supplied questionnaire Table answer under the given section page, in a single transaction. Each understanding is generated from the table's process steps.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAuditAreasFromQuestionnaireTables"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditPlanPageId"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/delete": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Delete pages
     * @description Delete audit plan pages and their descendant subtrees.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DeleteAuditPlanPages"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/archive": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Archive pages
     * @description Archive audit plan pages and their descendant subtrees. Archived pages are read-only until unarchived.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ArchiveAuditPlanPages"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/unarchive": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unarchive pages
     * @description Unarchive audit plan pages, their ancestors, and their descendant subtrees.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UnarchiveAuditPlanPages"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/{page_id}/status": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update page status
     * @description Update the status of an audit plan page
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          page_id: components["schemas"]["AuditPlanPageId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateAuditPlanPageStatus"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/lock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Lock pages
     * @description Lock audit plan pages and their descendant subtrees. Locking always cascades to descendants.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["LockAuditPlanPages"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/unlock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unlock pages
     * @description Unlock audit plan pages and all of their ancestors, optionally cascading to descendant subtrees.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UnlockAuditPlanPages"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/{page_id}/reviews": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create page reviews
     * @description Request, update, or remove reviewers on an audit plan page
     */
    post: {
      parameters: {
        query?: {
          account_id?: components["schemas"]["AccountId"] | null;
          /** @description When true, the same reviewers are also assigned to every descendant page. */
          include_children?: boolean;
          /**
           * @description Applies reviewer removals to every descendant page as well as the target. Additions are
           *     governed separately by `include_children`, so a caller can cascade one without the other.
           */
          remove_from_children?: boolean;
        };
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          page_id: components["schemas"]["AuditPlanPageId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateReviewAction"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/{page_id}/activity_stream_ids": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List page activity stream refs
     * @description Get the activity stream refs (id + pusher channel name) for an audit plan page and all of its descendant pages
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          page_id: components["schemas"]["AuditPlanPageId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Activity stream refs for an audit plan page and all of its descendant pages. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AuditPlanPageActivityStreamRefs"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/audit_plan/pages/{page_id}/activities": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get page clustered activity feed
     * @description Get the clustered activity feed for an audit plan page and its descendant subtree. Activity below the caller-supplied `depth` is rolled up into per-user clusters; activity above it appears as individual rows. Rows are newest-first and at most 25 are returned across `items` and `head`.
     */
    get: {
      parameters: {
        query: {
          account_id?: components["schemas"]["AccountId"] | null;
          /** @description Only return rows whose cursor is strictly less than this value. */
          before?: number | null;
          /**
           * @description When `Some(false)`, the feed is computed *as if no bulk_action_id
           *     existed*: `Many` clusters cannot form (the within-bulk no-break
           *     rule and the rooted-anchor override are both disabled), so the
           *     activity flattens to per-bucket `One` clusters and individual
           *     rows. Used to expand a `Many` cluster into the per-bucket
           *     clusters that would otherwise have appeared. Defaults to `true`
           *     (the normal feed shape) when absent.
           */
          cluster_bulk_actions?: boolean | null;
          /**
           * @description Rollup level. Pages above this level (relative to the requested page,
           *     which is level 0) contribute individual activity rows; pages at or below
           *     it roll up into per-user clusters. Non-negative; no upper bound.
           */
          depth: number;
          /** @description Only return rows whose cursor is strictly greater than this value. */
          since?: number | null;
        };
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          page_id: components["schemas"]["AuditPlanPageId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The clustered activity feed of an audit plan page and its descendant subtree. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ClusteredActivityFeed"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessments/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Search complexity assessments
     * @description Search complexity assessments with filters
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FilterComplexityAssessments"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityScopedAssessmentMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment_batches/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Search complexity assessment batches
     * @description Search Scoped complexity-assessment batches with filters. Returns one entry per (engagement, model_version) Scoped batch with members + tier counts. Global assessments are not included — those still come via /complexity_assessments/search.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FilterComplexityAssessments"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityAssessment"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessments": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create complexity assessment
     * @description Create a new complexity assessment for a engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityAssessment"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityAssessmentId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get complexity assessment
     * @description Get a specific complexity assessment by ID. For Scoped assessments, returns the Global scope only — call /scopes for every scope of the assessment.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description Full detail of a single scoped assessment — one member of the
         *     parent [`ComplexityAssessment`] batch.
         */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityScopedAssessment"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete complexity assessment
     * @description Soft delete a complexity assessment
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List complexity assessment scopes
     * @description Returns every scoped member of a complexity-assessment batch sharing this id. For Global batches the result is a single-element list (the Global scope); for Scoped batches it is one entry per Internal/External Application scope. Per-scope mutation paths use `/complexity_assessment/{id}/scopes/{scope_id}/...`.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityScopedAssessmentMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update complexity assessment owner
     * @description Update the owner of a complexity assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/reassess": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reassess complexity
     * @description Manually trigger a complexity assessment to reflect latest engagement changes
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/tier": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update complexity assessment tier
     * @description Update the complexity tier of a complexity assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityTierBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/tier/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset complexity tier to AI value
     * @description Reset the complexity tier to the AI-calculated value, removing any user override
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/trigger_autoruns": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Trigger autorun assessments
     * @description Trigger autorun assessments based on the complexity tier configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute/{attribute_assessment_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update attribute assessment value
     * @description Allow user to override AI-determined value for an attribute
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateAttributeValue"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/running_tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get running tasks
     * @description Get any running background tasks for a complexity assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/linked_running_tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get linked assessment running tasks
     * @description Get any running background tasks for TPRM assessments linked to this complexity assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get scoped complexity assessment
     * @description Get a single scope of a complexity assessment by (id, scope_id).
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description Full detail of a single scoped assessment — one member of the
         *     parent [`ComplexityAssessment`] batch.
         */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityScopedAssessment"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/reassess": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reassess scoped complexity
     * @description Manually trigger reassessment of one member of a complexity-assessment batch
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/tier": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update scoped complexity tier
     * @description Override the AI-calculated tier on one member of a complexity-assessment batch
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityTierBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/tier/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset scoped complexity tier
     * @description Clear the user override on one member's tier so it reverts to the AI-calculated value
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/attribute/{attribute_assessment_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update scoped attribute value
     * @description Override the AI-determined value of an attribute on a single scope
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateAttributeValue"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create attribute evidence
     * @description Create evidence for a specific attribute assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAttributeEvidence"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AttributeEvidenceId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List attribute evidence
     * @description List all active evidence for a specific attribute assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AttributeEvidence"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/evidence/deleted": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List deleted attribute evidence
     * @description List all deleted evidence for a specific attribute assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AttributeEvidence"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/evidence/{attribute_evidence_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Update attribute evidence
     * @description Update a specific attribute evidence record
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateAttributeEvidence"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete attribute evidence
     * @description Delete a specific attribute evidence record
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/evidence/{attribute_evidence_id}/restore": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Restore deleted attribute evidence
     * @description Restore a previously deleted attribute evidence record
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create complexity model
     * @description Create a new complexity model (without versions)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityModel"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/list": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List complexity models
     * @description Get all complexity models with their versions
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get complexity model
     * @description Get a specific complexity model with all versions
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModel"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete complexity model
     * @description Delete a complexity model
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update model name
     * @description Update the name of a complexity model
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityModelName"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create complexity model version
     * @description Create a new version of a complexity model
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityModelVersion"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelVersionId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/duplicate": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Duplicate complexity model version
     * @description Create a new version by duplicating an existing version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DuplicateComplexityModelVersion"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelVersionId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/versions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List complexity model versions
     * @description Get all versions for a specific complexity model
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelVersion"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get complexity model version
     * @description Get a specific version of a complexity model
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelVersion"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete complexity model version
     * @description Delete a complexity model version
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Export complexity model version as preset
     * @description Export a complexity model version in preset format for use in account presets
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["CreateComplexityModelVersion"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update model version name
     * @description Update the name of a complexity model version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityModelVersionName"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/operator": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update version operator
     * @description Update the aggregation operator for a complexity model version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ComplexityAggregationOperator"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/publish": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Publish complexity model version
     * @description Publish a complexity model version - makes it immutable
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/archive": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Archive complexity model version
     * @description Archive a complexity model version - prevents use in new assessments but keeps existing assessments working
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/unarchive": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unarchive complexity model version
     * @description Unarchive a complexity model version - makes it available for new assessments
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/create_from_preset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create version from preset
     * @description Create a complexity model version from a preset configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {model_id: components["schemas"]["ComplexityModelId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityModelVersion"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityModelVersionId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/attribute": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create complexity attribute
     * @description Add a new attribute to a complexity model version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityAttribute"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityAttributeId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/attribute/{attribute_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update complexity attribute
     * @description Update an existing complexity model attribute
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_id: components["schemas"]["ComplexityAttributeId"];
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityAttribute"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete complexity attribute
     * @description Delete a complexity model attribute (only if version is unpublished)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_id: components["schemas"]["ComplexityAttributeId"];
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/tiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List complexity tiers
     * @description Get all complexity tiers for a model version
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityTier"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create complexity tier
     * @description Create a new complexity tier for a model version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateComplexityTier"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityTierId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/tier/{tier_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Update complexity tier
     * @description Update an existing complexity tier
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          tier_id: components["schemas"]["ComplexityTierId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateComplexityTier"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete complexity tier
     * @description Delete a complexity tier from a model version
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          tier_id: components["schemas"]["ComplexityTierId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/tiers/used": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List used complexity tiers
     * @description Get only complexity tiers that are currently used by at least one assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityTier"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/tiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List all complexity tiers
     * @description Get all complexity tiers configured across all published model versions
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ComplexityTier"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List tier assessment autoruns
     * @description Get all autorun configurations for a complexity version
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TierAssessmentAutorun"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create tier assessment autorun
     * @description Configure automatic assessment creation for a complexity tier
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateUpdateTierAssessmentAutorun"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun/{autorun_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Update tier assessment autorun
     * @description Update an autorun configuration
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          autorun_id: components["schemas"]["TierAssessmentAutorunId"];
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateUpdateTierAssessmentAutorun"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete tier assessment autorun
     * @description Remove an autorun configuration
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          autorun_id: components["schemas"]["TierAssessmentAutorunId"];
          model_id: components["schemas"]["ComplexityModelId"];
          version_id: components["schemas"]["ComplexityModelVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/roll_forward/candidates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List roll-forward candidates
     * @description Members on the third party's other engagements. Only those on the same model version can be rolled forward from.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RollForwardCandidate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/roll_forward/plan": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Plan a roll-forward
     * @description What a run from the given source in the given mode would do to each attribute, without doing it.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RollForwardRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RollForwardPlan"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/roll_forward": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get the member's roll-forward run
     * @description The member's latest run and what it did to each attribute, or nothing if it has never been rolled forward.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RollForwardReport"] | null};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Roll the member forward
     * @description Record a run from the given source in the given mode and start the task that applies it. Conflicts if the member has already been rolled forward, unless that run failed, or is being assessed.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RollForwardRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Undo the member's roll-forward
     * @description Takes a completed run back: every answer it wrote that nobody has answered or cleared since returns to the AI's, its offers stop showing, and the member can be rolled forward again. A run already undone is left as it is.
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["RollForwardReport"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/attribute/{attribute_assessment_id}/confirmation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Confirm an attribute's answer
     * @description Record that the user stands behind the answer that applies. Any later write that changes the answer clears it.
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /** Withdraw an attribute's confirmation */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tiers": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List third party tiers
     * @description Get all third party tiers
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ThirdPartyTierMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create third party tier
     * @description Create a new third party tier
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateThirdPartyTier"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ThirdPartyTierMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tiers/{tier_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update tier title
     * @description Update the title of a third party tier
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tier_id: components["schemas"]["ThirdPartyTierId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tiers/{tier_id}/color": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update tier color
     * @description Update the color of a third party tier
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tier_id: components["schemas"]["ThirdPartyTierId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tiers/{tier_id}/ordinal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reorder tier
     * @description Update the ordinal position of a third party tier
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tier_id: components["schemas"]["ThirdPartyTierId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": number}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tiers/{tier_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete third party tier
     * @description Delete a third party tier
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tier_id: components["schemas"]["ThirdPartyTierId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tags": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List third party tags
     * @description Get all third party tags
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ThirdPartyTagMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create third party tag
     * @description Create a new third party tag
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateThirdPartyTag"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ThirdPartyTagMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tags/{tag_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update tag title
     * @description Update the title of a third party tag
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tag_id: components["schemas"]["ThirdPartyTagId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tags/{tag_id}/color": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update tag color
     * @description Update the color of a third party tag
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tag_id: components["schemas"]["ThirdPartyTagId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_party_tags/{tag_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete third party tag
     * @description Delete a third party tag
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {tag_id: components["schemas"]["ThirdPartyTagId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create third party
     * @description Create a new third party vendor
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateThirdParty"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ThirdParty"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * List third parties
     * @description Get all third parties
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FilterArgs"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated4"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get third party
     * @description Get a specific third party by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ThirdParty"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete third party
     * @description Delete a third party
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party name
     * @description Update the name of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/url": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party URL
     * @description Update the URL of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/tier_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party tier
     * @description Update the tier of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ThirdPartyTierId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/external_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party external ID
     * @description Update the external ID of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/tag_ids": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party tags
     * @description Update the tags of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ThirdPartyTagId"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/owner_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update third party owner
     * @description Update the owner of a third party
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/operational_contexts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List operational contexts
     * @description Get operational contexts for a third party
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["OperationalContextMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/assessments": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List assessments
     * @description Get assessments for a third party
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Assessment"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/portal/users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List portal users
     * @description Get portal users for a third party
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalUserMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/portal/invite_user": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Invite portal user
     * @description Invite a user to a third party's portal
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["InvitePortalUser"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/portal/users/{user_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove portal user
     * @description Remove a user's access to a third party's portal
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          user_id: components["schemas"]["UserId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/third_parties/{third_party_id}/private": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Make third party private
     * @description Make a third party private. It will initially only be accessible to the current user.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {third_party_id: components["schemas"]["ThirdPartyId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk update sources
     * @description Perform bulk operations on sources
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["BulkSourceUpdate"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download sources
     * @description Download multiple sources as a ZIP file
     */
    get: {
      parameters: {
        query: {account_id?: components["schemas"]["AccountId"] | null; source_id: components["schemas"]["SourceId"][]};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get source
     * @description Get a specific source by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Source"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete source
     * @description Delete a source
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}/usage/{usage}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update source usage
     * @description Update source usage for risk or control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          source_id: components["schemas"]["SourceId"];
          usage: components["schemas"]["SourceUsageType"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}/file": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document file
     * @description Update the file associated with a document source
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}/non_authoritative_markdown": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update document markdown
     * @description Update the non-authoritative markdown content of a document
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}/notes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update source notes
     * @description Replace the auditor's notes on a source
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/sources/{source_id}/reprocess": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /** [INTERNAL] Reprocess source */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {source_id: components["schemas"]["SourceId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List frameworks
     * @description Get all frameworks
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create framework
     * @description Create a new framework
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFramework"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get framework
     * @description Get a specific framework by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FrameworkMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete framework
     * @description Delete a framework
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update framework name
     * @description Update the name of a framework
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/icon_file_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update framework icon
     * @description Update the icon file of a framework
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/is_enabled": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update framework enabled status
     * @description Update whether a framework is enabled
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/versions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List framework versions
     * @description Get all versions of a framework
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkVersionMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create framework version
     * @description Create a new version of a framework
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFrameworkVersion"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/latest": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get latest framework version
     * @description Get the latest version of a framework
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkVersionMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/create_from_preset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create version from preset
     * @description Create a framework version from a preset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PresetFrameworkVersion"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/{framework_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign framework
     * @description Assign a framework to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {framework_id: components["schemas"]["FrameworkId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/frameworks/create_from_preset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create framework from preset
     * @description Create a framework from a preset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PresetFramework"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get framework version
     * @description Get a specific framework version by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkVersion"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete framework version
     * @description Delete a framework version
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}/version": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update version string
     * @description Update the version string of a framework version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}/publish": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Publish framework version
     * @description Publish a framework version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}/profiles": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List profiles
     * @description Get all profiles for a framework version
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkProfileMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create profile
     * @description Create a new profile for a framework version
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFrameworkProfile"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}/module_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List module templates
     * @description Get available module templates for a framework version
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description Available module templates for a framework version.
         *     These are the options users can pick when configuring which modules a control uses.
         */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkModuleTemplates"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_versions/{framework_version_id}/controls": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List controls
     * @description Get all controls for a framework version
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_version_id: components["schemas"]["FrameworkVersionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PredefinedControl"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_profiles/{framework_profile_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get framework profile
     * @description Get a specific framework profile by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_profile_id: components["schemas"]["FrameworkProfileId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FrameworkProfile"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete framework profile
     * @description Delete a framework profile
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_profile_id: components["schemas"]["FrameworkProfileId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_profiles/{framework_profile_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update profile name
     * @description Update the name of a framework profile
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_profile_id: components["schemas"]["FrameworkProfileId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_profiles/{framework_profile_id}/scope_types": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update profile scope types
     * @description Update the scope types of a framework profile
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_profile_id: components["schemas"]["FrameworkProfileId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TprmScopeType"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/framework_profiles/{framework_profile_id}/control_groups": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create control group
     * @description Create a new control group in a framework profile
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          framework_profile_id: components["schemas"]["FrameworkProfileId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateControlGroup"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control_groups/{control_group_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update control group title
     * @description Update the title of a control group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_group_id: components["schemas"]["ControlGroupId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control_groups/{control_group_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update control group description
     * @description Update the description of a control group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_group_id: components["schemas"]["ControlGroupId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control_groups/{control_group_id}/ordinal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reorder control group
     * @description Update the ordinal position of a control group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_group_id: components["schemas"]["ControlGroupId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": number}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control_groups/{control_group_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete control group
     * @description Delete a control group
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_group_id: components["schemas"]["ControlGroupId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control_groups/{control_group_id}/controls": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create control
     * @description Create a new control in a control group
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_group_id: components["schemas"]["ControlGroupId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreatePredefinedControl"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{predefined_control_id}/title": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update control title
     * @description Update the title of a control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          predefined_control_id: components["schemas"]["PredefinedControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{predefined_control_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update control description
     * @description Update the description of a control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          predefined_control_id: components["schemas"]["PredefinedControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{predefined_control_id}/ordinal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reorder control
     * @description Update the ordinal position of a control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          predefined_control_id: components["schemas"]["PredefinedControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": number}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{predefined_control_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete control
     * @description Delete a control
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          predefined_control_id: components["schemas"]["PredefinedControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load controls
     * @description Load multiple controls by IDs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PredefinedControlId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["PredefinedControl"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessment-controls/{assessment_control_id}/control-oe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List a control's OE assessments
     * @description List a control's operating-effectiveness assessments, one per scope that has been started
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ControlOe"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/control-oe-dependencies": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List OE dependency edges
     * @description List the engagement's operating-effectiveness dependency edges — one per control condition, each resolved against its target's live conclusion
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["OeDependencyEdge"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/control-oe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List OE dependency targets
     * @description List the engagement's operating-effectiveness assessments as candidate dependency targets, each with its effectiveness scale
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ControlOeTarget"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create OE assessment
     * @description Start an operating-effectiveness assessment on a control-and-scope; the period defaults from the engagement window
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for starting an OE assessment on a control-and-scope. The period
       *     defaults from the engagement when omitted.
       */
      requestBody: {content: {"application/json": components["schemas"]["CreateControlOe"]}};
      responses: {
        /** @description Operating effectiveness for one control at one scope. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ControlOe"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get OE assessment
     * @description Read an operating-effectiveness assessment with its basis, resolved evidence, dependency targets and scale
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Operating effectiveness for one control at one scope. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ControlOe"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete OE assessment
     * @description Soft-delete an operating-effectiveness assessment and its basis
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add basis item
     * @description Add a strand to the argument — a test, work of others, or a prior conclusion
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateBasisItem"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/note-conditions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add note condition
     * @description Add an unassessed note condition to a basis item — a judgement somebody makes later
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for writing a note's text. Rewording an assessed note returns it to
       *     unassessed, as the call was made on the old wording.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpsertNoteCondition"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/control-conditions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add control condition
     * @description Add a control dependency to a basis item — requiring another control concluded at or above a level
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpsertControlCondition"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/span": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update basis item span
     * @description Reset the stretch of the period a basis item claims to cover
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateBasisItemSpan"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/test": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Link basis item test
     * @description Link a test-kind basis item to a test in the Testing module, or unlink it; status derives from the linked test
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for linking a test-kind basis item to a test in the Testing module, or
       *     unlinking it. The item's status is derived from the linked test, never stored.
       */
      requestBody: {content: {"application/json": components["schemas"]["SetBasisItemTest"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/create-test": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create a stub test
     * @description Create a draft test in the Testing module and link this test-kind basis item to it; the auditor points it at real work later
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/prior-conclusion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * State a prior conclusion
     * @description State a prior-year conclusion by hand on a prior-conclusion basis item — the rating it reached and why it rolls forward
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for stating a prior-year conclusion by hand: the rating the control's
       *     operating effectiveness reached before, as a 1-based index into its scale,
       *     and why it is being rolled forward.
       */
      requestBody: {content: {"application/json": components["schemas"]["SetPriorConclusion"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/satisfactory": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set work-of-others verdict
     * @description Record whether a work-of-others report is satisfactory; unsatisfactory sinks the item's window
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for recording the auditor's call on a work-of-others report. Separate
       *     from citing the report itself, which is [`SetBasisItemCitations`].
       */
      requestBody: {content: {"application/json": components["schemas"]["SetWorkOfOthersSatisfactory"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/citations": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set basis item citations
     * @description Replace the data-room papers a basis item cites, minting a whole-source extract for each
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for replacing what a basis item cites. Each entry names a data-room
       *     source (with its `as_of` pin); citing a whole document leaves `extract`
       *     unset, so a `WholeSource` extract is minted for it.
       */
      requestBody: {content: {"application/json": components["schemas"]["SetBasisItemCitations"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete basis item
     * @description Remove a strand from the argument; its conditions cascade with it
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conditions/{condition_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update note condition
     * @description Reword a note condition; changed wording returns it to unassessed
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          condition_id: components["schemas"]["ControlOeConditionId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for writing a note's text. Rewording an assessed note returns it to
       *     unassessed, as the call was made on the old wording.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpsertNoteCondition"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Delete condition
     * @description Remove a condition from a basis item — a note or a control dependency
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          condition_id: components["schemas"]["ControlOeConditionId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conditions/{condition_id}/assessment": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assess note condition
     * @description Record whether a note condition holds, stamping who asserted it and when, or return it to unassessed
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          condition_id: components["schemas"]["ControlOeConditionId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /** @description Input for recording, or withdrawing, the call on a note condition. */
      requestBody: {content: {"application/json": components["schemas"]["AssessNoteCondition"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/basis-items/{basis_item_id}/exclusion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Exclude basis item
     * @description Set a basis item aside with a required reason; it then takes no part in coverage
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /** @description Input for setting a basis item aside. The reason is required. */
      requestBody: {content: {"application/json": components["schemas"]["ExcludeBasisItem"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Re-include basis item
     * @description Bring a set-aside basis item back into the argument
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          basis_item_id: components["schemas"]["ControlOeBasisItemId"];
          control_oe_id: components["schemas"]["ControlOeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conclusion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set OE conclusion
     * @description Record the conclusion — a rating on the control's effectiveness scale, and a justification
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for recording a conclusion. `rating` is rejected outside
       *     `1..=levels.len()` at both ends, at the write boundary.
       */
      requestBody: {content: {"application/json": components["schemas"]["SetControlOeConclusion"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/reliance": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set reliance
     * @description Record whether the auditor leans on this control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SetReliance"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/period": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update OE period
     * @description Reset the period the assessment argues over
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateControlOePeriod"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/plan": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Generate an OE plan
     * @description Draft the basis with the AI planner; the assessment reads as generating until the draft lands
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for triggering AI plan generation on an OE assessment. The auditor's
       *     steer is optional and kept so the plan can be regenerated without retyping it.
       */
      requestBody: {content: {"application/json": components["schemas"]["GenerateOePlan"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Discard the drafted plan
     * @description Drop the AI-drafted basis items
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/plan/accept": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Accept the drafted plan
     * @description Promote the AI-drafted basis items to the live plan
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conclusion/generate": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Generate an OE conclusion
     * @description Draft the conclusion with the AI; the assessment reads as concluding until the draft lands. Does not set reliance
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conclusion/accept": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Accept the drafted conclusion
     * @description Promote the AI-drafted rating and justification to the live conclusion
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/control-oe/{control_oe_id}/conclusion/draft": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Discard the drafted conclusion
     * @description Drop the AI-drafted conclusion, leaving the live one untouched
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {control_oe_id: components["schemas"]["ControlOeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create assessment
     * @description Create a new risk assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAssessment"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Assessment"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Search assessments
     * @description Search assessments with filters
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FilterAssessments"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Assessment"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get assessment
     * @description Get a specific assessment by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Assessment"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete assessment
     * @description Delete an assessment
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Export assessment
     * @description Export assessment data to file
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/agent_session": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Start assessment agent session
     * @description Start an agent session for an assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/continue": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Continue assessment
     * @description Run the next automated step, re-suggesting outdated decisions first
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        /** @description What continuing an assessment did. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentContinueOutcome"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/risks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List risks
     * @description Get all risks for an assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["RiskMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create risk
     * @description Create a new risk for an assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateRisk"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Risk"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/findings": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List findings
     * @description Get all findings for an assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FindingMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create finding
     * @description Create a new finding for an assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFinding"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FindingId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign assessment
     * @description Assign assessment to owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/status": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update assessment status
     * @description Update the status of an assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AssessmentStatus"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * List tasks
     * @description List conflicting background tasks for an proposed assessment lock
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Represents what part of an assessment is locked by a background task.
       *     This is the deserialized form that combines the discriminator column
       *     with the optional identifier columns.
       *
       *     # Adding New Variants
       *     When adding a new variant to this enum, you MUST also:
       *     1. Add a corresponding CHECK constraint in the `assessment_tasks` table
       *        (see migration `20260121145836_assessment_tasks.up.sql`)
       *     2. Add a corresponding variant to `AssessmentLockType`
       *     3. Update the `lock_type()`, `control_id()`, and `scope_id()` methods below
       */
      requestBody: {content: {"application/json": components["schemas"]["AssessmentLock"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/automation_overlay": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update assessment automation overlay
     * @description Set or clear the automation overlay. Pass a step index (0–3) to enable the overlay at that step, or null to disable it.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": number | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/decisions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk decide
     * @description Make bulk decisions on assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateAssessmentDecision"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/nodes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List nodes
     * @description Get all nodes for an assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentNode"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/assessment_control_ids": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List assessment control IDs
     * @description Get all assessment control IDs for an assessment
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentControlId"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/controls": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add custom control
     * @description Add a custom control to an assessment
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateCustomControlRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessedControl"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/controls/{assessment_control_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove control
     * @description Remove a control from an assessment
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          assessment_id: components["schemas"]["AssessmentId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/control_instances": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List control instances
     * @description List an assessment's control instances projected to their framework control and mapped process step, for the control assignment page
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentControlInstance"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/predefined_controls": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add predefined control
     * @description Add one instance of a framework control to an assessment, optionally mapped to a process step
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AddPredefinedControl"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["AssessmentControlId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/map_step_controls": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Map controls to process steps
     * @description Map the framework's controls onto the audit area's process steps with AI
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {assessment_id: components["schemas"]["AssessmentId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessed_controls/{assessment_control_id}/process_steps/{process_step_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Map control to process step
     * @description Map a control instance to a process step
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          process_step_id: components["schemas"]["ProcessStepId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Unmap control from process step
     * @description Remove a control instance's mapping to a process step, leaving the control on the assessment
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          process_step_id: components["schemas"]["ProcessStepId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessed_controls/load_by_ids": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load assessed controls by IDs
     * @description Load assessed controls by assessment_control_id
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AssessmentControlId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["AssessedControl"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/source_extracts/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load source extracts
     * @description Load source extracts in bulk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SourceExtractId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["SourceExtract"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get report
     * @description Get assessment report HTML
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download report
     * @description Download assessment report as file
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}/download_docx": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download report as DOCX
     * @description Download assessment report as DOCX file
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}/download_xlsx": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download report as XLSX
     * @description Download assessment report as XLSX file
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}/publish": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Publish report to portal
     * @description Create an immutable snapshot of the report for the client portal
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalReportSnapshotId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assessments/{assessment_id}/report/{report_template_id}/snapshots": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List report snapshots
     * @description List portal report snapshots for an assessment report
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_id: components["schemas"]["AssessmentId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalReportSnapshot"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/report_snapshots/{portal_report_snapshot_id}/published": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set snapshot published
     * @description Toggle the published status of a portal report snapshot
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/report_snapshots/{portal_report_snapshot_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete snapshot
     * @description Soft-delete a portal report snapshot
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{assessment_control_id}/reviews": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create reviews
     * @description Create review requests for control
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateReviewAction"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/controls/{assessment_control_id}/evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add control citations
     * @description Create source extracts for a control and return their citations
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RecordControlCitation"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Citation"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/scopes/{scope_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get scope
     * @description Get a specific TPRM scope by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["TprmScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TprmScopeMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * [INTERNAL] Delete scope
     * @description Delete a scope and soft-delete every source in it
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["TprmScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/scopes/{scope_id}/sources": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create sources
     * @description Create multiple sources for a scope
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; skip_invalidation?: boolean};
        header?: never;
        path: {scope_id: components["schemas"]["TprmScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateSource"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SourceMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/scopes/{scope_id}/merge": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Merge a scope
     * @description Move every source into another scope, then delete this one
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {scope_id: components["schemas"]["TprmScopeId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Must be a live scope in the same engagement as the one being merged away. */
      requestBody: {content: {"application/json": components["schemas"]["MergeScope"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/scopes/{scope_id}/sources/{risk_or_control}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List sources
     * @description List sources for a scope filtered by visibility
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          risk_or_control: components["schemas"]["TprmScopeVisibility"];
          scope_id: components["schemas"]["TprmScopeId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SourceMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List questionnaire models
     * @description Get all questionnaire models
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireModel"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create questionnaire model
     * @description Create a new questionnaire model
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTprmQuestionnaireModel"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireModelId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get questionnaire model
     * @description Get a specific questionnaire model by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireModel"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List questionnaire templates
     * @description Get all questionnaire templates for a model
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireTemplateMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/{questionnaire_template_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get questionnaire template
     * @description Get a specific questionnaire template by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireTemplate"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete questionnaire template
     * @description Delete a questionnaire template
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/{questionnaire_template_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update template name
     * @description Update the name of a questionnaire template
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/create_from_preset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create from preset
     * @description Create questionnaire templates from preset configuration
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PresetQuestionnaireTemplate"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/preset_schemas/{kind}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get preset upload JSON Schema
     * @description Return the JSON Schema for the payload accepted by the matching internal create-from-preset endpoint, so the upload UI can validate JSON live.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {kind: components["schemas"]["PresetSchemaKind"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": {[key: string]: IValue}}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List external questionnaires
     * @description List every external questionnaire in the account, across engagements
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaireMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create external questionnaire
     * @description Create a new external questionnaire
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTprmExternalQuestionnaire"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaire"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get external questionnaire
     * @description Get a specific external questionnaire by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaire"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete external questionnaire
     * @description Delete an external questionnaire
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/unlock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unlock external questionnaire
     * @description Unlock an external questionnaire for editing
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QuestionnaireNotifyClientRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/lock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Lock external questionnaire
     * @description Lock an external questionnaire to prevent changes
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/client_visibility": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set external questionnaire client visibility
     * @description Show or hide an external questionnaire (and its sub-questionnaires) from the third-party client
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/release": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Release external questionnaire to client
     * @description Move a questionnaire out of the auditor-scoping phase and notify the client
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["QuestionnaireNotifyClientRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/auditor_answers/{question_template_id}/text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /** Update auditor scoping text answer */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/auditor_answers/{question_template_id}/select": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /** Update auditor scoping select answer */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string[]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/external_questionnaires/{external_questionnaire_id}/auditor_answers/{question_template_id}/not_applicable": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /** Update auditor scoping not-applicable flag */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risks/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load risks
     * @description Load multiple risks by ID pairs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RiskIdPair"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["Risk"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risks/{risk_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign risk
     * @description Assign a risk to an owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {risk_id: components["schemas"]["RiskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risks/{risk_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete risk
     * @description Delete a risk
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {risk_id: components["schemas"]["RiskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risks/{risk_id}/contexts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add risk context
     * @description Add context to a risk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {risk_id: components["schemas"]["RiskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateRiskContext"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["RiskContextId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risk_contexts/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load risk contexts
     * @description Load multiple risk contexts by IDs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RiskContextId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["RiskContext"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/risks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk update risks
     * @description Perform bulk operations on risks
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["BulkRiskUpdate"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/risks/{risk_id}/reviews": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create risk reviews
     * @description Create review requests for a risk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {risk_id: components["schemas"]["RiskId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateReviewAction"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/findings/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load findings
     * @description Load multiple findings by ID pairs
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FindingIdPair"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["Finding"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/findings/{finding_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /** Delete finding */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {finding_id: components["schemas"]["FindingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/findings/{finding_id}/update_include_internal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update include internal
     * @description Update whether this finding is shown in the internal report
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {finding_id: components["schemas"]["FindingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/findings/{finding_id}/update_include_client_facing": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update include client-facing
     * @description Update whether this finding is shown in the client-facing report
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {finding_id: components["schemas"]["FindingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/report_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List report templates
     * @description Get all report templates
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmReportTemplate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create report template
     * @description Create a new report template
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTprmReportTemplate"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmReportTemplateId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/report_templates/{report_template_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete report template
     * @description Delete a report template
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/report_templates/{report_template_id}/portal_enabled": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update portal enabled
     * @description Enable or disable a report template for the client portal
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": null}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/report_template_prompt_registry": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Report template prompt registry
     * @description Static map of report template type -> the AI prompts that type uses. Drives both the create-template UI and the export pipeline.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": {[key: string]: components["schemas"]["ReportPromptDefinition"][]}};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assets": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List assets
     * @description Get all TPRM assets
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TprmAsset"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create asset
     * @description Create a new TPRM asset
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTprmAsset"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TprmAssetId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/assets/{asset_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete asset
     * @description Delete a TPRM asset
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["TprmAssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    /**
     * Update asset
     * @description Update a TPRM asset
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {asset_id: components["schemas"]["TprmAssetId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateTprmAsset"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/operational_contexts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create operational context
     * @description Create a new operational context
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateOperationalContext"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["OperationalContextId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/operational_contexts/{operational_context_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get operational context
     * @description Get a specific operational context by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          operational_context_id: components["schemas"]["OperationalContextId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["OperationalContext"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete operational context
     * @description Delete an operational context
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          operational_context_id: components["schemas"]["OperationalContextId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    /**
     * Update operational context
     * @description Update an operational context
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          operational_context_id: components["schemas"]["OperationalContextId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateOperationalContext"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/operational_contexts/{operational_context_id}/assets/{asset_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Link asset
     * @description Link an asset to an operational context
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          asset_id: components["schemas"]["TprmAssetId"];
          operational_context_id: components["schemas"]["OperationalContextId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Unlink asset
     * @description Unlink an asset from an operational context
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          asset_id: components["schemas"]["TprmAssetId"];
          operational_context_id: components["schemas"]["OperationalContextId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create engagement
     * @description Create a new engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateEngagementRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Engagement"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/search": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Search engagements
     * @description Search engagements with filters
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FilterArgs"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated5"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get engagement
     * @description Get a specific engagement by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Engagement"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete engagement
     * @description Delete a engagement by ID
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/scopes": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List scopes
     * @description Get all scopes for a engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmScopeMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create scope
     * @description Create a new scope for a engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateTprmScope"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TprmScopeMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/scopes/badges": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List scope badges
     * @description Get source error counts per scope for a engagement. Only scopes with at least one source in error state are returned; a missing entry implies a zero count.
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ScopeBadge"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/diagrams": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List diagrams
     * @description Get all diagrams for a engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["DiagramMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create diagram
     * @description Create a new diagram, optionally with AI generation
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateDiagram"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["DiagramMin"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/understandings": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List audit areas
     * @description Get all audit areas for a engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UnderstandingMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create audit area
     * @description Create a new audit area, triggering AI generation
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateUnderstanding"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UnderstandingMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/external_questionnaires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List external questionnaires
     * @description Get all external questionnaires for a engagement
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaireMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Rename engagement
     * @description Rename a engagement by ID
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign engagement
     * @description Assign engagement to owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/status": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement status
     * @description Update the status of a engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["EngagementStatus"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/engagement_window_start": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement window start
     * @description Update the engagement window start date
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/engagement_window_end": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement window end
     * @description Update the engagement window end date
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DateTime"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/engagement_type": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement type
     * @description Update the engagement type
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/external_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement external ID
     * @description Update the external ID of an engagement
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/automation_overlay": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update engagement automation overlay
     * @description Set or clear the manual automation overlay on an engagement. Pass `true` to mark the engagement as automating, or `false` to clear it.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/trigger_automation": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Trigger engagement automation
     * @description Enable the automation overlay on an engagement. Unlike the automation_overlay endpoint, this does not require internal access and can only enable (not disable) the overlay.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * List engagement tasks
     * @description List engagement tasks that would conflict with a provided lock
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Represents what part of an engagement is locked by a background task.
       *     This is the deserialized form that combines the discriminator column
       *     with the optional identifier columns.
       *
       *     # Adding New Variants
       *     When adding a new variant to this enum, you MUST also:
       *     1. Add a corresponding CHECK constraint in the `engagement_tasks` table
       *     2. Add a corresponding variant to `EngagementLockType`
       *     3. Update the accessor methods below
       */
      requestBody: {content: {"application/json": components["schemas"]["EngagementLock"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EngagementTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/deletable": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Can delete engagement
     * @description Evaluate whether it is possible to delete a engagement by ID; it shouldn't be attached to any assessments
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": boolean}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/report/{report_template_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get engagement report
     * @description Generate and return an engagement-level report as HTML
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/report/{report_template_id}/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Export engagement report
     * @description Export an engagement-level report to PDF as a background task
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          report_template_id: components["schemas"]["TprmReportTemplateId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagement_templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /** List engagement templates */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["EngagementTemplate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /** Replace engagement templates */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpsertEngagementTemplate"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get understanding
     * @description Get an understanding by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Understanding"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete understanding
     * @description Soft delete an understanding
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/diagrams": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List understanding diagrams
     * @description Get all diagrams for an understanding
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["DiagramMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update understanding name
     * @description Update the name of an understanding
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/summary": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update understanding summary
     * @description Update the summary of an understanding
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/context": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update understanding context
     * @description Update the context of an understanding
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign understanding
     * @description Assign understanding to owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Export understanding
     * @description Export an understanding to PDF
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/generate": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Generate understanding
     * @description Trigger generation of an understanding's content
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/create-data-room-source": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create data room source from understanding
     * @description Internal: export understanding to PDF and add it as a data room source
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateDataRoomSourceRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/hidden": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update understanding hidden
     * @description Set whether an understanding is hidden from external view
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understanding-summary-evidence/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load understanding summary evidence
     * @description Load understanding summary evidence in bulk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UnderstandingSummaryEvidenceId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["UnderstandingSummaryEvidence"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/summary-evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List understanding summary evidence
     * @description List all evidence for an understanding summary
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["UnderstandingSummaryEvidence"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Add understanding summary evidence
     * @description Add evidence to an understanding summary
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RecordUnderstandingSummaryEvidence"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/summary-evidence/{understanding_summary_evidence_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update understanding summary evidence
     * @description Update evidence for an understanding summary
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          understanding_id: components["schemas"]["UnderstandingId"];
          understanding_summary_evidence_id: components["schemas"]["UnderstandingSummaryEvidenceId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateUnderstandingSummaryEvidence"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/steps": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List process steps
     * @description List an understanding's process steps in display order
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ProcessStep"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create process step
     * @description Add a process step at the end of an understanding's step list
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {understanding_id: components["schemas"]["UnderstandingId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ProcessStepContent"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ProcessStepId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/steps/{process_step_id}/reorder": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reorder process step
     * @description Move a process step to a new position in the ordering
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          process_step_id: components["schemas"]["ProcessStepId"];
          understanding_id: components["schemas"]["UnderstandingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": number}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/steps/{process_step_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete process step
     * @description Delete a process step
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          process_step_id: components["schemas"]["ProcessStepId"];
          understanding_id: components["schemas"]["UnderstandingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    /**
     * Update process step
     * @description Update a process step's name and description
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          process_step_id: components["schemas"]["ProcessStepId"];
          understanding_id: components["schemas"]["UnderstandingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateProcessStep"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/understandings/{understanding_id}/steps/{process_step_id}/activities": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List process step activity
     * @description Get a process step's edit history, newest first
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          process_step_id: components["schemas"]["ProcessStepId"];
          understanding_id: components["schemas"]["UnderstandingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Activity"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/process_step_property_config": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update process-step property config
     * @description Replace the account-wide definitions of the custom properties recorded against process steps
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ProcessStepPropertyConfig"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/account_preferences": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update audit account preferences
     * @description Replace the account-wide preferences for the audit product (admin only)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TprmAccountPreferences"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get diagram
     * @description Get a diagram by ID
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Diagram"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    /**
     * Update diagram
     * @description Update a diagram
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateDiagram"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete diagram
     * @description Soft delete a diagram
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/relayout": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Re-layout diagram
     * @description Recompute node positions, connection anchors and lane bounds using the diagram's layout algorithm, preserving entity IDs. Discards manual positioning and connection waypoints.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Diagram"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update diagram name
     * @description Update the name of a diagram
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update diagram description
     * @description Update the description of a diagram
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/summary": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update diagram summary
     * @description Update the summary of a diagram
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/owner": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Assign diagram
     * @description Assign diagram to owner
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["OwnerId"] | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/lanes_enabled": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update diagram lanes enabled
     * @description Enable or disable lanes on a diagram
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/import_from_preset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * [INTERNAL] Import diagram from preset
     * @description Import a diagram from its preset JSON representation
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PresetDiagram"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/understanding-diagram-evidence/load": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Bulk load diagram evidence
     * @description Load understanding diagram evidence in bulk
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["DiagramEvidenceId"][]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": (components["schemas"]["DiagramEvidence"] | null)[]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List diagram evidence
     * @description List all evidence for a diagram
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DiagramEvidence"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Add diagram evidence
     * @description Add evidence to a diagram
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {diagram_id: components["schemas"]["DiagramId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RecordDiagramEvidence"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/diagrams/{diagram_id}/evidence/{diagram_evidence_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update diagram evidence
     * @description Update evidence for a diagram
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          diagram_evidence_id: components["schemas"]["DiagramEvidenceId"];
          diagram_id: components["schemas"]["DiagramId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateDiagramEvidence"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/standard_findings": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /** List standard findings */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["StandardFinding"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /** Create standard findings */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateStandardFinding"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/standard_findings/{standard_finding_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /** Delete standard finding */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          standard_finding_id: components["schemas"]["StandardFindingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    /** Update standard finding */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          standard_finding_id: components["schemas"]["StandardFindingId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["UpdateStandardFinding"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/populations": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List populations
     * @description List an engagement's populations
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PopulationMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create population
     * @description Create an empty draft population; its sources and prompt are edited in place, and extraction starts when it is extracted
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for creating a population. Creation only inserts the row, so a name —
       *     itself just a placeholder the frontend supplies — is the whole input.
       *     Sources, agent prompt, description and fields are edited in place on the
       *     resulting draft, and Extract commits it.
       */
      requestBody: {content: {"application/json": components["schemas"]["CreatePopulation"]}};
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get population
     * @description Get a population with its resolved source and processing state
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete population
     * @description Soft-delete a population
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/rows": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List population rows
     * @description Get a population's extracted rows, offset-paginated
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated6"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update population name
     * @description Rename a population
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for renaming a population. Bounds the name to the same length as
       *     [`CreatePopulation::name`].
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdatePopulationName"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update population description
     * @description Set a population's description (null clears it)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for setting a population's description. `None` clears it to NULL; the
       *     database has no empty-string representation of "no description", so a caller
       *     wanting to remove the text sends `null` rather than `""`.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdatePopulationDescription"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/agent-prompt": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update population agent prompt
     * @description Update a population's agent prompt (null clears it)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string | null}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/extract": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Extract a population
     * @description Pin the population's sources, commit it, and run extraction, which replaces any data a previous run left. Rejected when the population has no sources or is locked.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/sources": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add population sources
     * @description Add existing data-room sources to a population
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SourceId"][]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/sources/{source_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove a population source
     * @description Remove a source from a population; the source stays in the data room
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          population_id: components["schemas"]["PopulationId"];
          source_id: components["schemas"]["SourceId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/fields": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Set population fields
     * @description Replace a population's field schema; columns removed from the schema are stripped from every row
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["PopulationField"][]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/samples": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List a population's samples
     * @description List the live samples drawn from a population (its Linked samples)
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SampleMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/clone": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Clone population
     * @description Mint a second population over the same sources, named "<name> (copy)", and extract it. The description and agent prompt carry over; the fields, rows, samples and lock do not. Available while the population is locked.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/lock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Lock population
     * @description Lock a population: its name, description, sources, fields and data are frozen until it is unlocked. A population drawn from is already locked, and locking it again changes nothing.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/populations/{population_id}/unlock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unlock population
     * @description Release a population's lock, the only way it is released. The samples drawn from it are left as they are.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {population_id: components["schemas"]["PopulationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A population and its resolved source snapshots. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Population"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/samples": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List samples
     * @description List an engagement's samples
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SampleMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create sample
     * @description Mint a draft sample, optionally over a population; the population is edited in place and sampling starts when the sample is drawn
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for creating a sample. Creation only inserts the row; the description
       *     is set afterwards through [`UpdateSampleDescription`].
       *
       *     The population is optional and, when given, only pre-attached: either way the
       *     choice stays open through [`UpdateSamplePopulation`], as the method does
       *     through [`UpdateSampleMethod`], until the sample is locked.
       */
      requestBody: {content: {"application/json": components["schemas"]["CreateSample"]}};
      responses: {
        /** @description A sample and its resolved source population. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Sample"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get sample
     * @description Get a sample with its source population and processing state
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A sample and its resolved source population. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Sample"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete sample
     * @description Soft-delete a sample; the population it was drawn from stays locked
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/items": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List sample items
     * @description Get a sample's materialized items, offset-paginated
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated7"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Export sample
     * @description Write a sample's drawn items to a CSV file and return its id. Rejected until the sample has finished being drawn.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["FileId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update sample name
     * @description Rename a sample
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for renaming a sample. Bounds the name to the same length as
       *     [`CreateSample::name`].
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateSampleName"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update sample description
     * @description Set a sample's description (null clears it)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for setting a sample's description. `None` clears it to NULL; the
       *     database has no empty-string representation of "no description", so a caller
       *     wanting to remove the text sends `null` rather than `""`.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateSampleDescription"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/population": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update sample population
     * @description Point a sample at a population, attaching one or replacing the one it has. A drawn sample, or one mid-draw, returns to draft and loses its items. Rejected while the sample is locked, unless it names the population the sample already has, which changes nothing.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for pointing a sample at a population. A drawn sample's items are
       *     pointers into its population's rows and cannot be re-aimed, so re-pointing
       *     returns the sample to draft for a fresh draw.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateSamplePopulation"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/method": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update sample method
     * @description Choose a sample's sampling method and size, whether or not it has been drawn. Rejected while the sample is locked.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for choosing a sample's method and size, whether or not it has been
       *     drawn.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateSampleMethod"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/draw": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Draw a sample
     * @description Commit the sample and materialize its items from its population. A sample that already holds items is drawn again, replacing them. Rejected while the sample is locked or already being drawn, when no population is attached, when the population has not finished extracting, and when the design still describes the items the sample holds.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A sample and its resolved source population. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Sample"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/tests": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List a sample's tests
     * @description List the live tests that pin a sample (its Linked tests)
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TestMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/lock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Lock sample
     * @description Lock a sample: its name and description are frozen until it is unlocked. A sample a test has frozen a copy of is already locked, and locking it again changes nothing.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A sample and its resolved source population. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Sample"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/samples/{sample_id}/unlock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unlock sample
     * @description Release a sample's lock, the only way it is released. The tests that froze a copy of it are left as they are.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {sample_id: components["schemas"]["SampleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A sample and its resolved source population. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Sample"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/tests": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List tests
     * @description List an engagement's tests
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TestMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create test
     * @description Mint a draft test, optionally over a sample and a template; both are edited in place and the frozen snapshot is taken when the test is made ready
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for creating a test. Creation only inserts the row; the description is
       *     set afterwards through [`UpdateTestDescription`].
       *
       *     Both references are optional and, when given, pre-attached: `sample_id`
       *     names the sample, `test_template_id` the template whose latest version the
       *     draft pins. Both stay open through the attach endpoints until the test is
       *     made ready.
       */
      requestBody: {content: {"application/json": components["schemas"]["CreateTest"]}};
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get test
     * @description Get a test with its resolved sample, template, config, and per-step state
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    /**
     * Delete test
     * @description Soft-delete a test; the sample it froze a copy of stays locked
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/items": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List test items
     * @description Get a test's materialized items with extracted data, results, and evidence
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null; limit?: number | null; offset?: number | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Paginated8"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/name": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update test name
     * @description Rename a test
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for renaming a test. Bounds the name to the same length as
       *     [`CreateTest::name`].
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateTestName"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/description": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update test description
     * @description Set a test's description (null clears it)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for setting a test's description. `None` clears it to NULL; the
       *     database has no empty-string representation of "no description", so a caller
       *     wanting to remove the text sends `null` rather than `""`.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateTestDescription"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/conclusion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Update test conclusion
     * @description Write either half of the auditor's conclusion, leaving an absent half as it stands, or withdraw both. The generated conclusion is left untouched either way.
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description How an auditor changes a test's conclusion — the human lane of
       *     [`Test::conclusion`]. The generated lane is not reachable from here.
       *
       *     [`Self::Set`] is a changeset over the two halves: an absent field — or an
       *     explicit `null`, there being no per-field withdrawal to confuse it with —
       *     leaves that half as it stands, so either half may be claimed on its own.
       *     Claiming neither is refused; it would restamp the lane for nothing.
       *
       *     [`Self::ResetToAi`] is whole-lane and the only way to unclaim a half.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpdateTestConclusion"]}};
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/criteria/{criterion_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Upsert test criterion
     * @description Override or add a single criterion in a test's config
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          criterion_id: components["schemas"]["TestCriterionId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for upserting a single criterion into a test's config override — set as
       *     a present (`Some`) entry keyed by the path's id. Covers both overriding a
       *     template criterion and adding a new one; the criterion id comes from the URL.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpsertTestCriterion"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete test criterion
     * @description Remove a single criterion from a test's resolved config
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          criterion_id: components["schemas"]["TestCriterionId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/criteria/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset test criteria
     * @description Return a test's criteria to its pinned template's, leaving its extraction fields untouched
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/extraction-fields/{field_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    /**
     * Upsert test extraction field
     * @description Override or add a single extraction field in a test's config
     */
    put: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          field_id: components["schemas"]["TestExtractionFieldId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description Input for upserting a single extraction field into a test's config override —
       *     set as a present (`Some`) entry keyed by the path's id. Covers both
       *     overriding a template field and adding a new one; the field id comes from the
       *     URL.
       */
      requestBody: {content: {"application/json": components["schemas"]["UpsertTestExtractionField"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    post?: never;
    /**
     * Delete test extraction field
     * @description Remove a single extraction field from a test's resolved config
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          field_id: components["schemas"]["TestExtractionFieldId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/extraction-fields/reset": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reset test extraction fields
     * @description Return a test's extraction fields to its pinned template's, leaving its criteria untouched
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/sample": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Change test sample
     * @description Point a test at a sample. A draft only takes the reference; a ready test is re-pinned (wipes downstream + re-materializes).
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Body for the change-sample endpoint. */
      requestBody: {content: {"application/json": components["schemas"]["ChangeSampleBody"]}};
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/template": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Change test template
     * @description Point a draft test at a template, attaching one or replacing the one it has: pins its latest version and seeds the test's config against it. Rejected once the test has been made ready.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Names the template, not one of its versions: the attach pins the head as
       *     it stands.
       */
      requestBody: {content: {"application/json": components["schemas"]["ChangeTemplateBody"]}};
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/ready": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Make a test ready
     * @description Commit the test: materialize a frozen snapshot of its sample, leaving the template pin and config as the draft shaped them. Rejected when the sample is missing or has not finished being drawn, when the resolved procedure has no criterion, or when it is already ready.
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/lock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Lock test
     * @description Mark a test done (soft-blocks edits and AI actions)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/unlock": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unlock test
     * @description Re-open a locked test
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/evidence": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List test evidence
     * @description List a test's attached evidence sources with their mapped-item counts
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TestEvidence"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Attach test evidence
     * @description Attach evidence sources and start auto-mapping them to items
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /**
       * @description Input for attaching evidence sources to a test (lands in the tray, carrying
       *     no claim about which items the sources document). `(test_id, source_id)` is
       *     unique and the attach is all-or-nothing, so one already-attached source
       *     rejects the whole request.
       */
      requestBody: {content: {"application/json": components["schemas"]["AttachTestEvidence"]}};
      responses: {
        /**
         * @description A test with its resolved sample, template, and config. `criteria`,
         *     `extraction_fields`, and `levels` are the *resolved* values (override applied
         *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
         *     is none, via [`resolve_config`]).
         */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Test"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/evidence/{evidence_id}/map": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Map test evidence
     * @description Map an evidence row to a sample item
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          evidence_id: components["schemas"]["TestEvidenceId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description The item half of an `(evidence, item)` mapping — the evidence half comes from
       *     the path. Both the map and unmap endpoints are keyed on the pair, because one
       *     evidence source can document several items.
       */
      requestBody: {content: {"application/json": components["schemas"]["EvidenceMappingBody"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/evidence/{evidence_id}/unmap": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unmap test evidence
     * @description Withdraw the claim that an evidence row documents a sample item
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          evidence_id: components["schemas"]["TestEvidenceId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description The item half of an `(evidence, item)` mapping — the evidence half comes from
       *     the path. Both the map and unmap endpoints are keyed on the pair, because one
       *     evidence source can document several items.
       */
      requestBody: {content: {"application/json": components["schemas"]["EvidenceMappingBody"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/evidence/{evidence_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete test evidence
     * @description Remove an evidence row from the test
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {
          evidence_id: components["schemas"]["TestEvidenceId"];
          test_id: components["schemas"]["TestId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/suggest-fields": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Suggest extraction fields
     * @description Enqueue the field-suggestion step
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/extract": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Extract test data
     * @description Enqueue the extraction step over all or a subset of items
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Optional item subset for a step. `None` = all items. */
      requestBody: {content: {"application/json": components["schemas"]["RunStepArgs"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/run": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Run test results
     * @description Enqueue the criteria-evaluation step over all or a subset of items
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Optional item subset for a step. `None` = all items. */
      requestBody: {content: {"application/json": components["schemas"]["RunStepArgs"]}};
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/tests/{test_id}/conclude": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Conclude test
     * @description Enqueue the conclusion step
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_id: components["schemas"]["TestId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/engagements/{engagement_id}/test-templates": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List test templates
     * @description List an engagement's test templates
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TestTemplate"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create test template
     * @description Create an engagement-scoped test template (version 1)
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {engagement_id: components["schemas"]["EngagementId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Input for creating a template (creates version 1). */
      requestBody: {content: {"application/json": components["schemas"]["CreateTestTemplate"]}};
      responses: {
        /** @description A test template and its versions. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TestTemplate"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/test-templates/{test_template_id}/versions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add test template version
     * @description Append a new immutable version to a test template
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_template_id: components["schemas"]["TestTemplateId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description Input for appending a new version to an existing template. */
      requestBody: {content: {"application/json": components["schemas"]["CreateTestTemplateVersion"]}};
      responses: {
        /** @description A test template and its versions. */
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["TestTemplate"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/test-templates/{test_template_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete test template
     * @description Delete a test template (409 while any test pins one of its versions)
     */
    delete: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {test_template_id: components["schemas"]["TestTemplateId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description no content */
        200: {headers: {[name: string]: IValue}; content?: never};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/portal_discovery/portals": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List portals for the user in this region
     * @description Get a list of portals the user has been invited to in this region
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DiscoveredPortal"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/reviewer_roles": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List reviewer roles
     * @description Get all configurable reviewer roles for the account
     */
    get: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ReviewerRole"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    /**
     * Create reviewer role
     * @description Create a new configurable reviewer role
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateOrUpdateReviewerRole"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ReviewerRole"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/tprm/reviewer_roles/{reviewer_role_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update reviewer role
     * @description Rename a configurable reviewer role
     */
    patch: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {reviewer_role_id: components["schemas"]["ReviewerRoleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateOrUpdateReviewerRole"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    trace?: never;
  };
  "/region/{region}/api/tprm/reviewer_roles/{reviewer_role_id}/reorder": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Reorder reviewer role
     * @description Move a reviewer role to a new position in the ordering
     */
    post: {
      parameters: {
        query?: {account_id?: components["schemas"]["AccountId"] | null};
        header?: never;
        path: {reviewer_role_id: components["schemas"]["ReviewerRoleId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": number}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/conversations": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List conversations (internal)
     * @description Cross-account list of AI conversations in this region. Platformed staff only.
     */
    get: {
      parameters: {
        query?: {
          /**
           * @description Shared filter — comma-separated list of account UUIDs to restrict
           *     to. Empty / missing means "all accounts". Encoded as a single
           *     string because `axum::extract::Query` (serde_urlencoded) doesn't
           *     decode comma-separated arrays natively; we parse server-side.
           */
          account_ids?: string | null;
          executor_kind?: components["schemas"]["ConversationExecutorKind"] | null;
          /**
           * @description Shared filter — lower bound of the time window. Applied against
           *     the column named by `time_field`.
           */
          from?: components["schemas"]["DateTime"] | null;
          function?: components["schemas"]["ConversationFunctionKind"] | null;
          limit?: number | null;
          /**
           * @description The entity ID matched against `config.function.content`, as a plain
           *     UUID string (the typed refs the dashboard builds are all UUID-backed).
           */
          ref_id?: string | null;
          /**
           * @description Dashboard-specific — restrict to conversations whose function
           *     references the entity `(ref_kind, ref_id)`. Both are set together;
           *     either alone is ignored.
           */
          ref_kind?: components["schemas"]["ConversationRefKind"] | null;
          status?: components["schemas"]["ConversationStatus"] | null;
          /**
           * @description Which time-like column on the conversation `from`/`to` should
           *     filter. Dashboard-specific.
           */
          time_field?: components["schemas"]["ConversationTimeField"] | null;
          /**
           * @description Shared filter — upper bound of the time window. Applied against
           *     the column named by `time_field`.
           */
          to?: components["schemas"]["DateTime"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalConversationSummary"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/conversations/export": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Export conversations (internal)
     * @description The complete result set for the list's filter (up to a safety cap), as the source rows for the dashboard's CSV export. Platformed staff only.
     */
    get: {
      parameters: {
        query?: {
          /**
           * @description Shared filter — comma-separated list of account UUIDs to restrict
           *     to. Empty / missing means "all accounts". Encoded as a single
           *     string because `axum::extract::Query` (serde_urlencoded) doesn't
           *     decode comma-separated arrays natively; we parse server-side.
           */
          account_ids?: string | null;
          executor_kind?: components["schemas"]["ConversationExecutorKind"] | null;
          /**
           * @description Shared filter — lower bound of the time window. Applied against
           *     the column named by `time_field`.
           */
          from?: components["schemas"]["DateTime"] | null;
          function?: components["schemas"]["ConversationFunctionKind"] | null;
          limit?: number | null;
          /**
           * @description The entity ID matched against `config.function.content`, as a plain
           *     UUID string (the typed refs the dashboard builds are all UUID-backed).
           */
          ref_id?: string | null;
          /**
           * @description Dashboard-specific — restrict to conversations whose function
           *     references the entity `(ref_kind, ref_id)`. Both are set together;
           *     either alone is ignored.
           */
          ref_kind?: components["schemas"]["ConversationRefKind"] | null;
          status?: components["schemas"]["ConversationStatus"] | null;
          /**
           * @description Which time-like column on the conversation `from`/`to` should
           *     filter. Dashboard-specific.
           */
          time_field?: components["schemas"]["ConversationTimeField"] | null;
          /**
           * @description Shared filter — upper bound of the time window. Applied against
           *     the column named by `time_field`.
           */
          to?: components["schemas"]["DateTime"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description The export for one region: its rows, plus whether the server's safety cap
         *     clipped them (so the dashboard can warn rather than present a silently
         *     short CSV as complete).
         */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalConversationExport"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/conversations/{conversation_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get conversation (internal)
     * @description Returns a single conversation with its full event log. Platformed staff only.
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {conversation_id: components["schemas"]["ConversationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Detail payload for a single conversation, with its event log. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalConversation"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/conversations/counters": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get conversation counters (internal)
     * @description The volatile counters (status, event count, token totals) for a batch of conversations named by the comma-separated `ids` query param — refetched by the live dashboard when events land, coalescing a burst into one call. A GET so it runs read-only. IDs absent from this region are omitted. Platformed staff only.
     */
    get: {
      parameters: {
        query?: {
          /**
           * @description Comma-separated conversation IDs. Encoded as one string because
           *     `axum::extract::Query` doesn't decode arrays natively.
           */
          ids?: string | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalConversationCounters"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/conversations/{conversation_id}/retire": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Retire conversation (internal)
     * @description Detaches the conversation from its idempotency slot so the caller's next attempt starts a fresh conversation. Returns the updated conversation. Platformed staff only.
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {conversation_id: components["schemas"]["ConversationId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Detail payload for a single conversation, with its event log. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalConversation"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/llm-shim-journal": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List CompleteChat shim journal entries (internal)
     * @description Cross-account list of shim-path LLM calls journalled in this region. Metadata only; fetch payloads per row. Platformed staff only.
     */
    get: {
      parameters: {
        query?: {
          /**
           * @description Shared filter — comma-separated list of account UUIDs to restrict
           *     to. Empty / missing means "all accounts". Encoded as a single
           *     string because `axum::extract::Query` (serde_urlencoded) doesn't
           *     decode comma-separated arrays natively; we parse server-side.
           */
          account_ids?: string | null;
          /** @description Shared filter — lower bound on `created_at`. */
          from?: components["schemas"]["DateTime"] | null;
          /**
           * @description Case-insensitive substring match on `label`. `%` and `_` act as
           *     SQL wildcards.
           */
          label?: string | null;
          limit?: number | null;
          /** @description Restrict to rows with this outcome. Missing means "all rows". */
          outcome?: components["schemas"]["LlmShimJournalOutcome"] | null;
          /** @description Shared filter — upper bound on `created_at`. */
          to?: components["schemas"]["DateTime"] | null;
        };
        header?: never;
        path: {region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalLlmShimJournalEntry"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/api/internal/llm-shim-journal/{llm_shim_journal_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get CompleteChat shim journal payloads (internal)
     * @description Full request/response payloads for one journal row. Platformed staff only.
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {llm_shim_journal_id: components["schemas"]["LlmShimJournalId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Full payloads of one journal row. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["InternalLlmShimJournalPayload"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/mail_subscription/{mail_subscription_id}/verify": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Verify subscription
     * @description Verify a mail subscription with a one-time token
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          mail_subscription_id: components["schemas"]["MailSubscriptionId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/unsubscribe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Unsubscribe
     * @description Unsubscribe from mail notifications
     */
    post: {
      parameters: {query?: never; header?: never; path: {region: components["schemas"]["Region"]}; cookie?: never};
      requestBody: {content: {"application/json": components["schemas"]["UnsubscribeRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/whoami": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get external user info
     * @description Get information about the externally authenticated user
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ExternalWhoAmIResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/login": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * External login
     * @description Log in with external credentials
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/logout": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * External logout
     * @description Log out of external session
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/language": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set external user language
     * @description Update the external user's language preference
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/pusher/user-auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Pusher user authentication for external users
     * @description Authenticate an external user for Pusher real-time messaging
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["UserAuthBody2"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/pusher/auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Pusher channel authentication for external users
     * @description Authenticate access to a private Pusher channel for external users
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["ChannelAuthBody2"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/legacy_questionnaire/{external_questionnaire_id}/third_party_id": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get legacy questionnaire third party ID
     * @description Get legacy questionnaire third party ID
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["ThirdPartyId"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/accept_invite_key": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Accept invite key
     * @description Grant the user access to this portal using the provided invite key.
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/validate_invite": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Validate invite
     * @description Validate an invite to a portal
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ValidatePortalInvitePayload"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ValidatePortalInviteResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/resend_invite": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Resend portal invite
     * @description Resend an invitation email to a portal user with an expired token
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ResendPortalInvitePayload"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ResendPortalInviteResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/engagements": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List engagements
     * @description List engagements with outstanding external questionnaires
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalEngagementOutstanding"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{engagement_id}/external_questionnaires": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List external questionnaires
     * @description List external questionnaires by engagement
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          engagement_id: components["schemas"]["EngagementId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaireMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/portal_users": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List portal users
     * @description Get portal users for a third party
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalUserMin"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get a portal
     * @description Get metadata for a third party's portal
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Portal"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/invite_user": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Invite portal user
     * @description Invite a user to a third party's portal
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["InvitePortalUser"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get external questionnaire
     * @description Get an external questionnaire for collection
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description This type is exposed to the external API. */
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaireExternal"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/template": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get questionnaire template
     * @description Get the template for an external questionnaire
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmQuestionnaireTemplate"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/update_text": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update text answer
     * @description Update a text answer for a specific question
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/update_select": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update select answer
     * @description Update a select/dropdown answer for a specific question
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": string[]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/not_applicable": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Update not applicable flag
     * @description Mark a question as not applicable or remove that marking
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": boolean}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/add_files": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add files to answer
     * @description Add file attachments to a question answer
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileId"][]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/remove_file": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Remove file from answer
     * @description Remove a file attachment from a question answer
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/add_sub_questionnaire": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add sub-questionnaire
     * @description Add a sub-questionnaire to a question answer
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmExternalQuestionnaireId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/remove_sub_questionnaire": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Remove sub-questionnaire
     * @description Remove a sub-questionnaire from a question answer
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["TprmExternalQuestionnaireId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/add_row": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Add table row
     * @description Add a row to a table
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["AddRowBody"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TprmTableRowId"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/remove_row": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Remove table row
     * @description Remove a row from a table
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["RowRefBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/set_column": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Set a table column across rows
     * @description Set or clear one column on multiple rows of a table in one request
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SetColumnBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/move_row": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Move a table row
     * @description Move a row to a new position and optionally merge column values in one request
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["MoveRowBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/move_rows": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Move a block of table rows
     * @description Move a set of rows to a new position as one contiguous block
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["MoveRowsBody"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/files": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Upload file
     * @description Upload a file for questionnaire responses
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /** @description File upload */
      requestBody: {
        content: {
          "multipart/form-data": {
            /**
             * Format: binary
             * @description The file to upload
             */
            file: string;
          };
        };
      };
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["File"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/files/upload_session/create": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Create upload session
     * @description Create a large file upload session for questionnaire responses
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["CreateFileUploadSession"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["FileUploadSessionResponse"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/files/upload_session/complete": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Complete upload session
     * @description Complete a large file upload session for questionnaire responses
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["FileUploadSessionId"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["File"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/files/{file_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download file
     * @description Download a file attachment from questionnaire responses
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          file_id: components["schemas"]["FileId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/submit": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Submit questionnaire
     * @description Submit the completed external questionnaire
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/apply_consolidated_suggestion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Apply a consolidated suggestion
     * @description Set the answer from a consolidated suggestion and mark it as applied
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ApplyConsolidatedSuggestionRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/clear_suggestion": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Clear an applied suggestion
     * @description Clear the answer and unapply the suggestion
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/consolidated_suggestions/dismiss": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Dismiss a consolidated suggestion
     * @description Hide one consolidated suggestion from future listings; does not affect already-applied answers
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /**
       * @description One row, the one the responder dismissed. An apply clears the rest of the
       *     question's answers itself.
       */
      requestBody: {content: {"application/json": components["schemas"]["DismissConsolidatedSuggestionRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/consolidated_suggestions/restore": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Restore dismissed consolidated suggestions
     * @description Bring previously-dismissed consolidated suggestions back into future listings
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["ConsolidatedSuggestionsRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/question/{question_template_id}/request_ai_feedback": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Request AI feedback
     * @description Manually trigger an AI assessment of the answer, bypassing the automatic round limit
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/answering/upload_suggestion_document": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Upload a document for suggestion
     * @description Upload a document file and trigger markdown extraction
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      /** @description File upload */
      requestBody: {
        content: {
          "multipart/form-data": {
            /**
             * Format: binary
             * @description The file to upload
             */
            file: string;
          };
        };
      };
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["File"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/answering/suggest_from_documents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Suggest questionnaire answers from documents
     * @description Trigger AI-powered suggestion generation using already-uploaded document file IDs
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/suggestions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List suggestions
     * @description List AI-generated and past-questionnaire suggestions for this questionnaire
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": {[key: string]: components["schemas"]["ConsolidatedSuggestion"][]}};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/running_tasks": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List running suggestion tasks
     * @description List pending background tasks for suggestion (generation + per-document extraction)
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PendingBackgroundTask"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/suggestion_documents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List suggestion documents
     * @description List documents uploaded for AI suggestion, with extraction task status
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["SuggestionDocument"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/suggestion_documents/{suggestion_document_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a suggestion document
     * @description Soft-delete an uploaded suggestion document
     */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/suggestion_documents/{suggestion_document_id}/retry_extraction": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Retry suggestion document extraction
     * @description Re-queue the markdown extraction background task for an uploaded suggestion document
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/questionnaire/{external_questionnaire_id}/suggestion_documents/{suggestion_document_id}/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download suggestion document
     * @description Download a source document uploaded for answer suggestions
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
          suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/reports": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List portal reports
     * @description List published report snapshots available to this third party
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["PortalReport"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal/{third_party_id}/reports/{portal_report_snapshot_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get portal report
     * @description Render a published report snapshot as HTML
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
          third_party_id: components["schemas"]["ThirdPartyId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal_discovery/regions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List the regions that the user belongs to
     * @description Get a list of region names
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Region"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/portal_discovery/portals": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List the portals that the user belongs to (either as invitee or through an affiliated account)
     * @description Get a list of portals with third_party_id, display_name, and account_slug
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DiscoveredPortal"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/favicon": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download favicon
     * @description Download the favicon for the trust center
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/documents": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List trust center documents
     * @description Get all publicly available documents from the trust center
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["DocumentExternal"][]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/config": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get trust center configuration
     * @description Get the trust center configuration and branding
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterConfigMin"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/documents/{document_id}/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download document
     * @description Download a specific document from the trust center
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          document_id: components["schemas"]["DocumentId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/documents/request_access": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Request document access
     * @description Request access to restricted documents
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      /** @description This is inserted into the database as JSONB so be careful with changes. */
      requestBody: {content: {"application/json": components["schemas"]["DocumentAccessRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/contents/{content_id}": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get content
     * @description Get specific content from the trust center
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          content_id: components["schemas"]["ContentId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterContent"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/assets/{asset_id}/download": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Download asset
     * @description Download a specific asset (logo, image, etc.)
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          asset_id: components["schemas"]["AssetId"];
          account_id: components["schemas"]["AccountId"];
          region: components["schemas"]["Region"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Downloaded file. Callers must be prepared to follow redirects when using this endpoint, as files may be served via a CDN. */
        200: {headers: {[name: string]: IValue}; content: {"*/*": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/faq": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get FAQ
     * @description Get frequently asked questions
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterFaq"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/ai_faq": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get AI-powered FAQ
     * @description Get AI-generated answers to frequently asked questions
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["TrustCenterFaq"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/graph": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get trust center graph
     * @description Get graph data for trust center visualization
     */
    get: {
      parameters: {
        query?: {
          filter_entity_ids?: components["schemas"]["EntityId"][] | null;
          filter_properties?: string[] | null;
          recursion_depth?: number | null;
          selected_properties?: string[] | null;
        };
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["SubGraph"]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/schema": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Get graph schema
     * @description Get the schema for trust center graph data
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": {[key: string]: components["schemas"]["GraphProperty"]}};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/subscribe": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Subscribe to notifications
     * @description Subscribe to trust center update notifications
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SubscribeRequest"]}};
      responses: {
        200: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["SubscriptionAction"]};
        };
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/region/{region}/external_api/accounts/{account_id}/showcase/sar": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Submit access request
     * @description Submit a subject access request (SAR)
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {account_id: components["schemas"]["AccountId"]; region: components["schemas"]["Region"]};
        cookie?: never;
      };
      requestBody: {content: {"application/json": components["schemas"]["SARRequest"]}};
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": string}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/internal/regions": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List known regions (internal)
     * @description Returns the set of regions that the cross-region internal dashboards should fan out to. Sourced from the replicated `shared.account` table. Platformed staff only.
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["Region"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/internal/accounts": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * List accounts (internal)
     * @description Cross-region list of all accounts. Powers the shared filter bar's account picker. Platformed staff only.
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        200: {headers: {[name: string]: IValue}; content: {"application/json": components["schemas"]["AccountMin"][]}};
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/internal/pusher/auth": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    get?: never;
    put?: never;
    /**
     * Authorize a realtime channel subscription
     * @description Signs the current session's subscription to a private realtime channel.
     */
    post: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody: {content: {"application/x-www-form-urlencoded": components["schemas"]["ChannelAuthBody3"]}};
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/robot.txt": {
    parameters: {query?: never; header?: never; path?: never; cookie?: never};
    /**
     * Robots.txt (restrictive)
     * @description Robots.txt file that disallows all crawlers
     */
    get: {
      parameters: {query?: never; header?: never; path?: never; cookie?: never};
      requestBody?: never;
      responses: {
        default: {
          headers: {[name: string]: IValue};
          content: {"application/json": components["schemas"]["ErrorResponse"]};
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** @enum {string} */
    AIProvider: "OpenAI" | "VertexAI" | "AnthropicViaVertexAI" | "AzureAI";
    /**
     * @description An axis-aligned bounding box, origin top-left, in the page's
     *     [`DocumentLengthUnit`].
     *
     *     Document Intelligence positions each word as a four-corner polygon that may
     *     be rotated or skewed; we collapse it to its axis-aligned bounds at ingestion.
     *     A highlight is drawn as upright rectangles regardless, so the rotation is
     *     noise the rest of the system would only have to strip again — storing the
     *     box keeps the invariant (`min <= max` on both axes) in the type instead of in
     *     a convention every reader has to re-derive from a flat coordinate list.
     */
    Aabb: {
      /** @description Largest x/y — the bottom-right corner. */
      max: components["schemas"]["Point"];
      /** @description Smallest x/y — the top-left corner. */
      min: components["schemas"]["Point"];
    };
    /** @enum {string} */
    AccessLevel: "Read" | "Write";
    /** @enum {string} */
    AccessScope: "TrustCenter" | "Collect";
    AccessToken: {
      affiliated_account_id?: components["schemas"]["AccountId"] | null;
      client_account_id: components["schemas"]["AccountId"];
      expiry: components["schemas"]["DateTime"];
      scope: components["schemas"]["AccessScope"];
      token: string;
      user_id: components["schemas"]["UserId"];
    };
    Account: {
      account_id: components["schemas"]["AccountId"];
      ai_model_config: components["schemas"]["AiModelConfig"];
      default_qa_mode: components["schemas"]["QAMode"];
      display_name: string;
      enabled_features: components["schemas"]["AccountFeature"][];
      /** Format: int32 */
      express_credits: number;
      facts_clustered_at: components["schemas"]["DateTime"];
      facts_modified_at: components["schemas"]["DateTime"];
      invalidation_channel_name: string;
      language_code: string;
      name: string;
      plan_features: components["schemas"]["AccountFeature"][];
      /**
       * @default {
       *       "properties": []
       *     }
       */
      process_step_property_config: components["schemas"]["ProcessStepPropertyConfig"];
      prompt_modifiers: components["schemas"]["PromptModifiers"];
      region: components["schemas"]["Region"];
      slug: string;
      /**
       * @default {
       *       "default_client_private": false,
       *       "require_client_external_id": false
       *     }
       */
      tprm_preferences: components["schemas"]["TprmAccountPreferences"];
      type_: components["schemas"]["AccountType"];
    };
    AccountArgs: {account_id?: components["schemas"]["AccountId"] | null};
    /** @enum {string} */
    AccountFeature:
      | "EnableAccount"
      | "Scim"
      | "SingleSignOn"
      | "MicrosoftOAuth"
      | "LLMDocumentExtraction"
      | "ShowInternalUsers"
      | "VendorToolkit"
      | "TrustCenter"
      | "Scopes"
      | "ExpressCredits"
      | "InstantAnswering"
      | "CsvImport"
      | "ResponseWizard"
      | "SpreadsheetImport"
      | "MeilisearchFactLibrary"
      | "MeilisearchQuestionAnswering"
      | "TPRM"
      | "Collect"
      | "ContextualRiskAssessment"
      | "ContextualPredefinedRisks"
      | "PortalInviteKeys"
      | "Understandings"
      | "AuditPlan"
      | "AuditPlanDemo"
      | "EntityLevelAreas"
      | "Processes"
      | "ProcessSteps"
      | "MapStepControls"
      | "AgenticControlAssessment"
      | "ReducedAiFanOut"
      | "DataRoomExactNameMatching"
      | "ThirdPartyTiers"
      | "Testing"
      | "OperatingEffectiveness"
      | "OperatingEffectivenessDemo"
      | "NewDiagrams"
      | "ComplexityRollForward"
      | "Completion";
    AccountId: Nominal<string, "AccountId">;
    AccountIdPath: {account_id: components["schemas"]["AccountId"]};
    AccountIdPath2: {account_id: components["schemas"]["AccountId"]};
    AccountMin: {
      account_id: components["schemas"]["AccountId"];
      display_name: string;
      region: components["schemas"]["Region"];
      slug: string;
      type_: components["schemas"]["AccountType"];
    };
    AccountPath: {account_id: components["schemas"]["AccountId"]};
    AccountRestriction: {login_method: components["schemas"]["LoginMethodMin"]; require_2fa: boolean};
    AccountSlugPath: {account_slug: string};
    /** @enum {string} */
    AccountType: "Live" | "Sandbox";
    AccountUser: {
      /** @description Roles granted to the user directly (i.e. removable on the user itself). */
      direct_roles: components["schemas"]["RoleMin"][];
      /** @description Roles the user inherits via team membership, with the granting team(s). */
      inherited_roles: components["schemas"]["InheritedRole"][];
      /** @description The teams the user belongs to (excluding deleted teams). */
      teams: components["schemas"]["TeamMin"][];
      user: components["schemas"]["User"];
    };
    AccountWithRestriction: {
      account: components["schemas"]["AccountMin"];
      restriction?: components["schemas"]["AccountRestriction"] | null;
    };
    AcsPayload: {RelayState?: string | null; SAMLResponse: string};
    Actioned: {at: components["schemas"]["DateTime"]; by?: components["schemas"]["UserMin"] | null};
    Activity: {
      /** Format: double */
      activity_ordinal: number;
      activity_stream_id: components["schemas"]["ActivityStreamId"];
      files: components["schemas"]["File"][];
      mentions: components["schemas"]["Mention"][];
      occurred_at: components["schemas"]["DateTime"];
      payload: components["schemas"]["ActivityPayload"];
      user?: components["schemas"]["UserMin"] | null;
    };
    /**
     * @description A rolled-up run of activity by one user, classified by kind. Either
     *     contiguous adjacent activity attributed to a single page
     *     (`pages = ClusterPages::One`), or a bulk action that touched multiple
     *     pages (`pages = ClusterPages::Many`).
     *
     *     Kind comes from the clustering CTE's CASE on payload type (and, for
     *     lock activity, the `locked` content field); runs always break when
     *     kind changes, so every cluster is homogeneous in kind by construction.
     *     A lock-then-unlock run by the same user therefore splits into a
     *     `Locked` cluster and an `Unlocked` cluster rather than a mixed one.
     */
    ActivityCluster: {
      /**
       * Format: int64
       * @description Number of activities rolled up into the cluster.
       */
      activity_count: number;
      /**
       * @description The earliest point on the timeline this cluster covers. Its
       *     `ordinal` is the cluster's stable paging cursor — immutable for the
       *     lifetime of the cluster, even while the cluster is still growing.
       */
      earliest: components["schemas"]["FeedPoint"];
      kind: components["schemas"]["ActivityKind"];
      /**
       * @description The latest point on the timeline this cluster covers. For an
       *     immutable items cluster this is fixed; for the still-open `head` it
       *     advances as new activity joins. Together with `earliest.ordinal` it
       *     brackets the cluster's rows so callers can re-fetch this cluster's
       *     contents with `cluster_bulk_actions = false` to expand it.
       */
      latest: components["schemas"]["FeedPoint"];
      /** @description The pages this cluster's activity targeted. See [`ClusterPages`]. */
      pages: components["schemas"]["ClusterPages"];
      /** @description The acting user, or `None` for system / anonymised activity. */
      user?: components["schemas"]["UserMin"] | null;
    };
    /**
     * @description The kind of activity a cluster rolls up. Derived in the clustering CTE
     *     from the payload type — and, for `AuditPlanPageLocked` and `Review`, from
     *     a nested content field — never stored on the underlying `activity` row.
     *     The SQL `CASE` is the canonical mapping; this enum just decodes the
     *     emitted string.
     *
     *     Kind is also a hard break dimension when clustering: a run of activity
     *     from one user in one bucket splits whenever the kind changes, so a user
     *     who locks a page and immediately comments on it produces two separate
     *     clusters — and a lock followed by an unlock also splits, because they
     *     resolve to different kinds. The same applies to review actions: an
     *     `Approved` followed by a `RequestChanges` splits into two clusters.
     */
    ActivityKind:
      | "Comments"
      | "ReviewApproved"
      | "ReviewChangesRequested"
      | "ReviewRequested"
      | "ReviewUnrequested"
      | "Locked"
      | "Unlocked"
      | "Changes";
    ActivityPayload:
      | {
          content: components["schemas"]["CommentPayload"];
          /** @enum {string} */
          type: "Comment";
        }
      | {
          content: components["schemas"]["QuestionCreatedPayload"];
          /** @enum {string} */
          type: "QuestionCreated";
        }
      | {
          content: components["schemas"]["QuestionUpdatedPayload"];
          /** @enum {string} */
          type: "QuestionUpdated";
        }
      | {
          content: components["schemas"]["DocumentUpdatedPayload"];
          /** @enum {string} */
          type: "DocumentUpdated";
        }
      | {
          content: components["schemas"]["AssessedControlUpdatedPayload"];
          /** @enum {string} */
          type: "AssessedControlUpdated";
        }
      | {
          content: components["schemas"]["RiskUpdatedPayload"];
          /** @enum {string} */
          type: "RiskUpdated";
        }
      | {
          content: components["schemas"]["FindingUpdatedPayload"];
          /** @enum {string} */
          type: "FindingUpdated";
        }
      | {
          content: components["schemas"]["ComplexityAssessmentUpdatedPayload"];
          /** @enum {string} */
          type: "ComplexityAssessmentUpdated";
        }
      | {
          content: components["schemas"]["ReviewPayload"];
          /** @enum {string} */
          type: "Review";
        }
      | {
          content: components["schemas"]["AuditPlanPageStatusChangedPayload"];
          /** @enum {string} */
          type: "AuditPlanPageStatusChanged";
        }
      | {
          content: components["schemas"]["AuditPlanPageLockedPayload"];
          /** @enum {string} */
          type: "AuditPlanPageLocked";
        }
      | {
          content: components["schemas"]["AuditPlanPageArchivedPayload"];
          /** @enum {string} */
          type: "AuditPlanPageArchived";
        }
      | {
          content: components["schemas"]["AuditPlanPageDeletedPayload"];
          /** @enum {string} */
          type: "AuditPlanPageDeleted";
        }
      | {
          content: components["schemas"]["ProcessStepActivityPayload"];
          /** @enum {string} */
          type: "ProcessStepUpdated";
        };
    ActivityStream: {
      activity_stream_id: components["schemas"]["ActivityStreamId"];
      channel_name: string;
      created_at: components["schemas"]["DateTime"];
      summary: components["schemas"]["ActivitySummary"];
    };
    ActivityStreamId: Nominal<string, "ActivityStreamId">;
    ActivityStreamIdPath: {activity_stream_id: components["schemas"]["ActivityStreamId"]};
    /**
     * @description A reference to an activity stream — just enough for the frontend to
     *     subscribe to its pusher channel without having to compose channel names
     *     itself.
     */
    ActivityStreamRef: {activity_stream_id: components["schemas"]["ActivityStreamId"]; channel_name: string};
    ActivitySummary: {counts: {[key: string]: number}; mentions: components["schemas"]["Owner"][]};
    /** @enum {string} */
    ActivityType:
      | "Comment"
      | "QuestionCreated"
      | "QuestionUpdated"
      | "DocumentUpdated"
      | "AssessedControlUpdated"
      | "RiskUpdated"
      | "ComplexityAssessmentUpdated"
      | "Review"
      | "FindingUpdated"
      | "AuditPlanPageStatusChanged"
      | "AuditPlanPageLocked"
      | "AuditPlanPageArchived"
      | "AuditPlanPageDeleted"
      | "ProcessStepUpdated";
    AdHocQuestion: {
      access_level: components["schemas"]["AccessLevel"];
      asker?: components["schemas"]["UserMin"] | null;
      created_at: components["schemas"]["DateTime"];
      question: components["schemas"]["Question"];
      question_source?: components["schemas"]["QuestionSourceMin"] | null;
      scope_matrix: components["schemas"]["ScopeMatrix"];
      source_url?: string | null;
    };
    AdHocQuestionTask: {adhoc_question: components["schemas"]["AdHocQuestion"]};
    AddLoginMethod:
      | {
          content: components["schemas"]["SetPassword"];
          /** @enum {string} */
          type: "UsernamePassword";
        }
      | {
          content: components["schemas"]["OAuthLoginRequest"];
          /** @enum {string} */
          type: "OAuth";
        };
    AddPredefinedControl: {
      predefined_control_id: components["schemas"]["PredefinedControlId"];
      /** @default [] */
      process_step_ids: components["schemas"]["ProcessStepId"][];
    };
    AddRowBody: {
      /**
       * @description Column values to seed the new row with (e.g. the current group).
       * @default {}
       */
      values: {[key: string]: components["schemas"]["TprmExternalColumnValue"]};
    };
    AgentConfig: {
      ai_model: components["schemas"]["AiModel"];
      auto_request: boolean;
      internal_only: boolean;
      use_data: components["schemas"]["UseData"];
      use_prompt_modifiers: boolean;
    };
    AgentSessionAiDelta:
      | {
          /** @enum {string} */
          type: "NewContentItem";
        }
      | {
          content: components["schemas"]["AiMessageOutputFunctionCall"];
          /** @enum {string} */
          type: "NewFunctionCallItem";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Content";
        }
      | {
          content: components["schemas"]["AiMessageOutputFunctionCallOutput"];
          /** @enum {string} */
          type: "FunctionCallOutput";
        }
      | {
          /** @enum {string} */
          type: "Reset";
        };
    AgentSessionEvent: {
      /** Format: double */
      ordinal: number;
      payload: components["schemas"]["AgentSessionEventPayload"];
      /** Format: int32 */
      version: number;
    };
    AgentSessionEventPayload:
      | {
          /** @enum {string} */
          type: "SavePoint";
        }
      | {
          content: components["schemas"]["AgentSessionAiDelta"];
          /** @enum {string} */
          type: "AiDelta";
        }
      | {
          /** @enum {string} */
          type: "Compacting";
        };
    AgentSessionId: Nominal<string, "AgentSessionId">;
    AgentSessionIdPath: {agent_session_id: components["schemas"]["AgentSessionId"]};
    AgentSessionMessage: {
      committed_at?: components["schemas"]["DateTime"] | null;
      created_at: components["schemas"]["DateTime"];
      files: components["schemas"]["File"][];
      interrupt: boolean;
      mentions: components["schemas"]["Mention"][];
      /** Format: double */
      ordinal: number;
      payload: components["schemas"]["AgentSessionMessagePayload"];
      user?: components["schemas"]["UserMin"] | null;
      /** Format: int32 */
      version: number;
    };
    AgentSessionMessageFilter: {
      /** Format: double */
      after_ordinal?: number | null;
      /** Format: double */
      before_ordinal?: number | null;
      committed?: boolean | null;
      /** Format: int32 */
      limit?: number | null;
    };
    AgentSessionMessagePayload:
      | {
          content: components["schemas"]["UserMessagePayload"];
          /** @enum {string} */
          type: "User";
        }
      | {
          content: components["schemas"]["AiMessagePayload"];
          /** @enum {string} */
          type: "Ai";
        };
    AgentSessionMin: {agent_session_id: components["schemas"]["AgentSessionId"]; channel_name: string};
    /** @enum {string} */
    AiFeature:
      | "QuestionAnalysis"
      | "DocumentAnalysis"
      | "AnswerGeneration"
      | "FactClustering"
      | "ConflictDetection"
      | "ReviewAnswerRelevance"
      | "ReviewAnswerAccuracy"
      | "ReviewAnswerClarity"
      | "ReviewAnswerCommercial"
      | "ReviewSummary"
      | "ReviewAnswerSupportedByFact"
      | "ReportSummary"
      | "ControlSourceSummary"
      | "RiskAreaSourceSummary"
      | "ControlAssessment"
      | "RiskControlMapping"
      | "RiskDeduplication"
      | "GenerativeRiskDiscovery"
      | "RiskStability"
      | "RiskQuantification"
      | "ImageInterpretation"
      | "DocumentExtraction"
      | "AssessComplexity"
      | "VideoTranscription"
      | "AssessQuestion"
      | "FindingGeneration"
      | "FindingStability"
      | "DiagramSourceRelevance"
      | "DiagramInformationExtraction"
      | "DiagramConstruction"
      | "DiagramStyleAssignment"
      | "SourceSummarization"
      | "SourcePreFilter"
      | "TestEvidenceMapping"
      | "TestDataExtraction"
      | "TestResultEvaluation"
      | "TestConclusion"
      | "TestFieldSuggestion"
      | "PopulationExtraction"
      | "UnderstandingContextExpansion"
      | "UnderstandingSourceExtraction"
      | "UnderstandingConstruction"
      | "UnderstandingDiagramConstruction"
      | "UnderstandingProcessSteps"
      | "ProcessStepControlMapping"
      | "DrivingSourceCompaction"
      | "SuggestFromDocuments"
      | "OperatingEffectivenessConclusion";
    AiMessageOutputContent: {content: string};
    AiMessageOutputFunctionCall: {arguments: string; call_id: string; name: string};
    AiMessageOutputFunctionCallOutput: {call_id: string; output: string};
    AiMessageOutputItem:
      | {
          content: components["schemas"]["AiMessageOutputContent"];
          /** @enum {string} */
          type: "Content";
        }
      | {
          content: components["schemas"]["AiMessageOutputFunctionCall"];
          /** @enum {string} */
          type: "FunctionCall";
        }
      | {
          content: components["schemas"]["AiMessageOutputFunctionCallOutput"];
          /** @enum {string} */
          type: "FunctionCallOutput";
        };
    AiMessagePayload: {items: components["schemas"]["AiMessageOutputItem"][]};
    /** @enum {string} */
    AiModel:
      | "Gpt4Turbo"
      | "Gpt4oStructured"
      | "Gpt4oMini"
      | "Gpt5"
      | "Gpt5Mini"
      | "Gpt5Nano"
      | "Gpt5o4"
      | "Gpt5o4Pro"
      | "Gpt5o4Mini"
      | "Gpt5o4Nano"
      | "Gpt5o5"
      | "Gpt5o5Pro"
      | "Gpt5o6Sol"
      | "Gpt5o6Terra"
      | "Gpt5o6Luna"
      | "Claude3o5SonnetV2"
      | "Claude3o5Haiku"
      | "Claude3Opus"
      | "Claude3Haiku"
      | "Gemini1o5Pro"
      | "Gemini1o5Flash"
      | "Gemini2o5Pro"
      | "Gemini2o5Flash"
      | "Gemini2o5FlashDedicated"
      | "Gemini3Pro"
      | "Gemini3Flash";
    AiModelConfig: AiModelConfig;
    AiPromptInfo: {
      category: components["schemas"]["PromptCategory"];
      custom_template?: string | null;
      default_template: string;
      description: string;
      input_variables: components["schemas"]["AiPromptInputVariable"][];
      kind: components["schemas"]["AiPromptKind"];
      label: string;
      output_schema?: IValue;
      updated?: components["schemas"]["Actioned"] | null;
    };
    AiPromptInputVariable: {description: string; name: string};
    /** @enum {string} */
    AiPromptKind:
      | "UnderstandingContextExpansion"
      | "UnderstandingSourceExtraction"
      | "UnderstandingConstruction"
      | "UnderstandingSystemConstruction"
      | "UnderstandingProcessSteps"
      | "ProcessStepControlMapping"
      | "UnderstandingProcessFlowDiagram"
      | "UnderstandingArchitectureDiagram"
      | "DiagramSourceRelevance"
      | "DiagramInformationExtraction"
      | "DiagramConstruction"
      | "DiagramStyleAssignment"
      | "ControlScopeAssessment"
      | "ControlScopeDesign"
      | "ControlScopeImplementation"
      | "ControlScopeRepresentation"
      | "ControlScopeDesignEvaluation"
      | "ControlScopeImplementationEvaluation"
      | "ControlAggregateDesignEvaluation"
      | "ControlAggregateImplementationEvaluation"
      | "ControlAggregateRepresentation"
      | "OperatingEffectivenessPlan"
      | "OperatingEffectivenessConclusion";
    AiPromptPath: {prompt: components["schemas"]["AiPromptKind"]};
    /** @enum {string} */
    AiReview: "Positive" | "Negative" | "Neutral";
    /** @enum {string} */
    AiStatus: "NotAttempted" | "NoAnswer" | "RejectedAnswer" | "AcceptedAnswer";
    AiTodoItem: {
      detail: string;
      result?: string | null;
      status: components["schemas"]["AiTodoItemStatus"];
      title: string;
    };
    /** @enum {string} */
    AiTodoItemStatus: "NotStarted" | "InProgress" | "Completed" | "Cancelled";
    /** @description Why an answer is in the history rather than applying. */
    AnswerHistoryReason: "rolled_forward" | "auditor_edit";
    AnswerOption: {allow_other_text: boolean; label: string; value: string};
    AnswerPart: {config: components["schemas"]["YesNoAnswerConfig"]; enabled: components["schemas"]["Condition"]};
    AnswerPart2: {config: components["schemas"]["SelectAnswerConfig"]; enabled: components["schemas"]["Condition"]};
    AnswerPart3: {config: components["schemas"]["TextAnswerConfig"]; enabled: components["schemas"]["Condition"]};
    AnswerPart4: {config: components["schemas"]["FilesAnswerConfig"]; enabled: components["schemas"]["Condition"]};
    AnswerParts: {
      files: components["schemas"]["AnswerPart4"];
      select: components["schemas"]["AnswerPart2"];
      text: components["schemas"]["AnswerPart3"];
      yes_no: components["schemas"]["AnswerPart"];
    };
    /** @description Who produced an answer. */
    AnswerProvenance:
      | {
          by?: components["schemas"]["UserMin"] | null;
          /** @enum {string} */
          type: "human";
        }
      | {
          /** @enum {string} */
          type: "ai";
        }
      | {
          source: components["schemas"]["RollForwardProvenance"];
          source_engagement_name?: string | null;
          /** @enum {string} */
          type: "roll_forward";
        };
    AnswerReviewPart: {comment: string; review: components["schemas"]["AiReview"]};
    AnswerReviewParts: {
      accuracy: components["schemas"]["AnswerReviewPart"];
      clarity: components["schemas"]["AnswerReviewPart"];
      commercial: components["schemas"]["AnswerReviewPart"];
      relevance: components["schemas"]["AnswerReviewPart"];
    };
    AnswerSuggestion: {
      answer: components["schemas"]["TprmExternalAnswer"];
      answer_suggestion_id: components["schemas"]["AnswerSuggestionId"];
      created_at: components["schemas"]["DateTime"];
      /**
       * @description The label question's answer (see
       *     `TprmTextAnswerConfig::use_as_questionnaire_label`) this candidate is about,
       *     when the document names one.
       */
      entity_label?: string | null;
      evidence: string;
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      /** @description Why the AI answered this way and what it was unsure about. */
      reasoning: string;
      /**
       * @description The source suggestion document, resolved at read time. Carried alongside the
       *     suggestion so the UI can label its source even after the document is
       *     deleted and no longer in the upload list.
       */
      suggestion_document: components["schemas"]["SuggestionDocumentMin"];
      suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
    };
    AnswerSuggestionId: Nominal<string, "AnswerSuggestionId">;
    Apikey: {
      account_id: components["schemas"]["AccountId"];
      apikey: string;
      apikey_id: components["schemas"]["ApikeyId"];
      created_at: components["schemas"]["DateTime"];
      name: string;
    };
    ApikeyId: Nominal<string, "ApikeyId">;
    ApplyConsolidatedSuggestionRequest: {consolidated_suggestion_id: components["schemas"]["ConsolidatedSuggestionId"]};
    ArchiveAuditPlanPages: {page_ids: components["schemas"]["AuditPlanPageId"][]};
    /**
     * @description Configures a single scope-level `ControlScopeAssessment` agent
     *     run. Identifies the (assessment, control, scope) triple that pins
     *     which sources the agent works against. Unlike Design/Implementation
     *     or Representation, the Assessment decision has no per-framework module
     *     template — the terminal shape is a fixed
     *     `{ met: bool | null, explanation }`.
     */
    AssessControlAssessmentFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    AssessControlDesignImplementationFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      mode: components["schemas"]["DesignImplementationMode"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    /**
     * @description Configures a single scope-level Representation agent run. Identifies
     *     the (assessment, control, scope) triple that pins which sources,
     *     module template, and score-level definition the agent works
     *     against.
     */
    AssessControlRepresentationFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    /** @description Input for recording, or withdrawing, the call on a note condition. */
    AssessNoteCondition: {assessment: components["schemas"]["NoteAssessment"]};
    AssessedControl: AssessedControl;
    AssessedControlUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Added";
        }
      | {
          content: components["schemas"]["ControlIdentificationChanged"];
          /** @enum {string} */
          type: "Identified";
        }
      | {
          /** @enum {string} */
          type: "Removed";
        }
      | {
          content: components["schemas"]["TprmScopeId"][];
          /** @enum {string} */
          type: "SelectedScopes";
        }
      | {
          content: components["schemas"]["RecordControlAssessmentForScope"];
          /** @enum {string} */
          type: "MetForScope";
        }
      | {
          content: components["schemas"]["RecordControlAssessment"];
          /** @enum {string} */
          type: "Met";
        }
      | {
          content: components["schemas"]["RiskId"];
          /** @enum {string} */
          type: "RelevantRiskLinked";
        }
      | {
          content: components["schemas"]["RiskId"];
          /** @enum {string} */
          type: "RelevantRiskUnlinked";
        }
      | {
          content: components["schemas"]["SourceExtractId"];
          /** @enum {string} */
          type: "CitationAdded";
        }
      | {
          content: components["schemas"]["SourceExtractId"];
          /** @enum {string} */
          type: "CitationRemoved";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationChanged"];
          /** @enum {string} */
          type: "DesignChanged";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationChanged"];
          /** @enum {string} */
          type: "ImplementationChanged";
        }
      | {
          content: components["schemas"]["ControlRepresentationChanged"];
          /** @enum {string} */
          type: "RepresentationChanged";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluated"];
          /** @enum {string} */
          type: "DesignEvaluated";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluated"];
          /** @enum {string} */
          type: "ImplementationEvaluated";
        }
      | {
          /** @enum {string} */
          type: "OEPlanEdited";
        }
      | {
          /** @enum {string} */
          type: "OEConcluded";
        }
      | {
          content: components["schemas"]["Reliance"];
          /** @enum {string} */
          type: "OERelianceSet";
        }
      | {
          /** @enum {string} */
          type: "OEPlanAccepted";
        };
    Assessment: {
      agent_session?: components["schemas"]["AgentSessionMin"] | null;
      /**
       * @description If this is `None`, then the initial assessment or a reassessment is in
       *     progress.
       */
      ai_automation_finished_at?: components["schemas"]["DateTime"] | null;
      assessment_id: components["schemas"]["AssessmentId"];
      assessment_task?: components["schemas"]["PendingBackgroundTask"] | null;
      audit_area?: components["schemas"]["AuditAreaMin"] | null;
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /**
       * @description Set when AI automation stopped on an error that cannot be attributed
       *     to a single source (e.g. a provider content block on a multi-source
       *     call). Non-null renders the assessment-level error banner; cleared
       *     when automation (re)starts.
       */
      automation_error?: string | null;
      /**
       * @description When set, non-internal users see this assessment as "Automating"
       *     regardless of its real status. Internal users and API keys always see
       *     the real status.
       */
      automation_overlay_at?: components["schemas"]["DateTime"] | null;
      /**
       * Format: int32
       * @description When set, non-internal-mode users see this step value in the progress
       *     bar instead of the real step. Internal-mode users always see the real
       *     step.
       */
      automation_overlay_step?: number | null;
      completed_at?: components["schemas"]["DateTime"] | null;
      control_mode: components["schemas"]["AssessmentControlMode"];
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      driving_source?: components["schemas"]["DrivingSource"] | null;
      engagement: components["schemas"]["Engagement"];
      framework_version: components["schemas"]["FrameworkVersion"];
      has_completed_initial_assessment: boolean;
      name?: string | null;
      operational_context?: components["schemas"]["OperationalContextMin"] | null;
      owner?: components["schemas"]["Owner"] | null;
      questionnaire_stats: components["schemas"]["AssessmentQuestionnaireStats"];
      scheduled_to_run: boolean;
      status: components["schemas"]["AssessmentStatus"];
      /** Format: int32 */
      step: number;
      summary: components["schemas"]["AssessmentSummary"];
      /**
       * @description Set when the support team has been notified about a provider content
       *     block on this assessment; cleared when automation (re)starts.
       */
      support_notified_at?: components["schemas"]["DateTime"] | null;
    };
    AssessmentAssistantFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      engagement_id: components["schemas"]["EngagementId"];
    };
    /** @description What continuing an assessment did. */
    AssessmentContinueOutcome: ("Started" | "AlreadyRunning") | "AwaitingReview" | "Finished";
    AssessmentControlId: Nominal<string, "AssessmentControlId">;
    AssessmentControlIdPath: {assessment_control_id: components["schemas"]["AssessmentControlId"]};
    /**
     * @description A live control instance in an assessment, projected down to what the control
     *     assignment page needs to overlay onto the framework catalog. Custom controls
     *     (no framework control) have a `None` `predefined_control_id`.
     */
    AssessmentControlInstance: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      predefined_control_id?: components["schemas"]["PredefinedControlId"] | null;
      /** @description May include steps that have since been deleted from the understanding. */
      process_step_ids: components["schemas"]["ProcessStepId"][];
      title: string;
    };
    /** @description How an assessment's controls are populated and managed. */
    AssessmentControlMode: "Full" | "Assignment";
    AssessmentControlPath: {assessment_control_id: components["schemas"]["AssessmentControlId"]};
    AssessmentControlPath2: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
    };
    AssessmentDecision: {created: components["schemas"]["Actioned"]; was_suggested: boolean} & (
      | {
          /** @enum {string} */
          type: "SourceData";
        }
      | {
          content: components["schemas"]["ControlIdentificationContent"];
          /** @enum {string} */
          type: "ControlIdentification";
        }
      | {
          content: components["schemas"]["ControlScopeSelectionContent"];
          /** @enum {string} */
          type: "ControlScopeSelection";
        }
      | {
          content: components["schemas"]["ControlScopeAssessmentContent"];
          /** @enum {string} */
          type: "ControlScopeAssessment";
        }
      | {
          content: components["schemas"]["ControlRepresentationContent"];
          /** @enum {string} */
          type: "ControlScopeRepresentation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationContent"];
          /** @enum {string} */
          type: "ControlScopeDesign";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationContent"];
          /** @enum {string} */
          type: "ControlScopeImplementation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlScopeDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlScopeImplementationEvaluation";
        }
      | {
          content: components["schemas"]["ControlRepresentationContent"];
          /** @enum {string} */
          type: "ControlRepresentation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlImplementationEvaluation";
        }
      | {
          content: components["schemas"]["ControlAssessmentContent"];
          /** @enum {string} */
          type: "ControlAssessment";
        }
      | {
          content: components["schemas"]["IdentifiedControlsContent"];
          /** @enum {string} */
          type: "IdentifiedControls";
        }
      | {
          /** @enum {string} */
          type: "IdentifiedRisks";
        }
      | {
          content: components["schemas"]["IdentifiedRiskContent"];
          /** @enum {string} */
          type: "IdentifiedRisk";
        }
      | {
          content: components["schemas"]["RiskEvaluationContent"] | null;
          /** @enum {string} */
          type: "InherentRisk";
        }
      | {
          content: components["schemas"]["RiskRelevantControlsContent"];
          /** @enum {string} */
          type: "RiskRelevantControls";
        }
      | {
          content: components["schemas"]["RiskEvaluationContent"] | null;
          /** @enum {string} */
          type: "ResidualRisk";
        }
      | {
          content: components["schemas"]["RiskAcceptanceContent"];
          /** @enum {string} */
          type: "RiskAcceptance";
        }
      | {
          /** @enum {string} */
          type: "ControlFindings";
        }
      | {
          content: components["schemas"]["FindingContent"];
          /** @enum {string} */
          type: "Finding";
        }
    );
    AssessmentDecisionContent:
      | {
          /** @enum {string} */
          type: "SourceData";
        }
      | {
          content: components["schemas"]["ControlIdentificationContent"];
          /** @enum {string} */
          type: "ControlIdentification";
        }
      | {
          content: components["schemas"]["ControlScopeSelectionContent"];
          /** @enum {string} */
          type: "ControlScopeSelection";
        }
      | {
          content: components["schemas"]["ControlScopeAssessmentContent"];
          /** @enum {string} */
          type: "ControlScopeAssessment";
        }
      | {
          content: components["schemas"]["ControlRepresentationContent"];
          /** @enum {string} */
          type: "ControlScopeRepresentation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationContent"];
          /** @enum {string} */
          type: "ControlScopeDesign";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationContent"];
          /** @enum {string} */
          type: "ControlScopeImplementation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlScopeDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlScopeImplementationEvaluation";
        }
      | {
          content: components["schemas"]["ControlRepresentationContent"];
          /** @enum {string} */
          type: "ControlRepresentation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlDesignImplementationEvaluationContent"];
          /** @enum {string} */
          type: "ControlImplementationEvaluation";
        }
      | {
          content: components["schemas"]["ControlAssessmentContent"];
          /** @enum {string} */
          type: "ControlAssessment";
        }
      | {
          content: components["schemas"]["IdentifiedControlsContent"];
          /** @enum {string} */
          type: "IdentifiedControls";
        }
      | {
          /** @enum {string} */
          type: "IdentifiedRisks";
        }
      | {
          content: components["schemas"]["IdentifiedRiskContent"];
          /** @enum {string} */
          type: "IdentifiedRisk";
        }
      | {
          content: components["schemas"]["RiskEvaluationContent"] | null;
          /** @enum {string} */
          type: "InherentRisk";
        }
      | {
          content: components["schemas"]["RiskRelevantControlsContent"];
          /** @enum {string} */
          type: "RiskRelevantControls";
        }
      | {
          content: components["schemas"]["RiskEvaluationContent"] | null;
          /** @enum {string} */
          type: "ResidualRisk";
        }
      | {
          content: components["schemas"]["RiskAcceptanceContent"];
          /** @enum {string} */
          type: "RiskAcceptance";
        }
      | {
          /** @enum {string} */
          type: "ControlFindings";
        }
      | {
          content: components["schemas"]["FindingContent"];
          /** @enum {string} */
          type: "Finding";
        };
    /** @description This is the logical identifier for assessment nodes. */
    AssessmentDecisionNode:
      | {
          /** @enum {string} */
          type: "SourceData";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlIdentification";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlScopeSelection";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeAssessment";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeRepresentation";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeDesign";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeImplementation";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlScopeNode"];
          /** @enum {string} */
          type: "ControlScopeImplementationEvaluation";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlAssessment";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlRepresentation";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlDesignEvaluation";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlImplementationEvaluation";
        }
      | {
          /** @enum {string} */
          type: "IdentifiedControls";
        }
      | {
          /** @enum {string} */
          type: "IdentifiedRisks";
        }
      | {
          content: components["schemas"]["RiskNode"];
          /** @enum {string} */
          type: "IdentifiedRisk";
        }
      | {
          content: components["schemas"]["RiskNode"];
          /** @enum {string} */
          type: "InherentRisk";
        }
      | {
          content: components["schemas"]["RiskNode"];
          /** @enum {string} */
          type: "RiskRelevantControls";
        }
      | {
          content: components["schemas"]["RiskNode"];
          /** @enum {string} */
          type: "ResidualRisk";
        }
      | {
          content: components["schemas"]["RiskNode"];
          /** @enum {string} */
          type: "RiskAcceptance";
        }
      | {
          content: components["schemas"]["ControlNode"];
          /** @enum {string} */
          type: "ControlFindings";
        }
      | {
          content: components["schemas"]["FindingNode"];
          /** @enum {string} */
          type: "Finding";
        };
    /** @enum {string} */
    AssessmentDecisionNodeType:
      | "SourceData"
      | "ControlIdentification"
      | "ControlScopeSelection"
      | "ControlScopeAssessment"
      | "ControlScopeRepresentation"
      | "ControlScopeDesign"
      | "ControlScopeImplementation"
      | "ControlScopeDesignEvaluation"
      | "ControlScopeImplementationEvaluation"
      | "ControlRepresentation"
      | "ControlDesignEvaluation"
      | "ControlImplementationEvaluation"
      | "ControlAssessment"
      | "IdentifiedControls"
      | "IdentifiedRisks"
      | "IdentifiedRisk"
      | "InherentRisk"
      | "RiskRelevantControls"
      | "ResidualRisk"
      | "RiskAcceptance"
      | "ControlFindings"
      | "Finding";
    AssessmentId: Nominal<string, "AssessmentId">;
    AssessmentIdPath: {assessment_id: components["schemas"]["AssessmentId"]};
    /**
     * @description Represents what part of an assessment is locked by a background task.
     *     This is the deserialized form that combines the discriminator column
     *     with the optional identifier columns.
     *
     *     # Adding New Variants
     *     When adding a new variant to this enum, you MUST also:
     *     1. Add a corresponding CHECK constraint in the `assessment_tasks` table
     *        (see migration `20260121145836_assessment_tasks.up.sql`)
     *     2. Add a corresponding variant to `AssessmentLockType`
     *     3. Update the `lock_type()`, `control_id()`, and `scope_id()` methods below
     */
    AssessmentLock:
      | {
          target: components["schemas"]["AssessmentId"];
          /** @enum {string} */
          type: "Assessment";
        }
      | {
          target: [components["schemas"]["AssessmentId"], components["schemas"]["AssessmentControlId"]];
          /** @enum {string} */
          type: "ControlOE";
        }
      | {
          target: [
            components["schemas"]["AssessmentId"],
            components["schemas"]["AssessmentControlId"],
            components["schemas"]["TprmScopeId"],
          ];
          /** @enum {string} */
          type: "ControlScopeOE";
        };
    AssessmentMin: {
      assessment_id: components["schemas"]["AssessmentId"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      control_mode: components["schemas"]["AssessmentControlMode"];
      engagement: components["schemas"]["EngagementMin"];
      framework_version_id: components["schemas"]["FrameworkVersionId"];
      status: components["schemas"]["AssessmentStatus"];
      /** Format: int32 */
      step: number;
    };
    AssessmentNode: {
      invalidation?: components["schemas"]["InvalidationCause"][] | null;
      latest_decision?: components["schemas"]["AssessmentDecision"] | null;
      /**
       * @description Whether this node is "locked in" by the user (its audit-plan page is
       *     locked). Locked nodes are skipped by (re)assessment, so the UI can warn
       *     that they won't be updated on a rerun.
       */
      locked: boolean;
      node: components["schemas"]["AssessmentDecisionNode"];
      node_id: components["schemas"]["AssessmentNodeId"];
      suggested_change?: components["schemas"]["AssessmentDecision"] | null;
    };
    AssessmentNodeId: Nominal<string, "AssessmentNodeId">;
    AssessmentNotificationMin: {
      assessment_id: components["schemas"]["AssessmentId"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      engagement_id: components["schemas"]["EngagementId"];
      third_party: components["schemas"]["ThirdPartyNotificationMin"];
    };
    AssessmentQuestionnaireStats: {
      latest_created_at?: components["schemas"]["DateTime"] | null;
      latest_locked_at?: components["schemas"]["DateTime"] | null;
      latest_updated_at?: components["schemas"]["DateTime"] | null;
    };
    AssessmentReportPath: {
      assessment_id: components["schemas"]["AssessmentId"];
      report_template_id: components["schemas"]["TprmReportTemplateId"];
    };
    /** @enum {string} */
    AssessmentStatus: "Automating" | "Review" | "Complete" | "Archived" | "Cancelled";
    AssessmentSummary: {
      /** Format: int32 */
      num_controls: number;
      /** Format: int32 */
      num_met_controls: number;
      risks: components["schemas"]["RiskSummaryItem"][];
    };
    AssessmentTask: {
      background_task_id: components["schemas"]["BackgroundTaskId"];
      channel_name: string;
      created_at: components["schemas"]["DateTime"];
      lock: components["schemas"]["AssessmentLock"];
      name: string;
      /** Format: float */
      progress: number;
      scheduled_for: components["schemas"]["DateTime"];
    };
    Asset: {
      asset_id: components["schemas"]["AssetId"];
      file: components["schemas"]["File"];
      owner?: components["schemas"]["AssetOwner"] | null;
      title: string;
    };
    AssetId: Nominal<string, "AssetId">;
    AssetIdPath: {asset_id: components["schemas"]["AssetId"]};
    AssetIdPath2: {asset_id: components["schemas"]["TprmAssetId"]};
    AssetIdPath3: {asset_id: components["schemas"]["AssetId"]};
    AssetMin: {asset_id: components["schemas"]["AssetId"]; title: string};
    /** @enum {string} */
    AssetOwner: "TrustCenter";
    AssistantParts: IValue[];
    AttachQuestions: {questions: components["schemas"]["QuestionId"][]};
    /**
     * @description Input for attaching evidence sources to a test (lands in the tray, carrying
     *     no claim about which items the sources document). `(test_id, source_id)` is
     *     unique and the attach is all-or-nothing, so one already-attached source
     *     rejects the whole request.
     */
    AttachTestEvidence: {source_ids: components["schemas"]["SourceId"][]};
    Attribute: {
      action: components["schemas"]["ComplexityAction"];
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      attribute_id: components["schemas"]["ComplexityAttributeId"];
      attribute_name: string;
      value?: IValue;
    };
    AttributeAnswer: {
      /** @description When the act that produced this answer happened. */
      at?: components["schemas"]["DateTime"] | null;
      /** @description `None` is the auditor's answer of nothing: a cleared field. */
      content?: IValue;
      provenance: components["schemas"]["AnswerProvenance"];
    };
    /**
     * @description The attribute's answers as a reader sees them: the one that applies, the one a machine
     *     proposes against it, and the ones it displaced, newest first. Where the AI and a roll-forward
     *     both propose, the more recent shows. An AI answer that is the suggestion, or that agrees with
     *     the one applying, is not also listed as displaced.
     */
    AttributeAnswers: {
      history: components["schemas"]["AttributeHistoryEntry"][];
      suggestion?: components["schemas"]["AttributeAnswer"] | null;
      value?: components["schemas"]["AttributeAnswer"] | null;
    };
    AttributeAssessment: {
      active_rule_indices: number[];
      ai_value?: IValue;
      answers: components["schemas"]["AttributeAnswers"];
      assessed_at?: components["schemas"]["DateTime"] | null;
      attribute: components["schemas"]["ComplexityAttribute"];
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      /** @description A person standing behind the answer that applied at the time. */
      confirmed?: components["schemas"]["Actioned"] | null;
      evidence_ids: components["schemas"]["AttributeEvidenceId"][];
      overridden?: components["schemas"]["Actioned"] | null;
      /** @description The prior engagement's answer, where a roll-forward run copied one in. */
      rolled_forward?: components["schemas"]["RolledForward"] | null;
      /** @description The prior engagement's answer, where a roll-forward run offered it beside the field. */
      rolled_forward_suggestion?: components["schemas"]["RolledForward"] | null;
      task_id?: components["schemas"]["BackgroundTaskId"] | null;
      /**
       * @description Prefer [`AttributeAssessment::effective_value`] — a `None` here does
       *     not on its own mean the AI value applies. See [`AttributeValueUpdate`].
       */
      user_value?: IValue;
      /** Format: int32 */
      weighted_score?: number | null;
    };
    AttributeAssessmentId: Nominal<string, "AttributeAssessmentId">;
    AttributeAssessmentPath: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
    };
    AttributeAssessmentPath2: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
    };
    AttributeEvidence: {
      attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
      evidence_text: string;
      relevance_explanation: string;
      /**
       * @description The pinned snapshot of the source this evidence cites. Resolved at
       *     the ref's `as_of` (see [`super::source::SourceMin::as_of`]) so the
       *     displayed source matches the version the user saw when they
       *     recorded the evidence. `SourceMin::drifted` indicates whether the
       *     source has been updated since.
       */
      source: components["schemas"]["SourceMin"];
      source_context: string;
    };
    /** @enum {string} */
    AttributeEvidenceAction: "Added" | "Removed" | "Updated" | "Restored";
    AttributeEvidenceId: Nominal<string, "AttributeEvidenceId">;
    AttributeEvidencePath: {
      attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
    };
    AttributeHistoryEntry: {
      at?: components["schemas"]["DateTime"] | null;
      content?: IValue;
      provenance: components["schemas"]["AnswerProvenance"];
      reason: components["schemas"]["AnswerHistoryReason"];
    };
    AuditArea: {
      audit_area_id: components["schemas"]["AuditAreaId"];
      audit_area_type: components["schemas"]["AuditAreaType"];
      created_at: components["schemas"]["DateTime"];
      created_from: components["schemas"]["AuditAreaCreatedFrom"];
      engagement: components["schemas"]["EngagementMin"];
      name: string;
    };
    /** @description How an audit area came to exist. */
    AuditAreaCreatedFrom:
      | {
          /** @enum {string} */
          type: "Manual";
        }
      | {
          content: {
            /** @description `None` when the template has since been deleted. */
            audit_area_template_id?: components["schemas"]["AuditAreaTemplateId"] | null;
          };
          /** @enum {string} */
          type: "Template";
        }
      | {
          content: {
            question_template_id: components["schemas"]["TprmQuestionTemplateId"];
            source_id: components["schemas"]["SourceId"];
          };
          /** @enum {string} */
          type: "QuestionnaireTable";
        };
    AuditAreaId: Nominal<string, "AuditAreaId">;
    /**
     * @description How much of an audit area is sealed against edits.
     *
     *     Locking a page always cascades to its descendants, so a locked area page implies a
     *     locked subtree; the partial state arises the other way, from locking a sub-page on
     *     its own or from unlocking one, which reopens its ancestors but not its siblings.
     *
     *     Every page under the area counts, down to an individual risk or control — a wider
     *     reach than [`AuditAreaSection`], so an area holding one locked control is partially
     *     locked while each of its sections reports itself unlocked. Narrowing this to the
     *     sections would report that area as `Unlocked` and lose the only sign that anything
     *     under it is sealed.
     */
    AuditAreaLocking: ("Unlocked" | "Locked") | "PartiallyLocked";
    AuditAreaMin: {
      audit_area_id: components["schemas"]["AuditAreaId"];
      audit_area_type: components["schemas"]["AuditAreaType"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      created_from: components["schemas"]["AuditAreaCreatedFrom"];
      name: string;
    };
    /**
     * @description An audit area as it appears in the cross-engagement listing, carrying the plan-page
     *     state a reader needs to judge progress without opening the plan.
     *
     *     Deleting a plan page soft-deletes its audit area in the same transaction, so a live
     *     area always has a live page — hence the non-optional page fields.
     */
    AuditAreaOverview: {
      audit_area_id: components["schemas"]["AuditAreaId"];
      audit_area_type: components["schemas"]["AuditAreaType"];
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      /** @description Zeroed while the area has no sub-pages. */
      children_status_summary: components["schemas"]["ChildrenStatusSummary"];
      created_at: components["schemas"]["DateTime"];
      engagement: components["schemas"]["EngagementMin"];
      locking: components["schemas"]["AuditAreaLocking"];
      name: string;
      /**
       * @description Section the area sits under. `audit_area_type` mirrors this section's type,
       *     denormalised at creation.
       */
      parent: components["schemas"]["AuditPlanPageMin"];
      /** @description Absent until a review has been requested on the area's page. */
      reviewable?: components["schemas"]["ReviewableMin"] | null;
      /** @description Every live section page beneath the area, at any depth, in section order. */
      sections: components["schemas"]["AuditAreaSectionSummary"][];
      status: components["schemas"]["AuditPlanPageStatus"];
    };
    AuditAreaPath: {
      audit_area_id: components["schemas"]["AuditAreaId"];
      engagement_id: components["schemas"]["EngagementId"];
    };
    /**
     * @description The pages beneath an audit area that the listing reports on: the work an auditor
     *     plans and signs off as a unit. What is left out is everything an auditor navigates
     *     *through* rather than signs off — the listing pages that only hold risks and
     *     controls, and the per-risk and per-control leaves under them.
     *
     *     Declaration order is the order an auditor works through them, and `Ord` follows it.
     * @enum {string}
     */
    AuditAreaSection: "Understanding" | "Complexity" | "RisksAndControls" | "Findings";
    /**
     * @description A section page present beneath an audit area. An area carries one control
     *     assessment per framework, each with its own findings, so a section can repeat and
     *     the page id is what tells two of them apart.
     */
    AuditAreaSectionSummary: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      locked: boolean;
      section: components["schemas"]["AuditAreaSection"];
      status: components["schemas"]["AuditPlanPageStatus"];
    };
    AuditAreaTemplate: {
      audit_area_template_id: components["schemas"]["AuditAreaTemplateId"];
      audit_area_type: components["schemas"]["AuditAreaType"];
      complexity_model?: components["schemas"]["ComplexityModelMin"] | null;
      context: string;
      created_at: components["schemas"]["DateTime"];
      description: string;
      framework?: components["schemas"]["FrameworkMin"] | null;
      name: string;
      updated_at: components["schemas"]["DateTime"];
    };
    AuditAreaTemplateId: Nominal<string, "AuditAreaTemplateId">;
    AuditAreaTemplateMin: {audit_area_template_id: components["schemas"]["AuditAreaTemplateId"]; name: string};
    AuditAreaType: "EntityLevel" | "Process";
    AuditPlan: {
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      engagement: components["schemas"]["EngagementMin"];
      pages: components["schemas"]["AuditPlanPage"][];
      updated_at: components["schemas"]["DateTime"];
    };
    /** @description Full page with tagged page type carrying entity IDs. */
    AuditPlanPage: {
      activity_stream: components["schemas"]["ActivityStream"];
      archived: boolean;
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      /**
       * @description The background task automating this page (understanding generation, complexity attribute
       *     assessment, or risk-and-control assessment), if one is running. Present so the sidebar can
       *     show a spinner in place of the status pip and subscribe to the task for live updates,
       *     without fetching each underlying entity.
       */
      automating_task?: components["schemas"]["PendingBackgroundTask"] | null;
      awaiting_generation: boolean;
      /** @description Summary of direct children's statuses, computed at query time. */
      children_status_summary: components["schemas"]["ChildrenStatusSummary"];
      created_at: components["schemas"]["DateTime"];
      disabled: boolean;
      locked: boolean;
      name: string;
      page_type: components["schemas"]["AuditPlanPageContent"];
      parent_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /**
       * @description Reviewable holding this page's reviewers, if any have been requested. The full `Reviewable`
       *     (statuses, comments, reviewer roles) is fetched separately via the reviewable query.
       */
      reviewable_id?: components["schemas"]["ReviewableId"] | null;
      status: components["schemas"]["AuditPlanPageStatus"];
    };
    /** @description Activity stream refs for an audit plan page and all of its descendant pages. */
    AuditPlanPageActivityStreamRefs: {activity_stream_refs: components["schemas"]["ActivityStreamRef"][]};
    AuditPlanPageArchivedPayload: {archived: boolean};
    /** @description Tagged page content that carries entity-specific IDs depending on the page type. */
    AuditPlanPageContent:
      | {
          /** @enum {string} */
          type: "Root";
        }
      | {
          /** @enum {string} */
          type: "EntityLevelControls";
        }
      | {
          /** @enum {string} */
          type: "Processes";
        }
      | {
          audit_area_id: components["schemas"]["AuditAreaId"];
          /** @enum {string} */
          type: "AuditArea";
        }
      | {
          /**
           * @description Type of the audit area this understanding belongs to, fixed when the
           *     understanding is created. Determines the page's display name
           *     ("Process notes" / "System notes").
           */
          area_type: components["schemas"]["AuditAreaType"];
          /** @enum {string} */
          type: "Understanding";
          understanding_id: components["schemas"]["UnderstandingId"];
        }
      | {
          complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
          /** @enum {string} */
          type: "Complexity";
        }
      | {
          assessment_id: components["schemas"]["AssessmentId"];
          /**
           * @description Name of the assessment's framework, read from the framework when the
           *     page is loaded.
           */
          framework_name: string;
          /** @description Version label of the assessment's framework version. */
          framework_version: string;
          /** @enum {string} */
          type: "RisksAndControls";
        }
      | {
          /** @enum {string} */
          type: "RiskControlMatrix";
        }
      | {
          /** @enum {string} */
          type: "Risks";
        }
      | {
          /** @enum {string} */
          type: "Controls";
        }
      | {
          /** @enum {string} */
          type: "Findings";
        }
      | {
          risk_id: components["schemas"]["RiskId"];
          /** @enum {string} */
          type: "Risk";
        }
      | {
          assessment_control_id: components["schemas"]["AssessmentControlId"];
          /** @enum {string} */
          type: "Control";
        };
    AuditPlanPageDeletedPayload: {name: string; page_type: components["schemas"]["AuditPlanPageType"]};
    AuditPlanPageId: Nominal<string, "AuditPlanPageId">;
    AuditPlanPageLockedPayload: {locked: boolean};
    /** @description Lightweight page for listings — a subset of AuditPlanPage fields. */
    AuditPlanPageMin: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      created_at: components["schemas"]["DateTime"];
      name: string;
      page_type: components["schemas"]["AuditPlanPageContent"];
      parent_page_id?: components["schemas"]["AuditPlanPageId"] | null;
    };
    /** @description Minimal audit plan page info for review notifications. Deep-links to the planning page. */
    AuditPlanPageNotificationMin: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      engagement: components["schemas"]["EngagementNotificationMin"];
      name: string;
    };
    /** @enum {string} */
    AuditPlanPageStatus: "NotStarted" | "InProgress" | "InReview" | "Complete";
    AuditPlanPageStatusChangedPayload: {
      new_status: components["schemas"]["AuditPlanPageStatus"];
      old_status: components["schemas"]["AuditPlanPageStatus"];
    };
    /** @enum {string} */
    AuditPlanPageType:
      | "Root"
      | "EntityLevelControls"
      | "Processes"
      | "AuditArea"
      | "Understanding"
      | "Complexity"
      | "RisksAndControls"
      | "RiskControlMatrix"
      | "Risks"
      | "Controls"
      | "Findings"
      | "Risk"
      | "Control";
    AuditorAnswerPath: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
    };
    AutorunTrigger: {
      /** Format: uint */
      framework_count: number;
      tier_id: components["schemas"]["ComplexityTierId"];
      tier_name: string;
    };
    AxisIdPath: {axis_id: components["schemas"]["ScopeAxisId"]};
    /** @description The frontend defines its own types for these so we can use typebox to parse the task result */
    BackgroundTask:
      | {
          content: components["schemas"]["PendingBackgroundTask"];
          /** @enum {string} */
          type: "Pending";
        }
      | {
          content: components["schemas"]["CompleteBackgroundTask"];
          /** @enum {string} */
          type: "Complete";
        };
    BackgroundTaskId: Nominal<string, "BackgroundTaskId">;
    BackgroundTaskIdPath: {background_task_id: components["schemas"]["BackgroundTaskId"]};
    BackgroundTaskResult:
      | {
          /** @enum {string} */
          type: "Empty";
        }
      | {
          content: components["schemas"]["ExportedAssessment"];
          /** @enum {string} */
          type: "ExportAssessment";
        }
      | {
          content: components["schemas"]["ExportedEngagementReport"];
          /** @enum {string} */
          type: "ExportEngagementReport";
        }
      | {
          content: components["schemas"]["ExportedUnderstanding"];
          /** @enum {string} */
          type: "ExportUnderstanding";
        }
      | {
          content: components["schemas"]["CreatedUnderstandingDataRoomSource"];
          /** @enum {string} */
          type: "CreateUnderstandingDataRoomSource";
        }
      | {
          content: components["schemas"]["LegacyMigrationSummary"];
          /** @enum {string} */
          type: "MigrateEngagementsToAuditPlan";
        };
    /**
     * @description What a basis item leans on. Each kind carries both a plan and the thing
     *     itself — a planned item fills evidence in later — so every payload is optional.
     */
    BasisEvidence:
      | {
          goal?: string | null;
          /**
           * @description Absent while the test is unbuilt, or once a linked test is deleted.
           *     Boxed because `TestMin` dwarfs the other variants.
           */
          test?: components["schemas"]["TestMin"] | null;
          /** @enum {string} */
          type: "Test";
        }
      | {
          expected_report?: string | null;
          provider?: string | null;
          report_period?: components["schemas"]["DateRange"] | null;
          satisfactory?: boolean | null;
          /** @enum {string} */
          type: "WorkOfOthers";
        }
      | {
          justification?: string | null;
          /** Format: int32 */
          rating?: number | null;
          /** @enum {string} */
          type: "PriorConclusion";
        };
    /**
     * @description Who set a basis item aside, and why. A recorded act rather than a deletion; an
     *     excluded item takes no part in coverage.
     */
    BasisItemExclusion: {
      excluded_at: components["schemas"]["DateTime"];
      excluded_by?: components["schemas"]["UserMin"] | null;
      /** @description Required, so setting aside cannot quietly turn a red timeline green. */
      reason: string;
    };
    BasisItemPath: {
      basis_item_id: components["schemas"]["ControlOeBasisItemId"];
      control_oe_id: components["schemas"]["ControlOeId"];
    };
    /**
     * @description How far along a basis item is. Derived from its evidence and citations, never
     *     stored, so it cannot drift from the state of the thing it describes.
     */
    BasisItemStatus: "Obtained" | "Planned" | "Invalid";
    BatchAssessmentNotificationMin: {
      /** Format: int32 */
      assessment_total: number;
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /** @default null */
      engagement_id: components["schemas"]["EngagementId"] | null;
      third_party: components["schemas"]["ThirdPartyNotificationMin"];
    };
    BatchAuditPlanPageNotificationMin: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      /** Format: int32 */
      audit_plan_page_total: number;
      engagement: components["schemas"]["EngagementNotificationMin"];
    };
    BatchComplexityAssessmentNotificationMin: {
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /** Format: int32 */
      complexity_assessment_total: number;
      /** @default null */
      engagement_id: components["schemas"]["EngagementId"] | null;
      third_party: components["schemas"]["ThirdPartyNotificationMin"];
    };
    BatchControlNotificationMin: {
      assessment: components["schemas"]["AssessmentNotificationMin"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /** Format: int32 */
      control_total: number;
    };
    BatchDocumentNotificationMin: {
      document_category: components["schemas"]["DocumentCategory"];
      /** Format: int32 */
      document_total: number;
    };
    BatchQuestionNotificationMin: {
      /** Format: int32 */
      question_total: number;
      questionnaire?: components["schemas"]["QuestionnaireNotificationMin"] | null;
    };
    BatchQuestionnaireNotificationMin: {
      archived: boolean;
      /** Format: int32 */
      questionnaire_total: number;
    };
    BatchRiskNotificationMin: {
      assessment: components["schemas"]["AssessmentNotificationMin"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /** Format: int32 */
      risk_total: number;
    };
    BatchUnderstandingNotificationMin: {
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      engagement: components["schemas"]["EngagementNotificationMin"];
      /** Format: int32 */
      understanding_total: number;
    };
    BulkNotificationPayload:
      | {
          /** Format: int32 */
          content: number;
          /** @enum {string} */
          type: "Team";
        }
      | {
          /** Format: int32 */
          content: number;
          /** @enum {string} */
          type: "User";
        }
      | {
          content: components["schemas"]["BatchQuestionNotificationMin"];
          /** @enum {string} */
          type: "Question";
        }
      | {
          content: components["schemas"]["BatchQuestionnaireNotificationMin"];
          /** @enum {string} */
          type: "Questionnaire";
        }
      | {
          content: components["schemas"]["BatchDocumentNotificationMin"];
          /** @enum {string} */
          type: "Document";
        }
      | {
          /** Format: int32 */
          content: number;
          /** @enum {string} */
          type: "ReviewItem";
        }
      | {
          content: components["schemas"]["BatchAssessmentNotificationMin"];
          /** @enum {string} */
          type: "Assessment";
        }
      | {
          /** Format: int32 */
          content: number;
          /** @enum {string} */
          type: "ThirdParty";
        }
      | {
          content: components["schemas"]["BatchControlNotificationMin"];
          /** @enum {string} */
          type: "Control";
        }
      | {
          content: components["schemas"]["BatchControlNotificationMin"];
          /** @enum {string} */
          type: "ControlOE";
        }
      | {
          content: components["schemas"]["BatchRiskNotificationMin"];
          /** @enum {string} */
          type: "Risk";
        }
      | {
          content: components["schemas"]["BatchComplexityAssessmentNotificationMin"];
          /** @enum {string} */
          type: "ComplexityAssessment";
        }
      | {
          content: components["schemas"]["BatchUnderstandingNotificationMin"];
          /** @enum {string} */
          type: "Understanding";
        }
      | {
          content: components["schemas"]["BatchAuditPlanPageNotificationMin"];
          /** @enum {string} */
          type: "AuditPlanPage";
        };
    BulkQuestionAction:
      | {
          content: components["schemas"]["OwnerId"] | null;
          /** @enum {string} */
          type: "Assign";
        }
      | {
          content: components["schemas"]["QuestionStatus"];
          /** @enum {string} */
          type: "SetStatus";
        }
      | {
          content: components["schemas"]["DateTime"] | null;
          /** @enum {string} */
          type: "SetDueDate";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "SetText";
        }
      | {
          content: components["schemas"]["BulkQuestionOverrideScopes"];
          /** @enum {string} */
          type: "OverrideScopes";
        }
      | {
          content: components["schemas"]["CreateReviewAction"][];
          /** @enum {string} */
          type: "Review";
        }
      | {
          /** @enum {string} */
          type: "Delete";
        };
    BulkQuestionOverrideScopes: {
      enable_override: boolean;
      limited_to_scopes?: components["schemas"]["ScopeId"][] | null;
    };
    BulkQuestionUpdate: {
      items: components["schemas"]["BulkQuestionUpdateItem"][];
      layer_type: components["schemas"]["LayerType"];
    };
    BulkQuestionUpdateItem: {
      action: components["schemas"]["BulkQuestionAction"];
      question_id: components["schemas"]["QuestionId"];
    };
    BulkRiskAction:
      | {
          content: components["schemas"]["OwnerId"] | null;
          /** @enum {string} */
          type: "Assign";
        }
      | {
          /** @enum {string} */
          type: "Delete";
        };
    BulkRiskUpdate: {items: components["schemas"]["BulkRiskUpdateItem"][]};
    BulkRiskUpdateItem: {
      action: components["schemas"]["BulkRiskAction"];
      assessment_id: components["schemas"]["AssessmentId"];
      risk_id: components["schemas"]["RiskId"];
    };
    /** @enum {string} */
    BulkSourceAction:
      | "Delete"
      | "RiskAssessInclude"
      | "RiskAssessExclude"
      | "ControlEvalInclude"
      | "ControlEvalExclude";
    BulkSourceUpdate: {items: components["schemas"]["BulkSourceUpdateItem"][]};
    BulkSourceUpdateItem: {
      action: components["schemas"]["BulkSourceAction"];
      source_id: components["schemas"]["SourceId"];
    };
    BulkUpdateNotificationPreferences: {updates: components["schemas"]["UpdateNotificationPreference"][]};
    CacheDirective: "Cache" | "BypassCache";
    /**
     * @description Snapshot of a freshly-generated finding under consideration for
     *     reuse-matching. Content is frozen at conversation creation so the
     *     agent's render is stable across retries.
     */
    CandidateFinding: {content: components["schemas"]["FindingContent"]};
    /**
     * @description Compact shape of a newly-discovered risk for matching against
     *     existing assessment risks. Only the fields the model needs to
     *     decide equivalence are carried; contexts, ownership, and
     *     framework metadata stay on the caller's `PopulateRisk`.
     */
    CandidateRisk: {description: string; title: string};
    CatalogIdPath: {catalog_id: components["schemas"]["ErrorCatalogId"]};
    /** @enum {string} */
    CertificationType:
      | "CippPas"
      | "Crest"
      | "CsaStar"
      | "CyberEssentials"
      | "Iso27001"
      | "Iso27017"
      | "Iso27018"
      | "Iso27701"
      | "Soc2"
      | "Soc3";
    /** @description Body for the change-sample endpoint. */
    ChangeSampleBody: {sample_id: components["schemas"]["SampleId"]};
    /**
     * @description Names the template, not one of its versions: the attach pins the head as
     *     it stands.
     */
    ChangeTemplateBody: {test_template_id: components["schemas"]["TestTemplateId"]};
    ChannelAuthBody: {channel_name: string; socket_id: string};
    ChannelAuthBody2: {channel_name: string; socket_id: string};
    ChannelAuthBody3: {channel_name: string; socket_id: string};
    CharacterConfig: {lowercase: boolean; number: boolean; symbol: boolean; uppercase: boolean};
    /**
     * @description All the information required to generate a chart. This is sent to the
     *     report renderer service.
     */
    ChartContentPayload: {
      assessed_controls: {[key: string]: components["schemas"]["AssessedControl"]};
      assessment: components["schemas"]["Assessment"];
      controls: {[key: string]: components["schemas"]["PredefinedControl"]};
      framework_profiles: components["schemas"]["FrameworkProfile"][];
      kind: components["schemas"]["TprmReportChartKind"];
      module_templates: components["schemas"]["FrameworkModuleTemplates"];
      risks: components["schemas"]["Risk"][];
      template_name?: string | null;
    };
    /** @description Summary of direct children's statuses for a page. */
    ChildrenStatusSummary: {
      /** Format: int32 */
      complete: number;
      /** Format: int32 */
      in_progress: number;
      /** Format: int32 */
      in_review: number;
      /** Format: int32 */
      not_started: number;
      /** Format: int32 */
      total: number;
    };
    /**
     * @description A decision's use of a [`SourceExtract`]. `context` is the per-use rationale;
     *     the shared extract carries none, so it stays reusable across decisions.
     */
    Citation: {context?: string | null; source_extract_id: components["schemas"]["SourceExtractId"]};
    ClientFacingFindingContent: {content: string; title: string};
    ClusterIdPath: {cluster_id: components["schemas"]["FactClusterId"]};
    /** @description Identifies an audit plan page referenced by a cluster. */
    ClusterPageRef: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      name: string;
      page_type: components["schemas"]["AuditPlanPageType"];
    };
    /** @description Which page(s) the cluster's activity targeted. */
    ClusterPages:
      | {
          content: {page: components["schemas"]["ClusterPageRef"]};
          /** @enum {string} */
          type: "One";
        }
      | {
          content: {
            /** Format: int64 */
            count: number;
            root_page?: components["schemas"]["ClusterPageRef"] | null;
          };
          /** @enum {string} */
          type: "Many";
        };
    /** @description The clustered activity feed of an audit plan page and its descendant subtree. */
    ClusteredActivityFeed: {
      /**
       * @description The newest feed row while it can still grow — an individual *or* a
       *     cluster — recomputed each refresh, or `None`. Kept separate from
       *     `tail` because, unlike them, it is not yet immutable.
       */
      head?: components["schemas"]["FeedRow"] | null;
      /** @description Feed rows, newest-first. Every row here is immutable once returned. */
      tail: components["schemas"]["FeedRow"][];
    };
    /** @description Query parameters for the clustered activity feed of an audit plan page. */
    ClusteredActivityFeedArgs: {
      /**
       * Format: double
       * @description Only return rows whose cursor is strictly less than this value.
       */
      before?: number | null;
      /**
       * @description When `Some(false)`, the feed is computed *as if no bulk_action_id
       *     existed*: `Many` clusters cannot form (the within-bulk no-break
       *     rule and the rooted-anchor override are both disabled), so the
       *     activity flattens to per-bucket `One` clusters and individual
       *     rows. Used to expand a `Many` cluster into the per-bucket
       *     clusters that would otherwise have appeared. Defaults to `true`
       *     (the normal feed shape) when absent.
       */
      cluster_bulk_actions?: boolean | null;
      /**
       * Format: uint32
       * @description Rollup level. Pages above this level (relative to the requested page,
       *     which is level 0) contribute individual activity rows; pages at or below
       *     it roll up into per-user clusters. Non-negative; no upper bound.
       */
      depth: number;
      /**
       * Format: double
       * @description Only return rows whose cursor is strictly greater than this value.
       */
      since?: number | null;
    };
    /**
     * @description Mirrors the Chakra UI color palettes
     *     See: https://chakra-ui.com/docs/theming/colors
     * @enum {string}
     */
    ColorPalette: "gray" | "red" | "pink" | "purple" | "cyan" | "blue" | "teal" | "green" | "yellow" | "orange";
    ColoredText: {
      /**
       * @description Chakra UI colour — either a bare palette name (`green`, `red`; used by the
       *     testing scoring scale, like complexity tiers) or a shaded token (`green.600`;
       *     the control/OE scales).
       */
      color: string;
      /**
       * @description Display text for this rating level; may be empty to show only the color swatch.
       * @default
       */
      label: string;
    };
    /**
     * @description Configures a single `CombineControlDesignImplementationEvaluation`
     *     agent run. Identifies the (assessment, control, facet) triple; the
     *     agent reads every `ControlScope{Design,Implementation}Evaluation`
     *     decision for the control (matching the facet) from the DB and
     *     combines them into a control-level verdict.
     */
    CombineControlDesignImplementationEvaluationFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      mode: components["schemas"]["DesignImplementationMode"];
    };
    /**
     * @description Configures a single `CombineControlRepresentation` agent run.
     *     Identifies the (assessment, control) pair; the agent reads every
     *     `ControlScopeRepresentation` decision for the control from the DB and
     *     combines them into a control-level verdict. No `scope_id` — this
     *     is a control-level aggregation.
     */
    CombineControlRepresentationFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
    };
    CommentPayload: {message: components["schemas"]["RichText"]};
    /**
     * @description One mitigating control the residual `Quantify*` variants
     *     consider when scoring a risk: the control's title, description,
     *     and the caller-assembled comment describing how well the third
     *     party meets it.
     */
    CommentedControlSnapshot: {comment: string; description: string; title: string};
    CompleteBackgroundTask: {
      background_task_id?: components["schemas"]["BackgroundTaskId"] | null;
      completed_at?: components["schemas"]["DateTime"] | null;
      result: components["schemas"]["BackgroundTaskResult"];
    };
    ComplexityAction: ("Overridden" | "Reset" | "ResetToRolledForward") | "Cleared";
    ComplexityAggregationOperator: "Sum" | "Max" | "Min";
    /**
     * @description A complexity assessment as a whole — the parent / batch.
     *
     *     One row per (engagement, model_version). Owns the batch-level fields
     *     (owner, activity stream, model version pointer, lifecycle) and
     *     embeds its scoped members for list/detail rendering.
     *
     *     A `[Global]` model version produces a single-member batch on the
     *     engagement's Global scope; a `[InternalApplication, ExternalApplication]`
     *     version produces N members across the engagement's Application scopes;
     *     mixed `scope_types` produce members of every listed type.
     */
    ComplexityAssessment: {
      /**
       * @description Batch-level activity stream (owner change, scope_types change at
       *     publish time, batch-level reassess trigger). Per-scope events
       *     live on each member's own stream.
       */
      activity_stream: components["schemas"]["ActivityStream"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_model: components["schemas"]["ComplexityModelMin"];
      complexity_model_version: components["schemas"]["ComplexityModelVersionMin"];
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      engagement: components["schemas"]["Engagement"];
      /**
       * Format: uint32
       * @description Members that have a `score` but whose score doesn't fall within
       *     any tier band of the model version.
       */
      null_tier_count: number;
      /**
       * @description Batch-level owner. The "shared owner" is a single value, not a
       *     roll-up across members.
       */
      owner?: components["schemas"]["Owner"] | null;
      /** @description Per-scope members of the batch. */
      scoped_assessments: components["schemas"]["ComplexityScopedAssessmentMin"][];
      /** @description Count of members at each tier. */
      tier_counts: components["schemas"]["ComplexityAssessmentTierCount"][];
      /**
       * Format: uint32
       * @description Members that have not yet been assessed (no `score`).
       */
      unassessed_count: number;
      updated_at: components["schemas"]["DateTime"];
    };
    ComplexityAssessmentId: Nominal<string, "ComplexityAssessmentId">;
    ComplexityAssessmentNotificationMin: {
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_model_name: string;
      engagement_id: components["schemas"]["EngagementId"];
      /**
       * @description `Some` for events that target a specific scoped member; `None`
       *     for batch-level events. Old payloads written before COM-72
       *     deserialise as `None` and deep-link to the parent batch view.
       * @default null
       */
      scope_id: components["schemas"]["TprmScopeId"] | null;
      third_party: components["schemas"]["ThirdPartyNotificationMin"];
    };
    ComplexityAssessmentPath: {complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"]};
    ComplexityAssessmentPath2: {complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"]};
    ComplexityAssessmentTierCount: {
      complexity_tier: components["schemas"]["ComplexityTierMin"];
      /** Format: uint32 */
      count: number;
    };
    ComplexityAssessmentUpdatedPayload:
      | {
          content: components["schemas"]["Trigger"];
          /** @enum {string} */
          type: "Created";
        }
      | {
          content: components["schemas"]["Tier"];
          /** @enum {string} */
          type: "TierUpdated";
        }
      | {
          content: components["schemas"]["Attribute"];
          /** @enum {string} */
          type: "AttributeValueUpdated";
        }
      | {
          content: components["schemas"]["Evidence"];
          /** @enum {string} */
          type: "AttributeEvidenceUpdated";
        }
      | {
          content: components["schemas"]["OwnerId"];
          /** @enum {string} */
          type: "Assigned";
        }
      | {
          content: components["schemas"]["Trigger"];
          /** @enum {string} */
          type: "Reassessed";
        }
      | {
          content: components["schemas"]["AutorunTrigger"];
          /** @enum {string} */
          type: "TriggerTPAssessment";
        }
      | {
          content: components["schemas"]["RollForwardSummary"];
          /** @enum {string} */
          type: "RolledForward";
        }
      | {
          content: components["schemas"]["RollForwardUndoneSummary"];
          /** @enum {string} */
          type: "RollForwardUndone";
        };
    ComplexityAttribute: {
      ai_guidance?: string | null;
      attribute_type: components["schemas"]["ValueType"];
      complexity_attribute_id: components["schemas"]["ComplexityAttributeId"];
      /** Format: int32 */
      default_score?: number | null;
      name: string;
      operator: components["schemas"]["ComplexityAggregationOperator"];
      required: boolean;
      rules: components["schemas"]["ComplexityTierCriterion"][];
      /** Format: int32 */
      weight: number;
    };
    ComplexityAttributeId: Nominal<string, "ComplexityAttributeId">;
    ComplexityAttributeIdPath: {
      attribute_id: components["schemas"]["ComplexityAttributeId"];
      model_id: components["schemas"]["ComplexityModelId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    ComplexityModel: {
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      created_at: components["schemas"]["DateTime"];
      name: string;
      updated_at: components["schemas"]["DateTime"];
      versions: components["schemas"]["ComplexityModelVersion"][];
    };
    ComplexityModelId: Nominal<string, "ComplexityModelId">;
    ComplexityModelIdPath: {model_id: components["schemas"]["ComplexityModelId"]};
    ComplexityModelIdPath2: {model_id: components["schemas"]["ComplexityModelId"]};
    ComplexityModelMin: {
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      created_at: components["schemas"]["DateTime"];
      name: string;
      updated_at: components["schemas"]["DateTime"];
      versions: components["schemas"]["ComplexityModelVersionMin"][];
    };
    ComplexityModelVersion: {
      archived_at?: components["schemas"]["DateTime"] | null;
      attributes: components["schemas"]["ComplexityAttribute"][];
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      created_at: components["schemas"]["DateTime"];
      linked_assessments: components["schemas"]["ComplexityAssessmentId"][];
      operator: components["schemas"]["ComplexityAggregationOperator"];
      published_at?: components["schemas"]["DateTime"] | null;
      /**
       * @description Which engagement scope types this version assesses against. A
       *     `[Global]` version produces one scoped assessment per engagement
       *     (matching pre-COM-72 behaviour). A `[InternalApplication,
       *     ExternalApplication]` version produces one scoped assessment per
       *     Internal/External Application scope on the engagement. Mixed
       *     values are allowed.
       */
      scope_types: components["schemas"]["TprmScopeType"][];
      tiers: components["schemas"]["ComplexityTier"][];
      updated_at: components["schemas"]["DateTime"];
      version_name: string;
    };
    ComplexityModelVersionId: Nominal<string, "ComplexityModelVersionId">;
    ComplexityModelVersionIdPath: {
      model_id: components["schemas"]["ComplexityModelId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    ComplexityModelVersionIdPath2: {
      model_id: components["schemas"]["ComplexityModelId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    ComplexityModelVersionIdPath3: {
      model_id: components["schemas"]["ComplexityModelId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    ComplexityModelVersionMin: {
      archived_at?: components["schemas"]["DateTime"] | null;
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      created_at: components["schemas"]["DateTime"];
      /** Format: int32 */
      number_of_attributes: number;
      published_at?: components["schemas"]["DateTime"] | null;
      scope_types: components["schemas"]["TprmScopeType"][];
      updated_at: components["schemas"]["DateTime"];
      version_name: string;
    };
    ComplexityRollForwardRowId: Nominal<string, "ComplexityRollForwardRowId">;
    ComplexityRollForwardRunId: Nominal<string, "ComplexityRollForwardRunId">;
    /**
     * @description Full detail of a single scoped assessment — one member of the
     *     parent [`ComplexityAssessment`] batch.
     */
    ComplexityScopedAssessment: {
      /**
       * @description Per-scope activity stream — events that target this scope only.
       *     Batch-level events live on the parent's stream.
       */
      activity_stream: components["schemas"]["ActivityStream"];
      ai_complexity_tier?: components["schemas"]["ComplexityTier"] | null;
      assessed_at?: components["schemas"]["DateTime"] | null;
      attributes: components["schemas"]["AttributeAssessment"][];
      comment?: string | null;
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_model: components["schemas"]["ComplexityModelMin"];
      complexity_model_version: components["schemas"]["ComplexityModelVersion"];
      /** @description Prefer [`ComplexityScopedAssessment::effective_complexity_tier`]. */
      complexity_tier?: components["schemas"]["ComplexityTier"] | null;
      complexity_tier_justification?: string | null;
      created_at: components["schemas"]["DateTime"];
      engagement: components["schemas"]["Engagement"];
      /** @description Whether any linked TPRM assessments have running tasks */
      has_running_linked_assessments: boolean;
      missing_scores: components["schemas"]["ComplexityAttributeId"][];
      missing_values: components["schemas"]["ComplexityAttributeId"][];
      overridden?: components["schemas"]["Actioned"] | null;
      /** @description The scope this member is bound to. */
      scope: components["schemas"]["TprmScopeMin"];
      /** Format: int32 */
      score?: number | null;
      tier_answers: components["schemas"]["TierAnswers"];
      updated: components["schemas"]["Actioned"];
    };
    ComplexityScopedAssessmentAttributePath: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    /** @description Minimal scoped summary used by list/rollup flows on the parent. */
    ComplexityScopedAssessmentMin: {
      ai_complexity_tier?: components["schemas"]["ComplexityTier"] | null;
      assessed_at?: components["schemas"]["DateTime"] | null;
      /** Format: uint */
      assessed_attributes: number;
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_tier?: components["schemas"]["ComplexityTier"] | null;
      created_at: components["schemas"]["DateTime"];
      has_running_tasks: boolean;
      /** Format: uint */
      missing_scores: number;
      /** Format: uint */
      missing_values: number;
      scope: components["schemas"]["TprmScopeMin"];
      /** Format: int32 */
      score?: number | null;
      /** Format: uint */
      total_attributes: number;
      updated_at: components["schemas"]["DateTime"];
    };
    ComplexityScopedAssessmentPath: {
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    /**
     * @description Composite reference to a single `tprm.complexity_scoped_assessment`
     *     row.
     */
    ComplexityScopedAssessmentRef: {
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    ComplexityTier: {
      color: string;
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      complexity_tier_id: components["schemas"]["ComplexityTierId"];
      /** Format: int32 */
      lower_bound?: number | null;
      name: string;
      /** Format: int32 */
      upper_bound?: number | null;
    };
    ComplexityTierCriterion: {
      conditions: components["schemas"]["RuleCondition"][];
      /**
       * Format: int32
       * @description Score contributed by this criterion when its `rule` conditions
       *     match the attribute's value.
       */
      value: number;
    };
    ComplexityTierId: Nominal<string, "ComplexityTierId">;
    ComplexityTierIdPath: {
      model_id: components["schemas"]["ComplexityModelId"];
      tier_id: components["schemas"]["ComplexityTierId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    ComplexityTierMin: {color: string; complexity_tier_id: components["schemas"]["ComplexityTierId"]; name: string};
    /**
     * @description Roll-up of an engagement's complexity tier across all scopes of one
     *     model. `tier` is the canonical representative — Global-preferred,
     *     falling back to any deterministic scope. `diverging` is `true` when
     *     the assessed scopes disagree on which tier they fall in (e.g. one
     *     Application scope landed in "Low" and another in "High"); UIs should
     *     show a "Mixed" indicator rather than the raw `tier`.
     */
    ComplexityTierRollup: {diverging: boolean; tier: components["schemas"]["ComplexityTierMin"]};
    ComponentWiseRiskQuantificationModel: {
      /**
       * @description How the per-component values are combined into a single value; defaults to `Add`.
       * @default Add
       */
      combining_function: components["schemas"]["RiskQuantificationCombiningFunction"];
      /** @description The individual factors that are scored and then combined to produce the overall risk value. */
      components: components["schemas"]["RiskQuantificationModelComponent"][];
      /** @description When `true`, the overall result is presented as a choice from the threshold labels. */
      show_choice: boolean;
      /** @description When `true`, the overall result is presented as its numeric value. */
      show_numeric: boolean;
      /** @description Ordered bands that map the combined value to a named risk level; the highest threshold whose `value` is not exceeded is selected. */
      thresholds: components["schemas"]["RiskThreshold"][];
      /**
       * @description Unit label shown alongside the final combined value; omitting it shows no units.
       * @default
       */
      units: string;
    };
    ComputedRiskEvaluation: {
      color: components["schemas"]["ColorPalette"];
      components?: number[] | null;
      label: string;
      /** Format: int32 */
      level: number;
      reason: string;
      /** Format: double */
      value: number;
    };
    /**
     * @description Configures a single `ConcludeControlOe` agent run. The (control, scope) OE
     *     assessment to conclude; the agent reads its period, basis and their evidence
     *     state, condition states and design & implementation.
     */
    ConcludeControlOeFunction: {control_oe_id: components["schemas"]["ControlOeId"]};
    /**
     * @description Configures the one `ConcludeTest` agent run a test gets: the scale the
     *     rating indexes, the criteria each item's outcomes answer, the template
     *     author's extra instruction, and the counts the justification quotes.
     *
     *     The items are not carried here at all: they arrive through the `read_items`
     *     tool, which is the single path to them.
     *
     *     `levels` and `criteria` are resolved by the caller and pinned here for the
     *     life of the conversation: a rating is a 1-based index into `levels`, and
     *     the caller validates the model's rating against the same list the prompt
     *     described.
     */
    ConcludeTestFunction: {
      /** @description The template author's extra instruction, appended to the prompt. */
      conclusion_prompt?: string | null;
      counts: components["schemas"]["TestResultCounts"];
      /**
       * @description The test's resolved criteria, in the order `read_items` reports each
       *     item's outcomes.
       */
      criteria: components["schemas"]["TestCriterion"][];
      /** @description The test's resolved rating scale, worst first. */
      levels: components["schemas"]["ColoredText"][];
      test_id: components["schemas"]["TestId"];
    };
    Condition: {
      content: boolean;
      /** @enum {string} */
      type: "Literal";
    };
    ConditionPath: {
      condition_id: components["schemas"]["ControlOeConditionId"];
      control_oe_id: components["schemas"]["ControlOeId"];
    };
    ConditionType:
      | "Is"
      | "IsNot"
      | "LessThan"
      | "LessThanOrEqual"
      | "GreaterThan"
      | "GreaterThanOrEqual"
      | "Contains"
      | "ContainsAny"
      | "DoesNotContain";
    Config:
      | {
          content: components["schemas"]["PasswordPolicyConfig"];
          /** @enum {string} */
          type: "Password";
        }
      | {
          /** @enum {string} */
          type: "None";
        };
    ConfluenceDocumentSourceConfig: {
      labels: components["schemas"]["ConfluenceDocumentSourceLabels"];
      site: components["schemas"]["ConfluenceSite"];
      space?: components["schemas"]["ConfluenceSpace"] | null;
    };
    ConfluenceDocumentSourceLabels: ConfluenceDocumentSourceLabels;
    ConfluenceLabel: {id: string; name: string; prefix: string};
    ConfluenceSite: {avatar_url: string; id: string; name: string; url: string};
    ConfluenceSpace: {id: string; name: string};
    ConsentArgs: {external_redirect: string};
    ConsentResponse: {client_account: components["schemas"]["AccountMin"]; scope: components["schemas"]["AccessScope"]};
    ConsolidatedQuestionnaireContentPayload: {
      entries: components["schemas"]["ConsolidatedQuestionnaireEntry"][];
      title: string;
    };
    ConsolidatedQuestionnaireEntry: {
      questionnaire: components["schemas"]["TprmQuestionnaire"];
      subtitle?: string | null;
    };
    /** @enum {string} */
    ConsolidatedSourceRole: "Supporting" | "Conflict";
    /**
     * @description A question's answer: weighed from its document candidates, or a past
     *     questionnaire's answer as it stood.
     */
    ConsolidatedSuggestion: {
      answer: components["schemas"]["TprmExternalAnswer"];
      consolidated_suggestion_id: components["schemas"]["ConsolidatedSuggestionId"];
      dismissed?: components["schemas"]["Actioned"] | null;
      /**
       * @description The label question's answer (see
       *     `TprmTextAnswerConfig::use_as_questionnaire_label`) this answer is about.
       */
      entity_label?: string | null;
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      /** @description When this was last confirmed as the answer. */
      valid_at: components["schemas"]["DateTime"];
    } & (
      | {
          content: components["schemas"]["DocumentSuggestion"];
          /** @enum {string} */
          source: "Documents";
        }
      | {
          content: components["schemas"]["PastQuestionnaireSuggestion"];
          /** @enum {string} */
          source: "PastQuestionnaire";
        }
    );
    ConsolidatedSuggestionId: Nominal<string, "ConsolidatedSuggestionId">;
    /** @description A candidate behind a consolidated answer. */
    ConsolidatedSuggestionSource: {
      candidate: components["schemas"]["AnswerSuggestion"];
      /** @description What it contributes, or asserts where it conflicts. */
      claim: string;
      role: components["schemas"]["ConsolidatedSourceRole"];
    };
    ConsolidatedSuggestionsRequest: {consolidated_suggestion_ids: components["schemas"]["ConsolidatedSuggestionId"][]};
    ContactUsRecord: {
      /** Format: email */
      email: string;
      message: string;
      name: string;
      phone?: string | null;
    };
    ContentId: Nominal<string, "ContentId">;
    ContentIdPath: {content_id: components["schemas"]["ContentId"]};
    ContentIdPath2: {content_id: components["schemas"]["ContentId"]};
    /**
     * @description Configures a single `ContextualizePredefinedRisk` agent run.
     *     Identifies the assessment plus the ordinal of the predefined risk
     *     within the assessment's framework version. The agent loads the
     *     full predefined-risk record — including its `contextual_guidance`
     *     and control mappings — in its `system_prompt`, so only the
     *     identifier is persisted here.
     */
    ContextualizePredefinedRiskFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      /** Format: int32 */
      predefined_risk_ordinal: number;
    };
    ControlAssessmentContent: {
      citations?: components["schemas"]["Citation"][] | null;
      explanation: string;
      met?: boolean | null;
    };
    ControlChangedContent: {
      /** @default null */
      control: components["schemas"]["PredefinedControlMin"] | null;
    };
    ControlCharacteristicKind: "Text" | "SingleSelect";
    ControlCharacteristicOption: {
      /** @description Optional explanation of when to pick this choice; omit for no help text. */
      description?: string | null;
      /** @description Label for this selectable choice. */
      title: string;
    };
    ControlCharacteristicTemplate: {
      /** @description Optional guidance explaining what this characteristic captures; omit for no help text. */
      description?: string | null;
      /** @description How the characteristic is captured: free text or a single-select choice. */
      kind: components["schemas"]["ControlCharacteristicKind"];
      /** @description Selectable choices for a `SingleSelect` characteristic; ignored for `Text`. */
      options: components["schemas"]["ControlCharacteristicOption"][];
      /** @description Name of the characteristic shown to the assessor (e.g. `Control frequency`). */
      title: string;
    };
    /**
     * @description How a control dependency resolves against its target's live conclusion.
     *     Resolved against the *target's* current scale, so an upstream downgrade or a
     *     since-shortened scale needs no restatement by the consumer.
     */
    ControlConditionResolution: "Met" | "NotMet" | "Pending" | "Unresolvable";
    ControlDesignImplementationChanged: {
      characteristics: {[key: string]: string | null};
      description?: string | null;
      scope_id: components["schemas"]["TprmScopeId"];
    };
    ControlDesignImplementationContent: {
      characteristics: {[key: string]: string};
      citations: components["schemas"]["Citation"][];
      description: string;
    };
    ControlDesignImplementationEvaluated: {
      justification: string;
      scope_id?: components["schemas"]["TprmScopeId"] | null;
      /** Format: int32 */
      score: number;
    };
    ControlDesignImplementationEvaluationContent: {
      justification: string;
      /** Format: int32 */
      score: number;
    };
    ControlDesignImplementationModuleTemplate: {
      /** @description Characteristics the assessor records for the control (e.g. frequency, control type), each capturing one attribute of the control's design. */
      characteristics: components["schemas"]["ControlCharacteristicTemplate"][];
      /**
       * @description Extra instructions appended to the AI prompt that describes the control's design/implementation; leave empty for the default prompt.
       * @default
       */
      custom_description_prompt: string;
      /**
       * @description Extra instructions appended to the AI prompt that evaluates the control's design/implementation against the chosen rating level; leave empty for the default prompt.
       * @default
       */
      custom_evaluation_prompt: string;
      /**
       * @description Ordered rating scale (lowest to highest) for design/implementation effectiveness; defaults to a five-level red-to-green scale with empty labels.
       * @default [
       *       {
       *         "color": "red.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "orange.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "yellow.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "green.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "green.600",
       *         "label": ""
       *       }
       *     ]
       */
      levels: components["schemas"]["ColoredText"][];
    };
    ControlGroup: {
      control_group_id: components["schemas"]["ControlGroupId"];
      controls: components["schemas"]["PredefinedControlMin"][];
      description: string;
      /** Format: int32 */
      num_controls: number;
      title: string;
    };
    ControlGroupId: Nominal<string, "ControlGroupId">;
    ControlGroupIdPath: {control_group_id: components["schemas"]["ControlGroupId"]};
    ControlGroupMin: {
      control_group_id: components["schemas"]["ControlGroupId"];
      description: string;
      /** Format: int32 */
      num_controls: number;
      title: string;
    };
    ControlIdentificationChanged: {
      description?: string | null;
      /** @description True if this is the first identification, false if re-identification. */
      is_new: boolean;
      modules?: components["schemas"]["ControlModuleSelection"] | null;
      scope_types?: components["schemas"]["TprmScopeType"][] | null;
      title?: string | null;
    };
    ControlIdentificationContent: {
      /** @default false */
      deleted: boolean;
      description: string;
      /** @default false */
      is_required: boolean;
      modules: components["schemas"]["ControlModuleSelection"];
      /** @default null */
      predefined_control_id: components["schemas"]["PredefinedControlId"] | null;
      /** @default [] */
      scope_types: components["schemas"]["TprmScopeType"][];
      /** @default [] */
      scopes: components["schemas"]["TprmScopeId"][];
      title: string;
    };
    ControlMetChangedContent: {
      /** @default null */
      control: components["schemas"]["PredefinedControlMin"] | null;
      old_met?: boolean | null;
    };
    ControlModuleSelection: {
      design?: components["schemas"]["DesignModuleTemplateId"] | null;
      implementation?: components["schemas"]["ImplementationModuleTemplateId"] | null;
      operating_effectiveness?: components["schemas"]["OeModuleTemplateId"] | null;
      representation?: components["schemas"]["RepresentationModuleTemplateId"] | null;
    };
    ControlNode: {assessment_control_id: components["schemas"]["AssessmentControlId"]};
    /**
     * @description Notification payload for any assessment control (predefined or custom).
     *     Uses ControlIdentification as the source of truth for the title.
     *
     *     Old fields (`predefined_control_id`, `group`) are optional for backwards
     *     compatibility with persisted notifications that pre-date custom controls.
     */
    ControlNotificationMin: {
      assessment: components["schemas"]["AssessmentNotificationMin"];
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      /** @description Present only for predefined controls, retained for backwards compat. */
      group?: components["schemas"]["ControlGroupMin"] | null;
      /** @description Present only for predefined controls, retained for backwards compat. */
      predefined_control_id?: components["schemas"]["PredefinedControlId"] | null;
      title: string;
    };
    ControlOEModuleTemplate: {
      /**
       * @description Extra instructions for the AI prompt that judges operating effectiveness of an individual sample; omit for the default prompt.
       * @default null
       */
      control_effectiveness_prompt: string | null;
      /**
       * @description Ordered rating scale (lowest to highest) for the overall OE conclusion; defaults to a five-level red-to-green scale with empty labels.
       * @default [
       *       {
       *         "color": "red.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "orange.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "yellow.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "green.400",
       *         "label": ""
       *       },
       *       {
       *         "color": "green.600",
       *         "label": ""
       *       }
       *     ]
       */
      levels: components["schemas"]["ColoredText"][];
      /**
       * @description Extra instructions for the AI prompt that rolls the per-sample results up into an overall OE conclusion; omit for the default prompt.
       * @default null
       */
      overall_effectiveness_prompt: string | null;
    };
    /** @description Operating effectiveness for one control at one scope. */
    ControlOe: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      basis: components["schemas"]["ControlOeBasisItem"][];
      /**
       * @description Set while an AI conclusion is being generated; `draft_conclusion` carries
       *     the suggestion once it lands.
       */
      concluding_task?: components["schemas"]["PendingBackgroundTask"] | null;
      /**
       * @description Absent until concluded. A condition pointing here then reads as not-yet-
       *     concluded, a distinct state from failing.
       */
      conclusion?: components["schemas"]["ControlOeConclusion"] | null;
      control_oe_id: components["schemas"]["ControlOeId"];
      /** @description The period's coverage by the accepted basis. */
      coverage: components["schemas"]["CoverageSegment"][];
      created_at: components["schemas"]["DateTime"];
      /**
       * @description The AI-suggested conclusion, awaiting the auditor's accept or discard.
       *     Separate from the live `conclusion` so a suggestion never reads as decided.
       */
      draft_conclusion?: components["schemas"]["ControlOeConclusion"] | null;
      /**
       * @description The period's coverage were the drafted plan accepted, present while one
       *     awaits review.
       */
      draft_coverage?: components["schemas"]["CoverageSegment"][] | null;
      engagement_id: components["schemas"]["EngagementId"];
      /**
       * @description The scale conclusions and condition bars resolve against, read from the
       *     control's selected OE module template.
       */
      levels: components["schemas"]["ColoredText"][];
      period: components["schemas"]["DateRange"];
      /** @description The auditor's steer, kept so a plan can be regenerated without retyping it. */
      planning_prompt?: string | null;
      /**
       * @description Set while an AI plan is being generated for this assessment; the basis then
       *     carries the drafted items once it lands.
       */
      planning_task?: components["schemas"]["PendingBackgroundTask"] | null;
      reliance: components["schemas"]["Reliance"];
      scope_id: components["schemas"]["TprmScopeId"];
      updated_at: components["schemas"]["DateTime"];
    };
    /** @description One strand of the argument. */
    ControlOeBasisItem: {
      basis_item_id: components["schemas"]["ControlOeBasisItemId"];
      /**
       * @description What in the documents backs this item up. A whole document is cited as a
       *     `WholeSource` extract, so attaching and quoting use the same mechanism.
       */
      citations: components["schemas"]["Citation"][];
      conditions: components["schemas"]["ControlOeCondition"][];
      created_at: components["schemas"]["DateTime"];
      /** @description True for a not-yet-accepted item from an AI-drafted plan. */
      draft: boolean;
      evidence: components["schemas"]["BasisEvidence"];
      /**
       * @description Present when the item has been set aside; it then takes no part in
       *     coverage.
       */
      exclusion?: components["schemas"]["BasisItemExclusion"] | null;
      /** Format: int32 */
      sort_order: number;
      /** @description The stretch of the period this item claims to cover. Usually all of it. */
      span: components["schemas"]["DateRange"];
      standing: components["schemas"]["ItemStanding"];
      /** @description Derived from `evidence` and `citations`, never stored. */
      status: components["schemas"]["BasisItemStatus"];
      updated_at: components["schemas"]["DateTime"];
    };
    ControlOeBasisItemId: Nominal<string, "ControlOeBasisItemId">;
    /** @description The conclusion reached on a control-and-scope. */
    ControlOeConclusion: {
      justification: string;
      /**
       * @description The level `rating` resolves to on the live scale, absent when the rating
       *     overshoots a since-shortened scale — read as unresolvable, not clamped.
       */
      level?: components["schemas"]["ColoredText"] | null;
      /**
       * Format: int32
       * @description 1-based index into the OE module's `levels`.
       */
      rating: number;
    };
    /** @description What must hold for a basis item to contribute coverage. */
    ControlOeCondition:
      | {
          asserted_at?: components["schemas"]["DateTime"] | null;
          asserted_by?: components["schemas"]["UserMin"] | null;
          assessment: components["schemas"]["NoteAssessment"];
          condition_id: components["schemas"]["ControlOeConditionId"];
          text: string;
          /** @enum {string} */
          type: "Note";
        }
      | {
          condition_id: components["schemas"]["ControlOeConditionId"];
          /**
           * Format: int32
           * @description The required bar, as a 1-based index into the *target's* scale. Lives on
           *     the relationship, as different consumers need different comfort.
           */
          min_rating: number;
          /** @description Why the dependency exists, e.g. a named complementary user entity control. */
          provenance?: string | null;
          /**
           * @description The level `min_rating` names on the target's live scale, absent when it
           *     falls outside it — the dependency then resolves `Unresolvable`.
           */
          required_level?: components["schemas"]["ColoredText"] | null;
          /**
           * @description How the dependency resolves against the target's current conclusion,
           *     computed server-side so an upstream downgrade needs no restatement.
           */
          resolution: components["schemas"]["ControlConditionResolution"];
          target: components["schemas"]["ControlOeMin"];
          /** @enum {string} */
          type: "Control";
        };
    ControlOeConditionId: Nominal<string, "ControlOeConditionId">;
    ControlOeId: Nominal<string, "ControlOeId">;
    ControlOeIdPath: {control_oe_id: components["schemas"]["ControlOeId"]};
    /**
     * @description Enough of an OE assessment to resolve a dependency against it, without loading
     *     its basis.
     */
    ControlOeMin: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      conclusion?: components["schemas"]["ControlOeConclusion"] | null;
      control_oe_id: components["schemas"]["ControlOeId"];
      /**
       * @description The target control's title, so a condition pointing here reads without the
       *     consumer holding its own copy of the engagement's controls.
       */
      control_title: string;
      period: components["schemas"]["DateRange"];
      reliance: components["schemas"]["Reliance"];
      scope_id: components["schemas"]["TprmScopeId"];
      scope_label: string;
    };
    /**
     * @description A candidate target for a control dependency: an OE assessment in the
     *     engagement, with the scale a bar is chosen against.
     */
    ControlOeTarget: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      /**
       * @description The assessment the target belongs to, so a matrix can group its axes by
       *     assessment.
       */
      assessment_id: components["schemas"]["AssessmentId"];
      /**
       * @description The target's own conclusion, so the dependency map can show each node's
       *     state without a per-node read. Absent until it concludes.
       */
      conclusion?: components["schemas"]["ControlOeConclusion"] | null;
      control_oe_id: components["schemas"]["ControlOeId"];
      control_title: string;
      /** @description The target's effectiveness scale, for choosing the required level. */
      levels: components["schemas"]["ColoredText"][];
      reliance: components["schemas"]["Reliance"];
      scope_id: components["schemas"]["TprmScopeId"];
      scope_label: string;
    };
    ControlProcessStepPath: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      process_step_id: components["schemas"]["ProcessStepId"];
    };
    ControlRelevanceChangedContent: {
      /** @default null */
      control: components["schemas"]["PredefinedControlMin"] | null;
      was_relevant: boolean;
    };
    ControlRepresentationChanged: {
      justification: string;
      scope_id?: components["schemas"]["TprmScopeId"] | null;
      /** Format: int32 */
      score: number;
    };
    ControlRepresentationContent: {
      citations?: components["schemas"]["Citation"][] | null;
      justification: string;
      /** Format: int32 */
      score: number;
    };
    ControlRepresentationModuleTemplate: {
      /**
       * @description Extra instructions appended to the AI prompt used to evaluate management's control representation; leave empty for the default prompt.
       * @default
       */
      custom_prompt: string;
      /**
       * @description Ordered rating scale (lowest to highest) shown for the representation outcome; defaults to a two-level `Not asserted`/`Asserted` scale.
       * @default [
       *       {
       *         "color": "red.400",
       *         "label": "Not asserted"
       *       },
       *       {
       *         "color": "green.400",
       *         "label": "Asserted"
       *       }
       *     ]
       */
      levels: components["schemas"]["ColoredText"][];
    };
    ControlScopeAssessmentContent: {
      citations: components["schemas"]["Citation"][];
      explanation: string;
      met?: boolean | null;
    };
    ControlScopeChangedContent: {
      /** @default null */
      control: components["schemas"]["PredefinedControlMin"] | null;
      scope_id: components["schemas"]["TprmScopeId"];
    };
    ControlScopeMetChangedContent: {old_met?: boolean | null; scope_id: components["schemas"]["TprmScopeId"]};
    ControlScopeNode: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    ControlScopeSelectionContent: {
      /** @default false */
      deleted: boolean;
      /** @default false */
      is_required: boolean;
      /**
       * @default {
       *       "design": null,
       *       "implementation": null,
       *       "operating_effectiveness": null,
       *       "representation": null
       *     }
       */
      modules: components["schemas"]["ControlModuleSelection"];
      scope_ids: components["schemas"]["TprmScopeId"][];
    };
    /**
     * @description Curated chat-UI delta for the in-progress assistant turn. The runtime
     *     converts `platformed_llm::StreamEvent`s into these and publishes them on
     *     the conversation's live channel as the model streams. Transient — never
     *     persisted.
     */
    ConversationAssistantDelta:
      | {
          /** @enum {string} */
          type: "NewTextPart";
        }
      | {
          content: {call_id: string; name: string};
          /** @enum {string} */
          type: "NewToolCallPart";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "TextChunk";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "ToolCallArgumentsChunk";
        }
      | {
          /** @enum {string} */
          type: "Reset";
        };
    /** @description `kind = 'assistant'`. */
    ConversationAssistantPayload: {content: components["schemas"]["AssistantParts"]};
    /**
     * @description `kind = 'compaction'`. The rebuilt prompt returned by
     *     `platformed_llm::Compactor::compact`, plus a checkpoint of the
     *     running usage total at the moment the compaction fired — the
     *     runtime walks `list_events_for_prompt` (which starts at the most
     *     recent compaction) to seed its accumulator, and the per-event
     *     `usage` field on Assistant rows only contributes for events that
     *     are still in the slice. Without this checkpoint a resumed runner
     *     would lose every pre-compaction Assistant's usage when computing
     *     the running total.
     */
    ConversationCompactionPayload: {
      /**
       * @description Cumulative usage across every Assistant event the conversation
       *     produced before this compaction was written.
       * @default {
       *       "cache_creation_input_tokens": null,
       *       "cache_read_input_tokens": null,
       *       "input_tokens": 0,
       *       "output_tokens": 0
       *     }
       */
      cumulative_usage: components["schemas"]["UsageTotals"];
      rebuilt_prompt: components["schemas"]["InputItems"];
    };
    /**
     * @description Configuration captured at conversation creation. The chat product
     *     uses `ChatAssistant`-style variants; assessment-driven callers use
     *     bounded variants that don't carry user/mention/file plumbing.
     */
    ConversationConfig: {
      /**
       * @description User identity adopted by the assistant in chat-style conversations.
       *     Bounded callers leave this `None`.
       */
      agent_user_id?: components["schemas"]["UserId"] | null;
      ai_model: components["schemas"]["AiModel"];
      function: components["schemas"]["ConversationFunction"];
    };
    /**
     * @description `kind = 'error'`. A failure the runtime hit mid-tick, recorded in
     *     history so it's visible on the internal dashboard. Non-terminal: an
     *     `Error` event is a pure annotation, excluded from the prompt the LLM
     *     sees and from the drive classifier, so a `retryable` failure resumes
     *     straight past it. `retryable` mirrors the conversation's resulting
     *     status (`FailedRetryable` vs `Failed`) at the moment the error was
     *     recorded — kept per-event so a conversation that fails several times
     *     shows each failure's disposition.
     */
    ConversationErrorPayload: {message: string; retryable: boolean};
    /** @description A single event in the conversation log. */
    ConversationEvent: {
      created_at: components["schemas"]["DateTime"];
      /** Format: int64 */
      event_seq: number;
      files: components["schemas"]["File"][];
      /** @description `Assistant` only. */
      finish_reason?: components["schemas"]["FinishReason"] | null;
      /**
       * @description `User` only. Marks a message that should interrupt the in-flight
       *     assistant tick.
       */
      interrupt: boolean;
      mentions: components["schemas"]["Mention"][];
      payload: components["schemas"]["ConversationEventPayload"];
      /** @description `Assistant` only. */
      usage?: components["schemas"]["Usage2"] | null;
      /**
       * @description `User` only — the human who sent the message. May be null on a
       *     synthetic user turn produced by aggregating tool results.
       */
      user?: components["schemas"]["UserMin"] | null;
    };
    /**
     * @description Tagged union surfaced over the API and PubSub. The persisted layer
     *     stores `kind` as a column and `payload` as JSONB; this enum is the
     *     reconstructed view.
     */
    ConversationEventPayload:
      | {
          content: components["schemas"]["ConversationSystemPayload"];
          /** @enum {string} */
          type: "System";
        }
      | {
          content: components["schemas"]["ConversationUserPayload"];
          /** @enum {string} */
          type: "User";
        }
      | {
          content: components["schemas"]["ConversationAssistantPayload"];
          /** @enum {string} */
          type: "Assistant";
        }
      | {
          content: components["schemas"]["ConversationToolResultPayload"];
          /** @enum {string} */
          type: "ToolResult";
        }
      | {
          content: components["schemas"]["ConversationCompactionPayload"];
          /** @enum {string} */
          type: "Compaction";
        }
      | {
          content: components["schemas"]["ConversationTerminalPayload"];
          /** @enum {string} */
          type: "Terminal";
        }
      | {
          content: components["schemas"]["ConversationErrorPayload"];
          /** @enum {string} */
          type: "Error";
        };
    /**
     * @description How the conversation is scheduled. Recorded for debugging/introspection;
     *     the persisted event stream is identical regardless of which adapter
     *     drives it.
     */
    ConversationExecutorKind: "inline" | "task_chain";
    /**
     * @description Per-conversation function — defines the system prompt and the tool
     *     set the runtime hands the model. Each variant is either the
     *     tenant-facing chat assistant or a bounded agent that records a
     *     specific TPRM decision.
     */
    ConversationFunction:
      | {
          content: components["schemas"]["AssessmentAssistantFunction"];
          /** @enum {string} */
          type: "AssessmentAssistant";
        }
      | {
          content: components["schemas"]["AssessControlDesignImplementationFunction"];
          /** @enum {string} */
          type: "AssessControlDesignImplementation";
        }
      | {
          content: components["schemas"]["AssessControlRepresentationFunction"];
          /** @enum {string} */
          type: "AssessControlRepresentation";
        }
      | {
          content: components["schemas"]["AssessControlAssessmentFunction"];
          /** @enum {string} */
          type: "AssessControlAssessment";
        }
      | {
          content: components["schemas"]["PlanControlOeFunction"];
          /** @enum {string} */
          type: "PlanControlOe";
        }
      | {
          content: components["schemas"]["ConcludeControlOeFunction"];
          /** @enum {string} */
          type: "ConcludeControlOe";
        }
      | {
          content: components["schemas"]["EvaluateControlDesignImplementationFunction"];
          /** @enum {string} */
          type: "EvaluateControlDesignImplementation";
        }
      | {
          content: components["schemas"]["CombineControlRepresentationFunction"];
          /** @enum {string} */
          type: "CombineControlRepresentation";
        }
      | {
          content: components["schemas"]["CombineControlDesignImplementationEvaluationFunction"];
          /** @enum {string} */
          type: "CombineControlDesignImplementationEvaluation";
        }
      | {
          content: components["schemas"]["MapRiskRelevantControlsFunction"];
          /** @enum {string} */
          type: "MapRiskRelevantControls";
        }
      | {
          content: components["schemas"]["DiscoverGenerativeRisksFunction"];
          /** @enum {string} */
          type: "DiscoverGenerativeRisks";
        }
      | {
          content: components["schemas"]["ReuseRisksFunction"];
          /** @enum {string} */
          type: "ReuseRisks";
        }
      | {
          content: components["schemas"]["ContextualizePredefinedRiskFunction"];
          /** @enum {string} */
          type: "ContextualizePredefinedRisk";
        }
      | {
          content: components["schemas"]["GenerateControlFindingsFunction"];
          /** @enum {string} */
          type: "GenerateControlFindings";
        }
      | {
          content: components["schemas"]["ReuseFindingsFunction"];
          /** @enum {string} */
          type: "ReuseFindings";
        }
      | {
          content: components["schemas"]["MapToStandardFindingFunction"];
          /** @enum {string} */
          type: "MapToStandardFinding";
        }
      | {
          content: components["schemas"]["QuantifyBasicInherentRiskFunction"];
          /** @enum {string} */
          type: "QuantifyBasicInherentRisk";
        }
      | {
          content: components["schemas"]["QuantifyBasicResidualRiskFunction"];
          /** @enum {string} */
          type: "QuantifyBasicResidualRisk";
        }
      | {
          content: components["schemas"]["QuantifyComponentWiseInherentRiskFunction"];
          /** @enum {string} */
          type: "QuantifyComponentWiseInherentRisk";
        }
      | {
          content: components["schemas"]["QuantifyComponentWiseResidualRiskFunction"];
          /** @enum {string} */
          type: "QuantifyComponentWiseResidualRisk";
        }
      | {
          content: components["schemas"]["SuggestExtractionFieldsFunction"];
          /** @enum {string} */
          type: "SuggestExtractionFields";
        }
      | {
          content: components["schemas"]["MapTestEvidenceFunction"];
          /** @enum {string} */
          type: "MapTestEvidence";
        }
      | {
          content: components["schemas"]["ExtractTestDataFunction"];
          /** @enum {string} */
          type: "ExtractTestData";
        }
      | {
          content: components["schemas"]["RunTestResultsFunction"];
          /** @enum {string} */
          type: "RunTestResults";
        }
      | {
          content: components["schemas"]["ConcludeTestFunction"];
          /** @enum {string} */
          type: "ConcludeTest";
        }
      | {
          content: components["schemas"]["PopulationExtractionFunction"];
          /** @enum {string} */
          type: "PopulationExtraction";
        };
    /** @description Auto-generated discriminant enum variants */
    ConversationFunctionKind:
      | "AssessmentAssistant"
      | "AssessControlDesignImplementation"
      | "AssessControlRepresentation"
      | "AssessControlAssessment"
      | "PlanControlOe"
      | "ConcludeControlOe"
      | "EvaluateControlDesignImplementation"
      | "CombineControlRepresentation"
      | "CombineControlDesignImplementationEvaluation"
      | "MapRiskRelevantControls"
      | "DiscoverGenerativeRisks"
      | "ReuseRisks"
      | "ContextualizePredefinedRisk"
      | "GenerateControlFindings"
      | "ReuseFindings"
      | "MapToStandardFinding"
      | "QuantifyBasicInherentRisk"
      | "QuantifyBasicResidualRisk"
      | "QuantifyComponentWiseInherentRisk"
      | "QuantifyComponentWiseResidualRisk"
      | "SuggestExtractionFields"
      | "MapTestEvidence"
      | "ExtractTestData"
      | "RunTestResults"
      | "ConcludeTest"
      | "PopulationExtraction";
    ConversationId: Nominal<string, "ConversationId">;
    ConversationIdPath: {conversation_id: components["schemas"]["ConversationId"]};
    /**
     * @description PubSub event payload carried over the per-conversation live channel.
     *     Three shapes: a durable-append notification, transient assistant token
     *     deltas (not persisted), and a compaction cue.
     *
     *     `EventAppended` carries only the `event_seq`, not the event body. A single
     *     `conversation_event` can be large — a `read_source` tool result runs to
     *     tens of kilobytes — and the pinned Pusher client rejects bodies over ~10 KB
     *     before the HTTP call, which would silently drop exactly the events most
     *     worth watching. So subscribers treat it as a notification and refetch the
     *     durable event, mirroring `agent_session`'s notify-and-refetch. Token deltas
     *     are always small, so they stay inline.
     *
     *     `AssistantDelta` carries no `event_seq` — the runtime publishes deltas
     *     *before* the durable `Assistant` event lands, so the seq isn't known yet.
     *     Subscribers treat the delta stream as belonging to "the in-progress
     *     assistant bubble" and discard it when the `Assistant` turn's `EventAppended`
     *     triggers a refetch.
     */
    ConversationLiveEvent:
      | {
          content: {
            /** Format: int64 */
            event_seq: number;
          };
          /** @enum {string} */
          type: "EventAppended";
        }
      | {
          content: components["schemas"]["ConversationAssistantDelta"];
          /** @enum {string} */
          type: "AssistantDelta";
        }
      | {
          /** @enum {string} */
          type: "Compacting";
        };
    /**
     * @description A TPRM entity a conversation can be filtered against. The
     *     conversation carries the entity's ID inside `config.function.content`
     *     (no foreign key), so filtering matches that ID against the JSON. Each
     *     variant names the `content` field its ID lives under.
     */
    ConversationRefKind: "assessment" | "control" | "risk" | "finding";
    /**
     * @description Conversation lifecycle. `Running` means a tick is actively executing
     *     (the executor crashed if `Running` outlives its task lock); `Idle`
     *     means the conversation is waiting for an external event (more input,
     *     the next CPS tick); `Terminated` / `Failed` are sticky terminal
     *     states. `FailedRetryable` is a *non-terminal* failure: a tick hit a
     *     transient error, so the runtime left the conversation resumable —
     *     re-entering it drives on from the last durable event rather than
     *     short-circuiting the way a `Failed` row does.
     * @enum {string}
     */
    ConversationStatus: "running" | "idle" | "terminated" | "failed" | "failed_retryable";
    /**
     * @description Broadcast payload for the internal conversations dashboard's live list.
     *     Emitted on the global staff-only `private-internal-conversations` channel
     *     whenever a conversation is created or changes status. Carries everything a
     *     list row needs except the account display name, which the dashboard
     *     resolves from its already-loaded accounts list keyed by `account_id`.
     */
    ConversationSummaryChanged: {
      account_id: components["schemas"]["AccountId"];
      /**
       * @description Pusher channel for this conversation's live updates. Server-built (via
       *     `conversation_channel_name`) so a row inserted from this broadcast
       *     subscribes to the same channel the list rows do, without the frontend
       *     reconstructing the format.
       */
      channel_name: string;
      config: components["schemas"]["ConversationConfig"];
      conversation_id: components["schemas"]["ConversationId"];
      created_at: components["schemas"]["DateTime"];
      /** Format: int64 */
      event_count: number;
      executor_kind: components["schemas"]["ConversationExecutorKind"];
      /**
       * @description Region the conversation lives in — the dashboard needs it to build the
       *     detail link and to bucket the row, since the broadcast is a single
       *     global channel rather than one per region.
       */
      region: components["schemas"]["Region"];
      /**
       * @description Set once the conversation has been retired from the internal
       *     dashboard — the caller's next `find_or_create` skips it and starts
       *     a fresh conversation. The dashboard badges retired rows.
       */
      retired_at?: components["schemas"]["DateTime"] | null;
      status: components["schemas"]["ConversationStatus"];
      terminal_at?: components["schemas"]["DateTime"] | null;
    };
    /** @description `kind = 'system'`. */
    ConversationSystemPayload: {content: string};
    /** @description `kind = 'terminal'`. */
    ConversationTerminalPayload: {outcome: components["schemas"]["TerminalOutcome"]};
    /**
     * @description Which time-like column the shared `from`/`to` window applies to on the
     *     conversations dashboard. Dashboard-specific: each internal dashboard
     *     defines its own enum here. Defaults to `CreatedAt`.
     * @enum {string}
     */
    ConversationTimeField: "created_at" | "terminal_at";
    /**
     * @description `kind = 'tool_result'`. One row per tool invocation; the runtime
     *     folds contiguous tool-result events into a synthetic user turn when
     *     rebuilding the prompt for the next LLM call.
     */
    ConversationToolResultPayload: {call_id: string; output: components["schemas"]["UserParts"]};
    /** @description `kind = 'user'`. */
    ConversationUserPayload: {
      content: components["schemas"]["UserParts"];
      /** @description Sent by the runtime, refusing the model's final turn. */
      nudge?: boolean;
    };
    CoreResponse: {
      access_level: components["schemas"]["AccessLevel"];
      core_response_id: components["schemas"]["CoreResponseId"];
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
      question_text: string;
      response_text: string;
    };
    CoreResponseId: Nominal<string, "CoreResponseId">;
    CoreResponseIdPath: {id: components["schemas"]["CoreResponseId"]};
    CountResolutionsArgs: {
      /** @default false */
      assigned_to_me: boolean;
    };
    Counterparty: {
      counterparty_id: components["schemas"]["CounterpartyId"];
      crm_connection_id?: components["schemas"]["CrmConnectionId"] | null;
      crm_last_modified?: components["schemas"]["DateTime"] | null;
      language_code: string;
      name: string;
      uri?: string | null;
      url: string;
    };
    CounterpartyId: Nominal<string, "CounterpartyId">;
    CounterpartyIdPath: {counterparty_id: components["schemas"]["CounterpartyId"]};
    CountersQuery: {
      /**
       * @description Comma-separated conversation IDs. Encoded as one string because
       *     `axum::extract::Query` doesn't decode arrays natively.
       */
      ids?: string | null;
    };
    /** @description A run of consecutive days of the period in the same state. */
    CoverageSegment: {span: components["schemas"]["DateRange"]; state: components["schemas"]["CoverageState"]};
    /** @enum {string} */
    CoverageState: "Failed" | "Covered" | "Outstanding" | "Gap";
    CreateAccessToken: {
      affiliated_account_id?: components["schemas"]["AccountId"] | null;
      client_account_id: components["schemas"]["AccountId"];
      scope: components["schemas"]["AccessScope"];
      user_id: components["schemas"]["UserId"];
    };
    CreateAccount: {
      display_name: string;
      /** @default false */
      enable_analysis: boolean;
      /** @default [] */
      features: components["schemas"]["AccountFeature"][];
      name: string;
      preset?: components["schemas"]["PresetConfig"] | null;
      type_: components["schemas"]["AccountType"];
    };
    CreateAdHocQuestion: {
      asker_id?: components["schemas"]["UserId"] | null;
      question: components["schemas"]["CreateQuestion"];
      question_source_id?: components["schemas"]["QuestionSourceId"] | null;
      scope_matrix: components["schemas"]["ScopeMatrix"];
      source_url?: string | null;
    };
    CreateAgentSessionUserMessage: {
      file_ids: components["schemas"]["FileId"][];
      interrupt: boolean;
      mentions: components["schemas"]["CreateMention"][];
      payload: components["schemas"]["UserMessagePayload"];
    };
    CreateAssessment: {
      /**
       * @description The specific scoped complexity assessment whose tier triggered this
       *     framework run. Persisted as the paired `complexity_assessment_id` +
       *     `complexity_assessment_scope_id` columns on `tprm.assessment`
       *     (enforced by the `assessment_complexity_columns_consistent` CHECK).
       */
      complexity_scoped_assessment?: components["schemas"]["ComplexityScopedAssessmentRef"] | null;
      control_mode: components["schemas"]["AssessmentControlMode"];
      driving_source_context?: string | null;
      driving_source_ref?: components["schemas"]["SourceRef"] | null;
      driving_source_type?: components["schemas"]["AuditAreaType"] | null;
      engagement_id: components["schemas"]["EngagementId"];
      framework_version_id: components["schemas"]["FrameworkVersionId"];
      name?: string | null;
      operational_context_id?: components["schemas"]["OperationalContextId"] | null;
      owner_id?: components["schemas"]["OwnerId"] | null;
    };
    CreateAssessmentDecision: {
      node_id: components["schemas"]["AssessmentNodeId"];
      record: components["schemas"]["RecordAssessmentDecision"];
    };
    CreateAsset: {
      file_id: components["schemas"]["FileId"];
      owner?: components["schemas"]["AssetOwner"] | null;
      title: string;
    };
    CreateAttributeEvidence: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      evidence_text: string;
      relevance_explanation: string;
      source_context: string;
      source_ref: components["schemas"]["SourceRef"];
    };
    /** @description Request body for creating a new audit area with all its sub-pages. */
    CreateAuditArea: {
      /** @description Description / context for the understanding. */
      context: string;
      /**
       * @description Framework versions to create an assessment for, one per version.
       * @default []
       */
      framework_version_ids: components["schemas"]["FrameworkVersionId"][];
      /** @description Display name for the audit area, also used as the understanding's name. */
      name: string;
      /** @description The parent page (Processes or EntityLevelControls section). */
      parent_page_id: components["schemas"]["AuditPlanPageId"];
    };
    CreateAuditAreaAssessment: {
      control_mode: components["schemas"]["AssessmentControlMode"];
      /** @description The framework version to use for the assessment. */
      framework_version_id: components["schemas"]["FrameworkVersionId"];
    };
    CreateAuditAreaComplexity: {
      /**
       * @description The complexity model to assess against. Its latest published version is
       *     resolved at creation time.
       */
      complexity_model_id: components["schemas"]["ComplexityModelId"];
    };
    CreateAuditAreaUnderstanding: {
      /** @description Description / context for the understanding. */
      context: string;
    };
    CreateAuditAreasFromQuestionnaireTables: {
      parent_page_id: components["schemas"]["AuditPlanPageId"];
      tables: components["schemas"]["QuestionnaireTableRef"][];
    };
    CreateAuditAreasFromTemplates: {
      audit_area_template_ids: components["schemas"]["AuditAreaTemplateId"][];
      parent_page_id: components["schemas"]["AuditPlanPageId"];
    };
    CreateAutoComplete: {cache_directive: components["schemas"]["CacheDirective"]};
    /**
     * @description Which kind of basis item to add, with whatever intent is known. All optional,
     *     as a planned item is an argument with no evidence yet.
     */
    CreateBasisEvidence:
      | {
          goal?: string | null;
          test_id?: components["schemas"]["TestId"] | null;
          /** @enum {string} */
          type: "Test";
        }
      | {
          expected_report?: string | null;
          provider?: string | null;
          report_period?: components["schemas"]["DateRange"] | null;
          /** @enum {string} */
          type: "WorkOfOthers";
        }
      | {
          assessment_control_id?: components["schemas"]["AssessmentControlId"] | null;
          engagement_id?: components["schemas"]["EngagementId"] | null;
          scope_id?: components["schemas"]["TprmScopeId"] | null;
          /** @enum {string} */
          type: "PriorConclusion";
        };
    CreateBasisItem: {evidence: components["schemas"]["CreateBasisEvidence"]; span: components["schemas"]["DateRange"]};
    CreateComment: {
      file_ids: components["schemas"]["FileId"][];
      mentions: components["schemas"]["CreateMention"][];
      message: components["schemas"]["RichText"];
    };
    CreateComplexityAssessment: {
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      engagement_id: components["schemas"]["EngagementId"];
    };
    CreateComplexityAttribute: {
      /**
       * @description Free-text instructions steering the AI when it suggests a value for
       *     this attribute. Omit to give the AI no extra guidance.
       */
      ai_guidance?: string | null;
      /**
       * @description The data type of values entered for this attribute, which
       *     constrains the conditions its `rules` may use.
       */
      attribute_type: components["schemas"]["ValueType"];
      /**
       * Format: int32
       * @description Score used when no `rules` match (or there are none). Omit
       *     (`null`) to leave the attribute unscored until a rule matches.
       */
      default_score?: number | null;
      /**
       * @description Display name of this attribute / scoring criterion (1-256
       *     characters).
       */
      name: string;
      /**
       * @description How the matching `rules` values are aggregated into this
       *     attribute's score.
       */
      operator: components["schemas"]["ComplexityAggregationOperator"];
      /**
       * @description When `true`, the attribute must be answered for the scoped
       *     assessment to be considered complete.
       */
      required: boolean;
      /**
       * @description Criteria mapping attribute values to scores; matching criteria's
       *     `value`s are aggregated by this attribute's `operator`, falling
       *     back to `default_score` when none match.
       */
      rules: components["schemas"]["ComplexityTierCriterion"][];
      /**
       * Format: int32
       * @description Multiplier applied to this attribute's score; the weighted score
       *     (`score * weight`) is what the version `operator` aggregates.
       */
      weight: number;
    };
    CreateComplexityModel: {name: string; version: components["schemas"]["CreateComplexityModelVersion"]};
    CreateComplexityModelVersion: {
      /**
       * @description The criteria this version scores against. Each attribute produces a
       *     weighted score; the version `operator` then aggregates them into
       *     the overall complexity score that selects a tier.
       */
      attributes: components["schemas"]["CreateComplexityAttribute"][];
      /**
       * @description How the per-attribute weighted scores are aggregated into the
       *     single overall complexity score used to pick a tier.
       */
      operator: components["schemas"]["ComplexityAggregationOperator"];
      /**
       * @description Which engagement scope types this version assesses against.
       *     Defaults to `[Global]` for backwards compatibility — older
       *     callers that omit the field get one assessment per engagement on
       *     its Global scope. Locked once the version is published; changing
       *     requires creating a new version.
       * @default [
       *       "Global"
       *     ]
       */
      scope_types: components["schemas"]["TprmScopeType"][];
      /**
       * @description Ordered score bands that map an aggregated complexity score onto a
       *     named tier. Their `lower_bound`s partition the score range; a score
       *     outside every band yields no tier.
       */
      tiers: components["schemas"]["CreateComplexityTier"][];
      /**
       * @description Human-readable label for this version of the complexity model
       *     (1-256 characters), shown when selecting which version to assess
       *     against.
       */
      version_name: string;
    };
    CreateComplexityTier: {
      /** @description Hex colour used to render this tier's badge in the UI. */
      color: string;
      /**
       * Format: int32
       * @description Inclusive lower bound of this tier's score band; its upper bound is
       *     derived from the next tier's `lower_bound`. Omit (`null`) for the
       *     lowest, open-ended tier.
       */
      lower_bound?: number | null;
      /**
       * @description Display name of this tier (1-256 characters), e.g. `Low`, `Medium`,
       *     `High`.
       */
      name: string;
    };
    CreateControlGroup: {
      /** @default  */
      description: string;
      title: string;
    };
    /**
     * @description Input for starting an OE assessment on a control-and-scope. The period
     *     defaults from the engagement when omitted.
     */
    CreateControlOe: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      period?: components["schemas"]["DateRange"] | null;
      scope_id: components["schemas"]["TprmScopeId"];
    };
    CreateCoreResponse: {
      limited_to_scope_ids?: components["schemas"]["ScopeId"][] | null;
      question_text: string;
      response_text: string;
    };
    CreateCounterparty: {language_code: string; name: string; url: string};
    CreateCrmConnection: {
      config: components["schemas"]["CrmConnectionConfig"];
      connector_id: string;
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      name: string;
    };
    CreateCustomControlRequest: {
      description: string;
      /**
       * @default {
       *       "design": null,
       *       "implementation": null,
       *       "operating_effectiveness": null,
       *       "representation": null
       *     }
       */
      modules: components["schemas"]["ControlModuleSelection"];
      /** @default [] */
      process_step_ids: components["schemas"]["ProcessStepId"][];
      /** @default [] */
      scope_types: components["schemas"]["TprmScopeType"][];
      title: string;
    };
    CreateDataRoomSourceRequest: {scope_id: components["schemas"]["TprmScopeId"]};
    CreateDiagram: {
      context?: string | null;
      description: string;
      diagram_type: components["schemas"]["DiagramType"];
      name: string;
      summary?: string | null;
      understanding_id?: components["schemas"]["UnderstandingId"] | null;
    };
    CreateDocument: {
      authoring_config?: components["schemas"]["Config"] | null;
      authoring_template?: string | null;
      authority: components["schemas"]["DocumentAuthority"];
      category: components["schemas"]["DocumentCategory"];
      certification_audit_report?: components["schemas"]["DocumentId"] | null;
      certification_auditor_url?: string | null;
      certification_date_expires?: components["schemas"]["DateTime"] | null;
      certification_date_granted?: components["schemas"]["DateTime"] | null;
      certification_type?: components["schemas"]["CertificationType"] | null;
      file_id?: components["schemas"]["FileId"] | null;
      limited_to_scope_ids?: components["schemas"]["ScopeId"][] | null;
      markdown?: string | null;
      name: string;
      owner_id: components["schemas"]["OwnerId"];
      review_period: components["schemas"]["ReviewPeriod"];
      sharing_classification: components["schemas"]["SharingClassification"];
    };
    CreateDocumentSource: {
      config: components["schemas"]["DocumentSourceConfig"];
      connector_id: string;
      default_limited_to_scope_ids?: components["schemas"]["ScopeId"][] | null;
      default_owner_id: components["schemas"]["OwnerId"];
      default_sharing_classification: components["schemas"]["SharingClassification"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      name: string;
    };
    CreateDocumentationAttachment:
      | {
          content: {document_id: components["schemas"]["DocumentId"]};
          /** @enum {string} */
          type: "Document";
        }
      | {
          content: {standalone_file_id: components["schemas"]["StandaloneFileId"]};
          /** @enum {string} */
          type: "StandaloneFile";
        };
    CreateEditSystemAgent: {
      config: components["schemas"]["AgentConfig"];
      description?: string | null;
      domain: components["schemas"]["SystemAgentDomain"];
      name: string;
      prompt: string;
    };
    CreateEngagementRequest: {
      /**
       * @description The engagement is created from this template, which is recorded on it.
       *     The template's name becomes the initial engagement type.
       */
      engagement_template_id?: components["schemas"]["EngagementTemplateId"] | null;
      engagement_type?: string | null;
      engagement_window_end?: components["schemas"]["DateTime"] | null;
      engagement_window_start?: components["schemas"]["DateTime"] | null;
      /**
       * @description The entity-level audit area templates chosen for the audit plan. With an
       *     engagement template, they are the optional areas to add to its required
       *     ones. Without one, they are the account's templates to seed, and an
       *     absent list seeds them all.
       */
      entity_level_template_ids?: components["schemas"]["AuditAreaTemplateId"][] | null;
      name: string;
      owner_id?: components["schemas"]["OwnerId"] | null;
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    CreateEsignatureProvider: {
      config: components["schemas"]["EsignatureProviderConfig"];
      connector_type: components["schemas"]["EsignatureProviderConnectorType"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      external_reference?: components["schemas"]["PopulateExternalAccountReference"] | null;
      name: string;
    };
    CreateExternalAuthorization: {
      payload: components["schemas"]["CreateExternalAuthorizationPayload"];
      provider: components["schemas"]["ExternalAuthorizationProvider"];
      purpose: string;
    };
    CreateExternalAuthorizationOAuth: {code: string};
    CreateExternalAuthorizationPayload:
      | {
          content: components["schemas"]["CreateExternalAuthorizationOAuth"];
          /** @enum {string} */
          type: "Oauth";
        }
      | {
          content: components["schemas"]["CreateExternalAuthorizationRaw"];
          /** @enum {string} */
          type: "Raw";
        };
    CreateExternalAuthorizationRaw: {value: string};
    CreateExternalNonce: {
      metadata: components["schemas"]["CreatedAuthorizationMetadata"];
      provider: components["schemas"]["ExternalNonceProvider"];
      purpose: string;
    };
    CreateFileUploadSession: {
      mime_type: string;
      name: string;
      /** Format: int32 */
      size: number;
    };
    CreateFinding: {
      assessment_control_id?: components["schemas"]["AssessmentControlId"] | null;
      content: components["schemas"]["FindingContent"];
    };
    CreateFramework: {icon_file_id?: components["schemas"]["FileId"] | null; is_custom: boolean; name: string};
    CreateFrameworkProfile: {name: string; scope_types: components["schemas"]["TprmScopeType"][]};
    CreateFrameworkVersion: {
      /** @default  */
      custom_findings_prompt: string;
      generate_findings: boolean;
      /** @default false */
      generate_findings_from_missing_evidence: boolean;
      /** @default null */
      risk_quantification: components["schemas"]["RiskQuantificationModel"] | null;
      specification: string;
      version: string;
    };
    CreateLibrarySection: {
      description: string;
      name: string;
      parent_scope_id?: components["schemas"]["ScopeId"] | null;
      parent_section_id?: components["schemas"]["LibrarySectionId"] | null;
    };
    CreateMention: {
      content: components["schemas"]["OwnerId"];
      /** @enum {string} */
      type: "Owner";
    };
    CreateNotificationSink: {
      config: components["schemas"]["NotificationSinkConfig"];
      connector: components["schemas"]["NotificationSinkConnector"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      name: string;
    };
    CreateOperationalContext: {
      assets: components["schemas"]["TprmAssetId"][];
      description: string;
      name: string;
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    CreateOrUpdateReviewerRole: {name: string};
    CreateOrUpdateShowcaseUpdateMessage: {content?: string | null; title?: string | null};
    /** @description Query parameters for creating reviews on an audit plan page. */
    CreatePageReviewsArgs: {
      /**
       * @description When true, the same reviewers are also assigned to every descendant page.
       * @default false
       */
      include_children: boolean;
      /**
       * @description Applies reviewer removals to every descendant page as well as the target. Additions are
       *     governed separately by `include_children`, so a caller can cascade one without the other.
       * @default false
       */
      remove_from_children: boolean;
    };
    /**
     * @description Input for creating a population. Creation only inserts the row, so a name —
     *     itself just a placeholder the frontend supplies — is the whole input.
     *     Sources, agent prompt, description and fields are edited in place on the
     *     resulting draft, and Extract commits it.
     */
    CreatePopulation: {name: string};
    CreatePredefinedControl: {
      control_number?: string | null;
      description: string;
      /** @default null */
      design_module_template_id: components["schemas"]["DesignModuleTemplateId"] | null;
      /** @default null */
      implementation_module_template_id: components["schemas"]["ImplementationModuleTemplateId"] | null;
      /** @default false */
      is_required: boolean;
      /** @default null */
      oe_module_template_id: components["schemas"]["OeModuleTemplateId"] | null;
      /** @default null */
      representation_module_template_id: components["schemas"]["RepresentationModuleTemplateId"] | null;
      title: string;
    };
    CreatePrivateResourceAccessGrant: {
      access: components["schemas"]["PrivateResourceAccess"];
      owner_id?: components["schemas"]["OwnerId"] | null;
    };
    CreateQuestion: {
      guidance?: string | null;
      /**
       * @default {
       *       "files": {
       *         "config": {},
       *         "enabled": {
       *           "content": true,
       *           "type": "Literal"
       *         }
       *       },
       *       "select": {
       *         "config": {
       *           "options": []
       *         },
       *         "enabled": {
       *           "content": false,
       *           "type": "Literal"
       *         }
       *       },
       *       "text": {
       *         "config": {},
       *         "enabled": {
       *           "content": true,
       *           "type": "Literal"
       *         }
       *       },
       *       "yes_no": {
       *         "config": {},
       *         "enabled": {
       *           "content": false,
       *           "type": "Literal"
       *         }
       *       }
       *     }
       */
      parts: components["schemas"]["AnswerParts"];
      question_group?: components["schemas"]["CreateQuestionGroup"] | null;
      question_number?: string | null;
      response_layer: components["schemas"]["CreateResponseLayer"];
      text: string;
    };
    CreateQuestionDocumentation: {attachment: components["schemas"]["CreateDocumentationAttachment"]};
    CreateQuestionGroup: {name: string};
    CreateQuestionGroup2: {name: string};
    CreateQuestionInSection: {
      question: components["schemas"]["CreateQuestion"];
      question_group_id?: components["schemas"]["QuestionGroupId"] | null;
      section_id: components["schemas"]["SectionId"];
    };
    CreateQuestionSource: {
      config: components["schemas"]["QuestionSourceConfig"];
      connector_id: string;
      external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
      name: string;
    };
    CreateQuestionnaire: {
      /** @default false */
      archived: boolean;
      counterparty_id: components["schemas"]["CounterpartyId"];
      due_date?: components["schemas"]["DateTime"] | null;
      /** @default false */
      is_internal: boolean;
      name: string;
      owner_id?: components["schemas"]["OwnerId"] | null;
      /** @default {} */
      prompt_modifiers: components["schemas"]["PromptModifiers"];
      /**
       * @default {
       *       "rows": [
       *         {
       *           "scope_ids": []
       *         }
       *       ]
       *     }
       */
      scope_matrix: components["schemas"]["ScopeMatrix"];
      /** @default [] */
      sections: components["schemas"]["CreateSection"][];
    };
    CreateQuestionnaireDocumentation: {
      attachment: components["schemas"]["CreateDocumentationAttachment"];
      linked_question_ids: components["schemas"]["QuestionId"][];
      linked_to_questionnaire: boolean;
    };
    CreateRegisteredUser: {
      /** Format: email */
      email: string;
      /** @default {} */
      external_ids: {[key: string]: string};
      name: string;
    };
    CreateResponseLayer: {
      due_date?: components["schemas"]["DateTime"] | null;
      owner_id?: components["schemas"]["OwnerId"] | null;
      responder_id?: components["schemas"]["UserId"] | null;
      response_select?: components["schemas"]["ResponseOption"][] | null;
      response_text?: string | null;
      response_yes_no?: boolean | null;
      status: components["schemas"]["QuestionStatus"];
    };
    CreateReviewAction: {
      comment?: string | null;
      review_status: components["schemas"]["ReviewStatus"];
      reviewer_id: components["schemas"]["OwnerId"];
      reviewer_role_id?: components["schemas"]["ReviewerRoleId"] | null;
    };
    CreateRisk: {
      description: string;
      /** Format: int32 */
      predefined_risk_ordinal?: number | null;
      title: string;
    };
    CreateRiskArea: {
      /**
       * @description Detailed description of what risks this area covers; omitting it leaves the area without a description.
       * @default
       */
      description: string;
      /**
       * @description Worked examples of risks that do and do not belong in this area, used to guide classification; omitting it provides no examples.
       * @default []
       */
      examples: components["schemas"]["CreateRiskAreaExampleRisk"][];
      /** @description Short human-readable name of the risk area. */
      title: string;
    };
    CreateRiskAreaExampleRisk: {
      /** @description Whether this is a valid (belongs in the area) or invalid (does not belong) example. */
      kind: components["schemas"]["RiskAreaExampleRiskKind"];
      /**
       * @description Explanation of why this example is valid or invalid for the risk area; omitting it leaves no rationale.
       * @default
       */
      reason: string;
      /** @description The example risk statement used to guide classification into this risk area. */
      risk_text: string;
    };
    CreateRiskContext: {
      risk_area_id?: components["schemas"]["RiskAreaId"] | null;
      source_context: string;
      source_ref: components["schemas"]["SourceRef"];
    };
    /**
     * @description Input for creating a sample. Creation only inserts the row; the description
     *     is set afterwards through [`UpdateSampleDescription`].
     *
     *     The population is optional and, when given, only pre-attached: either way the
     *     choice stays open through [`UpdateSamplePopulation`], as the method does
     *     through [`UpdateSampleMethod`], until the sample is locked.
     */
    CreateSample: {
      method: components["schemas"]["SampleMethod"];
      name: string;
      population_id?: components["schemas"]["PopulationId"] | null;
    };
    CreateSavedView: {
      group: components["schemas"]["SavedViewGroup"];
      make_default: boolean;
      name: string;
      payload: {[key: string]: IValue};
    };
    CreateScimConfig: {name: string; send_invitations: boolean};
    CreateScope: {axis_id: components["schemas"]["ScopeAxisId"]; name: string};
    CreateScopeAxis: {
      color: string;
      /** @default  */
      description: string;
      name: string;
    };
    CreateSection: {description: string; questions: components["schemas"]["CreateQuestion"][]; title: string};
    CreateServiceUser: {description: string; name: string};
    CreateSource: {
      context: string;
      /** @description Whether this source should be visible in control evaluations. If not specified, defaults to true. */
      control_visible?: boolean | null;
      /** @description Which external questionnaire created this source? */
      external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      kind: components["schemas"]["CreateSourceKind"];
      name: string;
      /**
       * @description Whether this source was created specifically for operating effectiveness testing.
       *     When true, the source is primarily intended for OE workflows.
       */
      operating_effectiveness_visible?: boolean | null;
      /** @description If this is a child source (e.g. images extracted from a document), this is the parent source ID */
      parent_source_id?: components["schemas"]["SourceId"] | null;
      /** @description Whether this source should be visible in risk assessments. If not specified, defaults to true. */
      risk_visible?: boolean | null;
    };
    CreateSourceKind:
      | {
          id: components["schemas"]["FileId"];
          /** @enum {string} */
          type: "File";
        }
      | {
          id: components["schemas"]["TprmQuestionnaireId"];
          /** @enum {string} */
          type: "Questionnaire";
        };
    CreateSourcesParams: {
      /** @default false */
      skip_invalidation: boolean;
    };
    CreateStandaloneFile: {
      file_id: components["schemas"]["FileId"];
      sharing_classification: components["schemas"]["SharingClassification"];
    };
    CreateStandardFinding: {finding: string; implication: string; recommendations: string; title: string};
    CreateTeam: {description?: string | null; name: string};
    /**
     * @description Input for creating a test. Creation only inserts the row; the description is
     *     set afterwards through [`UpdateTestDescription`].
     *
     *     Both references are optional and, when given, pre-attached: `sample_id`
     *     names the sample, `test_template_id` the template whose latest version the
     *     draft pins. Both stay open through the attach endpoints until the test is
     *     made ready.
     */
    CreateTest: {
      name: string;
      sample_id?: components["schemas"]["SampleId"] | null;
      test_template_id?: components["schemas"]["TestTemplateId"] | null;
    };
    /** @description Input for creating a template (creates version 1). */
    CreateTestTemplate: {config: components["schemas"]["TestTemplateConfig"]; name: string};
    /** @description Input for appending a new version to an existing template. */
    CreateTestTemplateVersion: {config: components["schemas"]["TestTemplateConfig"]};
    CreateThirdParty: {
      due_date?: components["schemas"]["DateTime"] | null;
      external_id?: string | null;
      name: string;
      owner_id?: components["schemas"]["OwnerId"] | null;
      /**
       * @description `None` falls back to the account's `default_client_private` preference.
       * @default null
       */
      private: boolean | null;
      /** @default [] */
      tag_ids: components["schemas"]["ThirdPartyTagId"][];
      tier_id?: components["schemas"]["ThirdPartyTierId"] | null;
      url: string;
    };
    CreateThirdPartyTag: {color: string; title: string};
    CreateThirdPartyTier: {color: string; title: string};
    CreateTprmAsset: {description: string; name: string};
    CreateTprmExternalQuestionnaire: {
      /** @default true */
      client_visible: boolean;
      email_context?: string | null;
      engagement_id: components["schemas"]["EngagementId"];
      /** @default false */
      notify_client: boolean;
      parent_external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
      use_latest_version: boolean;
    };
    CreateTprmQuestionnaireModel: {name: string};
    CreateTprmReportTemplate: {
      /** @default {} */
      ai_prompts: {[key: string]: string};
      name: string;
      /** @default false */
      portal_enabled: boolean;
      type_: components["schemas"]["TprmReportTemplateType"];
    };
    CreateTprmScope: {
      external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      name: string;
      scope_type: components["schemas"]["TprmScopeType"];
    };
    CreateTrustCenterContent: {content: string; title: string};
    CreateUnderstanding: {
      audit_area_type: components["schemas"]["AuditAreaType"];
      context: components["schemas"]["UnderstandingContext"];
      /** @default false */
      hidden: boolean;
      name: string;
    };
    CreateUpdateTierAssessmentAutorun: {
      complexity_tier_id: components["schemas"]["ComplexityTierId"];
      framework_id: components["schemas"]["FrameworkId"];
      framework_version_id: components["schemas"]["FrameworkVersionId"];
    };
    CreateVerifiedDomain: {domain: string; enable_self_enrollment: boolean};
    /**
     * @description Contains metadata only available on the initial call to authorize an OAuth token, such as an external
     *     user ID or a workspace identifier.
     */
    CreatedAuthorizationMetadata: {
      external_account_id?: string | null;
      external_domain?: string | null;
      external_user_id?: string | null;
    };
    CreatedExternalAuthorization: {
      access_token_expiry?: components["schemas"]["DateTime"] | null;
      external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
      metadata: components["schemas"]["CreatedAuthorizationMetadata"];
      payload: components["schemas"]["ExternalAuthorizationPayload"];
      provider: components["schemas"]["ExternalAuthorizationProvider"];
      purpose: string;
      refresh_at?: components["schemas"]["DateTime"] | null;
      user?: components["schemas"]["UserMin"] | null;
    };
    CreatedExternalNonce: {nonce: string; provider: components["schemas"]["ExternalNonceProvider"]};
    CreatedUnderstandingDataRoomSource: {source_id: components["schemas"]["SourceId"]};
    /**
     * @description One item's per-criterion result, persisted in `tprm.test_result.results`
     *     keyed by [`TestCriterionId`].
     *
     *     A result is a projection, recomputed from (item, extracted values,
     *     criteria config); a run replaces an item's whole map. It is judged from
     *     the extracted layer alone, so every outcome is checkable against a cell
     *     the workpaper displays, and a criterion no field captures lands on
     *     [`PassFailUnknown::Unknown`].
     */
    CriterionResult: {
      comment?: string | null;
      /**
       * @description The extracted fields the outcome rests on, extending the provenance
       *     chain [`ExtractedValue::source_ids`] starts: a value cites its
       *     documents, an outcome cites its fields, so a Fail can be walked back
       *     through the exact cells to the exact quoted documents.
       *
       *     A Pass or Fail cites at least one field; an Unknown may cite none — a
       *     criterion no field captures has nothing to cite.
       */
      field_ids: components["schemas"]["TestExtractionFieldId"][];
      outcome: components["schemas"]["PassFailUnknown"];
    };
    CrmAccountInfo: {account_id: string};
    CrmConnection: {
      config: components["schemas"]["CrmConnectionConfig"];
      connector: components["schemas"]["CrmConnector"];
      crm_connection_id: components["schemas"]["CrmConnectionId"];
      external_authorization: components["schemas"]["ExternalAuthorizationMin"];
      name: string;
      sync?: components["schemas"]["PendingBackgroundTask"] | null;
    };
    CrmConnectionConfig: {
      content: components["schemas"]["HubspotCrmConnectionConfig"];
      /** @enum {string} */
      type: "Hubspot";
    };
    CrmConnectionId: Nominal<string, "CrmConnectionId">;
    CrmConnectionIdPath: {crm_connection_id: components["schemas"]["CrmConnectionId"]};
    CrmConnectionMin: {
      connector: components["schemas"]["CrmConnector"];
      crm_connection_id: components["schemas"]["CrmConnectionId"];
      name: string;
      sync?: components["schemas"]["PendingBackgroundTask"] | null;
    };
    CrmConnector: {connector_id: string; logo_url: string; name: string};
    CrmConnectorIdPath: {crm_connector_id: string};
    CustomDomain: {
      account_id: components["schemas"]["AccountId"];
      domain: string;
      domain_type: components["schemas"]["CustomDomainType"];
      redirect_to: boolean;
    };
    /** @enum {string} */
    CustomDomainType: "TrustCenter" | "Collect";
    Date: Date;
    /**
     * @description An inclusive, day-precise date range. Used for periods, spans and report
     *     periods alike; months are a rendering choice in the timeline, never the grain.
     */
    DateRange: {from: components["schemas"]["Date"]; to: components["schemas"]["Date"]};
    DateTime: DateTime;
    Deal: {
      /** Format: double */
      amount?: number | null;
      close_date?: components["schemas"]["DateTime"] | null;
      counterparty: components["schemas"]["Counterparty"];
      created_at: components["schemas"]["DateTime"];
      crm_connection_id: components["schemas"]["CrmConnectionId"];
      deal_id: components["schemas"]["DealId"];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      uri: string;
    };
    DealId: Nominal<string, "DealId">;
    DeleteAuditPlanPages: {page_ids: components["schemas"]["AuditPlanPageId"][]};
    DeleteDocumentSourceArgs: {
      /** @default false */
      retain_documents: boolean;
    };
    /**
     * @description Which facet of the control the agentic conversation should describe.
     *     Design and implementation share the same output shape
     *     (`characteristics + description + extracts`) and the same tool set;
     *     they only differ in the system prompt's framing of what the model
     *     should look for in the sources.
     */
    DesignImplementationMode: "Design" | "Implementation";
    DesignModuleTemplateId: Nominal<string, "DesignModuleTemplateId">;
    DesignModuleTemplateOption: {
      config: components["schemas"]["ControlDesignImplementationModuleTemplate"];
      design_module_template_id: components["schemas"]["DesignModuleTemplateId"];
      name: string;
    };
    DetachQuestions: {questions: components["schemas"]["QuestionId"][]};
    Diagram: {
      connections: {[key: string]: components["schemas"]["DiagramConnection"]};
      context?: string | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      description: string;
      diagram_id: components["schemas"]["DiagramId"];
      diagram_type: components["schemas"]["DiagramType"];
      engagement: components["schemas"]["EngagementMin"];
      generation_state: components["schemas"]["DiagramGenerationState"];
      lanes: {[key: string]: components["schemas"]["DiagramLane"]};
      lanes_enabled: boolean;
      name: string;
      nodes: {[key: string]: components["schemas"]["DiagramNode"]};
      owner?: components["schemas"]["Owner"] | null;
      regions: {[key: string]: components["schemas"]["DiagramRegion"]};
      summary?: string | null;
      understanding_id?: components["schemas"]["UnderstandingId"] | null;
      updated_at: components["schemas"]["DateTime"];
    };
    DiagramConnection: {
      anchors: components["schemas"]["DiagramConnectionAnchor"][];
      color: string;
      diagram_connection_id: components["schemas"]["DiagramConnectionId"];
      label: string;
      source_node_id: components["schemas"]["DiagramNodeId"];
      target_node_id: components["schemas"]["DiagramNodeId"];
    };
    DiagramConnectionAnchor: {position: [number, number]};
    DiagramConnectionId: Nominal<string, "DiagramConnectionId">;
    DiagramEvidence: {
      diagram_evidence_id: components["schemas"]["DiagramEvidenceId"];
      source: components["schemas"]["SourceMin"];
      source_context: string;
    };
    DiagramEvidenceId: Nominal<string, "DiagramEvidenceId">;
    DiagramEvidenceIdPath: {
      diagram_evidence_id: components["schemas"]["DiagramEvidenceId"];
      diagram_id: components["schemas"]["DiagramId"];
    };
    DiagramGenerationState:
      | {
          /** @enum {string} */
          type: "NotStarted";
        }
      | {
          background_task: components["schemas"]["PendingBackgroundTask"];
          /** @enum {string} */
          type: "Generating";
        }
      | {
          at: components["schemas"]["DateTime"];
          /** @enum {string} */
          type: "Completed";
        }
      | {
          at: components["schemas"]["DateTime"];
          error: string;
          /** @enum {string} */
          type: "Error";
        };
    DiagramId: Nominal<string, "DiagramId">;
    DiagramIdPath: {diagram_id: components["schemas"]["DiagramId"]};
    DiagramLane: {
      color: string;
      diagram_lane_id: components["schemas"]["DiagramLaneId"];
      label: string;
      /** Format: int32 */
      max_y: number;
      /** Format: int32 */
      min_y: number;
    };
    DiagramLaneId: Nominal<string, "DiagramLaneId">;
    DiagramMin: {
      context?: string | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      description: string;
      diagram_id: components["schemas"]["DiagramId"];
      diagram_type: components["schemas"]["DiagramType"];
      engagement: components["schemas"]["EngagementMin"];
      generation_state: components["schemas"]["DiagramGenerationState"];
      lanes_enabled: boolean;
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      understanding_id?: components["schemas"]["UnderstandingId"] | null;
      updated_at: components["schemas"]["DateTime"];
    };
    DiagramNode: {
      description: string;
      diagram_node_id: components["schemas"]["DiagramNodeId"];
      icon: string;
      label: string;
      lane_id?: components["schemas"]["DiagramLaneId"] | null;
      position: [number, number];
    };
    DiagramNodeId: Nominal<string, "DiagramNodeId">;
    DiagramPagePayload: {
      diagram: components["schemas"]["Diagram"];
      /**
       * @description The account has the `NewDiagrams` feature. The renderer service has no
       *     account access, so the flag travels with the payload; the renderer
       *     applies the new engine to the diagram types it supports.
       */
      new_diagrams_enabled: boolean;
    };
    DiagramRegion: {
      color: string;
      diagram_region_id: components["schemas"]["DiagramRegionId"];
      label: string;
      region: components["schemas"]["IRect"];
    };
    DiagramRegionId: Nominal<string, "DiagramRegionId">;
    DiagramSummary: {name: string; summary: string};
    /** @enum {string} */
    DiagramType: "ProcessFlow" | "Architecture";
    /**
     * @description Configures a single `DiscoverGenerativeRisks` agent run.
     *     Identifies the assessment; the agent loads the assessment's
     *     scopes and applicable framework risk areas in its
     *     `system_prompt`, browses the scopes' sources through tools, and
     *     emits a de-duplicated pool of candidate risks with per-source
     *     contexts. Scope-level fanout does not exist here — the whole
     *     generative pool is produced in one run so cross-scope
     *     deduplication is inherent.
     */
    DiscoverGenerativeRisksFunction: {assessment_id: components["schemas"]["AssessmentId"]};
    DiscoveredPortal: {
      account_slug: string;
      display_name: string;
      third_party_id: components["schemas"]["ThirdPartyId"];
      third_party_name: string;
    };
    /**
     * @description One row, the one the responder dismissed. An apply clears the rest of the
     *     question's answers itself.
     */
    DismissConsolidatedSuggestionRequest: {
      consolidated_suggestion_id: components["schemas"]["ConsolidatedSuggestionId"];
    };
    Document: {
      access_level: components["schemas"]["AccessLevel"];
      activity_stream: components["schemas"]["ActivityStream"];
      authoring_config?: components["schemas"]["Config"] | null;
      authoring_template?: string | null;
      authority: components["schemas"]["DocumentAuthority"];
      category: components["schemas"]["DocumentCategory"];
      certification_audit_report?: components["schemas"]["DocumentMin"] | null;
      certification_auditor_url?: string | null;
      certification_date_expires?: components["schemas"]["DateTime"] | null;
      certification_date_granted?: components["schemas"]["DateTime"] | null;
      certification_type?: components["schemas"]["CertificationType"] | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      document_id: components["schemas"]["DocumentId"];
      document_source_id?: components["schemas"]["DocumentSourceId"] | null;
      extract?: components["schemas"]["PendingBackgroundTask"] | null;
      fact_gen_prompt: components["schemas"]["FactGenPrompt"];
      file: components["schemas"]["File"];
      last_analyzed?: components["schemas"]["DateTime"] | null;
      last_review?: components["schemas"]["DateTime"] | null;
      last_update: components["schemas"]["Actioned"];
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
      markdown: string;
      markdown_modified: boolean;
      name: string;
      next_review?: components["schemas"]["DateTime"] | null;
      owner?: components["schemas"]["Owner"] | null;
      review_period: components["schemas"]["ReviewPeriod"];
      sharing_classification: components["schemas"]["SharingClassification"];
      trust_center_esignature_template_id?: components["schemas"]["EsignatureTemplateId"] | null;
      trust_center_readability: components["schemas"]["TrustCenterAccess"];
      trust_center_visibility: components["schemas"]["TrustCenterAccess"];
    };
    /** @description This is inserted into the database as JSONB so be careful with changes. */
    DocumentAccessRequest: {
      /** @default false */
      already_signed_nda: boolean;
      document_ids: components["schemas"]["DocumentId"][];
      /** Format: email */
      email: string;
      message: string;
      name: string;
      phone: string;
      point_of_contact: string;
    };
    DocumentAccessRequestId: Nominal<string, "DocumentAccessRequestId">;
    /** @enum {string} */
    DocumentAuthority: "File" | "Markdown" | "FileAndMarkdown" | "Template";
    /** @enum {string} */
    DocumentCategory: "Policy" | "Certification" | "Report" | "Other";
    DocumentExternal: {
      category: components["schemas"]["DocumentCategory"];
      certification_audit_report?: components["schemas"]["DocumentExternalMin"] | null;
      certification_auditor_url?: string | null;
      certification_date_expires?: components["schemas"]["DateTime"] | null;
      certification_date_granted?: components["schemas"]["DateTime"] | null;
      certification_type?: components["schemas"]["CertificationType"] | null;
      document_id: components["schemas"]["DocumentId"];
      is_readable: boolean;
      last_update: components["schemas"]["DateTime"];
      name: string;
      requires_esignature: boolean;
    };
    DocumentExternalMin: {
      category: components["schemas"]["DocumentCategory"];
      document_id: components["schemas"]["DocumentId"];
      is_readable: boolean;
      last_update: components["schemas"]["DateTime"];
      name: string;
      requires_esignature: boolean;
    };
    DocumentId: Nominal<string, "DocumentId">;
    DocumentIdPath: {document_id: components["schemas"]["DocumentId"]};
    DocumentIdPath2: {document_id: components["schemas"]["DocumentId"]};
    DocumentMin: {
      access_level: components["schemas"]["AccessLevel"];
      authority: components["schemas"]["DocumentAuthority"];
      category: components["schemas"]["DocumentCategory"];
      created_at: components["schemas"]["DateTime"];
      document_id: components["schemas"]["DocumentId"];
      file: components["schemas"]["File"];
      is_deleting: boolean;
      last_review?: components["schemas"]["DateTime"] | null;
      last_update: components["schemas"]["Actioned"];
      name: string;
      next_review?: components["schemas"]["DateTime"] | null;
      owner?: components["schemas"]["Owner"] | null;
      review_period: components["schemas"]["ReviewPeriod"];
      sharing_classification: components["schemas"]["SharingClassification"];
      trust_center_esignature_template_id?: components["schemas"]["EsignatureTemplateId"] | null;
      trust_center_readability: components["schemas"]["TrustCenterAccess"];
      trust_center_visibility: components["schemas"]["TrustCenterAccess"];
    };
    DocumentNotificationMin: {
      category: components["schemas"]["DocumentCategory"];
      document_id: components["schemas"]["DocumentId"];
      name: string;
    };
    /**
     * @description A resolved region of a page: what a reader draws to show where an extract
     *     came from — one upright rectangle over a run of the extract's words.
     *
     *     Unlike [`DocumentWord::aabb`] (page units), `aabb` here is **page-relative
     *     `[0, 1]`** — each coordinate is a fraction of the page's width or height — so
     *     a client scales it straight onto a render of any size without knowing the
     *     page's [`DocumentLengthUnit`] or dimensions.
     */
    DocumentRegion: {
      aabb: components["schemas"]["Aabb"];
      /** Format: uint32 */
      page_number: number;
    };
    DocumentSource: {
      config: components["schemas"]["DocumentSourceConfig"];
      connector: components["schemas"]["DocumentSourceConnector"];
      default_limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
      default_owner: components["schemas"]["Owner"];
      default_sharing_classification: components["schemas"]["SharingClassification"];
      document_source_id: components["schemas"]["DocumentSourceId"];
      external_authorization?: components["schemas"]["ExternalAuthorizationMin"] | null;
      last_error_catalog?: components["schemas"]["ReportedErrorCatalogMin"] | null;
      last_sync_at?: components["schemas"]["DateTime"] | null;
      name: string;
      /** Format: int32 */
      num_documents: number;
      sync?: components["schemas"]["PendingBackgroundTask"] | null;
    };
    DocumentSourceConfig:
      | {
          /** @enum {string} */
          type: "Platformed";
        }
      | {
          content: components["schemas"]["GDriveDocumentSourceConfig"];
          /** @enum {string} */
          type: "GDrive";
        }
      | {
          content: components["schemas"]["MicrosoftDocumentSourceConfig"];
          /** @enum {string} */
          type: "Microsoft";
        }
      | {
          content: components["schemas"]["ConfluenceDocumentSourceConfig"];
          /** @enum {string} */
          type: "Confluence";
        }
      | {
          content: components["schemas"]["NotionDocumentSourceConfig"];
          /** @enum {string} */
          type: "Notion";
        }
      | {
          content: components["schemas"]["IManageDocumentSourceConfig"];
          /** @enum {string} */
          type: "IManage";
        }
      | {
          content: components["schemas"]["WebDocumentSourceConfig"];
          /** @enum {string} */
          type: "Web";
        };
    DocumentSourceConnector: {connector_id: string; logo_url: string; name: string};
    DocumentSourceConnectorIdPath: {document_source_connector_id: string};
    DocumentSourceId: Nominal<string, "DocumentSourceId">;
    DocumentSourceIdPath: {document_source_id: components["schemas"]["DocumentSourceId"]};
    DocumentSourceKind: {file: components["schemas"]["File"]; markdown?: string | null};
    DocumentSourceMin: {
      connector: components["schemas"]["DocumentSourceConnector"];
      document_source_id?: components["schemas"]["DocumentSourceId"] | null;
      last_error_catalog?: components["schemas"]["ReportedErrorCatalogMin"] | null;
      last_sync_at?: components["schemas"]["DateTime"] | null;
      name: string;
      /** Format: int32 */
      num_documents: number;
      sync?: components["schemas"]["PendingBackgroundTask"] | null;
    };
    DocumentSourceMinKind: {file: components["schemas"]["File"]};
    /** @description An answer weighed from a questionnaire's document candidates. */
    DocumentSuggestion: {
      /** @description `None` for a lone candidate, which nothing weighed. */
      confidence?: components["schemas"]["SuggestionConfidence"] | null;
      /** @description Why this answer was chosen. */
      reasoning: string;
      sources: components["schemas"]["ConsolidatedSuggestionSource"][];
    };
    DocumentUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Created";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Name";
        }
      | {
          content: components["schemas"]["DocumentCategory"];
          /** @enum {string} */
          type: "Category";
        }
      | {
          /** @enum {string} */
          type: "Scopes";
        }
      | {
          content: components["schemas"]["SharingClassification"];
          /** @enum {string} */
          type: "SharingClassification";
        }
      | {
          /** @enum {string} */
          type: "Owner";
        }
      | {
          /** @enum {string} */
          type: "ReviewPeriod";
        }
      | {
          /** @enum {string} */
          type: "TrustCenterConfig";
        }
      | {
          /** @enum {string} */
          type: "File";
        }
      | {
          /** @enum {string} */
          type: "AiText";
        }
      | {
          /** @enum {string} */
          type: "Deleted";
        }
      | {
          /** @enum {string} */
          type: "Restored";
        }
      | {
          /** @enum {string} */
          type: "Generic";
        };
    Documentation: {
      attachment: components["schemas"]["DocumentationAttachment"];
      created_at: components["schemas"]["DateTime"];
      documentation_id: components["schemas"]["DocumentationId"];
      linked_questions: components["schemas"]["QuestionDocumentation"][];
      linked_to_questionnaire: boolean;
    };
    DocumentationAttachment:
      | {
          content: components["schemas"]["DocumentMin"];
          /** @enum {string} */
          type: "Document";
        }
      | {
          content: components["schemas"]["StandaloneFile"];
          /** @enum {string} */
          type: "StandaloneFile";
        };
    DocumentationId: Nominal<string, "DocumentationId">;
    DocusignEsignatureProviderConfig: {account_name: string; base_uri: string};
    DownloadOptions: {override_name?: string | null};
    DownloadParams: {source_id: components["schemas"]["SourceId"][]};
    /**
     * @description What one draw ran, as persisted alongside the items it produced. Adding a
     *     variant is free; adding a *field* to an existing variant is not, since rows
     *     written before it fail to deserialize.
     *
     *     One variant's parameters at a time: a design that leaves `RandomV1` and comes
     *     back to it finds the seed of the last `RandomV1` draw gone, because the
     *     intervening draw overwrote it with its own variant's parameters.
     *
     *     PascalCase variants with no `rename` (matching the sibling
     *     [`super::population::PopulationProcessingState`]).
     */
    DrawnSampleMethod:
      | {
          /** @enum {string} */
          type: "FullV1";
        }
      | {
          /** Format: uint32 */
          seed: number;
          size: components["schemas"]["SampleSize"];
          /** @enum {string} */
          type: "RandomV1";
        };
    DrivingSource: {
      compacted_context?: string | null;
      context: string;
      driving_source_type: components["schemas"]["AuditAreaType"];
      source: components["schemas"]["SourceMin"];
    };
    DuplicateComplexityModelVersion: {
      source_version_id: components["schemas"]["ComplexityModelVersionId"];
      version_name: string;
    };
    EmailPath: {email: string};
    EmptyLoginMethodPayload: Record<string, never>;
    EnableTwoFa: {
      content: components["schemas"]["EnableTwoFaTotp"];
      /** @enum {string} */
      type: "Totp";
    };
    EnableTwoFaTotp: {code: string; secret: string};
    Engagement: {
      assessments: components["schemas"]["EngagementAssessmentMin"][];
      automation_overlay_active: boolean;
      automation_overlay_at?: components["schemas"]["DateTime"] | null;
      /**
       * @description Complexity tier roll-up per complexity model assessed on this
       *     engagement, keyed by complexity model name. See
       *     [`ComplexityTierRollup`] — carries both the canonical tier and
       *     whether scoped members of the same model diverge.
       */
      complexity_tiers: {[key: string]: components["schemas"]["ComplexityTierRollup"] | null};
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      engagement_id: components["schemas"]["EngagementId"];
      /** @description The template the engagement was created from. */
      engagement_template_id?: components["schemas"]["EngagementTemplateId"] | null;
      engagement_type?: string | null;
      engagement_window_end?: components["schemas"]["DateTime"] | null;
      engagement_window_start?: components["schemas"]["DateTime"] | null;
      external_id?: string | null;
      external_questionnaires: components["schemas"]["EngagementExternalQuestionnaireMin"][];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      /**
       * @description For now these counts include all top-level and child sources. Later, we
       *     might want to merge child source counts into their parents.
       */
      source_counts: components["schemas"]["SourceCounts"];
      status: components["schemas"]["EngagementStatus"];
      third_party: components["schemas"]["ThirdParty"];
      updated_at: components["schemas"]["DateTime"];
    };
    /**
     * @description A minimal assessment as returned as part of the `Engagement` type. This is
     *     just enough information to show in the Engagements table in the UI.
     */
    EngagementAssessmentMin: {
      assessment_id: components["schemas"]["AssessmentId"];
      automation_overlay_at?: components["schemas"]["DateTime"] | null;
      framework_version: components["schemas"]["FrameworkVersionMin"];
      name?: string | null;
      status: components["schemas"]["AssessmentStatus"];
    };
    EngagementExternalQuestionnaireMin: {
      client_visible: boolean;
      created_at: components["schemas"]["DateTime"];
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      label: string;
      locked_at?: components["schemas"]["DateTime"] | null;
      model_name: string;
      /**
       * @description Whether a client portal user would see this as outstanding work:
       *     released to the client rather than auditor-only, in the phase the client
       *     can access, and still open for answers. An auditor viewing the portal
       *     additionally sees auditor-only questionnaires.
       */
      outstanding_for_client: boolean;
      phase: components["schemas"]["TprmExternalQuestionnairePhase"];
      submitted_at?: components["schemas"]["DateTime"] | null;
      template_name: string;
      updated_at?: components["schemas"]["DateTime"] | null;
    };
    EngagementId: Nominal<string, "EngagementId">;
    EngagementIdPath: {engagement_id: components["schemas"]["EngagementId"]};
    EngagementIdPath2: {engagement_id: components["schemas"]["EngagementId"]};
    EngagementIdPath3: {engagement_id: components["schemas"]["EngagementId"]};
    EngagementIdPath4: {engagement_id: components["schemas"]["EngagementId"]};
    EngagementIdPath5: {engagement_id: components["schemas"]["EngagementId"]};
    /**
     * @description Represents what part of an engagement is locked by a background task.
     *     This is the deserialized form that combines the discriminator column
     *     with the optional identifier columns.
     *
     *     # Adding New Variants
     *     When adding a new variant to this enum, you MUST also:
     *     1. Add a corresponding CHECK constraint in the `engagement_tasks` table
     *     2. Add a corresponding variant to `EngagementLockType`
     *     3. Update the accessor methods below
     */
    EngagementLock:
      | {
          target: {
            assessment_id: components["schemas"]["AssessmentId"];
            /** @default null */
            audit_area_id: components["schemas"]["AuditAreaId"] | null;
            engagement_id: components["schemas"]["EngagementId"];
          };
          /** @enum {string} */
          type: "Assessment";
        }
      | {
          target: {
            assessment_control_id: components["schemas"]["AssessmentControlId"];
            assessment_id: components["schemas"]["AssessmentId"];
            engagement_id: components["schemas"]["EngagementId"];
          };
          /** @enum {string} */
          type: "ControlOE";
        }
      | {
          target: {
            assessment_control_id: components["schemas"]["AssessmentControlId"];
            assessment_id: components["schemas"]["AssessmentId"];
            engagement_id: components["schemas"]["EngagementId"];
            scope_id: components["schemas"]["TprmScopeId"];
          };
          /** @enum {string} */
          type: "ControlScopeOE";
        }
      | {
          target: {
            engagement_id: components["schemas"]["EngagementId"];
            source_ref: components["schemas"]["SourceRef"];
          };
          /** @enum {string} */
          type: "Source";
        }
      | {
          target: {
            engagement_id: components["schemas"]["EngagementId"];
            population_id: components["schemas"]["PopulationId"];
          };
          /** @enum {string} */
          type: "Population";
        }
      | {
          target: {engagement_id: components["schemas"]["EngagementId"]; test_id: components["schemas"]["TestId"]};
          /** @enum {string} */
          type: "Test";
        }
      | {
          target: {
            /** @default null */
            audit_area_id: components["schemas"]["AuditAreaId"] | null;
            engagement_id: components["schemas"]["EngagementId"];
            understanding_id: components["schemas"]["UnderstandingId"];
          };
          /** @enum {string} */
          type: "Understanding";
        };
    EngagementMin: {
      engagement_id: components["schemas"]["EngagementId"];
      name: string;
      third_party: components["schemas"]["ThirdPartyMin"];
    };
    EngagementNotificationMin: {
      engagement_id: components["schemas"]["EngagementId"];
      name: string;
      third_party: components["schemas"]["ThirdPartyNotificationMin"];
    };
    /**
     * @description Payload for engagement-level reports. Contains the engagement metadata,
     *     all assessments (with summaries), and all understandings with diagrams.
     */
    EngagementReportContentPayload: {
      account_name: string;
      assessments: components["schemas"]["Assessment"][];
      engagement: components["schemas"]["Engagement"];
      /** @description See [`DiagramPagePayload::new_diagrams_enabled`]. */
      new_diagrams_enabled: boolean;
      report_template: components["schemas"]["TprmReportTemplate"];
      understandings: components["schemas"]["EngagementUnderstanding"][];
    };
    EngagementReportPath: {
      engagement_id: components["schemas"]["EngagementId"];
      report_template_id: components["schemas"]["TprmReportTemplateId"];
    };
    /** @enum {string} */
    EngagementStatus: "Active" | "Closed";
    EngagementTask: {
      background_task_id: components["schemas"]["BackgroundTaskId"];
      channel_name: string;
      created_at: components["schemas"]["DateTime"];
      lock: components["schemas"]["EngagementLock"];
      name: string;
      /** Format: float */
      progress: number;
      scheduled_for: components["schemas"]["DateTime"];
    };
    EngagementTemplate: {
      areas: components["schemas"]["EngagementTemplateArea"][];
      created_at: components["schemas"]["DateTime"];
      description: string;
      engagement_template_id: components["schemas"]["EngagementTemplateId"];
      name: string;
      updated_at: components["schemas"]["DateTime"];
    };
    EngagementTemplateArea: {
      audit_area_template: components["schemas"]["AuditAreaTemplateMin"];
      /**
       * @description A required area is always seeded; an optional one is seeded only when
       *     chosen for the engagement.
       */
      required: boolean;
    };
    EngagementTemplateId: Nominal<string, "EngagementTemplateId">;
    /** @description An understanding paired with its diagrams, for inclusion in engagement reports. */
    EngagementUnderstanding: {
      audit_area_type: components["schemas"]["AuditAreaType"];
      diagrams: components["schemas"]["Diagram"][];
      name: string;
      summary?: string | null;
      understanding_id: components["schemas"]["UnderstandingId"];
    };
    EntityId: Nominal<string, "EntityId">;
    /** @enum {string} */
    Environment: "development" | "test" | "staging" | "production";
    ErrorCatalogId: Nominal<string, "ErrorCatalogId">;
    ErrorResponse: {
      error: string;
      extra?: IValue;
      /** Format: uuid */
      reference?: string | null;
      sub_type?: string | null;
      type_: string;
    };
    EsignatureProvider: {
      account_id: components["schemas"]["AccountId"];
      config: components["schemas"]["EsignatureProviderConfig"];
      connector: components["schemas"]["EsignatureProviderConnector"];
      esignature_provider_id: components["schemas"]["EsignatureProviderId"];
      external_account_id?: string | null;
      external_authorization?: components["schemas"]["ExternalAuthorization"] | null;
      external_reference_id?: components["schemas"]["ExternalAccountReferenceId"] | null;
      last_sync_at?: components["schemas"]["DateTime"] | null;
      name: string;
    };
    EsignatureProviderConfig: {
      content: components["schemas"]["DocusignEsignatureProviderConfig"];
      /** @enum {string} */
      type: "Docusign";
    };
    EsignatureProviderConnector: {
      connector_type: components["schemas"]["EsignatureProviderConnectorType"];
      logo_url: string;
      name: string;
    };
    /** @enum {string} */
    EsignatureProviderConnectorType: "docusign";
    EsignatureProviderConnectorTypePath: {
      esignature_provider_connector_type: components["schemas"]["EsignatureProviderConnectorType"];
    };
    EsignatureProviderId: Nominal<string, "EsignatureProviderId">;
    EsignatureProviderIdPath: {esignature_provider_id: components["schemas"]["EsignatureProviderId"]};
    EsignatureProviderMin: {
      account_id: components["schemas"]["AccountId"];
      config: components["schemas"]["EsignatureProviderConfig"];
      connector: components["schemas"]["EsignatureProviderConnector"];
      esignature_provider_id: components["schemas"]["EsignatureProviderId"];
      last_sync_at?: components["schemas"]["DateTime"] | null;
      name: string;
    };
    EsignatureTemplate: {
      external_template_id: string;
      name: string;
      provider: components["schemas"]["EsignatureProviderMin"];
      template_id: components["schemas"]["EsignatureTemplateId"];
    };
    EsignatureTemplateId: Nominal<string, "EsignatureTemplateId">;
    /**
     * @description Configures a single scope-level `EvaluateControlDesignImplementation`
     *     agent run. Identifies the (assessment, control, scope, mode)
     *     tuple; the agent reads the matching `ControlScope{Design,
     *     Implementation}` decision and scores it against the framework's
     *     score levels.
     */
    EvaluateControlDesignImplementationFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      mode: components["schemas"]["DesignImplementationMode"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    Evidence: {
      action: components["schemas"]["AttributeEvidenceAction"];
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      attribute_evidence_id: components["schemas"]["AttributeEvidenceId"];
      attribute_id: components["schemas"]["ComplexityAttributeId"];
      attribute_name: string;
    };
    /**
     * @description The item half of an `(evidence, item)` mapping — the evidence half comes from
     *     the path. Both the map and unmap endpoints are keyed on the pair, because one
     *     evidence source can document several items.
     */
    EvidenceMappingBody: {test_item_id: components["schemas"]["TestItemId"]};
    /**
     * @description One source mapped to the item an `ExtractTestData` run covers, pinned to
     *     the version its attachment named and carrying the number the model
     *     addresses it by.
     *
     *     The number is write-once on the source, so carrying it pins a handle
     *     rather than snapshotting something that can drift.
     */
    EvidenceSource: {
      /** @description The source at the version its attachment pinned. */
      source: components["schemas"]["SourceRef"];
      /**
       * @description The source's engagement-wide number (`S1`, `S2`), unique across
       *     everything this run can name: numbers are allocated from one
       *     per-third-party sequence, a test belongs to one engagement, and an
       *     engagement to one third party.
       */
      source_number: string;
    };
    ExceptionConfig: {compromised_password_process: string; non_compliance: string};
    /** @description Input for setting a basis item aside. The reason is required. */
    ExcludeBasisItem: {reason: string};
    /**
     * @description Snapshot of an existing finding pinned onto the conversation
     *     config. `finding_id` is what the caller's resolver stamps onto
     *     the matching new finding; `content` is what the agent renders.
     */
    ExistingFinding: {content: components["schemas"]["FindingContent"]; finding_id: components["schemas"]["FindingId"]};
    /**
     * @description Snapshot of an existing assessment risk pinned onto the
     *     conversation config. `risk_id` is what `apply_reuse_matches`
     *     stamps onto the caller's `PopulateRisk`; `title` /
     *     `description` are what the agent renders. Both are frozen at
     *     the moment of conversation creation so the render and the
     *     resolve resolve against the same set even if the live risk row
     *     mutates between attempts.
     */
    ExistingRisk: {description: string; risk_id: components["schemas"]["RiskId"]; title: string};
    ExportedAssessment: {
      assessment_id: components["schemas"]["AssessmentId"];
      file_id: components["schemas"]["FileId"];
      report_summaries: components["schemas"]["ExportedReportSummary"][];
    };
    ExportedEngagementReport: {file_id: components["schemas"]["FileId"]};
    ExportedReportSummary: {report_name: string; summary: string};
    ExportedUnderstanding: {file_id: components["schemas"]["FileId"]};
    ExternalAccountReferenceId: Nominal<string, "ExternalAccountReferenceId">;
    /** @enum {string} */
    ExternalAccountReferenceType: "VtQuestionSourceSlack" | "MailingListPostmark" | "VtEsignatureProviderDocusign";
    ExternalAuthorization: {
      access_token_expiry?: components["schemas"]["DateTime"] | null;
      external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
      /**
       * @description The catalog of customer-facing errors currently flagged against this
       *     authorization (e.g. a revoked token), or `None` when it is healthy.
       */
      last_error_catalog_id?: components["schemas"]["ErrorCatalogId"] | null;
      payload: components["schemas"]["ExternalAuthorizationPayload"];
      provider: components["schemas"]["ExternalAuthorizationProvider"];
      purpose: string;
      refresh_at?: components["schemas"]["DateTime"] | null;
      /** Format: int32 */
      refresh_attempts: number;
      user?: components["schemas"]["UserMin"] | null;
    };
    ExternalAuthorizationId: Nominal<string, "ExternalAuthorizationId">;
    ExternalAuthorizationIdPath: {external_authorization_id: components["schemas"]["ExternalAuthorizationId"]};
    ExternalAuthorizationMin: {
      access_token_expiry?: components["schemas"]["DateTime"] | null;
      external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
      provider: components["schemas"]["ExternalAuthorizationProvider"];
      purpose: string;
      refresh_at?: components["schemas"]["DateTime"] | null;
      /** Format: int32 */
      refresh_attempts: number;
      user?: components["schemas"]["UserMin"] | null;
    };
    ExternalAuthorizationOauth: {access_token: string};
    ExternalAuthorizationPayload:
      | {
          content: components["schemas"]["ExternalAuthorizationOauth"];
          /** @enum {string} */
          type: "Oauth";
        }
      | {
          content: components["schemas"]["ExternalAuthorizationRaw"];
          /** @enum {string} */
          type: "Raw";
        };
    /** @enum {string} */
    ExternalAuthorizationProvider:
      | "Google"
      | "Atlassian"
      | "Hubspot"
      | "Slack"
      | "Microsoft"
      | "Docusign"
      | "Notion"
      | "imanage"
      | "Manual";
    ExternalAuthorizationRaw: {value: string};
    /** @enum {string} */
    ExternalNonceProvider: "imanage";
    ExternalQuestionnaireIdPath: {external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"]};
    ExternalQuestionnaireIdPath2: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    ExternalUser: {
      avatar_url?: components["schemas"]["Never"] | null;
      name?: components["schemas"]["Never"] | null;
      primary_email?: string | null;
      type_: components["schemas"]["UserTypeExternal"];
      user_id: components["schemas"]["UserId"];
    };
    ExternalWhoAmIResponse: {
      affiliated_account?: components["schemas"]["AccountMin"] | null;
      client_account: components["schemas"]["AccountMin"];
      internal_mode: boolean;
      user: components["schemas"]["RegisteredUserMin"];
    };
    /**
     * @description Configures a single `ExtractTestData` agent run: the one sampled item
     *     whose values the run reads, together with the two things every
     *     recorded value is checked against — the sources the run may read
     *     and cite, and the fields it may fill.
     *
     *     Both are resolved by the caller and carried here rather than looked
     *     up from `test_id` when the agent runs, because the runtime builds an
     *     agent's tool set from this value alone and does so synchronously.
     *
     *     `evidence` holds each mapped source at the version its attachment
     *     pinned, so a run reads the same bytes whatever has happened to the
     *     source since. `fields` is ordered as the system prompt numbers them:
     *     `record_extraction`'s `field_index` is a position in this list, so
     *     prompt and tool agree on what a number means only while they share
     *     one ordering.
     */
    ExtractTestDataFunction: {
      /**
       * @description The item's mapped evidence — the only sources the run may read or
       *     cite. Extraction trusts mapping's decision about relevance and
       *     never looks outside it.
       */
      evidence: components["schemas"]["EvidenceSource"][];
      /** @description The test's resolved extraction fields, in prompt order. */
      fields: components["schemas"]["ExtractionField"][];
      test_id: components["schemas"]["TestId"];
      test_item_id: components["schemas"]["TestItemId"];
    };
    /**
     * @description One extracted field value together with the account of where it came from.
     *
     *     An extracted value is a **projection**, not a claim: it is recomputed from
     *     (item, mapped evidence, field config) and an extraction run replaces an
     *     item's whole map. `tprm.test_materialized_sample.extracted_data` is the only
     *     durable record of a run — there is no decision log behind it — so the
     *     reasoning and the citation travel inside the value rather than beside it.
     */
    ExtractedValue: {
      /** @description What in the cited documents yields this value, quoting the concrete text. */
      reasoning: string;
      /**
       * @description The documents the value was read out of, at the version pinned in each
       *     attachment's `tprm.test_evidence.source_as_of`. Extraction cites at least
       *     one: a value with no evidence behind it is not extractable.
       */
      source_ids: components["schemas"]["SourceId"][];
      /**
       * @description Shaped by the field's [`ExtractionField::type_`], validated before it is
       *     accepted.
       */
      value: IValue;
    };
    /**
     * @description A field the extraction step fills in from mapped evidence. `type_` is a
     *     reused [`ValueType`]; `ai_hint` guides extraction.
     *
     *     `authored_at`/`authored_by` stamp the **last** principal to write the field.
     *     With the override's membership that gives three provenance states: no
     *     override entry is a field inherited from the pinned template, an entry
     *     stamped with no user was written by a background run, and an entry stamped
     *     with a user belongs to that auditor.
     *
     *     Last-writer rather than creator, because only last-writer reaches the third
     *     state: an auditor who edits a field a run proposed takes it over, where a
     *     creator stamp would go on naming the run. Editing is therefore the claim, and
     *     no separate gesture makes it. No write path consults the states — they are
     *     provenance on screen, and the ground a run that amends existing fields would
     *     stand on to leave an auditor's alone.
     */
    ExtractionField: {
      ai_hint?: string | null;
      /**
       * @description When the field was last written. `None` on a copy nothing has written:
       *     the pinned template's own field.
       * @default null
       */
      authored_at: components["schemas"]["DateTime"] | null;
      /**
       * @description Who last wrote the field, held raw so a rename reaches every document
       *     that shows the name. `None` alongside a set `authored_at` is a
       *     background run, which acts as no user.
       * @default null
       */
      authored_by: components["schemas"]["UserId"] | null;
      field_id: components["schemas"]["TestExtractionFieldId"];
      name: string;
      /** Format: int32 */
      sort_order: number;
      type_: components["schemas"]["ValueType"];
    };
    FacetCount: {
      /** Format: int64 */
      count: number;
      value: IValue;
    };
    Fact: {
      active_sources: components["schemas"]["Sources"];
      all_texts: components["schemas"]["FactTextMin"][];
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      deleted_sources: components["schemas"]["Sources"];
      disabled?: components["schemas"]["Actioned"] | null;
      fact_id: components["schemas"]["FactId"];
      library_section: components["schemas"]["ScopedLibrarySection"];
      representative_text: components["schemas"]["FactTextMin"];
      resolutions: components["schemas"]["ResolutionMin"][];
    };
    FactCluster: {
      children?: components["schemas"]["FactCluster"][] | null;
      cluster_id: components["schemas"]["FactClusterId"];
      /** Format: int32 */
      equivalence_count: number;
      title: string;
    };
    FactClusterId: Nominal<string, "FactClusterId">;
    FactCounts: {
      scopes: {[key: string]: number};
      /** Format: int32 */
      total: number;
    };
    FactGenPrompt: {custom_text_prompt?: string | null};
    FactId: Nominal<string, "FactId">;
    FactIdPath: {fact_id: components["schemas"]["FactId"]};
    FactMin: {
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      disabled?: components["schemas"]["Actioned"] | null;
      fact_id: components["schemas"]["FactId"];
      library_section: components["schemas"]["ScopedLibrarySection"];
      representative_text: components["schemas"]["FactTextMin"];
    };
    FactSearchArgs: {
      /**
       * @default {
       *       "limit": null,
       *       "offset": null
       *     }
       */
      pagination: components["schemas"]["PaginationArgs"];
      search?: string | null;
      section_filter?: components["schemas"]["LibrarySectionFilter"] | null;
    };
    FactSourceDocument: {
      deleted?: components["schemas"]["Actioned"] | null;
      document_category: components["schemas"]["DocumentCategory"];
      document_id: components["schemas"]["DocumentId"];
      document_name: string;
      document_revision: components["schemas"]["DateTime"];
      explanation_chunk: string;
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
    };
    FactSourceEntity: {
      deleted?: components["schemas"]["Actioned"] | null;
      entity_id: components["schemas"]["EntityId"];
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
    };
    FactSourceQuestion: {
      deleted?: components["schemas"]["Actioned"] | null;
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
      parent: components["schemas"]["FactSourceQuestionParent"];
      question_id: components["schemas"]["QuestionId"];
      question_number?: string | null;
      question_text: string;
      response_parts: components["schemas"]["AnswerParts"];
      response_select?: components["schemas"]["ResponseOption"][] | null;
      response_text?: string | null;
      response_yes_no?: boolean | null;
    };
    FactSourceQuestionParent:
      | {
          content: {
            questionnaire_archived_at?: components["schemas"]["DateTime"] | null;
            questionnaire_date: components["schemas"]["DateTime"];
            questionnaire_id: components["schemas"]["QuestionnaireId"];
            questionnaire_name: string;
            section_title: string;
          };
          /** @enum {string} */
          type: "Section";
        }
      | {
          content: {question_date: components["schemas"]["DateTime"]};
          /** @enum {string} */
          type: "AdHoc";
        };
    FactTextId: Nominal<string, "FactTextId">;
    FactTextMin: {
      content: string;
      created_at: components["schemas"]["DateTime"];
      fact_text_id: components["schemas"]["FactTextId"];
    };
    FeaturePath: {feature: components["schemas"]["AccountFeature"]};
    /**
     * @description A point on the activity-feed timeline: a real-world timestamp plus its
     *     monotonic ordinal cursor. `ordinal` is the stable paging key (callers
     *     pass it back as `since` / `before`); `timestamp` is what gets rendered.
     */
    FeedPoint: {
      /** Format: double */
      ordinal: number;
      timestamp: components["schemas"]["DateTime"];
    };
    /**
     * @description One row of the clustered activity feed: either an individual activity or a
     *     rolled-up cluster.
     */
    FeedRow:
      | {
          content: {activity: components["schemas"]["Activity"]; page?: components["schemas"]["ClusterPageRef"] | null};
          /** @enum {string} */
          type: "Individual";
        }
      | {
          content: components["schemas"]["ActivityCluster"];
          /** @enum {string} */
          type: "Cluster";
        };
    File: {
      file_id: components["schemas"]["FileId"];
      mime_type: string;
      name: string;
      /** Format: double */
      size: number;
      system_wide: boolean;
      uploaded_at: components["schemas"]["DateTime"];
    };
    FileId: Nominal<string, "FileId">;
    FileIdPath: {file_id: components["schemas"]["FileId"]};
    FileUploadSessionId: Nominal<string, "FileUploadSessionId">;
    FileUploadSessionResponse: {file_upload_session_id: components["schemas"]["FileUploadSessionId"]; uri: string};
    FilesAnswerConfig: {
      /** Format: int32 */
      max_numer?: number | null;
      /** Format: int32 */
      min_number?: number | null;
    };
    FilterArgs: {
      filter?: components["schemas"]["FilterClause"] | null;
      /** @default [] */
      order: components["schemas"]["OrderClause"][];
    };
    FilterAssessments: {
      completed?: boolean | null;
      engagement_id?: components["schemas"]["EngagementId"] | null;
      framework_id?: components["schemas"]["FrameworkId"] | null;
      framework_version_id?: components["schemas"]["FrameworkVersionId"] | null;
      third_party_id?: components["schemas"]["ThirdPartyId"] | null;
    };
    FilterClause:
      | ({
          /** @enum {string} */
          kind: "Expression";
        } & components["schemas"]["FilterExpression"])
      | ({
          /** @enum {string} */
          kind: "Composite";
        } & components["schemas"]["FilterCompositeClause"]);
    FilterComplexityAssessments: {
      engagement_id?: components["schemas"]["EngagementId"] | null;
      third_party_id?: components["schemas"]["ThirdPartyId"] | null;
    };
    FilterCompositeClause: {
      clauses: components["schemas"]["FilterClause"][];
      operator: components["schemas"]["FilterOperator"];
    };
    /** @enum {string} */
    FilterCondition: "IsNull" | "Equals" | "Contains" | "Includes" | "GreaterThan" | "LessThan";
    FilterExpression: {
      condition: components["schemas"]["FilterCondition"];
      field: string;
      negated: boolean;
      value: components["schemas"]["FilterValue"];
    };
    /** @enum {string} */
    FilterOperator: "All" | "Any";
    FilterValue:
      | {
          /** @enum {string} */
          kind: "True";
        }
      | {
          /** @enum {string} */
          kind: "Integer";
          /** Format: int32 */
          value: number;
        }
      | {
          /** @enum {string} */
          kind: "Float";
          /** Format: double */
          value: number;
        }
      | {
          /** @enum {string} */
          kind: "String";
          value: string;
        }
      | {
          /** @enum {string} */
          kind: "Uuid";
          /** Format: uuid */
          value: string;
        }
      | {
          /** @enum {string} */
          kind: "DateTime";
          value: components["schemas"]["DateTime"];
        };
    Finding: Finding;
    FindingContent: {
      client_facing?: components["schemas"]["ClientFacingFindingContent"] | null;
      internal: components["schemas"]["InternalFindingContent"];
      rating: components["schemas"]["FindingRating"];
      standard_finding_id?: components["schemas"]["StandardFindingId"] | null;
    };
    FindingId: Nominal<string, "FindingId">;
    FindingIdPair: {
      assessment_id: components["schemas"]["AssessmentId"];
      finding_id: components["schemas"]["FindingId"];
    };
    FindingIdPath: {finding_id: components["schemas"]["FindingId"]};
    FindingMin: {finding_id: components["schemas"]["FindingId"]};
    FindingNode: {finding_id: components["schemas"]["FindingId"]};
    /** @enum {string} */
    FindingRating: "high" | "moderate" | "low";
    FindingUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Created";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Content";
        };
    FinishReason: string;
    FrameworkAutorun: {
      /**
       * @description Framework versions that should always run regardless of third party tier
       * @default []
       */
      always: components["schemas"]["PresetFrameworkAutorun"][];
      /**
       * @description Per-tier framework autoruns, keyed by tier name: the mapped framework
       *     version runs only for third parties in that tier.
       * @default {}
       */
      tier: {[key: string]: components["schemas"]["PresetFrameworkAutorun"]};
    };
    /** @description The account's framework autoruns after the mapping was applied to them. */
    FrameworkAutorunBackfill: {
      /**
       * Format: uint
       * @description Autorun rows assigned a mapped template by this backfill.
       */
      backfilled: number;
      /**
       * @description Engagements the run refused that still hold a legacy assessment a placed
       *     autorun would duplicate; non-empty means the backfill was withheld:
       *     `backfilled` is 0 and `unmapped_frameworks` is empty.
       * @default []
       */
      blocked_by: components["schemas"]["EngagementId"][];
      /** @description Frameworks whose autoruns still place nowhere, by name. */
      unmapped_frameworks: string[];
    };
    FrameworkId: Nominal<string, "FrameworkId">;
    FrameworkIdPath: {framework_id: components["schemas"]["FrameworkId"]};
    FrameworkMin: {
      framework_id: components["schemas"]["FrameworkId"];
      icon_file?: components["schemas"]["File"] | null;
      is_custom: boolean;
      is_enabled: boolean;
      name: string;
      owner?: components["schemas"]["Owner"] | null;
    };
    /**
     * @description Available module templates for a framework version.
     *     These are the options users can pick when configuring which modules a control uses.
     */
    FrameworkModuleTemplates: {
      design: components["schemas"]["DesignModuleTemplateOption"][];
      implementation: components["schemas"]["ImplementationModuleTemplateOption"][];
      operating_effectiveness: components["schemas"]["OeModuleTemplateOption"][];
      representation: components["schemas"]["RepresentationModuleTemplateOption"][];
    };
    FrameworkProfile: {
      control_groups: components["schemas"]["ControlGroup"][];
      created_at: components["schemas"]["DateTime"];
      custom_prompt: string;
      framework_profile_id: components["schemas"]["FrameworkProfileId"];
      framework_version: components["schemas"]["FrameworkVersionMin"];
      name: string;
      risk_areas: components["schemas"]["RiskArea"][];
      scope_types: components["schemas"]["TprmScopeType"][];
    };
    FrameworkProfileId: Nominal<string, "FrameworkProfileId">;
    FrameworkProfileIdPath: {framework_profile_id: components["schemas"]["FrameworkProfileId"]};
    FrameworkProfileMin: {
      created_at: components["schemas"]["DateTime"];
      framework_profile_id: components["schemas"]["FrameworkProfileId"];
      framework_version: components["schemas"]["FrameworkVersionMin"];
      name: string;
      scope_types: components["schemas"]["TprmScopeType"][];
    };
    FrameworkVersion: {
      /** Format: int64 */
      active_assessments_count: number;
      created_at: components["schemas"]["DateTime"];
      custom_findings_prompt: string;
      framework: components["schemas"]["FrameworkMin"];
      framework_version_id: components["schemas"]["FrameworkVersionId"];
      generate_findings: boolean;
      generate_findings_from_missing_evidence: boolean;
      human_in_the_loop: boolean;
      predefined_risks: {[key: string]: components["schemas"]["PredefinedControlId"][]};
      published_at?: components["schemas"]["DateTime"] | null;
      risk_quantification?: components["schemas"]["RiskQuantificationModel"] | null;
      specification: string;
      version: string;
    };
    FrameworkVersionId: Nominal<string, "FrameworkVersionId">;
    FrameworkVersionIdPath: {framework_version_id: components["schemas"]["FrameworkVersionId"]};
    FrameworkVersionMin: {
      /** Format: int64 */
      active_assessments_count: number;
      created_at: components["schemas"]["DateTime"];
      framework: components["schemas"]["FrameworkMin"];
      framework_version_id: components["schemas"]["FrameworkVersionId"];
      human_in_the_loop: boolean;
      published_at?: components["schemas"]["DateTime"] | null;
      risk_quantification?: components["schemas"]["RiskQuantificationModel"] | null;
      specification: string;
      version: string;
    };
    FrontendEnvironment: {
      app_url: string;
      collect_url: string;
      credentials: components["schemas"]["PublicCredentials"];
      custom_domain?: components["schemas"]["CustomDomain"] | null;
      environment: components["schemas"]["Environment"];
      release: components["schemas"]["Release"];
      trust_url: string;
    };
    GDriveDocumentSourceConfig: {folder_icon_url: string; folder_id: string; folder_name: string};
    /**
     * @description Configures a single `GenerateControlFindings` agent run.
     *     Identifies the (assessment, control) pair; the agent loads the
     *     full `AssessedControl` plus the assessment's framework
     *     specification and custom findings prompt in its `system_prompt`,
     *     so only the identifiers are persisted here.
     */
    GenerateControlFindingsFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
    };
    GenerateDocxRequest: {language_key: string; payload: components["schemas"]["GenerateHtmlRequestPayload"]};
    GenerateHtmlRequest: {
      csp_nonce: string;
      language_key: string;
      payload: components["schemas"]["GenerateHtmlRequestPayload"];
    };
    GenerateHtmlRequestPayload:
      | {
          content: components["schemas"]["ReportContentPayload"];
          /** @enum {string} */
          type: "AssessmentReport";
        }
      | {
          content: components["schemas"]["ChartContentPayload"];
          /** @enum {string} */
          type: "AssessmentChart";
        }
      | {
          content: components["schemas"]["QuestionnaireContentPayload"];
          /** @enum {string} */
          type: "Questionnaire";
        }
      | {
          content: components["schemas"]["ConsolidatedQuestionnaireContentPayload"];
          /** @enum {string} */
          type: "ConsolidatedQuestionnaire";
        }
      | {
          content: components["schemas"]["UnderstandingReportContentPayload"];
          /** @enum {string} */
          type: "UnderstandingReport";
        }
      | {
          content: components["schemas"]["DiagramPagePayload"];
          /** @enum {string} */
          type: "DiagramPage";
        }
      | {
          content: components["schemas"]["EngagementReportContentPayload"];
          /** @enum {string} */
          type: "EngagementReport";
        };
    /**
     * @description Input for triggering AI plan generation on an OE assessment. The auditor's
     *     steer is optional and kept so the plan can be regenerated without retyping it.
     */
    GenerateOePlan: {prompt?: string | null};
    GenerateTotpResponse: {qr_code: string; secret: string};
    GenerateXlsxRequest: {language_key: string; payload: components["schemas"]["GenerateHtmlRequestPayload"]};
    GetGraphQuery: GetGraphQuery;
    GettingStartedChecklist: {
      invited_colleagues: components["schemas"]["Rational"];
      uploaded_documents: components["schemas"]["Rational"];
      uploaded_historical_questionnaires: components["schemas"]["Rational"];
      uploaded_questionnaire: components["schemas"]["Rational"];
    };
    /** @enum {string} */
    GraphComponentType: "String" | "Integer" | "Boolean" | "Asset" | "Relationship";
    GraphEntity: GraphEntity;
    GraphOperation:
      | {
          /** @enum {string} */
          op: "CreateEntity";
        }
      | {
          content: {entity_ref: components["schemas"]["GraphOperationEntityRef"]; recursive?: boolean | null};
          /** @enum {string} */
          op: "DeleteEntity";
        }
      | {
          content: {
            entity_ref: components["schemas"]["GraphOperationEntityRef"];
            name: string;
            value: components["schemas"]["GraphOperationPropertyValue"];
          };
          /** @enum {string} */
          op: "UpsertProperty";
        }
      | {
          content: {entity_ref: components["schemas"]["GraphOperationEntityRef"]; name: string};
          /** @enum {string} */
          op: "DeleteProperty";
        };
    GraphOperationEntityRef: GraphOperationEntityRef;
    GraphOperationPropertyValue:
      | {
          content: string;
          /** @enum {string} */
          type: "String";
        }
      | {
          /** Format: int32 */
          content: number;
          /** @enum {string} */
          type: "Integer";
        }
      | {
          content: boolean;
          /** @enum {string} */
          type: "Boolean";
        }
      | {
          content: components["schemas"]["AssetId"];
          /** @enum {string} */
          type: "Asset";
        }
      | {
          content: components["schemas"]["GraphOperationPropertyValueRelationship"];
          /** @enum {string} */
          type: "Relationship";
        };
    GraphOperationPropertyValueRelationship: {
      child_entity_ref: components["schemas"]["GraphOperationEntityRef"];
      parent_entity_ref: components["schemas"]["GraphOperationEntityRef"];
    };
    GraphProperty: {
      account_id?: components["schemas"]["AccountId"] | null;
      component_type: components["schemas"]["GraphComponentType"];
      config?: components["schemas"]["PropertyConfig"] | null;
      label?: string | null;
      property_name: string;
    };
    GraphPropertyValueRelationship: {
      child_entity_id: components["schemas"]["EntityId"];
      parent_entity_id: components["schemas"]["EntityId"];
    };
    HistoricRiskEvaluation: {color: components["schemas"]["ColorPalette"]; label: string; reason: string};
    HubspotCrmConnectionConfig: {hubspot_account_id: string};
    IManageDocumentSourceConfig: {
      customer_id: string;
      database: string;
      /** @default cloudimanage.com */
      domain: string;
      folder_id: string;
      folder_name: string;
    };
    IRect: {max: [number, number]; min: [number, number]};
    /** @enum {string} */
    IdValueType: "Integer" | "String";
    IdentifiedControlSummary: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      /** @default  */
      description: string;
      /** @default false */
      is_required: boolean;
      /**
       * @default {
       *       "design": null,
       *       "implementation": null,
       *       "operating_effectiveness": null,
       *       "representation": null
       *     }
       */
      modules: components["schemas"]["ControlModuleSelection"];
      /** @default null */
      predefined_control_id: components["schemas"]["PredefinedControlId"] | null;
      /** @default  */
      title: string;
    };
    IdentifiedControlsContent: {controls: components["schemas"]["IdentifiedControlSummary"][]};
    IdentifiedRiskContent: {
      contexts: components["schemas"]["RiskContextId"][];
      /** @default false */
      deleted: boolean;
      description: string;
      framework_version_id: components["schemas"]["FrameworkVersionId"];
      /** Format: int32 */
      predefined_risk_ordinal?: number | null;
      title: string;
    };
    IdentifiedSheetCell: {
      /** Format: int32 */
      col: number;
      /** Format: int32 */
      row: number;
    };
    IdentifiedSheetRange: {
      end: components["schemas"]["IdentifiedSheetCell"];
      start: components["schemas"]["IdentifiedSheetCell"];
    };
    IdentifiedSheetSection: {
      column_headers?: components["schemas"]["IdentifiedSheetRange"] | null;
      questions: components["schemas"]["IdentifiedSheetRange"];
      /** @default  */
      section_title: string;
    };
    ImageSourceKind: {file: components["schemas"]["File"]; markdown?: string | null};
    ImageSourceMinKind: {file: components["schemas"]["File"]};
    ImplementationModuleTemplateId: Nominal<string, "ImplementationModuleTemplateId">;
    ImplementationModuleTemplateOption: {
      config: components["schemas"]["ControlDesignImplementationModuleTemplate"];
      implementation_module_template_id: components["schemas"]["ImplementationModuleTemplateId"];
      name: string;
    };
    ImportQuestions: {
      /** @default false */
      automate: boolean;
      /** @default [] */
      questions: components["schemas"]["CreateQuestionInSection"][];
      /** @default [] */
      sections: components["schemas"]["CreateSection"][];
    };
    InAppNotification: {
      created_at: components["schemas"]["DateTime"];
      in_app_notification_id: components["schemas"]["InAppNotificationId"];
      /** Format: double */
      notification_ordinal: number;
      payload: components["schemas"]["InAppNotificationPayload"];
      read_at?: components["schemas"]["DateTime"] | null;
    };
    InAppNotificationId: Nominal<string, "InAppNotificationId">;
    InAppNotificationPayload: {
      action_message: string;
      actor?: components["schemas"]["NotificationRegisteredUserMin"] | null;
      payload: components["schemas"]["NotificationPayloadType"];
      redirect_link: string;
    };
    InAppNotificationStream: {
      channel_name: string;
      /** Format: double */
      number_unread: number;
    };
    InherentRiskChangedContent: {
      /** Format: int32 */
      old_level?: number | null;
    };
    InheritedRole: {
      role: components["schemas"]["RoleMin"];
      /** @description The team(s) the user is a member of that grant this role. */
      teams: components["schemas"]["TeamMin"][];
    };
    InputItems: IValue[];
    /** @description Detail payload for a single conversation, with its event log. */
    InternalConversation: {
      account: components["schemas"]["AccountMin"];
      /**
       * @description Pusher channel for this conversation's live updates. Server-built (via
       *     `conversation_channel_name`), so the detail view subscribes directly.
       */
      channel_name: string;
      config: components["schemas"]["ConversationConfig"];
      conversation_id: components["schemas"]["ConversationId"];
      created_at: components["schemas"]["DateTime"];
      events: components["schemas"]["ConversationEvent"][];
      executor_kind: components["schemas"]["ConversationExecutorKind"];
      /**
       * @description Set once the conversation has been retired: the caller's next
       *     `find_or_create` for the same `(parent, slug)` skips it and starts
       *     fresh. The detail view badges a retired conversation and hides the
       *     retire button.
       */
      retired_at?: components["schemas"]["DateTime"] | null;
      status: components["schemas"]["ConversationStatus"];
      terminal_at?: components["schemas"]["DateTime"] | null;
    };
    /**
     * @description The volatile counters of a conversation, refetched by the live dashboard
     *     when an event lands. Deliberately excludes the immutable `config`/account
     *     (already on the cached row) so the hot refresh path never re-ships the
     *     function config, which can be large.
     */
    InternalConversationCounters: {
      conversation_id: components["schemas"]["ConversationId"];
      /** Format: int64 */
      event_count: number;
      retired_at?: components["schemas"]["DateTime"] | null;
      status: components["schemas"]["ConversationStatus"];
      terminal_at?: components["schemas"]["DateTime"] | null;
      usage: components["schemas"]["UsageTotals"];
    };
    /**
     * @description The export for one region: its rows, plus whether the server's safety cap
     *     clipped them (so the dashboard can warn rather than present a silently
     *     short CSV as complete).
     */
    InternalConversationExport: {rows: components["schemas"]["InternalConversationExportRow"][]; truncated: boolean};
    /**
     * @description One row of the conversations CSV export. A projection of the list row:
     *     only the scalar fields the CSV needs, with the referenced entity IDs
     *     pulled out of the function config server-side. Deliberately omits the
     *     full `config` JSONB — some functions embed large entity snapshots, so an
     *     unfiltered export would otherwise move hundreds of MB.
     */
    InternalConversationExportRow: {
      account: components["schemas"]["AccountMin"];
      /**
       * @description Referenced entity IDs, extracted at any depth of the function config
       *     (a reuse function references several existing risks/findings), so each
       *     is a list.
       */
      assessment_ids: string[];
      control_ids: string[];
      /**
       * @description Operating-effectiveness IDs. A control/assessment filter matches these
       *     through a join, so they're exported alongside the direct IDs.
       */
      control_oe_ids: string[];
      conversation_id: components["schemas"]["ConversationId"];
      created_at: components["schemas"]["DateTime"];
      /** Format: int64 */
      event_count: number;
      executor_kind: components["schemas"]["ConversationExecutorKind"];
      finding_ids: string[];
      function_kind: string;
      retired_at?: components["schemas"]["DateTime"] | null;
      risk_ids: string[];
      status: components["schemas"]["ConversationStatus"];
      terminal_at?: components["schemas"]["DateTime"] | null;
      usage: components["schemas"]["UsageTotals"];
    };
    /**
     * @description Filter for the internal conversations list. Pagination is keyset by
     *     `(created_at, conversation_id)` — clients pass back the last seen
     *     pair as the cursor.
     */
    InternalConversationFilter: {
      /**
       * @description Shared filter — comma-separated list of account UUIDs to restrict
       *     to. Empty / missing means "all accounts". Encoded as a single
       *     string because `axum::extract::Query` (serde_urlencoded) doesn't
       *     decode comma-separated arrays natively; we parse server-side.
       */
      account_ids?: string | null;
      executor_kind?: components["schemas"]["ConversationExecutorKind"] | null;
      /**
       * @description Shared filter — lower bound of the time window. Applied against
       *     the column named by `time_field`.
       */
      from?: components["schemas"]["DateTime"] | null;
      function?: components["schemas"]["ConversationFunctionKind"] | null;
      /** Format: int32 */
      limit?: number | null;
      /**
       * @description The entity ID matched against `config.function.content`, as a plain
       *     UUID string (the typed refs the dashboard builds are all UUID-backed).
       */
      ref_id?: string | null;
      /**
       * @description Dashboard-specific — restrict to conversations whose function
       *     references the entity `(ref_kind, ref_id)`. Both are set together;
       *     either alone is ignored.
       */
      ref_kind?: components["schemas"]["ConversationRefKind"] | null;
      status?: components["schemas"]["ConversationStatus"] | null;
      /**
       * @description Which time-like column on the conversation `from`/`to` should
       *     filter. Dashboard-specific.
       */
      time_field?: components["schemas"]["ConversationTimeField"] | null;
      /**
       * @description Shared filter — upper bound of the time window. Applied against
       *     the column named by `time_field`.
       */
      to?: components["schemas"]["DateTime"] | null;
    };
    /** @description Row in the internal cross-account conversations list. */
    InternalConversationSummary: {
      account: components["schemas"]["AccountMin"];
      /**
       * @description Pusher channel for this conversation's live updates. Server-built (via
       *     `conversation_channel_name`) so the frontend never reconstructs the
       *     format — the dashboard subscribes to it directly.
       */
      channel_name: string;
      config: components["schemas"]["ConversationConfig"];
      conversation_id: components["schemas"]["ConversationId"];
      created_at: components["schemas"]["DateTime"];
      /** Format: int64 */
      event_count: number;
      executor_kind: components["schemas"]["ConversationExecutorKind"];
      /**
       * @description Set once the conversation has been retired: the caller's next
       *     `find_or_create` for the same `(parent, slug)` skips it and starts
       *     fresh. The dashboard badges retired rows and hides the retire
       *     button.
       */
      retired_at?: components["schemas"]["DateTime"] | null;
      status: components["schemas"]["ConversationStatus"];
      terminal_at?: components["schemas"]["DateTime"] | null;
      /**
       * @description Running token usage summed across the conversation's assistant
       *     events, maintained on the row as events are appended.
       */
      usage: components["schemas"]["UsageTotals"];
    };
    InternalFindingContent: {content: string; title: string};
    /**
     * @description Row in the internal cross-account CompleteChat shim journal list. Metadata
     *     only — request/response payloads can carry whole prompts, so they are
     *     fetched per-row via the payload endpoint.
     */
    InternalLlmShimJournalEntry: {
      account: components["schemas"]["AccountMin"];
      created_at: components["schemas"]["DateTime"];
      /**
       * @description Error text when the call failed; `None` on success. Each row holds
       *     exactly one of a response / error (`chk_one_outcome`).
       */
      error?: string | null;
      /** @description Caller name recorded at the shim call site. */
      label: string;
      llm_shim_journal_id: components["schemas"]["LlmShimJournalId"];
      method: string;
      provider_name: string;
      /** Format: int32 */
      request_bytes: number;
      /**
       * @description Hex-encoded SHA-256 of the serialized request payload. Groups
       *     byte-identical requests; not unique.
       */
      request_sha256: string;
      /** Format: int32 */
      response_bytes?: number | null;
    };
    /** @description Filter for the internal CompleteChat shim journal list. */
    InternalLlmShimJournalFilter: {
      /**
       * @description Shared filter — comma-separated list of account UUIDs to restrict
       *     to. Empty / missing means "all accounts". Encoded as a single
       *     string because `axum::extract::Query` (serde_urlencoded) doesn't
       *     decode comma-separated arrays natively; we parse server-side.
       */
      account_ids?: string | null;
      /** @description Shared filter — lower bound on `created_at`. */
      from?: components["schemas"]["DateTime"] | null;
      /**
       * @description Case-insensitive substring match on `label`. `%` and `_` act as
       *     SQL wildcards.
       */
      label?: string | null;
      /** Format: int32 */
      limit?: number | null;
      /** @description Restrict to rows with this outcome. Missing means "all rows". */
      outcome?: components["schemas"]["LlmShimJournalOutcome"] | null;
      /** @description Shared filter — upper bound on `created_at`. */
      to?: components["schemas"]["DateTime"] | null;
    };
    /** @description Full payloads of one journal row. */
    InternalLlmShimJournalPayload: {error?: string | null; request_payload: IValue; response?: IValue};
    Invalidation:
      | {
          content: components["schemas"]["QuestionId"];
          /** @enum {string} */
          type: "Question";
        }
      | {
          content: components["schemas"]["QuestionnaireId"];
          /** @enum {string} */
          type: "Questionnaire";
        }
      | {
          content: components["schemas"]["EngagementId"];
          /** @enum {string} */
          type: "AuditPlanStructure";
        };
    InvalidationCause:
      | {
          /** @enum {string} */
          type: "New";
        }
      | {
          /** @enum {string} */
          type: "SourcesChanged";
        }
      | {
          /** @enum {string} */
          type: "RiskIdentified";
        }
      | {
          /** @enum {string} */
          type: "RiskUpdated";
        }
      | {
          content: components["schemas"]["ControlChangedContent"];
          /** @enum {string} */
          type: "ControlIdentificationChanged";
        }
      | {
          /** @enum {string} */
          type: "ControlScopeSelectionChanged";
        }
      | {
          content: components["schemas"]["ControlScopeChangedContent"];
          /** @enum {string} */
          type: "ControlScopeDesignChanged";
        }
      | {
          content: components["schemas"]["ControlScopeChangedContent"];
          /** @enum {string} */
          type: "ControlScopeImplementationChanged";
        }
      | {
          content: components["schemas"]["ControlScopeChangedContent"];
          /** @enum {string} */
          type: "ControlScopeRepresentationChanged";
        }
      | {
          content: components["schemas"]["ControlScopeChangedContent"];
          /** @enum {string} */
          type: "ControlScopeDesignEvaluated";
        }
      | {
          content: components["schemas"]["ControlScopeChangedContent"];
          /** @enum {string} */
          type: "ControlScopeImplementationEvaluated";
        }
      | {
          content: components["schemas"]["ControlChangedContent"];
          /** @enum {string} */
          type: "ControlRepresentationChanged";
        }
      | {
          content: components["schemas"]["ControlChangedContent"];
          /** @enum {string} */
          type: "ControlDesignEvaluated";
        }
      | {
          content: components["schemas"]["ControlChangedContent"];
          /** @enum {string} */
          type: "ControlImplementationEvaluated";
        }
      | {
          /** @enum {string} */
          type: "ControlsChanged";
        }
      | {
          content: components["schemas"]["InherentRiskChangedContent"];
          /** @enum {string} */
          type: "InherentRiskChanged";
        }
      | {
          content: components["schemas"]["ControlRelevanceChangedContent"];
          /** @enum {string} */
          type: "ControlRelevanceChanged";
        }
      | {
          content: components["schemas"]["ControlMetChangedContent"];
          /** @enum {string} */
          type: "ControlMetChanged";
        }
      | {
          content: components["schemas"]["ControlScopeMetChangedContent"];
          /** @enum {string} */
          type: "ControlScopeMetChanged";
        }
      | {
          content: components["schemas"]["ResidualRiskChangedContent"];
          /** @enum {string} */
          type: "ResidualRiskChanged";
        };
    InviteInfo: {
      email: string;
      initiated_by?: components["schemas"]["OneTimeTokenInitiator"] | null;
      login_methods: components["schemas"]["UserLoginMethod"][];
      /**
       * @description If the user has already been registered the inviter would have set their
       *     name already, but we'll allow them to change it during the invite flow.
       */
      name?: string | null;
    };
    InvitePortalUser: {
      /** Format: email */
      email: string;
    };
    InviteUser: {
      /** Format: email */
      email: string;
      name: string;
      /**
       * @description Roles to grant the invited user (admin only).
       * @default []
       */
      role_ids: components["schemas"]["RoleId"][];
      /**
       * @description Teams to add the invited user to (admin only).
       * @default []
       */
      team_ids: components["schemas"]["TeamId"][];
    };
    ItemStanding: "Excluded" | "Failed" | "Holds" | "Outstanding";
    /** @enum {string} */
    LayerType: "External" | "Internal" | "AI";
    LayerTypePath: {layer_type: components["schemas"]["LayerType"]};
    LegacyAreaMapping: {
      /**
       * @description The entity-level audit area template the frameworks land under. The
       *     engagement's existing area for this template is reused; otherwise one is
       *     created, without the template's own framework assessment.
       */
      audit_area_template_id: components["schemas"]["AuditAreaTemplateId"];
      framework_ids: components["schemas"]["FrameworkId"][];
    };
    /**
     * @description What a run did with one engagement. A refused engagement is left exactly
     *     as it was; the run carries on to the next.
     */
    LegacyEngagementOutcome:
      | {
          content: components["schemas"]["LegacyMigrationReport"];
          /** @enum {string} */
          type: "Migrated";
        }
      | {
          content: {engagement_id: components["schemas"]["EngagementId"]; error: string};
          /** @enum {string} */
          type: "Failed";
        };
    LegacyMigrationReport: {
      /** @description Live assessments already attached to an audit area, left untouched. */
      already_migrated: components["schemas"]["AssessmentId"][];
      areas: components["schemas"]["MigratedArea"][];
      engagement_id: components["schemas"]["EngagementId"];
      /** @description False when the engagement already had an audit plan. */
      plan_created: boolean;
    };
    LegacyMigrationSummary: {
      /**
       * @default {
       *       "backfilled": 0,
       *       "blocked_by": [],
       *       "unmapped_frameworks": []
       *     }
       */
      autoruns: components["schemas"]["FrameworkAutorunBackfill"];
      dry_run: boolean;
      engagements: components["schemas"]["LegacyEngagementOutcome"][];
    };
    LegacyPath: {external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"]};
    LibrarySectionFilter: {recursive: boolean; scoped_id: components["schemas"]["ScopedLibrarySectionId"]};
    LibrarySectionId: Nominal<string, "LibrarySectionId">;
    LibrarySectionIdPath: {id: components["schemas"]["LibrarySectionId"]};
    LibrarySectionMin: {
      deleted?: components["schemas"]["Actioned"] | null;
      description?: string | null;
      library_section_id: components["schemas"]["LibrarySectionId"];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      parent_scope?: components["schemas"]["ScopeMin"] | null;
      parent_section_id?: components["schemas"]["LibrarySectionId"] | null;
    };
    LibrarySectionWithoutScope: {
      deleted?: components["schemas"]["Actioned"] | null;
      description?: string | null;
      library_section_id: components["schemas"]["LibrarySectionId"];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      parent_section_id?: components["schemas"]["LibrarySectionId"] | null;
    };
    LinkNotificationSink: {
      account_id: components["schemas"]["AccountId"];
      external_user_id?: string | null;
      notification_sink_id: components["schemas"]["NotificationSinkId"];
    };
    LinkedNotificationSinkMin: {
      external_user_id?: string | null;
      notification_sink: components["schemas"]["NotificationSinkMin"];
    };
    ListActivitiesArgs: {
      /** Format: double */
      before?: number | null;
      /** Format: double */
      since?: number | null;
    };
    ListAssets: {owner?: components["schemas"]["AssetOwner"] | null};
    ListLibrarySectionFactsArgs: {
      /** @default false */
      recurse: boolean;
    };
    ListNotificationsArgs: {
      /** Format: double */
      before?: number | null;
      /** Format: double */
      limit?: number | null;
      /** Format: double */
      since?: number | null;
    };
    ListOwnersQuery: {
      /**
       * @description When set to a specific product, only owners (users) with access to that
       *     product are returned. Teams are always included.
       */
      product?: components["schemas"]["ProductType"] | null;
    };
    ListResolutionsArgs: {
      /** @default false */
      assigned_to_me: boolean;
      /** Format: int32 */
      limit?: number | null;
      /** Format: int32 */
      offset?: number | null;
    };
    ListScopeFactsArgs: {
      /** @default false */
      recurse: boolean;
    };
    ListShowcaseMessageParams: {status: components["schemas"]["UpdateNotificationStatus"]};
    ListUsersQuery: {
      /**
       * @description When set to a specific product, only users with access to that product
       *     are returned. Used by in-app user pickers so you can only select people
       *     who can actually use the application.
       */
      product?: components["schemas"]["ProductType"] | null;
    };
    LlmShimJournalId: Nominal<string, "LlmShimJournalId">;
    LlmShimJournalIdPath: {llm_shim_journal_id: components["schemas"]["LlmShimJournalId"]};
    /**
     * @description Restricts the journal list to rows with one outcome.
     * @enum {string}
     */
    LlmShimJournalOutcome: "success" | "error";
    LockAuditPlanPages: {page_ids: components["schemas"]["AuditPlanPageId"][]};
    LoginCredentials: {password: string; totp_code?: string | null};
    LoginMethod: {
      account?: components["schemas"]["AccountMin"] | null;
      inner: components["schemas"]["LoginMethodInner"];
      login_method_id: components["schemas"]["LoginMethodId"];
      name: string;
    };
    LoginMethodGenericOauth: Record<string, never>;
    LoginMethodGenericSaml: {issuer_id: string; metadata_url: string};
    LoginMethodId: Nominal<string, "LoginMethodId">;
    LoginMethodIdPath: {login_method_id: components["schemas"]["LoginMethodId"]};
    LoginMethodIdPath2: {login_method_id: components["schemas"]["LoginMethodId"]};
    LoginMethodInner:
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "UsernamePassword";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "GoogleOAuth";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "MicrosoftOAuth";
        }
      | {
          content: components["schemas"]["LoginMethodGenericOauth"];
          /** @enum {string} */
          type: "GenericOauth";
        }
      | {
          content: components["schemas"]["LoginMethodGenericSaml"];
          /** @enum {string} */
          type: "GenericSaml";
        };
    LoginMethodInnerMin:
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "UsernamePassword";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "GoogleOAuth";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "MicrosoftOAuth";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "GenericOauth";
        }
      | {
          content: components["schemas"]["EmptyLoginMethodPayload"];
          /** @enum {string} */
          type: "GenericSaml";
        };
    LoginMethodMin: {
      inner: components["schemas"]["LoginMethodInnerMin"];
      login_method_id: components["schemas"]["LoginMethodId"];
      name: string;
    };
    /** @enum {string} */
    LoginMethodType: "UsernamePassword" | "GoogleOAuth" | "MicrosoftOAuth" | "GenericOauth" | "GenericSaml";
    LoginRedirectRequest: {email: string; redirect_url: string};
    LoginRequest:
      | {
          content: components["schemas"]["UsernamePasswordLoginRequest"];
          /** @enum {string} */
          type: "UsernamePassword";
        }
      | {
          content: components["schemas"]["OAuthLoginRequest"];
          /** @enum {string} */
          type: "OAuth";
        };
    LoginResponse:
      | {
          content: components["schemas"]["RegisteredUser"];
          /** @enum {string} */
          type: "Success";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Redirect";
        };
    LogoKeyPath: {key: string};
    LogoutArgs: {
      /**
       * @description End every session the user holds on every device, and the access
       *     tokens issued from them.
       * @default false
       */
      all_devices: boolean;
    };
    MailSubscriptionId: Nominal<string, "MailSubscriptionId">;
    MailSubscriptionIdPath: {mail_subscription_id: components["schemas"]["MailSubscriptionId"]};
    MailingList: {
      /** Format: int32 */
      active_count: number;
      /** Format: int32 */
      inactive_count: number;
      subscribers: components["schemas"]["Subscriber"][];
    };
    MailingListId: Nominal<string, "MailingListId">;
    /**
     * @description Configures a single `MapRiskRelevantControls` agent run.
     *     Identifies the (assessment, risk) pair; the agent reads the
     *     risk's `IdentifiedRisk` decision and the assessment's
     *     `IdentifiedControls` decision from the DB and picks which
     *     controls mitigate the risk.
     */
    MapRiskRelevantControlsFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      risk_id: components["schemas"]["RiskId"];
    };
    /**
     * @description Configures a single `MapTestEvidence` agent run: the test whose
     *     frozen sample the matches are filed against, and the one attached
     *     evidence document the run examines.
     *
     *     `source_as_of` is the version the attachment pinned, carried on the
     *     persisted config so a retry resolving this conversation reads the
     *     version the auditor attached even once the attachment row has moved
     *     on.
     *
     *     It selects a version, not a snapshot of the bytes: extraction fills
     *     markdown and summary into the selected log entry in place, so the
     *     same pin yields empty content before processing finishes and the
     *     document afterwards.
     */
    MapTestEvidenceFunction: {
      source_as_of: components["schemas"]["DateTime"];
      source_id: components["schemas"]["SourceId"];
      test_id: components["schemas"]["TestId"];
    };
    /**
     * @description Configures a single `MapToStandardFinding` agent run. Vector
     *     search + candidate assembly happens caller-side — the config
     *     carries the derived shortlist plus the generated finding's
     *     client-facing content so the render and the resolver both see
     *     the same list on retry.
     */
    MapToStandardFindingFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      candidates: components["schemas"]["StandardFindingCandidate"][];
      generated_finding: components["schemas"]["MapToStandardFindingGenerated"];
    };
    /**
     * @description Client-facing content of the generated finding the model is
     *     deciding whether to remap to a standard finding.
     */
    MapToStandardFindingGenerated: {content: string; title: string};
    MemberAttributePath: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    MemberPath: {
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    Mention: {
      content: components["schemas"]["Owner"] | null;
      /** @enum {string} */
      type: "Owner";
    };
    MentionElement: {
      /** Format: int32 */
      index: number;
    };
    /** @description Must be a live scope in the same engagement as the one being merged away. */
    MergeScope: {
      /**
       * @description Appended to the name of every source moved, so evidence from the two
       *     rooms stays distinguishable. Nothing enforces unique source names.
       */
      source_name_suffix?: string | null;
      target_scope_id: components["schemas"]["TprmScopeId"];
    };
    MessageIdPath: {message_id: components["schemas"]["ShowcaseUpdateMessageId"]};
    MicrosoftDocumentSourceConfig: {drive_id: string; item_id: string; item_name: string};
    MigrateLegacyEngagements: {
      areas: components["schemas"]["LegacyAreaMapping"][];
      /**
       * @description Migrate each engagement and roll it back, reporting what the live run
       *     would do.
       * @default false
       */
      dry_run: boolean;
    };
    MigratedArea: {
      assessments: components["schemas"]["MigratedAssessment"][];
      audit_area_id: components["schemas"]["AuditAreaId"];
      audit_area_template_id: components["schemas"]["AuditAreaTemplateId"];
      /** @description False when the engagement's existing area for the template was reused. */
      created: boolean;
      name: string;
      page_id: components["schemas"]["AuditPlanPageId"];
    };
    MigratedAssessment: {
      /** @description Whether the minted pages were archived, derived from `status`. */
      archived: boolean;
      assessment_id: components["schemas"]["AssessmentId"];
      /** Format: uint */
      control_pages: number;
      framework_name: string;
      /** @description The `RisksAndControls` page minted for the assessment. */
      page_id: components["schemas"]["AuditPlanPageId"];
      /** @description Sign-off stamped on the minted pages, derived from `status`. */
      page_status: components["schemas"]["AuditPlanPageStatus"];
      /** Format: uint */
      risk_pages: number;
      status: components["schemas"]["AssessmentStatus"];
    };
    MoveRowBody: {
      row_id: components["schemas"]["TprmTableRowId"];
      /** Format: int64 */
      target_index: number;
      /**
       * @description Column values merged into the moved row (e.g. the group it was dropped
       *     into); empty for an order-only move.
       * @default {}
       */
      values: {[key: string]: components["schemas"]["TprmExternalColumnValue"]};
    };
    MoveRowsBody: {
      row_ids: components["schemas"]["TprmTableRowId"][];
      /** Format: int64 */
      target_index: number;
      /**
       * @description Column values merged into every moved row; empty for an order-only move.
       * @default {}
       */
      values: {[key: string]: components["schemas"]["TprmExternalColumnValue"]};
    };
    /**
     * @description A population source whose records are prose, and the version of it the
     *     population's pin fixed.
     *
     *     Pinned rather than live because a run's rows have to be answerable to the
     *     bytes the run read: a citation resolved against a source that changed
     *     mid-run points into a document nobody saw.
     */
    NarrativePopulationSource: {name: string; source: components["schemas"]["SourceRef"]};
    Never: Never;
    NewAccount: {account: components["schemas"]["Account"]; apikey: components["schemas"]["Apikey"]};
    /**
     * @description An auditor's call on a note condition. A note is written before anyone
     *     checks it, so it starts `Unassessed`; only an assessed note carries who made
     *     the call and when.
     * @enum {string}
     */
    NoteAssessment: "Unassessed" | "Holds" | "DoesNotHold";
    /** @enum {string} */
    NotificationChannelCategory: "ConnectedApps" | "Email" | "EmailDigest" | "InApp";
    NotificationChannelConnectorTypePath: {
      notification_channel_connector_type: components["schemas"]["NotificationSinkConnectorType"];
    };
    NotificationPayloadType:
      | {
          content: components["schemas"]["SingleNotificationPayload"];
          /** @enum {string} */
          type: "Single";
        }
      | {
          content: components["schemas"]["BulkNotificationPayload"];
          /** @enum {string} */
          type: "Bulk";
        };
    NotificationPreferencesConfig: {
      notification_preferences: {[key: string]: components["schemas"]["NotificationType"][]};
    };
    NotificationRegisteredUserMin: {
      avatar_url?: string | null;
      name: string;
      primary_email: string;
      user_id: components["schemas"]["UserId"];
    };
    NotificationSink: {
      account_id: components["schemas"]["AccountId"];
      config: components["schemas"]["NotificationSinkConfig"];
      connector: components["schemas"]["NotificationSinkConnector"];
      external_authorization?: components["schemas"]["ExternalAuthorization"] | null;
      name: string;
      notification_sink_id: components["schemas"]["NotificationSinkId"];
    };
    NotificationSinkConfig: {
      content: components["schemas"]["SlackNotificationSinkConfig"];
      /** @enum {string} */
      type: "Slack";
    };
    NotificationSinkConnector: {
      connector_type: components["schemas"]["NotificationSinkConnectorType"];
      logo_url: string;
      name: string;
    };
    /** @enum {string} */
    NotificationSinkConnectorType: "slack";
    NotificationSinkId: Nominal<string, "NotificationSinkId">;
    NotificationSinkIdPath: {notification_sink_id: components["schemas"]["NotificationSinkId"]};
    NotificationSinkMin: {
      account_id: components["schemas"]["AccountId"];
      config: components["schemas"]["NotificationSinkConfig"];
      connector: components["schemas"]["NotificationSinkConnector"];
      /**
       * @description Present when the underlying connection has a problem to surface to the
       *     user (e.g. its authorization was revoked and notifications can't be sent).
       *     Embedded rather than referenced by catalog id because this list is
       *     user-scoped and spans accounts, so it has no single account context in
       *     which to look the errors up separately.
       */
      last_error?: components["schemas"]["ReportedError"] | null;
      name: string;
      notification_sink_id: components["schemas"]["NotificationSinkId"];
    };
    /** @enum {string} */
    NotificationStatus: "Read" | "Unread" | "All";
    /** @enum {string} */
    NotificationType:
      | "AddedToTeam"
      | "RemovedFromTeam"
      | "AdminAdded"
      | "AdminRemoved"
      | "AddedAsAdmin"
      | "RemovedAsAdmin"
      | "QuestionAssigned"
      | "QuestionCommented"
      | "QuestionFinishedAutomating"
      | "QuestionMentioned"
      | "QuestionUpdated"
      | "QuestionDueSoon"
      | "QuestionReviewRequested"
      | "QuestionReviewCommented"
      | "QuestionReviewChangesRequested"
      | "QuestionReviewApproved"
      | "QuestionnaireAssigned"
      | "QuestionnaireCommented"
      | "QuestionnaireFinishedAutomating"
      | "QuestionnaireMentioned"
      | "QuestionnaireUpdated"
      | "QuestionnaireDueSoon"
      | "DocumentAssigned"
      | "DocumentCommented"
      | "DocumentMentioned"
      | "DocumentUpdated"
      | "ReviewItemAssigned"
      | "ControlMentioned"
      | "ControlCommented"
      | "ControlReviewRequested"
      | "ControlReviewCommented"
      | "ControlReviewChangesRequested"
      | "ControlReviewApproved"
      | "RiskAssigned"
      | "RiskMentioned"
      | "RiskCommented"
      | "RiskReviewRequested"
      | "RiskReviewCommented"
      | "RiskReviewChangesRequested"
      | "RiskReviewApproved"
      | "AssessmentFinishedAutomating"
      | "AssessmentAssigned"
      | "ComplexityAssessmentAssigned"
      | "ComplexityAssessmentCompleted"
      | "ComplexityAssessmentTierUpdated"
      | "ControlOECompleted"
      | "UnderstandingGenerationCompleted"
      | "UnderstandingGenerationFailed"
      | "AuditPlanPageReviewerAssigned"
      | "AuditPlanPageCompleted"
      | "AuditPlanPageCommented"
      | "AuditPlanPageMentioned"
      | "AuditPlanPageReviewCommented"
      | "AuditPlanPageReviewApproved"
      | "AuditPlanPageReviewChangesRequested"
      | "ThirdPartyAssigned"
      | "ThirdPartyQuestionnaireSubmitted";
    NotionDocumentSourceConfig: Record<string, never>;
    OAuthLoginRequest: {email_hint?: string | null; redirect?: string | null};
    /** @enum {string} */
    OAuthRedirectTarget:
      | "google"
      | "atlassian"
      | "hubspot"
      | "slack"
      | "microsoft-spa"
      | "microsoft-web"
      | "docusign"
      | "notion"
      | "imanage";
    OauthCallbackParams: {code: string; state: string};
    /**
     * @description One dependency edge in an engagement's OE graph: a control condition resolved
     *     against its target's live conclusion. The condition *is* the edge — there is
     *     no separate edge table — so the set is derived from the condition rows.
     */
    OeDependencyEdge: {
      condition_id: components["schemas"]["ControlOeConditionId"];
      /**
       * Format: int32
       * @description The bar: a 1-based index into the target's scale.
       */
      min_rating: number;
      /** @description Why the dependency exists, e.g. a named complementary user entity control. */
      provenance?: string | null;
      /**
       * @description The target's level at the bar, absent when the bar falls outside the
       *     target's current scale.
       */
      required_level?: components["schemas"]["ColoredText"] | null;
      /** @description Whether the bar is met against the target's live conclusion. */
      resolution: components["schemas"]["ControlConditionResolution"];
      source_assessment_control_id: components["schemas"]["AssessmentControlId"];
      /** @description The dependent assessment, whose argument carries the condition. */
      source_control_oe_id: components["schemas"]["ControlOeId"];
      source_scope_id: components["schemas"]["TprmScopeId"];
      target_assessment_control_id: components["schemas"]["AssessmentControlId"];
      /** @description The depended-on assessment. */
      target_control_oe_id: components["schemas"]["ControlOeId"];
      target_control_title: string;
      /**
       * Format: int32
       * @description The target's conclusion rating, absent until it concludes.
       */
      target_rating?: number | null;
      /** @description The target's reliance. */
      target_reliance: components["schemas"]["Reliance"];
      target_scope_id: components["schemas"]["TprmScopeId"];
    };
    OeModuleTemplateId: Nominal<string, "OeModuleTemplateId">;
    OeModuleTemplateOption: {
      config: components["schemas"]["ControlOEModuleTemplate"];
      name: string;
      oe_module_template_id: components["schemas"]["OeModuleTemplateId"];
    };
    OneTimeTokenInitiator: {
      account: components["schemas"]["AccountMin"];
      user?: components["schemas"]["UserMin"] | null;
    };
    OperationalContext: {
      assets: components["schemas"]["TprmAsset"][];
      description: string;
      name: string;
      operational_context_id: components["schemas"]["OperationalContextId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    OperationalContextAssetPath: {
      asset_id: components["schemas"]["TprmAssetId"];
      operational_context_id: components["schemas"]["OperationalContextId"];
    };
    OperationalContextId: Nominal<string, "OperationalContextId">;
    OperationalContextIdPath: {operational_context_id: components["schemas"]["OperationalContextId"]};
    OperationalContextMin: {
      assets: components["schemas"]["TprmAsset"][];
      description: string;
      name: string;
      operational_context_id: components["schemas"]["OperationalContextId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    OrderClause: {direction: components["schemas"]["OrderDirection"]; field: string};
    /** @enum {string} */
    OrderDirection: "ascending" | "descending";
    /** Format: double */
    OrderedFloat: number;
    OriginalFile: {file: components["schemas"]["File"]; imported_at?: components["schemas"]["DateTime"] | null};
    OriginalSource: {imported_at?: components["schemas"]["DateTime"] | null; url: string};
    Owner: {owner_id: components["schemas"]["OwnerId"]; owner_payload: components["schemas"]["OwnerPayload"]};
    OwnerId: Nominal<string, "OwnerId">;
    OwnerIdPath: {owner_id: components["schemas"]["OwnerId"]};
    OwnerPayload:
      | {
          content: components["schemas"]["TeamMin"];
          /** @enum {string} */
          type: "Team";
        }
      | {
          content: components["schemas"]["UserMin"];
          /** @enum {string} */
          type: "User";
        };
    /** @enum {string} */
    OwnerType: "User" | "Team";
    PageIdPath: {
      engagement_id: components["schemas"]["EngagementId"];
      page_id: components["schemas"]["AuditPlanPageId"];
    };
    Paginated: Paginated<components["schemas"]["Task"]>;
    Paginated2: Paginated<components["schemas"]["Fact"]>;
    Paginated3: Paginated<components["schemas"]["ResolutionMin"]>;
    Paginated4: Paginated<components["schemas"]["ThirdParty"]>;
    Paginated5: Paginated<components["schemas"]["Engagement"]>;
    Paginated6: Paginated<components["schemas"]["PopulationRow"]>;
    Paginated7: Paginated<components["schemas"]["SampleItem"]>;
    Paginated8: Paginated<components["schemas"]["TestMaterializedItem"]>;
    PaginationArgs: {
      /** Format: int32 */
      limit?: number | null;
      /** Format: int32 */
      offset?: number | null;
    };
    /** @enum {string} */
    PassFailUnknown: "Pass" | "Fail" | "Unknown";
    PasswordConfig: {
      characters: components["schemas"]["CharacterConfig"];
      /** Format: uint16 */
      expiry?: number | null;
      /** Format: uint8 */
      length_requirement?: number | null;
      random: boolean;
      unique: boolean;
    };
    /** @enum {string} */
    PasswordManager: "1Password" | "LastPass" | "Keeper";
    PasswordPolicyConfig: {
      exceptions: components["schemas"]["ExceptionConfig"];
      passwords: components["schemas"]["PasswordConfig"];
      tools: components["schemas"]["ToolsConfig"];
    };
    /** @description An answer rolled over from a past request. */
    PastQuestionnaireSuggestion: {
      /** @description The request's questionnaire model name, as the portal titles it. */
      name: string;
      /** @description The questionnaire it answered, which may be a sub-questionnaire of the request. */
      source_external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      submitted_at?: components["schemas"]["DateTime"] | null;
    };
    PendingBackgroundTask: {
      background_task_id: components["schemas"]["BackgroundTaskId"];
      channel_name: string;
      created_at: components["schemas"]["DateTime"];
      name: string;
      /** Format: float */
      progress: number;
      scheduled_for: components["schemas"]["DateTime"];
    };
    /**
     * @description Configures a single `PlanControlOe` agent run. The (control, scope) OE
     *     assessment to draft a plan for; the agent reads its framework OE approach,
     *     design & implementation, control description and declared dependencies.
     */
    PlanControlOeFunction: {control_oe_id: components["schemas"]["ControlOeId"]};
    /** @description A point on a page, origin top-left, in the page's [`DocumentLengthUnit`]. */
    Point: {
      /** Format: double */
      x: number;
      /** Format: double */
      y: number;
    };
    PopulateExternalAccountReference: {
      reference: string;
      reference_type: components["schemas"]["ExternalAccountReferenceType"];
    };
    PopulateRegisteredUser: {
      /** Format: email */
      email: string;
      /** @default {} */
      external_ids: {[key: string]: string};
      login_method_id?: components["schemas"]["LoginMethodId"] | null;
      name: string;
      password?: string | null;
      /**
       * @description Roles to grant the user on creation (admin only).
       * @default []
       */
      role_ids: components["schemas"]["RoleId"][];
      /**
       * @description Teams to add the user to on creation (admin only).
       * @default []
       */
      team_ids: components["schemas"]["TeamId"][];
    };
    /** @description A population and its resolved source snapshots. */
    Population: {
      /** @description Instruction describing how the sources are merged into the target fields. */
      agent_prompt?: string | null;
      created_at: components["schemas"]["DateTime"];
      description?: string | null;
      engagement: components["schemas"]["EngagementMin"];
      /**
       * @description What the most recent run made of each source, updated as the run
       *     finishes with each.
       */
      extract_last_attempt?: components["schemas"]["PopulationExtractionReport"] | null;
      /** @description How the rows now in the table were built, source by source. */
      extract_report?: components["schemas"]["PopulationExtractionReport"] | null;
      fields: components["schemas"]["PopulationField"][];
      /**
       * @description True exactly when [`Self::locked_at`] is set. A locked population is
       *     immutable — its sources, fields and rows can't change — but still
       *     readable, so samples can go on being drawn from it.
       */
      is_locked: boolean;
      /**
       * Format: int64
       * @description Number of live (non-deleted) samples drawn from this population, drafts
       *     included — the "Linked samples" stat, and the count that blocks deleting
       *     the population (an FK-shaped guard that does not know about draftness).
       */
      live_sample_count: number;
      /**
       * @description When the lock was taken — by the first draw from this population, or by
       *     hand. Held until someone clears it.
       */
      locked_at?: components["schemas"]["DateTime"] | null;
      name: string;
      population_id: components["schemas"]["PopulationId"];
      processing_state: components["schemas"]["PopulationProcessingState"];
      /** Format: int64 */
      row_count: number;
      /**
       * @description Whether the rows in the table were built from a source set the
       *     population no longer holds as it stands — one since added, removed, or
       *     changed under the pin the run took. It marks rather than blocks:
       *     completeness of a frame is the auditor's judgement, so this is the
       *     signal they act on.
       */
      rows_predate_sources: boolean;
      /**
       * @description The sources the population draws from, each resolved at its pinned
       *     `source_as_of`; a source carries `drifted` when it has changed since the
       *     snapshot was taken. Ordered as they were added.
       */
      sources: components["schemas"]["SourceMin"][];
      updated_at: components["schemas"]["DateTime"];
    };
    PopulationColumnId: Nominal<string, "PopulationColumnId">;
    /**
     * @description Configures the conversation one extraction of a population runs in.
     *
     *     `columns` is the population's standing schema in the order the prompt
     *     numbers them: a header binding and a recorded cell both name a column by its
     *     position in this list, so prompt and answer agree on what a number means
     *     only while they share one ordering. An empty list is a population whose
     *     schema this run derives, which has nothing to reconcile and nothing to
     *     record into.
     *
     *     The two source lists are the two mechanisms. A tabular source is transcribed
     *     off its raw bytes before the conversation opens and reaches the model only
     *     as sample rows and a keyed lookup; a narrative source is what the model
     *     reads and enumerates. Between them, `unbound_headers` and `narrative` are
     *     the whole of what a run can have to decide — both empty means the run parses
     *     offline and deterministically and no turn is dispatched.
     */
    PopulationExtractionFunction: {
      /** @description The population's standing columns, in prompt order. */
      columns: components["schemas"]["PopulationField"][];
      /**
       * @description The sources whose records only a reader can pick out.
       * @default []
       */
      narrative: components["schemas"]["NarrativePopulationSource"][];
      population_id: components["schemas"]["PopulationId"];
      /**
       * @description The sources already transcribed into the population's rows.
       * @default []
       */
      tabular: components["schemas"]["TabularPopulationSource"][];
      /** @description The tabular headers no standing column claims. */
      unbound_headers: components["schemas"]["UnboundPopulationHeader"][];
    };
    /**
     * @description What one extraction run made of each of a population's sources.
     *
     *     A population holds two of these and they can describe different runs. The
     *     **report** accounts for the rows currently in the table, so only a run that
     *     wrote rows writes it and it can never contradict the table beneath it. The
     *     **last attempt** accounts for the most recent run whether it wrote rows or
     *     not, so a failure reads source by source — *October 61, November 58,
     *     December refused* decides the auditor's next move where a bare error string
     *     does not.
     *
     *     Persisted as JSONB: a field added later needs `#[serde(default)]`.
     */
    PopulationExtractionReport: {
      /**
       * @description One entry per source the run was given, in the population's source
       *     order.
       */
      sources: components["schemas"]["PopulationSourceReport"][];
    };
    /**
     * @description A column in a population. Generic form of operating effectiveness's
     *     `SampleAttribute`. Rows are keyed by the generated [`PopulationColumnId`]
     *     rather than the column name, so blank or duplicate names are a non-issue.
     *
     *     A column id outlives the extraction that minted it. A test freezes its rows
     *     keyed by these ids while reading the definitions live, so a column whose id
     *     changed under it would leave a frozen row nothing can say the meaning of.
     */
    PopulationField: {
      /**
       * @description What belongs in this column, beyond what its name says. A name is a
       *     label for a human reading the table; enumeration needs a specification
       *     of the cell, and *"the person who authorised the change, named in the
       *     sign-off block"* leaves an extraction nothing to choose between
       *     *"reviewed by"* and *"raised by"*. Written by the run that derived the
       *     column, from the same reading that chose its name.
       * @default null
       */
      ai_hint: string | null;
      /**
       * @description The source headers whose values land in this column — written when the
       *     column is derived from a header, and when a run's model reconciles a
       *     header nothing claimed. Extraction binds a header carried here without
       *     consulting a model, so a binding is judged once and survives the column
       *     being renamed.
       * @default []
       */
      bound_headers: string[];
      column_id: components["schemas"]["PopulationColumnId"];
      /** @description Human-readable column name. */
      column_name: string;
      is_id_column: boolean;
      type_: components["schemas"]["ValueType"];
    };
    PopulationId: Nominal<string, "PopulationId">;
    PopulationIdPath: {population_id: components["schemas"]["PopulationId"]};
    /** @description Lightweight population summary for the library listing. */
    PopulationMin: {
      created_at: components["schemas"]["DateTime"];
      description?: string | null;
      /** @description True exactly when [`Self::locked_at`] is set. */
      is_locked: boolean;
      /**
       * Format: int64
       * @description Number of live (non-deleted) samples drawn from this population, drafts
       *     included — the "Linked samples" stat.
       */
      live_sample_count: number;
      locked_at?: components["schemas"]["DateTime"] | null;
      name: string;
      population_id: components["schemas"]["PopulationId"];
      processing_state: components["schemas"]["PopulationProcessingState"];
      /** Format: int64 */
      row_count: number;
      /**
       * @description The sources the population draws from, in order. The frontend shows the
       *     first few as chips and collapses the rest; the count is the length.
       */
      sources: components["schemas"]["PopulationSourceMin"][];
      updated_at: components["schemas"]["DateTime"];
    };
    /**
     * @description Processing status of a population's extraction, mirroring
     *     `SourceProcessingState`. Derived from the `committed_at` / `extracted_at` /
     *     `extract_background_task_id` / `extract_error` columns so the frontend can
     *     drive live updates off the pending task.
     *
     *     [`Self::Draft`] precedes the extraction pipeline rather than extending it:
     *     `Processing` → `Completed`/`Error` describe how far committed work has run,
     *     and a draft has no committed work.
     */
    PopulationProcessingState:
      | {
          /** @enum {string} */
          type: "Draft";
        }
      | {
          background_task?: components["schemas"]["PendingBackgroundTask"] | null;
          /** @enum {string} */
          type: "Processing";
        }
      | {
          at: components["schemas"]["DateTime"];
          /** @enum {string} */
          type: "Completed";
        }
      | {
          at: components["schemas"]["DateTime"];
          error: string;
          /** @enum {string} */
          type: "Error";
        };
    /**
     * @description A single extracted row. `data` maps each [`PopulationColumnId`] to its cell
     *     value, a JSON value matching the column's [`ValueType`].
     */
    PopulationRow: {
      /**
       * @description The passages each cell's value is answerable to, keyed by the column the
       *     value fills and ordered as the run recorded them. A cell is the owner
       *     because a row's values need not come from one place.
       *
       *     A transcribed row carries none: a delimited cell's passage is a cell,
       *     and its location is the row index the row already has. A
       *     [`Citation::context`] is present exactly where the value was worked out
       *     rather than read, so a reader landing on a passage the value is not
       *     written in has the account of it.
       */
      citations: {[key: string]: components["schemas"]["Citation"][]};
      data: {[key: string]: IValue};
      population_row_id: components["schemas"]["PopulationRowId"];
      /** Format: int32 */
      row_index: number;
    };
    PopulationRowId: Nominal<string, "PopulationRowId">;
    /**
     * @description Which of the two mechanisms turned a source into rows: parsed exactly from
     *     raw bytes that already are a table, or read and judged into records.
     * @enum {string}
     */
    PopulationSourceMechanism: "transcribed" | "enumerated";
    /**
     * @description A source of a population, reduced to what the library listing renders: its
     *     name and type (which drives the file-type icon).
     */
    PopulationSourceMin: {name: string; type_: components["schemas"]["SourceType"]};
    /**
     * @description How a run finished with one source.
     *
     *     A source ends a run yielding no rows in four different ways — refused,
     *     exhausted, never opened, or read through and found to hold none — and the
     *     table cannot tell them apart: a month missing because its document was never
     *     opened reads exactly like a month that genuinely held nothing. Only the last
     *     is a frame an auditor can sample around, which is why the run records which
     *     one it was.
     */
    PopulationSourceOutcome:
      | {
          /** @enum {string} */
          type: "Pending";
        }
      | {
          /** @enum {string} */
          type: "Read";
        }
      | {
          reason: string;
          /** @enum {string} */
          type: "Refused";
        }
      | {
          /** @enum {string} */
          type: "Exhausted";
        }
      | {
          /** @enum {string} */
          type: "Unread";
        };
    PopulationSourcePath: {
      population_id: components["schemas"]["PopulationId"];
      source_id: components["schemas"]["SourceId"];
    };
    /**
     * @description One source's part in a run: which mechanism read it, how many rows came out
     *     of it, and how the run finished with it.
     */
    PopulationSourceReport: {
      mechanism: components["schemas"]["PopulationSourceMechanism"];
      /**
       * @description The name the source carried when the run read it, so the report still
       *     reads after the source is renamed or detached.
       */
      name: string;
      outcome: components["schemas"]["PopulationSourceOutcome"];
      /**
       * Format: int64
       * @description Rows this source contributed. An enumerated row assembled from two
       *     sources counts in both: this is each source's contribution, not a
       *     partition of the table.
       */
      rows: number;
      source_id: components["schemas"]["SourceId"];
    };
    Portal: {
      first_visit: boolean;
      name: string;
      portal_reports_enabled: boolean;
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    PortalEngagementOutstanding: {
      engagement_id: components["schemas"]["EngagementId"];
      name: string;
      /** Format: int32 */
      questionnaire_count: number;
    };
    /** @description This type is exposed to the external API. */
    PortalInviteInfoExternal: {initiated_by?: components["schemas"]["OneTimeTokenInitiator"] | null};
    /** @description A published report snapshot visible in the client portal. */
    PortalReport: {
      created_at: components["schemas"]["DateTime"];
      engagement_name: string;
      framework_name: string;
      portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
      report_name: string;
    };
    /** @description Metadata for a portal report snapshot (excludes the payload which is large). */
    PortalReportSnapshot: {
      assessment_id: components["schemas"]["AssessmentId"];
      created_at: components["schemas"]["DateTime"];
      created_by?: components["schemas"]["UserId"] | null;
      portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
      published: boolean;
      report_template_id: components["schemas"]["TprmReportTemplateId"];
    };
    PortalReportSnapshotId: Nominal<string, "PortalReportSnapshotId">;
    PortalReportSnapshotPath: {
      portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    PortalSummary: {
      latest_request_created_at?: components["schemas"]["DateTime"] | null;
      latest_request_locked_at?: components["schemas"]["DateTime"] | null;
      latest_request_updated_at?: components["schemas"]["DateTime"] | null;
    };
    PortalUserInfo:
      | {
          content: {email: string; user_id: components["schemas"]["UserId"]};
          /** @enum {string} */
          type: "InvitePending";
        }
      | {
          content: {
            last_visited_at: components["schemas"]["DateTime"];
            user: components["schemas"]["RegisteredUserMin"];
          };
          /** @enum {string} */
          type: "Joined";
        };
    PortalUserMin: {info: components["schemas"]["PortalUserInfo"]; invited_at: components["schemas"]["DateTime"]};
    /** @enum {string} */
    PovModifier: "FirstPerson" | "ThirdPerson";
    PreLoginResponse: {requires_2fa: boolean; state: components["schemas"]["UserRegistrationState"]};
    PredefinedControl: {
      control_number?: string | null;
      description: string;
      group: components["schemas"]["ControlGroupMin"];
      is_required: boolean;
      predefined_control_id: components["schemas"]["PredefinedControlId"];
      profile: components["schemas"]["FrameworkProfileMin"];
      /**
       * @description Name of the module template group (derived from per-module template names).
       *     Used by the frontend to find the matching module configs.
       */
      template_name?: string | null;
      title: string;
    };
    PredefinedControlId: Nominal<string, "PredefinedControlId">;
    PredefinedControlIdPath: {predefined_control_id: components["schemas"]["PredefinedControlId"]};
    PredefinedControlMin: {predefined_control_id: components["schemas"]["PredefinedControlId"]};
    PresetAnswerConfig:
      | {
          content: components["schemas"]["TprmTextAnswerConfig"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmFilesAnswerConfig"];
          /** @enum {string} */
          type: "Files";
        }
      | {
          content: components["schemas"]["TprmSelectAnswerConfig"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["PresetSubQuestionnairesAnswerConfig"];
          /** @enum {string} */
          type: "SubQuestionnaires";
        }
      | {
          content: components["schemas"]["PresetTableAnswerConfig"];
          /** @enum {string} */
          type: "Table";
        };
    /**
     * @description An audit area template, identified by the pair its account's templates are
     *     unique on.
     */
    PresetAutorunAuditArea: {audit_area_type: components["schemas"]["AuditAreaType"]; name: string};
    PresetComplexityAutorun: {
      /**
       * @description Name of the complexity model to run; resolved against complexity models
       *     in the account when the preset is loaded.
       */
      model_name: string;
      /**
       * @description Specific version of the complexity model to run; null uses the model's
       *     default/latest version.
       */
      version?: string | null;
    };
    PresetConfig: {
      name: string;
      /** @default false */
      skip_remote_files: boolean;
      users: components["schemas"]["PresetUserOverride"][];
    };
    PresetControl: {
      control_number?: string | null;
      description: string;
      design_template?: string | null;
      implementation_template?: string | null;
      /** @default false */
      is_required: boolean;
      oe_template?: string | null;
      representation_template?: string | null;
      title: string;
    };
    PresetControlGroup: {
      controls: components["schemas"]["PresetControl"][];
      /** @default  */
      description: string;
      title: string;
    };
    PresetCreatePredefinedRisk: {
      /**
       * @description Whether the risk is always identified, regardless of which controls are
       *     in scope.
       * @default false
       */
      always_include: boolean;
      /** @description Optional extra guidance shown to assessors when considering this risk. */
      contextual_guidance?: string | null;
      /**
       * @description Control numbers (e.g. `"AC-01"`) this risk is mitigated by; resolved to
       *     control IDs within the framework version when the preset is loaded.
       * @default []
       */
      control_mappings: string[];
      /** @description Description of the risk. */
      description: string;
      /**
       * @description Inherent risk level. Must be set if and only if the framework version has
       *     a risk-quantification model.
       */
      inherent_risk_level?: components["schemas"]["RecordRiskEvaluation"] | null;
      /** @description Rationale for the inherent risk level. */
      inherent_risk_reason?: string | null;
      /** @description Short title of the risk. */
      title: string;
    };
    PresetDiagram: {
      /** @default [] */
      connections: components["schemas"]["PresetDiagramConnection"][];
      /** @default  */
      description: string;
      /**
       * @description Defaults to `ProcessFlow`.
       * @default ProcessFlow
       */
      diagram_type: components["schemas"]["DiagramType"];
      /**
       * @description A node belongs to the lane with `min_y <= position.y < max_y`; any
       *     lanes enable lanes on the diagram.
       * @default []
       */
      lanes: components["schemas"]["PresetDiagramLane"][];
      name: string;
      /** @default [] */
      nodes: components["schemas"]["PresetDiagramNode"][];
      /**
       * @description Markdown summary shown alongside the diagram.
       * @default null
       */
      summary: string | null;
    };
    PresetDiagramConnection: {
      /** @default [] */
      anchors: components["schemas"]["PresetDiagramConnectionAnchor"][];
      color: string;
      label: string;
      source_node_name: string;
      target_node_name: string;
    };
    PresetDiagramConnectionAnchor: {position: [number, number]};
    PresetDiagramLane: {
      /** @description A palette name, as on connections (e.g. `"blue"`). */
      color: string;
      /** @description Lane heading. */
      label: string;
      /**
       * Format: int32
       * @description Bottom edge, in grid cells (exclusive).
       */
      max_y: number;
      /**
       * Format: int32
       * @description Top edge, in grid cells.
       */
      min_y: number;
    };
    PresetDiagramNode: {description: string; icon: string; label: string; name: string; position: [number, number]};
    PresetFramework: {name: string; versions: components["schemas"]["PresetFrameworkVersion"][]};
    PresetFrameworkAutorun: {
      /**
       * @description The audit area template that places the resulting assessment in the
       *     audit plan; resolved against the account's audit area templates when the
       *     preset is loaded. Ignored on accounts without the `AuditPlan` feature;
       *     on an `AuditPlan` account, omitting it skips the autorun entirely.
       * @default null
       */
      audit_area: components["schemas"]["PresetAutorunAuditArea"] | null;
      /**
       * @description Name of the framework to run; resolved against frameworks in the account
       *     when the preset is loaded.
       */
      framework_name: string;
      /** @description Version label of the framework to run. */
      framework_version: string;
    };
    PresetFrameworkProfile: {
      control_groups: components["schemas"]["PresetControlGroup"][];
      name: string;
      risk_areas: components["schemas"]["CreateRiskArea"][];
      scope_types: components["schemas"]["TprmScopeType"][];
    };
    PresetFrameworkVersion: {
      /** @default  */
      custom_findings_prompt: string;
      /** @default false */
      generate_findings: boolean;
      /** @default false */
      generate_findings_from_missing_evidence: boolean;
      is_published: boolean;
      /**
       * @default {
       *       "design": [],
       *       "implementation": [],
       *       "oe": [],
       *       "representation": []
       *     }
       */
      module_templates: components["schemas"]["PresetModuleTemplates"];
      predefined_risks: components["schemas"]["PresetPredefinedRisk"][];
      profiles: components["schemas"]["PresetFrameworkProfile"][];
      /** @default null */
      risk_quantification: components["schemas"]["RiskQuantificationModel"] | null;
      specification: string;
      version: string;
    };
    PresetModuleTemplates: {
      /**
       * @description Named templates for the control-design testing module.
       * @default []
       */
      design: components["schemas"]["PresetNamedConfig2"][];
      /**
       * @description Named templates for the control-implementation testing module.
       * @default []
       */
      implementation: components["schemas"]["PresetNamedConfig2"][];
      /**
       * @description Named templates for the operational-effectiveness (OE) testing module.
       * @default []
       */
      oe: components["schemas"]["PresetNamedConfig3"][];
      /**
       * @description Named templates for the control-representation testing module.
       * @default []
       */
      representation: components["schemas"]["PresetNamedConfig"][];
    };
    PresetNamedConfig: {
      /** @description The module template configuration. */
      config: components["schemas"]["ControlRepresentationModuleTemplate"];
      /** @description Name used to reference this module template from a control. */
      name: string;
    };
    PresetNamedConfig2: {
      /** @description The module template configuration. */
      config: components["schemas"]["ControlDesignImplementationModuleTemplate"];
      /** @description Name used to reference this module template from a control. */
      name: string;
    };
    PresetNamedConfig3: {
      /** @description The module template configuration. */
      config: components["schemas"]["ControlOEModuleTemplate"];
      /** @description Name used to reference this module template from a control. */
      name: string;
    };
    PresetOption: {label: string; value: string};
    PresetPredefinedRisk: {
      /** @description The predefined risk to create. */
      risk: components["schemas"]["PresetCreatePredefinedRisk"];
    };
    PresetQuestionTemplate: {
      /**
       * @description Optional guidance steering the AI when it suggests answers from
       *     uploaded documents.
       * @default null
       */
      ai_answer_suggestion_guidance: string | null;
      /**
       * @description Optional guidance steering the AI "Suggested Improvements" feedback on
       *     answers the respondent writes.
       */
      ai_guidance?: string | null;
      /**
       * @description Per-question override of the AI "Suggested Improvements" config. Unset
       *     fields fall back to the questionnaire-level default.
       * @default null
       */
      ai_suggestions_config: components["schemas"]["TprmAiSuggestionsConfig"] | null;
      /**
       * @description Whether the respondent may mark the question not applicable.
       * @default false
       */
      allow_not_applicable: boolean;
      /** @description The answer type and its configuration. */
      answer_config: components["schemas"]["PresetAnswerConfig"];
      /**
       * @description Who answers this question. `Auditor` questions form the internal scoping
       *     form completed by firm staff before the questionnaire is released to the
       *     client, and are never shown to the client; client questions may reference
       *     them by `key` in conditions. Defaults to `Client`.
       * @default Client
       */
      audience: components["schemas"]["TprmQuestionAudience"];
      /**
       * @description Optional condition controlling when this question is shown, based on
       *     answers to other questions.
       */
      condition?: components["schemas"]["TprmCondition"] | null;
      /**
       * @description Keys of other questions whose answers are provided to the AI as context
       *     for this question.
       * @default null
       */
      context_question_keys: string[] | null;
      /** @description Optional guidance shown to respondents to help them answer. */
      guidance?: string | null;
      /** @description Whether an answer is mandatory before the questionnaire can be submitted. */
      is_required: boolean;
      /**
       * @description Stable identifier for the question, unique within the template. Used to
       *     reference this question from conditions, context, and related-root links.
       */
      key?: string | null;
      /**
       * @description Number displayed when this question's resolved numbering mode is manual.
       * @default null
       */
      question_number: string | null;
      /**
       * @description Optional `key` of a question on the parent (root) questionnaire
       *     template. Resolved to a FK at preset-load time and surfaced as a
       *     related question on each instance of this question.
       * @default null
       */
      related_root_question_key: string | null;
      /** @description The question text shown to respondents. */
      text: string;
    };
    PresetQuestionnaireTemplate: {
      /**
       * @description Questionnaire-level default for the AI "Suggested Improvements" config,
       *     overridable per question.
       * @default null
       */
      ai_suggestions_config: components["schemas"]["TprmAiSuggestionsConfig"] | null;
      /**
       * @description Complexity models to auto-run when this questionnaire is submitted.
       * @default []
       */
      complexity_autorun: components["schemas"]["PresetComplexityAutorun"][];
      /**
       * @description Framework assessments to auto-run when this questionnaire is submitted.
       * @default null
       */
      framework_autorun: components["schemas"]["FrameworkAutorun"] | null;
      /** @description If not provided, templates without a model_name will be grouped under "Preset Questionnaire Model". */
      model_name?: string | null;
      /**
       * @description Display name of the template. Other templates reference it by this name
       *     (as a `parent_name` or sub-questionnaire reference).
       */
      name: string;
      /**
       * @description Default numbering behaviour for sections that do not override it.
       * @default AutoStable
       */
      numbering_mode: components["schemas"]["TprmQuestionnaireNumberingMode"];
      /**
       * @description Name of the parent template, if this is a sub-questionnaire template;
       *     resolved to the parent's ID when the preset is loaded. Null for a
       *     top-level template.
       */
      parent_name?: string | null;
      /** @description Ordered sections making up the questionnaire. */
      sections: components["schemas"]["PresetSectionTemplate"][];
      /**
       * @description Whether answer suggestions (both from prior questionnaires and from
       *     uploaded documents) are available on instances of this template.
       * @default true
       */
      suggestions_enabled: boolean;
      /**
       * @description Criteria that auto-assign a third party to a tier based on answers.
       * @default []
       */
      tiering_criteria: components["schemas"]["TprmTierCriterion"][];
      /**
       * @description Audit-area understandings to auto-generate when this questionnaire is
       *     submitted.
       * @default []
       */
      understanding_autorun: components["schemas"]["PresetUnderstandingAutorun"][];
    };
    /** @enum {string} */
    PresetSchemaKind:
      | "QuestionnaireTemplate"
      | "Framework"
      | "FrameworkVersion"
      | "AuditAreaTemplate"
      | "EngagementTemplate"
      | "ComplexityModelVersion";
    PresetSchemaPath: {kind: components["schemas"]["PresetSchemaKind"]};
    PresetSectionTemplate: {
      /** @description Optional explanatory text shown beneath the section heading. */
      description?: string | null;
      /** @description Ordered questions in this section. */
      questions: components["schemas"]["PresetQuestionTemplate"][];
      /** @description Section heading shown to respondents. */
      title: string;
    };
    /**
     * @description This mirrors `SubQuestionnairesAnswerConfig` but replaces the template ID
     *     with a name reference.
     */
    PresetSubQuestionnairesAnswerConfig: {
      /**
       * @description Name of the questionnaire template to nest; resolved to its ID when the
       *     preset is loaded, so the referenced template must exist in this preset.
       */
      questionnaire_template_name: string;
      /** @description Scope type each sub-questionnaire instance is created against. */
      scope_type: components["schemas"]["TprmScopeType"];
    };
    /**
     * @description This mirrors `TprmTableAnswerConfig` but replaces the framework ID with a
     *     name reference. Columns are authored inline and carry through as they are.
     */
    PresetTableAnswerConfig: {
      /** @description The configurable set of columns collected for every row of this question. */
      columns: components["schemas"]["TprmTableColumn"][];
      /**
       * @description Name of the framework the process this table describes is assessed
       *     against, resolved against the account's frameworks when the preset is
       *     loaded. Only valid on a process-steps table (`row_noun` "step").
       * @default null
       */
      framework_name: string | null;
      /**
       * @description `key` of a `columns` entry whose value groups rows under headers in the
       *     table; omit for a flat, ungrouped list of rows.
       */
      group_by_column_key?: string | null;
      /**
       * @description `key` of a `columns` entry whose value labels each row (its "title"),
       *     shown as the row heading; omit to identify rows by number only.
       */
      primary_column_key?: string | null;
      /**
       * @description Singular, lowercase noun for one row (e.g. "step", "asset"), used to label
       *     the add button, empty state and row heading. Omit to fall back to the
       *     generic "row".
       */
      row_noun?: string | null;
      /**
       * @description Plural form of `row_noun`, used wherever the count is not exactly one
       *     (e.g. "steps", "assets"). Supply this for irregular English plurals
       *     ("entry" → "entries") and for non-English nouns, where appending "s" is
       *     wrong. Omit to default to `row_noun` with an "s" appended; ignored when
       *     `row_noun` itself is omitted.
       */
      row_noun_plural?: string | null;
    };
    PresetUnderstandingAutorun: {
      /** @description Which audit area the understanding belongs to. */
      audit_area_type: components["schemas"]["AuditAreaType"];
      /**
       * @description The pre-expanded context fed to the generation pipeline. The LLM
       *     context-expansion step is skipped for autorun.
       */
      context: string;
      /** @description The display name of the understanding. */
      name: string;
    };
    PresetUserOverride: {
      avatar_url?: string | null;
      email: string;
      google_user_id?: string | null;
      login_method?: components["schemas"]["LoginMethodType"] | null;
      name: string;
      overrides_email?: string | null;
      password?: string | null;
    };
    PrivateIdPath: {private_id: components["schemas"]["PrivateResourceId"]};
    PrivateResource: {
      access_grants: components["schemas"]["PrivateResourceAccessGrant"][];
      access_level?: components["schemas"]["PrivateResourceAccess"] | null;
      private_id: components["schemas"]["PrivateResourceId"];
    };
    /** @enum {string} */
    PrivateResourceAccess: "See" | "Read" | "Write" | "Admin";
    PrivateResourceAccessGrant: {
      access: components["schemas"]["PrivateResourceAccess"];
      owner?: components["schemas"]["Owner"] | null;
    };
    PrivateResourceId: Nominal<string, "PrivateResourceId">;
    PrivateResourceMin: {private_id: components["schemas"]["PrivateResourceId"]};
    /**
     * @description One filled-out process Table question (a Table whose `row_noun` is "step")
     *     in a submitted questionnaire, offered as a process to instantiate on the
     *     "From questionnaires" tab of the add-process dialog. Identified by
     *     `(questionnaire_id, question_template_id)`; the same template question
     *     answered in two submissions yields two candidates.
     */
    ProcessCandidate: {
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      questionnaire_id: components["schemas"]["TprmQuestionnaireId"];
      /** @description The submitted questionnaire's name, for grouping candidates in the UI. */
      questionnaire_name: string;
      /**
       * Format: uint32
       * @description Number of rows ("steps") the client filled in.
       */
      row_count: number;
      /**
       * @description The data-room source holding the questionnaire. Identifies the candidate,
       *     since it survives a re-submission where the questionnaire itself does not.
       */
      source_id: components["schemas"]["SourceId"];
      /** @description The Table question's prompt, shown as the candidate (and process) title. */
      title: string;
    };
    ProcessStep: {
      content: components["schemas"]["ProcessStepContent"];
      /** @description `None` until a person changes the step's content. Reordering does not count. */
      edited?: components["schemas"]["Actioned"] | null;
      origin: components["schemas"]["ProcessStepOrigin"];
      /**
       * @description Where `content` departs from the AI's draft, each `from` the AI's value. Empty
       *     for a step the AI never drafted.
       */
      overrides: components["schemas"]["ProcessStepFieldChanged"][];
      process_step_id: components["schemas"]["ProcessStepId"];
    };
    /**
     * @description Step activity lives on the understanding's stream, so each row names the step it
     *     describes. `step_name` is denormalised: it labels the row in the plan feed, where
     *     steps interleave, and survives the step being renamed or deleted.
     */
    ProcessStepActivityPayload: {
      change: components["schemas"]["ProcessStepUpdatedPayload"];
      process_step_id: components["schemas"]["ProcessStepId"];
      step_name: string;
    };
    ProcessStepContent: {
      /** @default  */
      description: string;
      name: string;
      /** @default {} */
      properties: {[key: string]: string};
    };
    /**
     * @description Which of a step's fields changed. A step's properties are configurable per account,
     *     so a property is addressed by its title rather than a variant.
     */
    ProcessStepField:
      | {
          /** @enum {string} */
          type: "Name";
        }
      | {
          /** @enum {string} */
          type: "Description";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Property";
        };
    /**
     * @description `from` is recorded alongside `to` so each row is self-describing: the drawer renders
     *     the before/after diff from these rows alone.
     */
    ProcessStepFieldChanged: {field: components["schemas"]["ProcessStepField"]; from: string; to: string};
    ProcessStepId: Nominal<string, "ProcessStepId">;
    ProcessStepIdPath: {
      process_step_id: components["schemas"]["ProcessStepId"];
      understanding_id: components["schemas"]["UnderstandingId"];
    };
    /** @description Fixed for the step's life: editing does not change it. */
    ProcessStepOrigin:
      | {
          content: {at: components["schemas"]["DateTime"]};
          /** @enum {string} */
          type: "Ai";
        }
      | {
          content: components["schemas"]["Actioned"];
          /** @enum {string} */
          type: "Human";
        };
    ProcessStepProperty: {
      /**
       * @description How the model should infer this property's value for a step.
       * @default
       */
      ai_guidance: string;
      description?: string | null;
      kind: components["schemas"]["ProcessStepPropertyKind"];
      /** @description Ignored for `Text`. */
      options: components["schemas"]["ProcessStepPropertyOption"][];
      title: string;
    };
    ProcessStepPropertyConfig: {properties: components["schemas"]["ProcessStepProperty"][]};
    /** @enum {string} */
    ProcessStepPropertyKind: "Text" | "SingleSelect";
    ProcessStepPropertyOption: {description?: string | null; title: string};
    ProcessStepUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Created";
        }
      | {
          /** @enum {string} */
          type: "Removed";
        }
      | {
          content: components["schemas"]["ProcessStepFieldChanged"];
          /** @enum {string} */
          type: "FieldChanged";
        };
    /** @description A process understanding's steps and column config, for the process steps report. */
    ProcessUnderstandingReport: {
      /** @description The understanding's diagrams as PNGs, for the Overview sheet. Ordinal order. */
      diagrams: components["schemas"]["ReportDiagramImage"][];
      name: string;
      property_config: components["schemas"]["ProcessStepPropertyConfig"];
      /** @description Steps in ordinal order. */
      steps: components["schemas"]["ProcessStep"][];
      /** @description The process notes shown on the report's Overview tab. */
      summary?: string | null;
    };
    /** @enum {string} */
    ProductType: "VendorToolkit" | "TPRM" | "All";
    ProductTypePath: {product_type: components["schemas"]["ProductType"]};
    ProductTypeStatusPath: {
      product_type: components["schemas"]["ProductType"];
      status: components["schemas"]["NotificationStatus"];
    };
    /** @enum {string} */
    PromptCategory:
      | "Understanding"
      | "UnderstandingDiagram"
      | "DiagramLegacy"
      | "ControlAssessment"
      | "ControlEvaluation"
      | "ControlAggregation";
    PromptCategoryInfo: {description: string; id: components["schemas"]["PromptCategory"]; label: string};
    /** @enum {string} */
    PromptModifierType: "Verbosity" | "Pov" | "Custom";
    PromptModifiers: {
      Custom?: string;
      Pov?: components["schemas"]["PovModifier"];
      Verbosity?: components["schemas"]["VerbosityModifier"];
    };
    /**
     * @description How a prompt template is applied at export time. Determines which
     *     substitution variables are available, how many AI calls are made, and how
     *     outputs are keyed in the AI output cache.
     */
    PromptScope: "WholeReport" | "PerControlGroup";
    PropertyConfig: Record<string, never>;
    PublicCredentials: {
      atlassian_client_id: string;
      docusign_client_id: string;
      docusign_endpoint: string;
      google_client_id: string;
      hubspot_client_id: string;
      imanage_client_id: string;
      logodev_pubkey: string;
      ms_client_id: string;
      notion_client_id: string;
      posthog_app_key: string;
      posthog_host: string;
      posthog_trust_center_key: string;
      posthog_ui_host: string;
      pusher_cluster: string;
      pusher_key: string;
      sentry_dsn: string;
      slack_client_id: string;
      tolgee_cdn: string;
    };
    /** @enum {string} */
    QAMode: "Manual" | "Automated";
    /**
     * @description One axis of the framework's `ComponentWise` risk-quantification
     *     model — the label, description, permitted range, step, and
     *     units the agent scores the risk along.
     */
    QuantificationAxisSnapshot: {
      description: string;
      /** Format: double */
      max_value: number;
      /** Format: double */
      min_value: number;
      name: string;
      /** Format: double */
      step: number;
      units?: string;
    };
    /** @description Configures a single `QuantifyBasicInherentRisk` agent run. */
    QuantifyBasicInherentRiskFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      risk: components["schemas"]["RiskSnapshot"];
      risk_id: components["schemas"]["RiskId"];
    };
    /**
     * @description Configures a single `QuantifyBasicResidualRisk` agent run.
     *     `inherent_level` is the already-computed inherent verdict the
     *     residual assessment cannot exceed. `controls` are the caller-
     *     assembled mitigating controls with per-control comments.
     */
    QuantifyBasicResidualRiskFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      controls: components["schemas"]["CommentedControlSnapshot"][];
      inherent_level: components["schemas"]["RiskLevel"];
      risk: components["schemas"]["RiskSnapshot"];
      risk_id: components["schemas"]["RiskId"];
    };
    /**
     * @description Configures a single `QuantifyComponentWiseInherentRisk` agent
     *     run. `axes` is the framework's model definition, snapshotted so
     *     the model sees the same axes and bounds on retry.
     */
    QuantifyComponentWiseInherentRiskFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      axes: components["schemas"]["QuantificationAxisSnapshot"][];
      risk: components["schemas"]["RiskSnapshot"];
      risk_id: components["schemas"]["RiskId"];
    };
    /**
     * @description Configures a single `QuantifyComponentWiseResidualRisk` agent
     *     run. Same shape as the inherent component-wise variant plus the
     *     inherent ratings (an upper bound per axis) and mitigating
     *     controls.
     */
    QuantifyComponentWiseResidualRiskFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      axes: components["schemas"]["QuantificationAxisSnapshot"][];
      controls: components["schemas"]["CommentedControlSnapshot"][];
      inherent_ratings: number[];
      risk: components["schemas"]["RiskSnapshot"];
      risk_id: components["schemas"]["RiskId"];
    };
    Question: {
      answer_is_original?: boolean | null;
      deleted?: components["schemas"]["Actioned"] | null;
      disable_analysis: boolean;
      fact_summary: components["schemas"]["QuestionFactSummary"];
      guidance?: string | null;
      is_internal: boolean;
      limited_to_scopes?: components["schemas"]["ScopeMin"][] | null;
      override_limited_to_scopes: boolean;
      parts: components["schemas"]["AnswerParts"];
      prompt_modifiers: components["schemas"]["PromptModifiers"];
      question_id: components["schemas"]["QuestionId"];
      question_number?: string | null;
      relevant_core_responses: components["schemas"]["RelevantCoreResponse"][];
      response_layers: {[key: string]: components["schemas"]["ResponseLayer"]};
      text: string;
      used_prompt_modifiers?: components["schemas"]["PromptModifiers"] | null;
    };
    QuestionCreatedPayload: Record<string, never>;
    QuestionDocumentation: {
      linked_at: components["schemas"]["DateTime"];
      linked_by?: components["schemas"]["UserMin"] | null;
      question_id: components["schemas"]["QuestionId"];
    };
    QuestionDocumentationPath: {
      documentation_id: components["schemas"]["DocumentationId"];
      layer_type: components["schemas"]["LayerType"];
      question_id: components["schemas"]["QuestionId"];
    };
    QuestionFactSummary: {
      /** Format: int32 */
      num_used_facts: number;
    };
    QuestionGroupId: Nominal<string, "QuestionGroupId">;
    QuestionGroupMin: {
      name: string;
      question_group_id: components["schemas"]["QuestionGroupId"];
      question_ids: components["schemas"]["QuestionId"][];
    };
    QuestionId: Nominal<string, "QuestionId">;
    QuestionIdPath: {question_id: components["schemas"]["QuestionId"]};
    QuestionIdPath2: {question_id: components["schemas"]["QuestionId"]};
    QuestionLayerPath: {
      layer_type: components["schemas"]["LayerType"];
      question_id: components["schemas"]["QuestionId"];
    };
    QuestionMin: {question_id: components["schemas"]["QuestionId"]; question_number?: string | null; text: string};
    QuestionNotificationMin: {
      question: components["schemas"]["QuestionMin"];
      questionnaire?: components["schemas"]["QuestionnaireNotificationMin"] | null;
    };
    QuestionSource: {
      config: components["schemas"]["QuestionSourceConfig"];
      connector: components["schemas"]["QuestionSourceConnector"];
      external_authorization: components["schemas"]["ExternalAuthorizationMin"];
      external_reference_id?: components["schemas"]["ExternalAccountReferenceId"] | null;
      name: string;
      question_source_id: components["schemas"]["QuestionSourceId"];
    };
    QuestionSourceAccountInfo: {
      external_icon_url: string;
      external_name: string;
      reference?: components["schemas"]["PopulateExternalAccountReference"] | null;
    };
    QuestionSourceConfig: {
      content: components["schemas"]["SlackQuestionSourceConfig"];
      /** @enum {string} */
      type: "Slack";
    };
    QuestionSourceConnector: {connector_id: string; logo_url: string; name: string};
    QuestionSourceConnectorIdPath: {question_source_connector_id: string};
    QuestionSourceId: Nominal<string, "QuestionSourceId">;
    QuestionSourceIdPath: {question_source_id: components["schemas"]["QuestionSourceId"]};
    QuestionSourceMin: {
      connector: components["schemas"]["QuestionSourceConnector"];
      name: string;
      question_source_id: components["schemas"]["QuestionSourceId"];
    };
    QuestionStats: {
      /** Format: int32 */
      completed: number;
      /** Format: int32 */
      count: number;
      /** Format: int32 */
      in_review: number;
    };
    /** @enum {string} */
    QuestionStatus: "Automating" | "Respond" | "Review" | "Complete";
    QuestionUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Text";
        }
      | {
          /** @enum {string} */
          type: "Parts";
        }
      | {
          content: components["schemas"]["DateTime"] | null;
          /** @enum {string} */
          type: "DueDate";
        }
      | {
          /** @enum {string} */
          type: "Owner";
        }
      | {
          content: components["schemas"]["QuestionStatus"];
          /** @enum {string} */
          type: "Status";
        }
      | {
          /** @enum {string} */
          type: "Response";
        }
      | {
          /** @enum {string} */
          type: "Scopes";
        }
      | {
          /** @enum {string} */
          type: "Generic";
        };
    Questionnaire: {
      access_level: components["schemas"]["AccessLevel"];
      archived_at?: components["schemas"]["DateTime"] | null;
      counterparty: components["schemas"]["Counterparty"];
      created_at: components["schemas"]["DateTime"];
      deal?: components["schemas"]["Deal"] | null;
      deleted?: components["schemas"]["Actioned"] | null;
      due_date?: components["schemas"]["DateTime"] | null;
      external_language_code: string;
      internal_language_code: string;
      is_internal: boolean;
      name: string;
      original_files: components["schemas"]["OriginalFile"][];
      original_sources: components["schemas"]["OriginalSource"][];
      owner?: components["schemas"]["Owner"] | null;
      prompt_modifiers: components["schemas"]["PromptModifiers"];
      qa_mode?: components["schemas"]["QAMode"] | null;
      question_stats: components["schemas"]["QuestionStats"];
      questionnaire_date?: components["schemas"]["DateTime"] | null;
      questionnaire_id: components["schemas"]["QuestionnaireId"];
      scope_matrix: components["schemas"]["ScopeMatrix"];
      sections: components["schemas"]["Section"][];
      status: components["schemas"]["QuestionnaireStatus"];
      trust_center_visibility: components["schemas"]["TrustCenterAccess"];
    };
    QuestionnaireContentPayload: {questionnaire: components["schemas"]["TprmQuestionnaire"]};
    QuestionnaireDocumentationPath: {
      documentation_id: components["schemas"]["DocumentationId"];
      questionnaire_id: components["schemas"]["QuestionnaireId"];
    };
    QuestionnaireFileIdPath: {
      original_file_id: components["schemas"]["FileId"];
      questionnaire_id: components["schemas"]["QuestionnaireId"];
    };
    QuestionnaireFilePath: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      file_id: components["schemas"]["FileId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    QuestionnaireId: Nominal<string, "QuestionnaireId">;
    QuestionnaireIdPath: {questionnaire_id: components["schemas"]["QuestionnaireId"]};
    QuestionnaireIdSectionIdPath: {
      questionnaire_id: components["schemas"]["QuestionnaireId"];
      section_id: components["schemas"]["SectionId"];
    };
    QuestionnaireIdSectionIdQuestionGroupIdPath: {
      question_group_id: components["schemas"]["QuestionGroupId"];
      questionnaire_id: components["schemas"]["QuestionnaireId"];
      section_id: components["schemas"]["SectionId"];
    };
    QuestionnaireLayerDocumentationPath: {
      documentation_id: components["schemas"]["DocumentationId"];
      layer_type: components["schemas"]["LayerType"];
      questionnaire_id: components["schemas"]["QuestionnaireId"];
    };
    QuestionnaireLayerPath: {
      layer_type: components["schemas"]["LayerType"];
      questionnaire_id: components["schemas"]["QuestionnaireId"];
    };
    QuestionnaireMin: {
      archived_at?: components["schemas"]["DateTime"] | null;
      counterparty: components["schemas"]["Counterparty"];
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      due_date?: components["schemas"]["DateTime"] | null;
      external_language_code: string;
      internal_language_code: string;
      is_internal: boolean;
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      prompt_modifiers: components["schemas"]["PromptModifiers"];
      qa_mode?: components["schemas"]["QAMode"] | null;
      question_stats: components["schemas"]["QuestionStats"];
      questionnaire_date?: components["schemas"]["DateTime"] | null;
      questionnaire_id: components["schemas"]["QuestionnaireId"];
      scope_matrix: components["schemas"]["ScopeMatrix"];
      status: components["schemas"]["QuestionnaireStatus"];
      trust_center_visibility: components["schemas"]["TrustCenterAccess"];
    };
    QuestionnaireModelAndTemplateIdPath: {
      questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
      questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
    };
    QuestionnaireModelIdPath: {questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"]};
    QuestionnaireModelIdPath2: {questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"]};
    QuestionnaireNotificationMin: {
      archived: boolean;
      name: string;
      questionnaire_id: components["schemas"]["QuestionnaireId"];
    };
    QuestionnaireNotifyClientRequest: {
      email_context?: string | null;
      /** @default false */
      notify_client: boolean;
    };
    QuestionnaireQuestionPath: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    QuestionnaireQuestionTask: {
      question: components["schemas"]["Question"];
      questionnaire: components["schemas"]["QuestionnaireMin"];
    };
    QuestionnaireSectionPath: {
      questionnaire_id: components["schemas"]["QuestionnaireId"];
      section_id: components["schemas"]["SectionId"];
    };
    QuestionnaireSourceKind: {questionnaire: components["schemas"]["TprmQuestionnaire"]};
    QuestionnaireSourceMinKind: {questionnaire: components["schemas"]["TprmQuestionnaireMin"]};
    QuestionnaireSourcePath: {questionnaire_id: components["schemas"]["QuestionnaireId"]; source_url: string};
    /** @enum {string} */
    QuestionnaireStatus: "Importing" | "Automating" | "InProgress" | "Complete";
    /**
     * @description Identifies one process Table answer in a submitted questionnaire, by the data-room
     *     source holding it.
     */
    QuestionnaireTableRef: {
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      source_id: components["schemas"]["SourceId"];
    };
    Rational: {
      /** Format: int32 */
      den: number;
      /** Format: int32 */
      num: number;
    };
    RecordAssessmentDecision: {content: components["schemas"]["AssessmentDecisionContent"]; was_suggested: boolean};
    RecordBasicRiskEvaluation: {
      /** @description The chosen overall risk level. */
      level: components["schemas"]["RiskLevel"];
      /** @description Free-text justification explaining why this risk level was assigned. */
      reason: string;
    };
    RecordComponentWiseRiskEvaluation: {
      /** @description Score for each component, in the same order as the model's `components`; each value must fall within that component's allowed range. */
      components: components["schemas"]["OrderedFloat"][];
      /** @description Free-text justification explaining the component scores given. */
      reason: string;
    };
    RecordControlAssessment: {explanation: string; met?: boolean | null};
    RecordControlAssessmentForScope: {
      explanation: string;
      met?: boolean | null;
      scope_id: components["schemas"]["TprmScopeId"];
    };
    /**
     * @description One citation to record: a reference into a source snapshot, becoming a single
     *     [`Citation`] via `build_control_citations`. `extract` is the passage cited;
     *     `None` cites the whole source (persisted as a `WholeSource` extract). A source
     *     cited at several passages is several records, each with its own `context`.
     */
    RecordControlCitation: {
      context?: string | null;
      extract?: components["schemas"]["RecordSourceExtract"] | null;
      source_ref: components["schemas"]["SourceRef"];
    };
    RecordDiagramEvidence: {source_context: string; source_ref: components["schemas"]["SourceRef"]};
    RecordRiskEvaluation:
      | {
          content: components["schemas"]["RecordBasicRiskEvaluation"];
          /** @enum {string} */
          type: "Basic";
        }
      | {
          content: components["schemas"]["RecordComponentWiseRiskEvaluation"];
          /** @enum {string} */
          type: "ComponentWise";
        };
    /**
     * @description A source extract to record, before it's assigned an id or index. `text` is
     *     located against the source to derive `position` (see `resolve_extracts`).
     */
    RecordSourceExtract: {
      position: components["schemas"]["SourceExtractPosition"];
      source_as_of: components["schemas"]["DateTime"];
      source_id: components["schemas"]["SourceId"];
      text: string;
    };
    RecordUnderstandingSummaryEvidence: {source_context: string; source_ref: components["schemas"]["SourceRef"]};
    Region: string;
    RegionPath: {region: components["schemas"]["Region"]};
    RegisterInterestRecord: {
      /** Format: email */
      email: string;
      name: string;
    };
    RegisteredUser: {
      avatar_url?: string | null;
      enabled_2fa: boolean;
      language_code?: string | null;
      login_method?: components["schemas"]["LoginMethodMin"] | null;
      name: string;
      primary_email: string;
      registered_at: components["schemas"]["DateTime"];
      type_: components["schemas"]["UserTypeRegistered"];
      user_id: components["schemas"]["UserId"];
    };
    RegisteredUserMin: {
      avatar_url?: string | null;
      language_code?: string | null;
      name: string;
      primary_email: string;
      /** @default Registered */
      type_: components["schemas"]["UserTypeRegistered"];
      user_id: components["schemas"]["UserId"];
    };
    Release: string | null;
    RelevantControl: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      /**
       * @default {
       *       "design": null,
       *       "implementation": null,
       *       "operating_effectiveness": null,
       *       "representation": null
       *     }
       */
      modules: components["schemas"]["ControlModuleSelection"];
    };
    RelevantCoreResponse: {
      core_response: components["schemas"]["CoreResponse"];
      /** Format: double */
      question_cosine_distance: number;
    };
    RelevantFact: {
      /** Format: double */
      answer_cosine_distance?: number | null;
      fact: components["schemas"]["Fact"];
      /** Format: double */
      question_cosine_distance: number;
    };
    /**
     * @description Whether the auditor chooses to lean on this control instead of doing
     *     substantive work — an economic judgement, not a verdict.
     *
     *     Has **no `Default`**: `NotDecided` is a real third state, and a default would
     *     let a reader reach "relied" by inaction. Stored as the bare variant name in a
     *     `text` column.
     * @enum {string}
     */
    Reliance: "NotDecided" | "Relied" | "NotRelied";
    ReminderSchedule: {
      /** Format: int32 */
      days_before: number;
      /** Format: int32 */
      hour_number: number;
      timezone: string;
    };
    /**
     * @description All the information required to generate a report. This is sent to the
     *     report renderer service.
     */
    ReportContentPayload: {
      account_name: string;
      activity_streams?: {[key: string]: components["schemas"]["Activity"][]} | null;
      ai_outputs: {[key: string]: string};
      /**
       * @description The architecture diagrams on the audit area's understanding, as PNGs, in
       *     ordinal order. Gathered only for the `ItgcDetailed` report, which opens
       *     on the system architecture.
       */
      architecture_diagrams: components["schemas"]["ReportDiagramImage"][];
      assessed_controls: {[key: string]: components["schemas"]["AssessedControl"]};
      assessment: components["schemas"]["Assessment"];
      /**
       * @description Per-scope IT complexity, gathered only for the templates that render it.
       *     Empty for every other template, and when the engagement has no complexity
       *     assessment; the ASA 315 report then falls back to risk-derived complexity.
       */
      complexity_assessments: components["schemas"]["ComplexityScopedAssessment"][];
      controls: {[key: string]: components["schemas"]["PredefinedControl"]};
      findings: components["schemas"]["Finding"][];
      framework_profiles: components["schemas"]["FrameworkProfile"][];
      module_templates: components["schemas"]["FrameworkModuleTemplates"];
      /**
       * @description The process understanding behind the assessment's audit area, gathered
       *     only for the `ProcessSteps` report which renders its steps as a table.
       */
      process_understanding?: components["schemas"]["ProcessUnderstandingReport"] | null;
      report_template: components["schemas"]["TprmReportTemplate"];
      risk_contexts: {[key: string]: components["schemas"]["RiskContext"]};
      risks: components["schemas"]["Risk"][];
      /**
       * @description Questionnaire answers per application scope, gathered only for the
       *     ASA 315 report, which tabulates them in §3. Empty for every other
       *     template.
       */
      scope_questionnaires: {[key: string]: components["schemas"]["ReportScopeQuestionnaire"][]};
      scopes: {[key: string]: components["schemas"]["TprmScopeMin"]};
      source_extracts: {[key: string]: components["schemas"]["SourceExtract"]};
      sources: components["schemas"]["SourceMin"][];
    };
    /** @description A diagram rasterised to a PNG, for the process steps report. */
    ReportDiagramImage: {
      /** @description Base64-encoded PNG. */
      image_base64: string;
      name: string;
    };
    /**
     * @description Static definition of a single AI prompt that a report type uses. The
     *     registry of these definitions drives:
     *     - which fields the create-template UI shows (and requires),
     *     - what `report_ai::generate_outputs` produces at export time,
     *     - what cache keys outputs are stored under in `tprm.report_ai_output`,
     *     - what keys renderers read from `payload.ai_outputs`.
     *
     *     `key` is the stable identifier for this prompt. The frontend maps it to
     *     the right i18n labels for the create-template dialog; the export pipeline
     *     uses it as the cache key for `WholeReport` prompts and as the prefix
     *     (`{key}:{control_group_id}`) for `PerControlGroup` prompts.
     *
     *     `default_template` is **seed text for new templates only** — used by the
     *     create dialog to pre-fill the textarea. It is not a runtime fallback: at
     *     export time we read whatever is stored on the template row. Rolling out a
     *     new default to existing rows is an explicit data migration so cached
     *     outputs and customer behaviour can't change silently from a code edit.
     *
     *     `optional` is a UI hint: if true, the create dialog accepts a blank
     *     textarea. At export time, missing or empty stored values cause the prompt
     *     to be skipped regardless of `optional`; renderers handle the missing key
     *     gracefully for every prompt that any template might leave blank.
     */
    ReportPromptDefinition: {
      default_template: string;
      key: string;
      optional: boolean;
      scope: components["schemas"]["PromptScope"];
    };
    /** @description One keyed question and its answer, flattened for report rendering. */
    ReportQuestionnaireAnswer: {
      /** @description Select answers resolve to their option labels. */
      answer_text: string;
      /**
       * @description The template-level key, e.g. `app_general.vendor`. Reports address
       *     questions by key, so unkeyed ones are omitted.
       */
      key: string;
      question_text: string;
    };
    /** @description A questionnaire attached to one scope, in template order. */
    ReportScopeQuestionnaire: {
      answers: components["schemas"]["ReportQuestionnaireAnswer"][];
      questionnaire_id: components["schemas"]["TprmQuestionnaireId"];
      template_name: string;
    };
    ReportTemplateIdPath: {report_template_id: components["schemas"]["TprmReportTemplateId"]};
    ReportedError: {
      description: string;
      link_url?: string | null;
      occurred_at: components["schemas"]["DateTime"];
      title: string;
    };
    ReportedErrorCatalogMin: {
      catalog_id: components["schemas"]["ErrorCatalogId"];
      created_at: components["schemas"]["DateTime"];
      /** Format: int32 */
      num_errors: number;
    };
    RepresentationModuleTemplateId: Nominal<string, "RepresentationModuleTemplateId">;
    RepresentationModuleTemplateOption: {
      config: components["schemas"]["ControlRepresentationModuleTemplate"];
      name: string;
      representation_module_template_id: components["schemas"]["RepresentationModuleTemplateId"];
    };
    RequestLoginReset: {email: string; redirect?: string | null};
    RequestRegistration: {email: string; name: string; redirect?: string | null};
    ResendPortalInvitePayload: {email: string};
    ResendPortalInviteResponse: "EmailSent" | "AlreadyJoined";
    ResetLoginInfo: {
      email: string;
      initiated_by?: components["schemas"]["OneTimeTokenInitiator"] | null;
      is_new_user: boolean;
      login_methods: components["schemas"]["UserLoginMethod"][];
      requires_2fa: boolean;
    };
    ResetLoginMethodResponse:
      | {
          /** @enum {string} */
          type: "Success";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Redirect";
        };
    ResidualRiskChangedContent: {
      /** Format: int32 */
      old_level?: number | null;
    };
    Resolution: {
      created_at: components["schemas"]["DateTime"];
      ignored?: components["schemas"]["Actioned"] | null;
      involved_facts: components["schemas"]["Fact"][];
      is_internal: boolean;
      owner?: components["schemas"]["Owner"] | null;
      reason: string;
      resolution_id: components["schemas"]["ResolutionId"];
      resolution_type: components["schemas"]["ResolutionType"];
      resolved?: components["schemas"]["Actioned"] | null;
      review_explanation: string;
      /** Format: float */
      review_necessity: number;
      scope?: components["schemas"]["ScopeMin"] | null;
    };
    ResolutionId: Nominal<string, "ResolutionId">;
    ResolutionIdPath: {resolution_id: components["schemas"]["ResolutionId"]};
    ResolutionMin: {
      created_at: components["schemas"]["DateTime"];
      ignored?: components["schemas"]["Actioned"] | null;
      is_internal: boolean;
      /** Format: int32 */
      num_involved_facts: number;
      owner?: components["schemas"]["Owner"] | null;
      reason: string;
      resolution_id: components["schemas"]["ResolutionId"];
      resolution_type: components["schemas"]["ResolutionType"];
      resolved?: components["schemas"]["Actioned"] | null;
      review_explanation: string;
      /** Format: float */
      review_necessity: number;
      scope?: components["schemas"]["ScopeMin"] | null;
    };
    ResolutionNotificationMin: {reason: string; resolution_id: components["schemas"]["ResolutionId"]};
    /** @enum {string} */
    ResolutionType: "Contradiction" | "Stale" | "Recurrent" | "Sensitive";
    ResolveOwner:
      | {
          content: components["schemas"]["TeamId"];
          /** @enum {string} */
          type: "Team";
        }
      | {
          content: components["schemas"]["UserId"];
          /** @enum {string} */
          type: "User";
        };
    /** @description A [`SourceExtractPosition`] resolved against its source's layout, as read. */
    ResolvedExtractPosition:
      | {
          /** @enum {string} */
          type: "WholeSource";
        }
      | {
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          /** @enum {string} */
          type: "QuestionnaireAnswer";
        }
      | {
          /** Format: uint32 */
          length: number;
          /** Format: uint32 */
          offset: number;
          /** @description Page geometry for this span; empty when the source has no layout. */
          regions: components["schemas"]["DocumentRegion"][];
          /** @enum {string} */
          type: "DocumentText";
        }
      | {
          /** Format: double */
          end_time: number;
          /** Format: double */
          start_time: number;
          /** @enum {string} */
          type: "VideoSection";
        }
      | {
          /** Format: uint32 */
          cue_index: number;
          /** @enum {string} */
          type: "VideoScreenshot";
        }
      | {
          /** @enum {string} */
          type: "Unlocated";
        };
    /**
     * @description An [`ExtractionField`] as the API presents it, its stamp resolved against the
     *     user directory.
     */
    ResolvedExtractionField: {
      ai_hint?: string | null;
      authored?: components["schemas"]["Actioned"] | null;
      field_id: components["schemas"]["TestExtractionFieldId"];
      name: string;
      /** Format: int32 */
      sort_order: number;
      type_: components["schemas"]["ValueType"];
    };
    ResponseLayer: {
      activity_stream: components["schemas"]["ActivityStream"];
      ai_attempted: boolean;
      /** Format: int32 */
      documentation_count: number;
      due_date?: components["schemas"]["DateTime"] | null;
      last_modified: components["schemas"]["Actioned"];
      linked_core_response?: components["schemas"]["CoreResponse"] | null;
      owner?: components["schemas"]["Owner"] | null;
      response_select?: components["schemas"]["ResponseOption"][] | null;
      response_text?: string | null;
      response_yes_no?: boolean | null;
      reviewable?: components["schemas"]["ReviewableMin"] | null;
      status: components["schemas"]["QuestionStatus"];
    };
    ResponseOption: {other_text?: string | null; value: string};
    /**
     * @description Configures a single `ReuseFindings` agent run. Snapshots both
     *     finding lists onto the persisted `conversation.config`: the
     *     freshly-generated candidates and the control's existing findings
     *     at the moment the conversation was opened. On a retry that finds
     *     the existing conversation, the snapshot is what both the agent's
     *     `system_prompt` and the caller's index resolver read — so
     *     `old_id: N` refers to the same underlying `FindingId` on every
     *     attempt.
     */
    ReuseFindingsFunction: {
      assessment_control_id: components["schemas"]["AssessmentControlId"];
      assessment_id: components["schemas"]["AssessmentId"];
      new_findings: components["schemas"]["CandidateFinding"][];
      old_findings: components["schemas"]["ExistingFinding"][];
    };
    /**
     * @description Configures a single `ReuseRisks` agent run. Snapshots both risk
     *     lists onto the persisted `conversation.config`: the
     *     freshly-discovered candidates (which live only in memory until
     *     the discovery pipeline persists them) and the assessment's
     *     existing risks at the moment the conversation was opened. On a
     *     retry that finds the existing conversation, the snapshot is
     *     what both the agent's `system_prompt` and the caller's index
     *     resolver read — so `old_risk_id: N` refers to the same
     *     underlying `RiskId` on every attempt.
     */
    ReuseRisksFunction: {
      assessment_id: components["schemas"]["AssessmentId"];
      new_risks: components["schemas"]["CandidateRisk"][];
      old_risks: components["schemas"]["ExistingRisk"][];
    };
    ReviewAction: {
      actioned: components["schemas"]["Actioned"];
      comment?: string | null;
      review_action_id: components["schemas"]["ReviewActionId"];
      review_status: components["schemas"]["ReviewStatus"];
      reviewer: components["schemas"]["Owner"];
      reviewer_role_id?: components["schemas"]["ReviewerRoleId"] | null;
    };
    ReviewActionId: Nominal<string, "ReviewActionId">;
    ReviewActionMin: {review_status: components["schemas"]["ReviewStatus"]; reviewer: components["schemas"]["Owner"]};
    ReviewActionPayload:
      | {
          content: string;
          /** @enum {string} */
          type: "Commented";
        }
      | {
          content: components["schemas"]["OwnerId"][];
          /** @enum {string} */
          type: "RequestReview";
        }
      | {
          content: components["schemas"]["OwnerId"][];
          /** @enum {string} */
          type: "UnrequestReview";
        }
      | {
          content: string | null;
          /** @enum {string} */
          type: "Approved";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "RequestChanges";
        };
    ReviewPayload: {
      action: components["schemas"]["ReviewActionPayload"];
      on_behalf?: components["schemas"]["TeamId"] | null;
    };
    ReviewPeriod:
      | {
          /** Format: int16 */
          content: number;
          /** @enum {string} */
          type: "Days";
        }
      | {
          /** @enum {string} */
          type: "None";
        };
    /**
     * @description Should be ordered by priority in overall status, with later ones having higher priority.
     * @enum {string}
     */
    ReviewStatus: "Unrequested" | "Pending" | "Commented" | "Approved" | "RequestedChanges";
    Reviewable: Reviewable;
    ReviewableId: Nominal<string, "ReviewableId">;
    ReviewableIdPath: {reviewable_id: components["schemas"]["ReviewableId"]};
    ReviewableMin: ReviewableMin;
    ReviewerRole: {
      name: string;
      /** Format: int32 */
      ordinal: number;
      reviewer_role_id: components["schemas"]["ReviewerRoleId"];
    };
    ReviewerRoleId: Nominal<string, "ReviewerRoleId">;
    ReviewerRoleIdPath: {reviewer_role_id: components["schemas"]["ReviewerRoleId"]};
    RichText: {elements: components["schemas"]["RichTextElement"][]};
    RichTextAttributes: {bold?: boolean | null; italic?: boolean | null};
    RichTextElement:
      | {
          content: components["schemas"]["TextElement"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["MentionElement"];
          /** @enum {string} */
          type: "Mention";
        };
    Risk: Risk;
    RiskAcceptanceContent: {accepted: boolean};
    RiskArea: {
      description: string;
      examples: components["schemas"]["RiskAreaExampleRisk"][];
      risk_area_id: components["schemas"]["RiskAreaId"];
      title: string;
    };
    RiskAreaExampleRisk: {
      kind: components["schemas"]["RiskAreaExampleRiskKind"];
      reason: string;
      risk_area_example_risk_id: components["schemas"]["RiskAreaExampleRiskId"];
      risk_text: string;
    };
    RiskAreaExampleRiskId: Nominal<string, "RiskAreaExampleRiskId">;
    RiskAreaExampleRiskKind: "Valid" | "Invalid";
    RiskAreaId: Nominal<string, "RiskAreaId">;
    RiskContext: {
      deleted?: components["schemas"]["Actioned"] | null;
      risk_area?: components["schemas"]["RiskArea"] | null;
      risk_context_id: components["schemas"]["RiskContextId"];
      source: components["schemas"]["SourceMin"];
      source_context: string;
    };
    RiskContextId: Nominal<string, "RiskContextId">;
    RiskEvaluationContent: {
      components?: number[] | null;
      /** Format: int32 */
      level: number;
      reason: string;
      /** Format: double */
      value: number;
    };
    RiskId: Nominal<string, "RiskId">;
    RiskIdPair: {assessment_id: components["schemas"]["AssessmentId"]; risk_id: components["schemas"]["RiskId"]};
    RiskIdPath: {risk_id: components["schemas"]["RiskId"]};
    RiskLevel: ("Low" | "Medium" | "High") | "FalsePositive";
    RiskMin: {risk_id: components["schemas"]["RiskId"]};
    RiskNode: {risk_id: components["schemas"]["RiskId"]};
    RiskNotificationMin: {
      assessment: components["schemas"]["AssessmentNotificationMin"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      risk_id: components["schemas"]["RiskId"];
      title: string;
    };
    RiskQuantificationCombiningFunction: "Add" | "Multiply" | "Min" | "Max";
    RiskQuantificationModel:
      | {
          /** @enum {string} */
          type: "Basic";
        }
      | {
          content: components["schemas"]["ComponentWiseRiskQuantificationModel"];
          /** @enum {string} */
          type: "ComponentWise";
        };
    RiskQuantificationModelComponent: {
      /** @description Instruction given to the AI for assessing this component's value. */
      ai_prompt: string;
      /**
       * Format: double
       * @description Offset added to this component's value before it is combined; defaults to `0`.
       * @default 0
       */
      bias: number;
      /**
       * @description Longer explanation of what this component measures; omitting it leaves no description.
       * @default
       */
      description: string;
      /** @description Human-readable name of this component shown in the UI. */
      label: string;
      /**
       * Format: double
       * @description Largest value this component may take.
       */
      max_value: number;
      /**
       * Format: double
       * @description Smallest value this component may take; defaults to `0`.
       * @default 0
       */
      min_value: number;
      /** @description When `true`, this component is entered as a choice from its `thresholds`. */
      show_choice: boolean;
      /** @description When `true`, this component is entered as a numeric value. */
      show_numeric: boolean;
      /**
       * Format: double
       * @description Increment between selectable values for this component; defaults to `1`.
       * @default 1
       */
      step: number;
      /** @description Optional named bands for presenting this individual component's value as a choice; omitting it offers no per-component thresholds. */
      thresholds?: components["schemas"]["RiskThreshold"][] | null;
      /**
       * @description Unit label shown for this component's value; omitting it shows no units.
       * @default
       */
      units: string;
      /**
       * Format: double
       * @description Multiplier applied to this component's biased value before combining; defaults to `1`.
       * @default 1
       */
      weight: number;
    };
    RiskRelevantControlsContent: {
      /** @default [] */
      controls: components["schemas"]["RelevantControl"][];
    };
    /**
     * @description A risk's title and description as the agent sees them. Reused
     *     by all four `Quantify*` variants.
     */
    RiskSnapshot: {description: string; title: string};
    RiskSummaryItem: {
      accepted: boolean;
      /** Format: int32 */
      level?: number | null;
      /** Format: int32 */
      num_risks: number;
    };
    RiskThreshold: {
      /** @description Colour used to display this risk band. */
      color: components["schemas"]["ColorPalette"];
      /** @description Name shown for this risk band. */
      label: string;
      /**
       * Format: double
       * @description Lower bound of the combined value at which this band starts to apply.
       */
      value: number;
    };
    RiskUpdatedPayload:
      | {
          /** @enum {string} */
          type: "Created";
        }
      | {
          /** @enum {string} */
          type: "Removed";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Title";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Description";
        }
      | {
          content: components["schemas"]["HistoricRiskEvaluation"];
          /** @enum {string} */
          type: "InherentLevel";
        }
      | {
          content: components["schemas"]["HistoricRiskEvaluation"];
          /** @enum {string} */
          type: "ResidualLevel";
        }
      | {
          content: boolean;
          /** @enum {string} */
          type: "Accepted";
        }
      | {
          content: components["schemas"]["AssessmentControlId"];
          /** @enum {string} */
          type: "RelevantControlLinked";
        }
      | {
          content: components["schemas"]["AssessmentControlId"];
          /** @enum {string} */
          type: "RelevantControlUnlinked";
        }
      | {
          /** @enum {string} */
          type: "Owner";
        }
      | {
          content: components["schemas"]["RiskContextId"];
          /** @enum {string} */
          type: "ContextAdded";
        }
      | {
          content: components["schemas"]["RiskContextId"];
          /** @enum {string} */
          type: "ContextRemoved";
        };
    Role: {
      description: string;
      /** Format: int32 */
      member_count: number;
      name: string;
      role_id: components["schemas"]["RoleId"];
      system_role?: components["schemas"]["SystemRole"] | null;
    };
    RoleId: Nominal<string, "RoleId">;
    RoleIdPath: {role_id: components["schemas"]["RoleId"]};
    RoleMin: {
      name: string;
      role_id: components["schemas"]["RoleId"];
      system_role?: components["schemas"]["SystemRole"] | null;
    };
    RoleUserPath: {role_id: components["schemas"]["RoleId"]; user_id: components["schemas"]["UserId"]};
    /** @description A member on another engagement of the same third party. */
    RollForwardCandidate: {
      /**
       * Format: int64
       * @description Attributes with an answer that applies.
       */
      answered_count: number;
      assessed_at?: components["schemas"]["DateTime"] | null;
      audit_area_name?: string | null;
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_model_id: components["schemas"]["ComplexityModelId"];
      complexity_model_name: string;
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      engagement_id: components["schemas"]["EngagementId"];
      engagement_name: string;
      scope_id: components["schemas"]["TprmScopeId"];
      scope_name?: string | null;
      version_name: string;
    };
    /** @description Why a run stopped short, stored in the run row as its string form. */
    RollForwardFailure: ("source_gone" | "member_gone") | "page_locked" | "assessing" | "failed";
    /**
     * @description What a roll-forward run does with each prior answer.
     *     The serde names are the literals the `mode` column's CHECK accepts.
     */
    RollForwardMode: "suggest" | "fill_blanks" | "prefill_all";
    /**
     * @description What the plan found for one attribute, which is not on its own what the
     *     run does with it: [`RollForwardMode::writes`] decides that. The serde
     *     names are the literals the `outcome` column's CHECK accepts.
     */
    RollForwardOutcome: ("written" | "suggested") | "matched" | "not_answered";
    RollForwardPlan: {
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      rows: components["schemas"]["RollForwardPlanRow"][];
      source_engagement_id: components["schemas"]["EngagementId"];
    };
    /** @description What a run would do to one attribute, before it has done it. */
    RollForwardPlanRow: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      attribute_name: string;
      complexity_attribute_id: components["schemas"]["ComplexityAttributeId"];
      outcome: components["schemas"]["RollForwardOutcome"];
      prior_value?: IValue;
      source_attribute_assessment_id?: components["schemas"]["AttributeAssessmentId"] | null;
    };
    /**
     * @description Where a rolled-forward value was copied from. Persisted rather than joined:
     *     the source may since be reassessed or deleted.
     */
    RollForwardProvenance: {
      complexity_roll_forward_run_id: components["schemas"]["ComplexityRollForwardRunId"];
      source_attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      /**
       * @description The version the source answer was written under, kept so a reader can
       *     ask whether the attribute's definition has changed since.
       */
      source_complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      source_engagement_id: components["schemas"]["EngagementId"];
    };
    RollForwardReport: {rows: components["schemas"]["RollForwardRow"][]; run: components["schemas"]["RollForwardRun"]};
    RollForwardRequest: {
      mode: components["schemas"]["RollForwardMode"];
      source: components["schemas"]["ComplexityScopedAssessmentRef"];
    };
    RollForwardRow: {
      attribute_assessment_id: components["schemas"]["AttributeAssessmentId"];
      complexity_roll_forward_row_id: components["schemas"]["ComplexityRollForwardRowId"];
      outcome: components["schemas"]["RollForwardOutcome"];
      /** @description The source's answer at the time of the run. */
      prior_value?: IValue;
      source_attribute_assessment_id?: components["schemas"]["AttributeAssessmentId"] | null;
    };
    /** @description At most one live run per member; a failed or undone one can be replaced. */
    RollForwardRun: {
      completed_at?: components["schemas"]["DateTime"] | null;
      complexity_assessment_id: components["schemas"]["ComplexityAssessmentId"];
      complexity_model_version_id: components["schemas"]["ComplexityModelVersionId"];
      complexity_roll_forward_run_id: components["schemas"]["ComplexityRollForwardRunId"];
      failed_at?: components["schemas"]["DateTime"] | null;
      failure?: components["schemas"]["RollForwardFailure"] | null;
      /** Format: int32 */
      matched_count: number;
      mode: components["schemas"]["RollForwardMode"];
      scope_id: components["schemas"]["TprmScopeId"];
      /** Format: int32 */
      skipped_count: number;
      /** @description `None` once the source member has been deleted. */
      source?: components["schemas"]["ComplexityScopedAssessmentRef"] | null;
      source_complexity_model_version_id?: components["schemas"]["ComplexityModelVersionId"] | null;
      source_engagement_id?: components["schemas"]["EngagementId"] | null;
      started: components["schemas"]["Actioned"];
      /** Format: int32 */
      suggested_count: number;
      task_id?: components["schemas"]["BackgroundTaskId"] | null;
      /** @description Only a completed run can be undone. */
      undone?: components["schemas"]["Actioned"] | null;
      /** Format: int32 */
      written_count: number;
    };
    RollForwardSummary: {
      complexity_roll_forward_run_id: components["schemas"]["ComplexityRollForwardRunId"];
      /**
       * Format: int32
       * @default 0
       */
      matched: number;
      /** Format: int32 */
      skipped: number;
      source_engagement_id: components["schemas"]["EngagementId"];
      /** Format: int32 */
      suggested: number;
      /** Format: int32 */
      written: number;
    };
    RollForwardUndoneSummary: {
      /**
       * Format: int32
       * @description Attributes whose rolled-forward answer was taken back.
       */
      cleared: number;
      complexity_roll_forward_run_id: components["schemas"]["ComplexityRollForwardRunId"];
    };
    /** @description A third answer beside the user's and the AI's. */
    RolledForward: {
      at: components["schemas"]["DateTime"];
      provenance: components["schemas"]["RollForwardProvenance"];
      /** @description Resolved on read; absent once the source engagement is gone. */
      source_engagement_name?: string | null;
      value?: IValue;
    };
    RowRefBody: {row_id: components["schemas"]["TprmTableRowId"]};
    RuleCondition: {condition: components["schemas"]["ConditionType"]; value: IValue};
    /** @description Optional item subset for a step. `None` = all items. */
    RunStepArgs: {item_ids?: components["schemas"]["TestItemId"][] | null};
    /**
     * @description Configures a single `RunTestResults` agent run: the sampled item to
     *     judge, the criteria it answers, and the fields it may cite.
     *
     *     Criteria and fields are resolved by the caller and carried here rather
     *     than looked up from `test_id` at run time: the runtime builds the tool
     *     set from this value synchronously, and `record_result`'s
     *     `criterion_index`/`field_indexes` are positions in these lists, so
     *     carrying them fixes what a position means for the life of the
     *     conversation.
     *
     *     The item's extracted values are not carried: they are read from
     *     `tprm.test_materialized_sample` at prompt build, which re-checks
     *     `extracted_at` and fails the run if an API unmap (outside the run's
     *     `Test` lock) has stripped the layer.
     */
    RunTestResultsFunction: {
      /** @description The test's resolved criteria, in prompt order. */
      criteria: components["schemas"]["TestCriterion"][];
      /**
       * @description The test's resolved extraction fields, in prompt order — the only
       *     things an outcome may cite.
       */
      fields: components["schemas"]["ExtractionField"][];
      test_id: components["schemas"]["TestId"];
      test_item_id: components["schemas"]["TestItemId"];
    };
    SARRequest: {
      address?: string | null;
      company?: string | null;
      content: string;
      email: string;
      name?: string | null;
      phone_number?: string | null;
    };
    /** @description A sample and its resolved source population. */
    Sample: {
      created_at: components["schemas"]["DateTime"];
      description?: string | null;
      engagement: components["schemas"]["EngagementMin"];
      /**
       * @description The population's fields, resolved from the (locked, immutable) population
       *     so the sampled-data table can render the same columns.
       */
      fields: components["schemas"]["PopulationField"][];
      /**
       * @description True exactly when [`Self::locked_at`] is set. Every edit to the sample —
       *     its name, its description and its design — gates on it.
       */
      is_locked: boolean;
      /**
       * Format: int64
       * @description The number of materialized items — the sample-size stat.
       */
      item_count: number;
      /**
       * @description What the standing items were drawn with, `None` before the first draw.
       *     It differs from [`Self::method`] once the design has been edited since
       *     that draw.
       */
      last_drawn_method?: components["schemas"]["DrawnSampleMethod"] | null;
      /**
       * @description When the lock was taken — by the first test to freeze a copy of this
       *     sample, or by hand. Held until someone clears it.
       */
      locked_at?: components["schemas"]["DateTime"] | null;
      method: components["schemas"]["SampleMethod"];
      name: string;
      /**
       * @description The source population (carries its own `row_count` and `is_locked`). The
       *     frontend derives coverage as `item_count / population.row_count`.
       *
       *     `None` while the sample is a draft that has not been pointed at one; a
       *     committed sample always has a population.
       */
      population?: components["schemas"]["PopulationMin"] | null;
      processing_state: components["schemas"]["SampleProcessingState"];
      sample_id: components["schemas"]["SampleId"];
      updated_at: components["schemas"]["DateTime"];
    };
    SampleId: Nominal<string, "SampleId">;
    SampleIdPath: {sample_id: components["schemas"]["SampleId"]};
    /**
     * @description A single materialized item, resolved by joining `sample_item ->
     *     population_row`. `data` maps each [`PopulationColumnId`] to its cell value, a
     *     JSON value matching the column's `ValueType`, as in
     *     [`super::population::PopulationRow`].
     */
    SampleItem: {
      data: {[key: string]: IValue};
      /** Format: int32 */
      item_index: number;
      sample_item_id: components["schemas"]["SampleItemId"];
    };
    SampleItemId: Nominal<string, "SampleItemId">;
    /**
     * @description The design: the method and the size the auditor chose, which a client both
     *     reads and writes.
     */
    SampleMethod:
      | {
          /** @enum {string} */
          type: "FullV1";
        }
      | {
          size: components["schemas"]["SampleSize"];
          /** @enum {string} */
          type: "RandomV1";
        };
    /**
     * @description Lightweight sample summary for the library listing and the population's
     *     "Linked samples" tab.
     */
    SampleMin: {
      created_at: components["schemas"]["DateTime"];
      description?: string | null;
      /** @description True exactly when [`Self::locked_at`] is set. */
      is_locked: boolean;
      /** Format: int64 */
      item_count: number;
      /** @description The same lock instant [`Sample::locked_at`] carries. */
      locked_at?: components["schemas"]["DateTime"] | null;
      method: components["schemas"]["SampleMethod"];
      name: string;
      /**
       * @description `None` while the sample is a draft that has not been pointed at a
       *     population.
       */
      population_name?: string | null;
      processing_state: components["schemas"]["SampleProcessingState"];
      sample_id: components["schemas"]["SampleId"];
      /** @description The same instant [`Sample::updated_at`] carries: any write to the row. */
      updated_at: components["schemas"]["DateTime"];
    };
    /**
     * @description Processing status of a sample's materialization, mirroring
     *     [`super::population::PopulationProcessingState`]. Derived from the
     *     `committed_at` / `sampled_at` / `sample_background_task_id` / `sample_error`
     *     columns so the frontend can drive live updates off the pending task.
     *
     *     [`Self::Draft`] precedes the sampling pipeline rather than extending it:
     *     `Sampling` → `Completed`/`Error` describe how far committed work has run, and
     *     a draft has no committed work.
     */
    SampleProcessingState:
      | {
          /** @enum {string} */
          type: "Draft";
        }
      | {
          background_task?: components["schemas"]["PendingBackgroundTask"] | null;
          /** @enum {string} */
          type: "Sampling";
        }
      | {
          at: components["schemas"]["DateTime"];
          /** @enum {string} */
          type: "Completed";
        }
      | {
          at: components["schemas"]["DateTime"];
          error: string;
          /** @enum {string} */
          type: "Error";
        };
    /**
     * @description How many rows a method asks for. What a draw produced is `sample.item_count`,
     *     and the two may differ.
     */
    SampleSize:
      | {
          /** Format: uint32 */
          n: number;
          /** @enum {string} */
          type: "Count";
        }
      | {
          /** Format: uint32 */
          pct: number;
          /** @enum {string} */
          type: "Percent";
        };
    SavedView: {
      created: components["schemas"]["Actioned"];
      group: components["schemas"]["SavedViewGroup"];
      name: string;
      payload: {[key: string]: IValue};
      updated: components["schemas"]["Actioned"];
      view_id: components["schemas"]["SavedViewId"];
    };
    SavedViewGroup:
      | {
          /** @enum {string} */
          type: "User";
        }
      | {
          /** @enum {string} */
          type: "Account";
        }
      | {
          /** @enum {string} */
          type: "Preset";
        };
    SavedViewId: Nominal<string, "SavedViewId">;
    SavedViewKeyIdPath: {view_id: components["schemas"]["SavedViewId"]; view_key: string};
    SavedViewKeyPath: {view_key: string};
    SavedViewList: {
      default_view_id?: components["schemas"]["SavedViewId"] | null;
      views: components["schemas"]["SavedView"][];
    };
    ScimConfig: {
      account_id: components["schemas"]["AccountId"];
      auth_token: string;
      name: string;
      scim_config_id: components["schemas"]["ScimConfigId"];
      send_invitations: boolean;
    };
    ScimConfigId: Nominal<string, "ScimConfigId">;
    ScimConfigIdPath: {scim_config_id: components["schemas"]["ScimConfigId"]};
    ScimConfigList: {base_url: string; configs: components["schemas"]["ScimConfig"][]};
    Scope: {
      access_controls?: components["schemas"]["ScopeAccess"] | null;
      axis: components["schemas"]["ScopeAxisMin"];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      scope_id: components["schemas"]["ScopeId"];
    };
    ScopeAccess: {
      owners: components["schemas"]["Owner"][];
      readers: components["schemas"]["Owner"][];
      writers: components["schemas"]["Owner"][];
    };
    ScopeAxisId: Nominal<string, "ScopeAxisId">;
    ScopeAxisMin: {axis_id: components["schemas"]["ScopeAxisId"]; color: string; name: string};
    /**
     * @description Lightweight summary of a scope's current health, intended for badge/indicator
     *     UIs that need to know whether a scope has sources in error state without
     *     paying for the full [`TprmScopeMin`] hydration or source-count subqueries.
     *
     *     Fetched in bulk per engagement via `GET /engagements/{id}/scopes/badges`.
     *     Scopes with zero source errors are omitted from the response, so a missing
     *     entry implies a zero count.
     */
    ScopeBadge: {
      scope_id: components["schemas"]["TprmScopeId"];
      /**
       * Format: int64
       * @description Number of non-deleted sources in this scope whose processing finished
       *     with an error.  Only scopes with at least one such source are returned.
       */
      source_error_count: number;
    };
    ScopeId: Nominal<string, "ScopeId">;
    ScopeIdList: {scope_ids: components["schemas"]["ScopeId"][]};
    ScopeIdOrGlobal: "global" | components["schemas"]["ScopeId"];
    ScopeIdOrGlobalPath: {scope_id: components["schemas"]["ScopeIdOrGlobal"]};
    ScopeIdPath: {scope_id: components["schemas"]["ScopeId"]};
    ScopeIdPath2: {scope_id: components["schemas"]["TprmScopeId"]};
    ScopeMatrix: {rows: components["schemas"]["ScopeIdList"][]};
    ScopeMin: {
      axis: components["schemas"]["ScopeAxisMin"];
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      scope_id: components["schemas"]["ScopeId"];
    };
    ScopeVisibilityPath: {
      risk_or_control: components["schemas"]["TprmScopeVisibility"];
      scope_id: components["schemas"]["TprmScopeId"];
    };
    ScopedLibrarySection: {
      library_section?: components["schemas"]["LibrarySectionWithoutScope"] | null;
      scope?: components["schemas"]["ScopeMin"] | null;
    };
    ScopedLibrarySectionId: {
      library_section_id?: components["schemas"]["LibrarySectionId"] | null;
      scope_id?: components["schemas"]["ScopeId"] | null;
    };
    SearchIndexStats: {
      field_distribution: {[key: string]: number};
      is_indexing: boolean;
      /** Format: uint */
      number_of_documents: number;
    };
    /** @description Statistics for the Meilisearch instance. */
    SearchStats: {
      /** Format: uint */
      database_size: number;
      indexes: {[key: string]: components["schemas"]["SearchIndexStats"]};
      last_update?: components["schemas"]["DateTime"] | null;
      /** Format: uint */
      used_database_size: number;
    };
    Section: {
      description: string;
      question_groups: components["schemas"]["QuestionGroupMin"][];
      questions: components["schemas"]["QuestionMin"][];
      section_id: components["schemas"]["SectionId"];
      title: string;
    };
    SectionId: Nominal<string, "SectionId">;
    SectionMin: {description: string; section_id: components["schemas"]["SectionId"]; title: string};
    SelectAnswerConfig: {
      /** Format: int32 */
      max_selected?: number | null;
      options: components["schemas"]["AnswerOption"][];
    };
    SendSupportEmail: {
      action: string;
      attachments: components["schemas"]["FileId"][];
      body: string;
      cc_user: boolean;
      /** @default false */
      express: boolean;
      subject: string;
    };
    ServiceUser: {
      avatar_url?: components["schemas"]["Never"] | null;
      description: string;
      name: string;
      primary_email?: components["schemas"]["Never"] | null;
      type_: components["schemas"]["UserTypeService"];
      user_id: components["schemas"]["UserId"];
    };
    ServiceUserApikey: {
      apikey: string;
      created: components["schemas"]["Actioned"];
      deleted?: components["schemas"]["Actioned"] | null;
      user_apikey_id: components["schemas"]["UserApikeyId"];
    };
    ServiceUserApikeyMin: {
      created: components["schemas"]["Actioned"];
      deleted?: components["schemas"]["Actioned"] | null;
      user_apikey_id: components["schemas"]["UserApikeyId"];
    };
    SessionLog: {product: components["schemas"]["ProductType"]};
    /**
     * @description Input for replacing what a basis item cites. Each entry names a data-room
     *     source (with its `as_of` pin); citing a whole document leaves `extract`
     *     unset, so a `WholeSource` extract is minted for it.
     */
    SetBasisItemCitations: {citations: components["schemas"]["RecordControlCitation"][]};
    /**
     * @description Input for linking a test-kind basis item to a test in the Testing module, or
     *     unlinking it. The item's status is derived from the linked test, never stored.
     */
    SetBasisItemTest: {test_id?: components["schemas"]["TestId"] | null};
    SetColumnBody: {
      column_key: string;
      row_ids: components["schemas"]["TprmTableRowId"][];
      value?: components["schemas"]["TprmExternalColumnValue"] | null;
    };
    /**
     * @description Input for recording a conclusion. `rating` is rejected outside
     *     `1..=levels.len()` at both ends, at the write boundary.
     */
    SetControlOeConclusion: {
      justification: string;
      /** Format: int32 */
      rating: number;
    };
    SetPassword: {
      /**
       * @description This only needs to be provided if this is a first-time invite flow. It
       *     will be ignored if the user is already registered.
       */
      name?: string | null;
      new_password: string;
      new_two_factor?: components["schemas"]["EnableTwoFaTotp"] | null;
      prev_credentials?: components["schemas"]["LoginCredentials"] | null;
    };
    /**
     * @description Input for stating a prior-year conclusion by hand: the rating the control's
     *     operating effectiveness reached before, as a 1-based index into its scale,
     *     and why it is being rolled forward.
     */
    SetPriorConclusion: {
      justification?: string | null;
      /** Format: int32 */
      rating?: number | null;
    };
    SetReliance: {reliance: components["schemas"]["Reliance"]};
    /**
     * @description Input for recording the auditor's call on a work-of-others report. Separate
     *     from citing the report itself, which is [`SetBasisItemCitations`].
     */
    SetWorkOfOthersSatisfactory: {satisfactory?: boolean | null};
    /** @enum {string} */
    SharingClassification: "Internal" | "NDA" | "External";
    ShowcaseMessageIds: {
      message_ids: components["schemas"]["ShowcaseUpdateMessageId"][];
      /** Format: int32 */
      total: number;
    };
    ShowcaseUpdateMessage: {
      content?: string | null;
      deleted_at?: components["schemas"]["DateTime"] | null;
      sent_at?: components["schemas"]["DateTime"] | null;
      title?: string | null;
      update_message_id: components["schemas"]["ShowcaseUpdateMessageId"];
      updated_at: components["schemas"]["DateTime"];
    };
    ShowcaseUpdateMessageId: Nominal<string, "ShowcaseUpdateMessageId">;
    SingleNotificationPayload:
      | {
          content: components["schemas"]["TeamMin"];
          /** @enum {string} */
          type: "Team";
        }
      | {
          content: components["schemas"]["UserMin"];
          /** @enum {string} */
          type: "User";
        }
      | {
          content: components["schemas"]["QuestionNotificationMin"];
          /** @enum {string} */
          type: "Question";
        }
      | {
          content: components["schemas"]["QuestionnaireNotificationMin"];
          /** @enum {string} */
          type: "Questionnaire";
        }
      | {
          content: components["schemas"]["DocumentNotificationMin"];
          /** @enum {string} */
          type: "Document";
        }
      | {
          content: components["schemas"]["ResolutionNotificationMin"];
          /** @enum {string} */
          type: "ReviewItem";
        }
      | {
          content: components["schemas"]["AssessmentNotificationMin"];
          /** @enum {string} */
          type: "Assessment";
        }
      | {
          content: components["schemas"]["ThirdPartyNotificationMin"];
          /** @enum {string} */
          type: "ThirdParty";
        }
      | {
          content: components["schemas"]["ControlNotificationMin"];
          /** @enum {string} */
          type: "Control";
        }
      | {
          content: components["schemas"]["ControlNotificationMin"];
          /** @enum {string} */
          type: "ControlOE";
        }
      | {
          content: components["schemas"]["RiskNotificationMin"];
          /** @enum {string} */
          type: "Risk";
        }
      | {
          content: components["schemas"]["ThirdPartyNotificationMin"];
          /** @enum {string} */
          type: "ThirdPartyQuestionnaire";
        }
      | {
          content: components["schemas"]["ComplexityAssessmentNotificationMin"];
          /** @enum {string} */
          type: "ComplexityAssessment";
        }
      | {
          content: components["schemas"]["UnderstandingNotificationMin"];
          /** @enum {string} */
          type: "Understanding";
        }
      | {
          content: components["schemas"]["AuditPlanPageNotificationMin"];
          /** @enum {string} */
          type: "AuditPlanPage";
        };
    SlackNotificationSinkConfig: {team_id: string; team_name: string};
    SlackQuestionSourceConfig: Record<string, never>;
    SnapshotIdPath: {portal_report_snapshot_id: components["schemas"]["PortalReportSnapshotId"]};
    Source: {
      /** @description See [`SourceMin::as_of`]. */
      as_of: components["schemas"]["DateTime"];
      child_sources: components["schemas"]["SourceMin"][];
      context: string;
      control_visible: boolean;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      /** @description See [`SourceMin::drifted`]. */
      drifted: boolean;
      /** @description See [`SourceMin::has_failed_child_source`]. */
      has_failed_child_source: boolean;
      kind: components["schemas"]["SourceKind"];
      name: string;
      notes: string;
      /**
       * @description Whether this source was created specifically for operating effectiveness testing.
       *     When true, the source is primarily intended for OE workflows.
       */
      operating_effectiveness_visible: boolean;
      parent_source?: components["schemas"]["SourceMin"] | null;
      processing_state: components["schemas"]["SourceProcessingState"];
      risk_visible: boolean;
      scope: components["schemas"]["TprmScopeMin"];
      source_id: components["schemas"]["SourceId"];
      source_number: string;
      summary?: string | null;
    };
    SourceChunkId: Nominal<string, "SourceChunkId">;
    SourceCounts: {
      /** Format: int32 */
      completed: number;
      /** Format: int32 */
      error: number;
      /** Format: int32 */
      not_started: number;
      /** Format: int32 */
      processing: number;
      /** Format: int32 */
      total: number;
    };
    /** @description A pinpointed, reusable reference into a single source snapshot, as read. */
    SourceExtract: {
      /**
       * Format: int32
       * @description Stable within a source, never reused; rendered to the agent as `E{index}`.
       */
      index: number;
      position: components["schemas"]["ResolvedExtractPosition"];
      source: components["schemas"]["SourceMin"];
      source_extract_id: components["schemas"]["SourceExtractId"];
      /** @description The verbatim text — how a reader locates the extract when `position` can't. */
      text: string;
    };
    SourceExtractId: Nominal<string, "SourceExtractId">;
    /**
     * @description Where an extract sits in its source: the stored form and, bar
     *     [`Unlocated`](Self::Unlocated), the dedup key. Geometry is deliberately
     *     absent so identity doesn't shift when a source later gains layout.
     */
    SourceExtractPosition:
      | {
          /** @enum {string} */
          type: "WholeSource";
        }
      | {
          question_template_id: components["schemas"]["TprmQuestionTemplateId"];
          /** @enum {string} */
          type: "QuestionnaireAnswer";
        }
      | {
          /** Format: uint32 */
          length: number;
          /** Format: uint32 */
          offset: number;
          /** @enum {string} */
          type: "DocumentText";
        }
      | {
          /** Format: double */
          end_time: number;
          /** Format: double */
          start_time: number;
          /** @enum {string} */
          type: "VideoSection";
        }
      | {
          /** Format: uint32 */
          cue_index: number;
          /** @enum {string} */
          type: "VideoScreenshot";
        }
      | {
          /** @enum {string} */
          type: "Unlocated";
        };
    SourceId: Nominal<string, "SourceId">;
    SourceIdPath: {source_id: components["schemas"]["SourceId"]};
    SourceKind:
      | {
          content: components["schemas"]["DocumentSourceKind"];
          /** @enum {string} */
          type: "Document";
        }
      | {
          content: components["schemas"]["ImageSourceKind"];
          /** @enum {string} */
          type: "Image";
        }
      | {
          content: components["schemas"]["VideoSourceKind"];
          /** @enum {string} */
          type: "Video";
        }
      | {
          content: components["schemas"]["QuestionnaireSourceKind"];
          /** @enum {string} */
          type: "Questionnaire";
        };
    SourceMin: {
      /**
       * @description The instant at which this snapshot was resolved. When the frontend
       *     creates a new citation referencing this source, it should pin its
       *     `SourceRef` to this `as_of` so the citation captures the version the
       *     user actually saw.
       */
      as_of: components["schemas"]["DateTime"];
      /**
       * Format: int64
       * @description UTF-8 byte length of the source's primary model-visible content
       *     — what [`SourceKind::content_string`] would render, without
       *     per-source context or summary. Bytes (not characters) because
       *     LLM tokens correlate more closely with byte count than codepoint
       *     count; the agentic `list_sources_for_scope` tool surfaces this
       *     to the model for "is this source small enough to read whole?"
       *     reasoning. Populated at SQL-query time for source kinds whose
       *     content is materialised on the log entry (document, image,
       *     video); `None` for kinds whose content needs an extra join to
       *     render (currently questionnaire).
       */
      content_length?: number | null;
      context: string;
      control_visible: boolean;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      /**
       * @description True when this snapshot is older than the source's current state —
       *     i.e. the source has been modified since `as_of`. Used by the UI to
       *     indicate that a pinned citation is showing historical data.
       */
      drifted: boolean;
      /**
       * @description True if any direct child source has a `SourceProcessingState::Error`.
       *     Lets the UI surface child failures on the parent without traversing
       *     `Source::child_sources`, which is not present on `SourceMin`.
       */
      has_failed_child_source: boolean;
      kind: components["schemas"]["SourceMinKind"];
      name: string;
      /**
       * @description Whether this source was created specifically for operating effectiveness testing.
       *     When true, the source is primarily intended for OE workflows.
       */
      operating_effectiveness_visible: boolean;
      processing_state: components["schemas"]["SourceProcessingState"];
      risk_visible: boolean;
      scope: components["schemas"]["TprmScopeMin"];
      source_id: components["schemas"]["SourceId"];
      source_number: string;
      summary?: string | null;
    };
    SourceMinKind:
      | {
          content: components["schemas"]["DocumentSourceMinKind"];
          /** @enum {string} */
          type: "Document";
        }
      | {
          content: components["schemas"]["ImageSourceMinKind"];
          /** @enum {string} */
          type: "Image";
        }
      | {
          content: components["schemas"]["VideoSourceMinKind"];
          /** @enum {string} */
          type: "Video";
        }
      | {
          content: components["schemas"]["QuestionnaireSourceMinKind"];
          /** @enum {string} */
          type: "Questionnaire";
        };
    SourceProcessingState:
      | {
          /** @enum {string} */
          type: "NotStarted";
        }
      | {
          background_task: components["schemas"]["PendingBackgroundTask"];
          /** @enum {string} */
          type: "Processing";
        }
      | {
          at: components["schemas"]["DateTime"];
          /** @enum {string} */
          type: "Completed";
        }
      | {
          at: components["schemas"]["DateTime"];
          error: string;
          /** @enum {string} */
          type: "Error";
        };
    /**
     * @description A pinned reference to a source: `source_id` plus the point-in-time `as_of`
     *     at which the reference was captured. Reads of a `SourceRef` resolve every
     *     property of the source as it existed at `as_of` — so renames, re-uploads,
     *     or re-scoping that happened after the reference was recorded do not follow
     *     the reference.
     *
     *     Stored as two columns in SQL (`<name>_source_id UUID`, `<name>_source_as_of
     *     TIMESTAMPTZ`) rather than a composite SQL type so that plain SQL joins and
     *     predicates remain simple.
     */
    SourceRef: {as_of: components["schemas"]["DateTime"]; source_id: components["schemas"]["SourceId"]};
    /** @enum {string} */
    SourceType: "Document" | "Image" | "Video" | "Questionnaire";
    SourceUsagePath: {source_id: components["schemas"]["SourceId"]; usage: components["schemas"]["SourceUsageType"]};
    /** @enum {string} */
    SourceUsageType: "Risk" | "Control" | "OperatingEffectiveness";
    SourcedFact:
      | {
          content: components["schemas"]["Fact"];
          /** @enum {string} */
          type: "Fact";
        }
      | {
          content: components["schemas"]["FactTextMin"];
          /** @enum {string} */
          type: "FactText";
        };
    Sources: {
      document_sources: components["schemas"]["FactSourceDocument"][];
      question_sources: components["schemas"]["FactSourceQuestion"][];
      subgraph_sources: components["schemas"]["FactSourceEntity"][];
    };
    /** @enum {string} */
    Sso: "GSuite" | "Okta" | "AzureAD" | "None";
    StandaloneFile: {
      file: components["schemas"]["File"];
      sharing_classification: components["schemas"]["SharingClassification"];
      standalone_file_id: components["schemas"]["StandaloneFileId"];
    };
    StandaloneFileId: Nominal<string, "StandaloneFileId">;
    StandardFinding: {
      created: components["schemas"]["Actioned"];
      deleted?: components["schemas"]["Actioned"] | null;
      finding: string;
      implication: string;
      recommendations: string;
      standard_finding_id: components["schemas"]["StandardFindingId"];
      title: string;
    };
    /**
     * @description One candidate standard finding surfaced by the caller's vector
     *     search. `standard_finding_id` is what `apply_map_result` stamps
     *     onto the caller's `PopulateFinding`; `title` and `content` are
     *     what the agent renders when deciding the match.
     */
    StandardFindingCandidate: {
      content: string;
      standard_finding_id: components["schemas"]["StandardFindingId"];
      title: string;
    };
    StandardFindingId: Nominal<string, "StandardFindingId">;
    StandardFindingIdPath: {standard_finding_id: components["schemas"]["StandardFindingId"]};
    SubGraph: {
      entities: {[key: string]: components["schemas"]["GraphEntity"]};
      root_entity_ids: components["schemas"]["EntityId"][];
    };
    SubscribeRecord: {
      /** Format: email */
      email: string;
    };
    SubscribeRequest: {
      /** Format: email */
      email: string;
      metadata: components["schemas"]["SubscriberMetadata"];
    };
    Subscriber: {
      email: string;
      mail_subscription_id: components["schemas"]["MailSubscriptionId"];
      metadata: components["schemas"]["SubscriberMetadata"];
      subscribed_at?: components["schemas"]["DateTime"] | null;
      verified_at?: components["schemas"]["DateTime"] | null;
    };
    SubscriberMetadata: {company?: string | null; name?: string | null};
    /** @enum {string} */
    SubscriptionAction: "Verification" | "AlreadySubscribed" | "Resubscribe" | "RateLimited";
    /**
     * @description Configures the one `SuggestExtractionFields` agent run a test gets.
     *
     *     The test id is the whole configuration. Everything the run works from
     *     — the criteria, the sample's column schema, the fields already
     *     configured, the attached documents — is resolved when the prompt is
     *     built and when a tool executes, because nothing a proposal is checked
     *     against has to hold still for the life of the conversation: a field is
     *     addressed by the name the model proposes and a document by its
     *     engagement-wide source number, so no position and no minted id is
     *     being pinned.
     */
    SuggestExtractionFieldsFunction: {test_id: components["schemas"]["TestId"]};
    /** @enum {string} */
    SuggestionConfidence: "High" | "Medium" | "Low";
    SuggestionDocument: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      file: components["schemas"]["File"];
      status: components["schemas"]["SuggestionDocumentStatus"];
      suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
    };
    SuggestionDocumentId: Nominal<string, "SuggestionDocumentId">;
    SuggestionDocumentMin: {
      file: components["schemas"]["File"];
      suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
    };
    SuggestionDocumentPath: {
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      suggestion_document_id: components["schemas"]["SuggestionDocumentId"];
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    SuggestionDocumentStatus: "Extracting" | "ExtractionFailed" | "Unread" | "Read";
    /** @enum {string} */
    SystemAgentDomain: "ReviewAnswer";
    SystemAgentDomainPath: {domain: components["schemas"]["SystemAgentDomain"]};
    /** @enum {string} */
    SystemAgentRole:
      | "ReviewAnswerRelevance"
      | "ReviewAnswerAccuracy"
      | "ReviewAnswerSupportedByFact"
      | "ReviewAnswerClarity"
      | "ReviewAnswerCommercial"
      | "Custom";
    SystemAgentUser: {
      avatar_url?: components["schemas"]["Never"] | null;
      config: components["schemas"]["AgentConfig"];
      description: string;
      domain: components["schemas"]["SystemAgentDomain"];
      editable: boolean;
      name: string;
      primary_email?: components["schemas"]["Never"] | null;
      prompt: string;
      role: components["schemas"]["SystemAgentRole"];
      type_: components["schemas"]["UserTypeSystemAgent"];
      user_id: components["schemas"]["UserId"];
    };
    /** @enum {string} */
    SystemRole: "Admin" | "VendorToolkit" | "TPRM";
    /**
     * @description A population source whose raw bytes are a delimited table, as the model sees
     *     it: its identity, so a call reaching for it can be answered with where its
     *     rows already are, and the first rows it yielded.
     *
     *     The sample is what a recorded value is shaped against. A demonstrated format
     *     fixes dates, money and the shape of the identifier `lookup_row` matches on,
     *     which a described one cannot.
     */
    TabularPopulationSource: {
      /** @description This file's header row, in the order it lists them. */
      headers: string[];
      name: string;
      /**
       * @description The file's first data rows, each cell under the header at its own
       *     position.
       */
      sample_rows: string[][];
      source_id: components["schemas"]["SourceId"];
    };
    Task:
      | {
          content: components["schemas"]["QuestionnaireQuestionTask"];
          /** @enum {string} */
          type: "QuestionnaireQuestion";
        }
      | {
          content: components["schemas"]["AdHocQuestionTask"];
          /** @enum {string} */
          type: "AdHocQuestion";
        };
    Team: {
      deleted_at?: components["schemas"]["DateTime"] | null;
      description?: string | null;
      /** Format: int32 */
      member_count: number;
      name: string;
      team_id: components["schemas"]["TeamId"];
    };
    TeamId: Nominal<string, "TeamId">;
    TeamIdPath: {team_id: components["schemas"]["TeamId"]};
    TeamMin: {name: string; team_id: components["schemas"]["TeamId"]};
    TeamParams: {deleted?: boolean | null};
    TeamPermissionPath: {permission_id: components["schemas"]["RoleId"]; team_id: components["schemas"]["TeamId"]};
    TeamUserPath: {team_id: components["schemas"]["TeamId"]; user_id: components["schemas"]["UserId"]};
    /**
     * @description Reason a conversation terminated. Stored in the payload of the
     *     `Terminal` event and surfaced through the continuation (if any).
     */
    TerminalOutcome:
      | {
          /** @enum {string} */
          type: "Success";
        }
      | {
          content: {error: string};
          /** @enum {string} */
          type: "Failed";
        }
      | {
          /** @enum {string} */
          type: "BudgetExceeded";
        }
      | {
          /** @enum {string} */
          type: "Cancelled";
        };
    /**
     * @description A test with its resolved sample, template, and config. `criteria`,
     *     `extraction_fields`, and `levels` are the *resolved* values (override applied
     *     over the pinned version, or over [`TestTemplateConfig::authored`] when there
     *     is none, via [`resolve_config`]).
     */
    Test: {
      ai_concluded_at?: components["schemas"]["DateTime"] | null;
      ai_conclusion?: components["schemas"]["TestConclusion"] | null;
      conclusion: components["schemas"]["TestConclusionOverride"];
      created_at: components["schemas"]["DateTime"];
      criteria: components["schemas"]["TestCriterion"][];
      description?: string | null;
      /**
       * @description `committed_at IS NULL` — minted but not committed. No frozen snapshot
       *     exists and the test is inert: it does not lock its sample and counts
       *     toward no rollup. Distinct from
       *     [`Self::is_locked`], which marks the *end* of a committed test's life.
       */
      draft: boolean;
      /** @description Resolved from [`Self::effective_rating`] against `levels`. */
      effectiveness?: components["schemas"]["ColoredText"] | null;
      engagement: components["schemas"]["EngagementMin"];
      extraction_fields: components["schemas"]["ResolvedExtractionField"][];
      /** @description `locked_at.is_some()` — the "Done" marker. */
      is_locked: boolean;
      /** Format: int64 */
      item_count: number;
      levels: components["schemas"]["ColoredText"][];
      name: string;
      overridden?: components["schemas"]["Actioned"] | null;
      /**
       * @description The column definitions [`TestMaterializedItem::population_data`] is keyed
       *     by, snapshotted with the items. Empty on a draft, which has materialized
       *     nothing.
       */
      population_fields: components["schemas"]["PopulationField"][];
      /**
       * @description `None` while the test is a draft that has not been pointed at a sample; a
       *     committed test always has one.
       */
      sample?: components["schemas"]["SampleMin"] | null;
      steps: components["schemas"]["TestStepStates"];
      /**
       * @description The pinned template version, the one current when the template was
       *     attached. `None` until a template is attached; an authored test never
       *     has one.
       */
      template?: components["schemas"]["TestTemplateRef"] | null;
      /**
       * @description The pinned template version's immutable config, *before* this test's sparse
       *     override is applied. Lets the UI diff the resolved `criteria`/
       *     `extraction_fields`/`levels` against the template to show per-criterion
       *     "Modified" state and offer reset-to-template. `None` exactly when
       *     `template` is `None`: an authored test (see [`TestConfigOverride`]).
       */
      template_config?: components["schemas"]["TestTemplateConfig"] | null;
      test_id: components["schemas"]["TestId"];
      updated_at: components["schemas"]["DateTime"];
    };
    /**
     * @description The conclude task's lane, stored as JSON in `tprm.test.ai_conclusion`.
     *     `rating` indexes the resolved `levels` (1-based, `1..=levels.len()`).
     */
    TestConclusion: {
      justification: string;
      /** Format: int32 */
      rating: number;
    };
    /**
     * @description Projected over `tprm.test.conclusion_rating` and `conclusion_justification`,
     *     never itself persisted. `None` is a half the auditor has not claimed;
     *     `Some("")` is a justification they deliberately left blank.
     */
    TestConclusionOverride: {
      justification?: string | null;
      /** Format: int32 */
      rating?: number | null;
    };
    /**
     * @description A single Pass/Fail/Unknown criterion the test evaluates per item. `ai_hint`
     *     guides the evaluation. Carries a stable [`TestCriterionId`] so the per-test
     *     override map and per-item results key off it.
     */
    TestCriterion: {
      ai_hint?: string | null;
      criterion_id: components["schemas"]["TestCriterionId"];
      name: string;
      /**
       * Format: int32
       * @description Deterministic display order within the test.
       */
      sort_order: number;
    };
    TestCriterionId: Nominal<string, "TestCriterionId">;
    TestCriterionPath: {
      criterion_id: components["schemas"]["TestCriterionId"];
      test_id: components["schemas"]["TestId"];
    };
    /**
     * @description An evidence source attached to a test. `mapped_item_count == 0` means no
     *     mapping ties the source to any item yet — the tray.
     */
    TestEvidence: {
      /** Format: int64 */
      mapped_item_count: number;
      /** @description The source resolved at the version the attachment pinned. */
      source: components["schemas"]["SourceMin"];
      test_evidence_id: components["schemas"]["TestEvidenceId"];
    };
    TestEvidenceId: Nominal<string, "TestEvidenceId">;
    TestEvidencePath: {evidence_id: components["schemas"]["TestEvidenceId"]; test_id: components["schemas"]["TestId"]};
    TestExtractionFieldId: Nominal<string, "TestExtractionFieldId">;
    TestExtractionFieldPath: {
      field_id: components["schemas"]["TestExtractionFieldId"];
      test_id: components["schemas"]["TestId"];
    };
    TestId: Nominal<string, "TestId">;
    TestIdPath: {test_id: components["schemas"]["TestId"]};
    TestItemId: Nominal<string, "TestItemId">;
    /**
     * @description A single materialized item: the frozen population snapshot plus the
     *     evidence-extracted layer, per-criterion results, and mapped evidence.
     *     `test_item_id` is the item's identity within the test, minted at
     *     materialization — the snapshot never references the mutable sample tables.
     */
    TestMaterializedItem: {
      /** @description Evidence mapped to this item, resolved at each source's pinned `as_of`. */
      evidence: components["schemas"]["SourceMin"][];
      extracted_at?: components["schemas"]["DateTime"] | null;
      /**
       * @description The values the extract step read out of this item's mapped evidence,
       *     keyed by field. A field the run did not find is absent from the map, so
       *     "found two of five fields" needs no encoding of its own.
       *
       *     Read together with `extracted_at`, which separates a **gap** from a
       *     **finding** — the same blank cell in the workpaper, but different next
       *     actions for the auditor:
       *
       *     | `extracted_at` | `extracted_data` | meaning |
       *     |---|---|---|
       *     | `None` | `None` | not run for this item, or skipped for having no mapped evidence — a gap; map something to it |
       *     | `Some` | `Some({})` | evidence was read and none of the configured fields were in it — a possible exception |
       *     | `Some` | `Some(values)` | values found |
       *
       *     Unmapping an item's last document returns it to the first row: the
       *     extracted layer is cleared with the final claim, so a value never
       *     outlives the evidence that was behind it.
       */
      extracted_data?: {[key: string]: components["schemas"]["ExtractedValue"]} | null;
      /**
       * @description The fields the run that wrote `extracted_data` was asked for, written
       *     with it and cleared with it. A field in this set and absent from the
       *     map was looked for and not stated. A field absent from this set was
       *     added after the run, so its blank cell carries no claim either way,
       *     which the table above cannot express on its own. A stamped item with
       *     no set reads as asked for nothing.
       */
      extracted_field_ids?: components["schemas"]["TestExtractionFieldId"][] | null;
      /** Format: int32 */
      item_index: number;
      /** @description SNAPSHOT of the population row's data at materialization. */
      population_data: {[key: string]: IValue};
      /** @description `None` until the run step has produced results for this item. */
      results?: {[key: string]: components["schemas"]["CriterionResult"]} | null;
      test_item_id: components["schemas"]["TestItemId"];
    };
    /**
     * @description Lightweight test summary for the library listing and the sample's "Linked
     *     tests" tab.
     */
    TestMin: {
      created_at: components["schemas"]["DateTime"];
      description?: string | null;
      /**
       * @description `committed_at IS NULL` — minted but not committed. Inert: it locks
       *     nothing and counts toward no rollup.
       */
      draft: boolean;
      effectiveness?: components["schemas"]["ColoredText"] | null;
      /**
       * Format: int32
       * @description The effective rating (1-based), shown as the effectiveness badge's
       *     fallback when the resolved level has no label (the default colour-only
       *     scale). `Some` exactly when `effectiveness` is `Some`.
       */
      effectiveness_rating?: number | null;
      is_locked: boolean;
      /** Format: int64 */
      item_count: number;
      /**
       * Format: int64
       * @description How many distinct controls lean on this test through an operating-effectiveness
       *     basis item. Set-aside items and deleted assessments don't count.
       */
      linked_control_count: number;
      name: string;
      /**
       * @description `None` — with `sample_name` and `sample_method` — while the test is a
       *     draft that has not been pointed at a sample.
       */
      sample_id?: components["schemas"]["SampleId"] | null;
      /** @description The pinned sample's drawing method, for the list's sample subtitle. */
      sample_method?: components["schemas"]["SampleMethod"] | null;
      sample_name?: string | null;
      /**
       * Format: int64
       * @description The pinned sample's item count, for the list's sample subtitle. Distinct
       *     from `item_count` (this test's *materialized* items). Zero with no
       *     sample.
       */
      sample_size: number;
      test_id: components["schemas"]["TestId"];
    };
    /**
     * @description Counts over a test's result set, counted before the conversation
     *     starts. They appear verbatim in the justification the model writes, and a
     *     model asked to count several hundred rows itself will eventually miscount
     *     them.
     *
     *     `tested`, `exceptions` and `unknowns` partition nothing: an item is an
     *     exception when any criterion failed and an unknown when none failed but at
     *     least one criterion was undecided, so the two are disjoint but neither
     *     covers an item whose criteria all passed.
     */
    TestResultCounts: {
      /**
       * Format: int64
       * @description Items with at least one failed criterion.
       */
      exceptions: number;
      /**
       * Format: int64
       * @description Items in the test's frozen sample.
       */
      items: number;
      /**
       * Format: int64
       * @description Items extraction has never run over — a gap in coverage the auditor
       *     closes by mapping evidence, not a finding about the control.
       */
      never_extracted: number;
      /**
       * Format: int64
       * @description Items the evaluation step recorded results for.
       */
      tested: number;
      /**
       * Format: int64
       * @description Items with no failed criterion and at least one Unknown.
       */
      unknowns: number;
    };
    /**
     * @description A step's live state paired with whether it has ever been enqueued.
     *
     *     The two are independent: [`Self::state`] is derived from a running task and
     *     from data presence, so it falls back to [`TestStepState::NotStarted`] for a
     *     run that failed or produced nothing, and only [`Self::started_at`]
     *     distinguishes those from a step nobody has ever run.
     */
    TestStepProgress: {
      /**
       * @description Stamped when the step starts, never cleared, so it is monotone across
       *     re-runs. Every step carries one, read or not, so the five records share
       *     a shape.
       */
      started_at?: components["schemas"]["DateTime"] | null;
      state: components["schemas"]["TestStepState"];
    };
    /**
     * @description Per-step processing state, mirroring
     *     [`super::population::PopulationProcessingState`]. The running step is a
     *     single whole-test `EngagementLock::Test` task; "done-ness" is
     *     derived from data presence, so [`Self::Completed`] carries no
     *     timestamp.
     */
    TestStepState:
      | {
          /** @enum {string} */
          type: "NotStarted";
        }
      | {
          background_task?: components["schemas"]["PendingBackgroundTask"] | null;
          /** @enum {string} */
          type: "Processing";
        }
      | {
          /** @enum {string} */
          type: "Completed";
        }
      | {
          error: string;
          /** @enum {string} */
          type: "Error";
        };
    /** @description Per-step states for the gated workflow, one field per step left-to-right. */
    TestStepStates: {
      conclude: components["schemas"]["TestStepProgress"];
      extract: components["schemas"]["TestStepProgress"];
      map_evidence: components["schemas"]["TestStepProgress"];
      run_results: components["schemas"]["TestStepProgress"];
      suggest_fields: components["schemas"]["TestStepProgress"];
    };
    /** @description A test template and its versions. */
    TestTemplate: {
      /**
       * @description True when at least one test (live or deleted) pins any version of this
       *     template; deletion is blocked while in use.
       */
      in_use: boolean;
      name: string;
      test_template_id: components["schemas"]["TestTemplateId"];
      /** @description Versions in ascending `version` order. */
      versions: components["schemas"]["TestTemplateVersionMin"][];
    };
    /**
     * @description The immutable per-version body of a test template. Frozen once any test pins
     *     it; edits append a new version rather than mutating this one. Persisted as
     *     JSONB in `tprm.test_template_version.config`, so adding fields here is
     *     code-only — old versions deserialize forever.
     *
     *     `extraction_fields` shares [`ExtractionField`] with the per-test override, so
     *     each carries an authorship stamp a template never sets: authorship is a
     *     test's provenance, and a version has one author for the whole config.
     */
    TestTemplateConfig: {
      /**
       * @description Extra instructions appended to the prompt that concludes a test drawn
       *     from this template; `None` leaves that prompt at its default. A template
       *     author's field rather than an auditor's, so no
       *     [`super::test::TestConfigOverride`] entry answers it.
       * @default null
       */
      conclusion_prompt: string | null;
      criteria: components["schemas"]["TestCriterion"][];
      extraction_fields: components["schemas"]["ExtractionField"][];
      /** @description Ordered scoring scale (lowest to highest); `num_levels = levels.len()`. */
      levels: components["schemas"]["ColoredText"][];
    };
    TestTemplateId: Nominal<string, "TestTemplateId">;
    TestTemplateIdPath: {test_template_id: components["schemas"]["TestTemplateId"]};
    /** @description The pinned template identity + version a test was drawn from. */
    TestTemplateRef: {
      name: string;
      test_template_id: components["schemas"]["TestTemplateId"];
      /** Format: int32 */
      version: number;
    };
    TestTemplateVersionId: Nominal<string, "TestTemplateVersionId">;
    /** @description Lightweight summary of one immutable template version. */
    TestTemplateVersionMin: {
      created_at: components["schemas"]["DateTime"];
      test_template_version_id: components["schemas"]["TestTemplateVersionId"];
      /**
       * Format: int32
       * @description 1-based, monotonic per template.
       */
      version: number;
    };
    TextAnswerConfig: {
      /** Format: int32 */
      word_count_limit?: number | null;
    };
    TextElement: {
      /**
       * @default {
       *       "bold": null,
       *       "italic": null
       *     }
       */
      attributes: components["schemas"]["RichTextAttributes"];
      text: string;
    };
    ThirdParty: {
      access_level?: components["schemas"]["PrivateResourceAccess"] | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      due_date?: components["schemas"]["DateTime"] | null;
      external_id?: string | null;
      name: string;
      /** Format: int32 */
      num_assessments: number;
      owner?: components["schemas"]["Owner"] | null;
      portal_summary: components["schemas"]["PortalSummary"];
      private?: components["schemas"]["PrivateResourceMin"] | null;
      /** Format: float */
      score: number;
      source_counts: components["schemas"]["SourceCounts"];
      tags: components["schemas"]["ThirdPartyTagMin"][];
      third_party_id: components["schemas"]["ThirdPartyId"];
      tier?: components["schemas"]["ThirdPartyTierMin"] | null;
      url: string;
    };
    ThirdPartyId: Nominal<string, "ThirdPartyId">;
    ThirdPartyIdPath: {third_party_id: components["schemas"]["ThirdPartyId"]};
    ThirdPartyIdPath2: {third_party_id: components["schemas"]["ThirdPartyId"]};
    ThirdPartyIdUserIdPath: {
      third_party_id: components["schemas"]["ThirdPartyId"];
      user_id: components["schemas"]["UserId"];
    };
    ThirdPartyMin: {
      access_level?: components["schemas"]["PrivateResourceAccess"] | null;
      name: string;
      third_party_id: components["schemas"]["ThirdPartyId"];
    };
    ThirdPartyNotificationMin: {name: string; third_party_id: components["schemas"]["ThirdPartyId"]};
    ThirdPartyTagId: Nominal<string, "ThirdPartyTagId">;
    ThirdPartyTagIdPath: {tag_id: components["schemas"]["ThirdPartyTagId"]};
    ThirdPartyTagMin: {color: string; tag_id: components["schemas"]["ThirdPartyTagId"]; title: string};
    ThirdPartyTierId: Nominal<string, "ThirdPartyTierId">;
    ThirdPartyTierIdPath: {tier_id: components["schemas"]["ThirdPartyTierId"]};
    ThirdPartyTierMin: {
      color: string;
      /** Format: int32 */
      ordinal: number;
      tier_id: components["schemas"]["ThirdPartyTierId"];
      title: string;
    };
    Tier: {
      action: components["schemas"]["ComplexityAction"];
      justification?: string | null;
      tier_id: components["schemas"]["ComplexityTierId"];
      tier_name: string;
    };
    TierAnswer: {
      at?: components["schemas"]["DateTime"] | null;
      provenance: components["schemas"]["AnswerProvenance"];
      tier: components["schemas"]["ComplexityTierMin"];
    };
    /** @description The member's tier as a reader sees it. Nothing proposes a tier, so there is no suggestion. */
    TierAnswers: {
      history: components["schemas"]["TierHistoryEntry"][];
      value?: components["schemas"]["TierAnswer"] | null;
    };
    TierAssessmentAutorun: {
      complexity_tier: components["schemas"]["ComplexityTierMin"];
      framework: components["schemas"]["FrameworkMin"];
      framework_version: components["schemas"]["FrameworkVersionMin"];
      tier_assessment_autorun_id: components["schemas"]["TierAssessmentAutorunId"];
    };
    TierAssessmentAutorunId: Nominal<string, "TierAssessmentAutorunId">;
    TierAssessmentAutorunIdPath: {
      autorun_id: components["schemas"]["TierAssessmentAutorunId"];
      model_id: components["schemas"]["ComplexityModelId"];
      version_id: components["schemas"]["ComplexityModelVersionId"];
    };
    TierHistoryEntry: {
      at?: components["schemas"]["DateTime"] | null;
      provenance: components["schemas"]["AnswerProvenance"];
      reason: components["schemas"]["AnswerHistoryReason"];
      tier: components["schemas"]["ComplexityTierMin"];
    };
    TodoFunctionArgs: {items: components["schemas"]["AiTodoItem"][]};
    ToolsConfig: {
      password_manager: components["schemas"]["PasswordManager"];
      password_manager_instructions: string;
      sso: components["schemas"]["Sso"];
      sso_instructions: string;
    };
    TprmAccountPreferences: {
      /**
       * @description Seeds the Private toggle when a client is created without an explicit choice.
       * @default false
       */
      default_client_private: boolean;
      /**
       * @description Rejects a client whose external ID is missing or blank.
       * @default false
       */
      require_client_external_id: boolean;
    };
    /** @enum {string} */
    TprmAiSuggestionSensitivity: "Lenient" | "Balanced" | "Strict";
    /**
     * @description Tunable levers for the AI "Suggested Improvements" feature (the per-answer
     *     `AssessQuestion` feedback shown in the client portal).
     *
     *     The same object lives at two levels — on the questionnaire template (the
     *     default for all its questions) and on an individual question (an override).
     *     Every field is optional so each level overrides only what it sets;
     *     unset fields fall back to the questionnaire default, then to a built-in
     *     default. Resolve with [`TprmAiSuggestionsConfig::resolve`].
     *
     *     Authored in account presets only; view-only in the app.
     */
    TprmAiSuggestionsConfig: {
      /** @description Whether AI "Suggested Improvements" run at all. Built-in default: `true`. */
      enabled?: boolean | null;
      /**
       * Format: int32
       * @description Cap on the number of improvement points returned in one assessment.
       *     `None` (built-in default) means no cap.
       */
      max_points?: number | null;
      /**
       * Format: int32
       * @description Max assessment rounds per question across answer edits. Once a question
       *     has been assessed this many times, edits no longer trigger a fresh
       *     suggestion. `None` (built-in default) means unlimited; `Some(1)` is
       *     one-shot.
       */
      max_rounds?: number | null;
      /**
       * @description How strictly the AI flags missing information. Built-in default:
       *     [`TprmAiSuggestionSensitivity::Lenient`].
       */
      sensitivity?: components["schemas"]["TprmAiSuggestionSensitivity"] | null;
    };
    TprmAnswer:
      | {
          content: components["schemas"]["TprmTextAnswer"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmFilesAnswer"];
          /** @enum {string} */
          type: "Files";
        }
      | {
          content: components["schemas"]["TprmSelectAnswer"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmSubQuestionnairesAnswer"];
          /** @enum {string} */
          type: "SubQuestionnaires";
        }
      | {
          content: components["schemas"]["TprmTableAnswer"];
          /** @enum {string} */
          type: "Table";
        }
      | {
          /** @enum {string} */
          type: "NotApplicable";
        };
    /** @description This is serialized as JSON to the database, so be careful with changes. */
    TprmAnswerConfig:
      | {
          content: components["schemas"]["TprmTextAnswerConfig"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmFilesAnswerConfig"];
          /** @enum {string} */
          type: "Files";
        }
      | {
          content: components["schemas"]["TprmSelectAnswerConfig"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmSubQuestionnairesAnswerConfig"];
          /** @enum {string} */
          type: "SubQuestionnaires";
        }
      | {
          content: components["schemas"]["TprmTableAnswerConfig"];
          /** @enum {string} */
          type: "Table";
        };
    /** @description The suggestion a response was filled from. */
    TprmAppliedSuggestion: {
      consolidated_suggestion_id: components["schemas"]["ConsolidatedSuggestionId"];
      /** @description A later run has written a newer answer for the same question and entity. */
      outdated: boolean;
      /** @description The past questionnaire it was rolled over from. `None` for a document answer. */
      source_external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
    };
    TprmAsset: {asset_id: components["schemas"]["TprmAssetId"]; description: string; name: string};
    TprmAssetId: Nominal<string, "TprmAssetId">;
    /**
     * @description The type + config of a table column. A strict subset of `TprmAnswerConfig`,
     *     reusing the same discriminants and inner config structs.
     */
    TprmColumnConfig:
      | {
          content: components["schemas"]["TprmTextAnswerConfig"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmSelectAnswerConfig"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmFilesAnswerConfig"];
          /** @enum {string} */
          type: "Files";
        };
    /**
     * @description A single cell value. A strict subset of `TprmAnswer` reusing the same
     *     per-type answer structs, so a cell serializes identically to a normal answer
     *     of that type.
     */
    TprmColumnValue:
      | {
          content: components["schemas"]["TprmTextAnswer"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmSelectAnswer"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmFilesAnswer"];
          /** @enum {string} */
          type: "Files";
        };
    /** @description This is serialized as JSON to the database, so be careful with changes. */
    TprmCondition:
      | {
          content: boolean;
          /** @enum {string} */
          type: "Literal";
        }
      | {
          content: {
            /** @description How the answer's selected values are compared against `values`. */
            criteria: components["schemas"]["TprmConditionSelectMatchesCriteria"];
            /** @description The `key` of the select question whose answer is being tested. */
            question_template_key: string;
            /** @description The option values (matching select option `value`s) to compare the answer against. */
            values: string[];
          };
          /** @enum {string} */
          type: "SelectMatches";
        }
      | {
          content: {
            /** @description How the selected-value count is compared against `value`. */
            operator: components["schemas"]["TprmConditionComparisonOperator"];
            /** @description The `key` of the question whose selected-value count is being tested. */
            question_template_key: string;
            /**
             * Format: int32
             * @description The threshold count the operator compares the answer's selection count against.
             */
            value: number;
          };
          /** @enum {string} */
          type: "Count";
        }
      | {
          content: components["schemas"]["TprmCondition"][];
          /** @enum {string} */
          type: "And";
        }
      | {
          content: components["schemas"]["TprmCondition"][];
          /** @enum {string} */
          type: "Or";
        }
      | {
          content: components["schemas"]["TprmCondition"];
          /** @enum {string} */
          type: "Not";
        };
    /** @description This is serialized as JSON to the database, so be careful with changes. */
    TprmConditionComparisonOperator:
      | "Equal"
      | "NotEqual"
      | "LessThan"
      | "LessThanOrEqual"
      | "GreaterThan"
      | "GreaterThanOrEqual";
    /** @description This is serialized as JSON to the database, so be careful with changes. */
    TprmConditionSelectMatchesCriteria: "Exact" | "ContainsAll" | "ContainsOnly" | "ContainsAny" | "NotContainsAny";
    TprmExternalAnswer:
      | {
          content: components["schemas"]["TprmExternalTextAnswer"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmExternalFilesAnswer"];
          /** @enum {string} */
          type: "Files";
        }
      | {
          content: components["schemas"]["TprmExternalSelectAnswer"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmExternalSubQuestionnairesAnswer"];
          /** @enum {string} */
          type: "SubQuestionnaires";
        }
      | {
          content: components["schemas"]["TprmExternalTableAnswer"];
          /** @enum {string} */
          type: "Table";
        }
      | {
          /** @enum {string} */
          type: "NotApplicable";
        };
    TprmExternalColumnValue:
      | {
          content: components["schemas"]["TprmExternalTextAnswer"];
          /** @enum {string} */
          type: "Text";
        }
      | {
          content: components["schemas"]["TprmExternalSelectAnswer"];
          /** @enum {string} */
          type: "Select";
        }
      | {
          content: components["schemas"]["TprmExternalFilesAnswer"];
          /** @enum {string} */
          type: "Files";
        };
    TprmExternalFilesAnswer: {file_ids: components["schemas"]["FileId"][]};
    TprmExternalQuestionnaire: {
      client_visible: boolean;
      created_at: components["schemas"]["DateTime"];
      engagement: components["schemas"]["Engagement"];
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      label: string;
      locked_at?: components["schemas"]["DateTime"] | null;
      parent_external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      phase: components["schemas"]["TprmExternalQuestionnairePhase"];
      referenced_files: {[key: string]: components["schemas"]["File"]};
      referenced_questionnaires: {[key: string]: components["schemas"]["TprmExternalQuestionnaireMin"]};
      responses: {[key: string]: components["schemas"]["TprmExternalResponse"]};
      submitted_at?: components["schemas"]["DateTime"] | null;
      template: components["schemas"]["TprmQuestionnaireTemplate"];
      updated_at?: components["schemas"]["DateTime"] | null;
      use_latest_version: boolean;
    };
    /** @description This type is exposed to the external API. */
    TprmExternalQuestionnaireExternal: {
      created_at: components["schemas"]["DateTime"];
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      label: string;
      locked_at?: components["schemas"]["DateTime"] | null;
      parent_external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      referenced_files: {[key: string]: components["schemas"]["File"]};
      referenced_questionnaires: {[key: string]: components["schemas"]["TprmExternalQuestionnaireExternal"]};
      responses: {[key: string]: components["schemas"]["TprmExternalResponse"]};
      /** @description ID of the currently-running `SuggestFromDocuments` background task */
      suggestion_generation_task_id?: components["schemas"]["BackgroundTaskId"] | null;
      template: components["schemas"]["TprmQuestionnaireTemplateMin"];
      updated_at?: components["schemas"]["DateTime"] | null;
    };
    TprmExternalQuestionnaireId: Nominal<string, "TprmExternalQuestionnaireId">;
    TprmExternalQuestionnaireMin: {
      client_visible: boolean;
      created_at: components["schemas"]["DateTime"];
      engagement: components["schemas"]["Engagement"];
      external_questionnaire_id: components["schemas"]["TprmExternalQuestionnaireId"];
      /**
       * @description Whether the template has any auditor (scoping) questions — i.e. whether a
       *     scoping form exists to view/edit, in any phase.
       */
      has_auditor_questions: boolean;
      label: string;
      locked_at?: components["schemas"]["DateTime"] | null;
      parent_external_questionnaire_id?: components["schemas"]["TprmExternalQuestionnaireId"] | null;
      phase: components["schemas"]["TprmExternalQuestionnairePhase"];
      submitted_at?: components["schemas"]["DateTime"] | null;
      template: components["schemas"]["TprmQuestionnaireTemplateMin"];
      updated_at?: components["schemas"]["DateTime"] | null;
    };
    /**
     * @description Which phase of its lifecycle a questionnaire is in. A template that declares
     *     auditor (scoping) questions starts in `AuditorScoping`, where firm staff
     *     complete the internal scoping form and the client is not yet involved.
     *     Releasing it moves it to `WithClient`, which notifies the client and is the
     *     only phase in which the client can access it. A template with no auditor
     *     questions is created directly in `WithClient`.
     * @enum {string}
     */
    TprmExternalQuestionnairePhase: "AuditorScoping" | "WithClient";
    TprmExternalResponse: {
      /**
       * @description True when the automatic AI assessor will no longer run for this question
       *     because the resolved `max_rounds` limit has been reached (the feature is
       *     enabled and the question has AI guidance). Manual "Request feedback" is
       *     then the only way to get a fresh suggestion.
       */
      ai_assessment_rounds_exhausted: boolean;
      ai_feedback?: string | null;
      ai_validation_task?: components["schemas"]["PendingBackgroundTask"] | null;
      answer: components["schemas"]["TprmExternalAnswer"];
      /**
       * @description The suggestion this was filled from, until that suggestion is deleted; from
       *     then on the answer reads as the responder's own.
       */
      applied_suggestion?: components["schemas"]["TprmAppliedSuggestion"] | null;
      related_questions: components["schemas"]["TprmRelatedQuestionSummary"][];
      submitted_at?: components["schemas"]["DateTime"] | null;
    };
    TprmExternalSelectAnswer: {selected: string[]};
    TprmExternalSubQuestionnairesAnswer: {questionnaire_ids: components["schemas"]["TprmExternalQuestionnaireId"][]};
    TprmExternalTableAnswer: {rows: components["schemas"]["TprmExternalTableRow"][]};
    TprmExternalTableRow: {
      id: components["schemas"]["TprmTableRowId"];
      values: {[key: string]: components["schemas"]["TprmExternalColumnValue"]};
    };
    TprmExternalTextAnswer: {text: string};
    TprmFilesAnswer: {source_ids: components["schemas"]["SourceId"][]};
    TprmFilesAnswerConfig: {
      /**
       * @description When files are uploaded as answers to this question, this determines
       *     whether the created sources should be visible in control evaluations.
       *     Defaults to `true` if not specified.
       */
      control_visible?: boolean | null;
      /**
       * Format: int32
       * @description Maximum number of files that may be uploaded as the answer; omit for no upper bound.
       */
      max_number?: number | null;
      /**
       * Format: int32
       * @description Minimum number of files that must be uploaded as the answer; omit for no lower bound.
       */
      min_number?: number | null;
      /**
       * @description When files are uploaded as answers to this question, this determines
       *     whether the created sources should be visible in risk assessments.
       *     Defaults to `true` if not specified.
       */
      risk_visible?: boolean | null;
    };
    /**
     * @description Who answers a question. `Auditor` questions are the internal "scoping" form:
     *     firm staff complete them before the questionnaire is released to the client,
     *     and they are never shown to the client. `Client` questions are the normal
     *     externally-answered questions. Client-question conditions may reference
     *     auditor questions by `key`, which is how scoping answers gate what the client
     *     is asked.
     * @enum {string}
     */
    TprmQuestionAudience: "Client" | "Auditor";
    TprmQuestionTemplate: {
      /**
       * @description Guidance for the AI when suggesting answers from uploaded documents
       *     (`SuggestFromDocuments`). Contrast `ai_guidance`, which steers the
       *     "Suggested Improvements" feedback on a manually written answer.
       */
      ai_answer_suggestion_guidance?: string | null;
      ai_guidance?: string | null;
      /**
       * @description Per-question override of the AI "Suggested Improvements" config. Unset
       *     fields fall back to the questionnaire-level default. See
       *     [`TprmAiSuggestionsConfig`].
       */
      ai_suggestions_config?: components["schemas"]["TprmAiSuggestionsConfig"] | null;
      allow_not_applicable: boolean;
      answer_config: components["schemas"]["TprmAnswerConfig"];
      /**
       * @description Whether this question is answered internally by the auditor (scoping) or
       *     by the external client.
       */
      audience: components["schemas"]["TprmQuestionAudience"];
      condition?: components["schemas"]["TprmCondition"] | null;
      context_question_keys?: string[] | null;
      deleted?: components["schemas"]["Actioned"] | null;
      guidance?: string | null;
      is_required: boolean;
      key?: string | null;
      question_number?: string | null;
      question_template_id: components["schemas"]["TprmQuestionTemplateId"];
      /**
       * @description When set, this question (which must live on a subquestionnaire template)
       *     declares an instance-level "related question" pointing at a question on
       *     the root questionnaire template. The reference is stored as a FK to
       *     `question_template`; preset authors write a `related_root_question_key`
       *     string which is resolved at preset-load time. At instantiation, a row is
       *     inserted into `tprm.external_response_related_question` linking the
       *     child instance question to the root instance question — that join table
       *     is what Collect and the AI assessor read.
       */
      related_root_question_template_id?: components["schemas"]["TprmQuestionTemplateId"] | null;
      text: string;
    };
    TprmQuestionTemplateId: Nominal<string, "TprmQuestionTemplateId">;
    TprmQuestionnaire: {
      questionnaire_id: components["schemas"]["TprmQuestionnaireId"];
      referenced_sources: {[key: string]: components["schemas"]["SourceMin"]};
      responses: {[key: string]: components["schemas"]["TprmResponse"]};
      template: components["schemas"]["TprmQuestionnaireTemplate"];
    };
    TprmQuestionnaireId: Nominal<string, "TprmQuestionnaireId">;
    TprmQuestionnaireMin: {
      questionnaire_id: components["schemas"]["TprmQuestionnaireId"];
      template: components["schemas"]["TprmQuestionnaireTemplateMin"];
    };
    TprmQuestionnaireModel: {
      created_at: components["schemas"]["DateTime"];
      name: string;
      questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
      versions: components["schemas"]["TprmQuestionnaireTemplateMin"][];
    };
    TprmQuestionnaireModelId: Nominal<string, "TprmQuestionnaireModelId">;
    TprmQuestionnaireModelMin: {
      name: string;
      questionnaire_model_id: components["schemas"]["TprmQuestionnaireModelId"];
    };
    /** @enum {string} */
    TprmQuestionnaireNumberingMode: "AutoContinuous" | "AutoStable" | "Manual";
    TprmQuestionnaireTemplate: {
      /**
       * @description Questionnaire-level default for the AI "Suggested Improvements" config,
       *     overridable per question. See [`TprmAiSuggestionsConfig`].
       */
      ai_suggestions_config?: components["schemas"]["TprmAiSuggestionsConfig"] | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      model: components["schemas"]["TprmQuestionnaireModelMin"];
      name: string;
      numbering_mode: components["schemas"]["TprmQuestionnaireNumberingMode"];
      parent_questionnaire_template?: components["schemas"]["TprmQuestionnaireTemplateMin"] | null;
      questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
      referenced_templates: {[key: string]: components["schemas"]["TprmQuestionnaireTemplate"]};
      sections: components["schemas"]["TprmSectionTemplate"][];
      suggestions_enabled: boolean;
      tiering_criteria: components["schemas"]["TprmTierCriterion"][];
    };
    TprmQuestionnaireTemplateId: Nominal<string, "TprmQuestionnaireTemplateId">;
    TprmQuestionnaireTemplateMin: {
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      model: components["schemas"]["TprmQuestionnaireModelMin"];
      name: string;
      numbering_mode: components["schemas"]["TprmQuestionnaireNumberingMode"];
      parent_questionnaire_template_id?: components["schemas"]["TprmQuestionnaireTemplateId"] | null;
      questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
      suggestions_enabled: boolean;
    };
    /**
     * @description One related question + its current answer, surfaced for an instance
     *     question. Server-flattened so the frontend doesn't need to rerender per
     *     answer type.
     *
     *     `reusable_answer` is populated only when the related question's
     *     `answer_config` matches the source sub-question's `answer_config` closely
     *     enough to support a verbatim copy via "Reuse this answer".
     */
    TprmRelatedQuestionSummary: {
      answer_text: string;
      question_text: string;
      reusable_answer?: components["schemas"]["TprmExternalAnswer"] | null;
    };
    /** @enum {string} */
    TprmReportChartKind:
      | "ItAssessmentControlsSummaryBarPlot"
      | "ItAssessmentControlsSummaryRadarPlot"
      | "ItAssessmentRisksSummaryBarPlot"
      | "ItAssessmentControlDesignsRadarPlot"
      | "ItAssessmentControlImplementationsRadarPlot";
    TprmReportTemplate: {
      ai_prompts: {[key: string]: string};
      name: string;
      portal_enabled: boolean;
      report_template_id: components["schemas"]["TprmReportTemplateId"];
      type_: components["schemas"]["TprmReportTemplateType"];
    };
    TprmReportTemplateId: Nominal<string, "TprmReportTemplateId">;
    /** @enum {string} */
    TprmReportTemplateType:
      | "Management"
      | "ItAssessment"
      | "ItAssessmentNoRisks"
      | "Audit"
      | "AuditNoRisks"
      | "ClientFacingFindings"
      | "InternalFindings"
      | "OperatingEffectiveness"
      | "HealthCheck"
      | "HealthCheckExecutiveSummary"
      | "HlbMannJuddAsa315ItEnvironmentReviewDocx"
      | "MinimalDocx"
      | "MinimalXlsx"
      | "EngagementSummary"
      | "ProcessSteps"
      | "RiskRegister"
      | "ItgcDetailed"
      | "MercerHoleItgcPartnerDocx"
      | "ForvisMazarsNlWorkprogram"
      | "ForvisMazarsNlAuditReport"
      | "VanReeRiskReport"
      | "LovewellBlakeProcessUnderstanding"
      | "FalkIsa315ItAuditDocx"
      | "GenericItgcPartnerDocx"
      | "GenericItgcDetailed"
      | "GenericItgcPartnerDocxDe"
      | "GenericItgcDetailedDe"
      | "WesselmanItgcPartnerDocx"
      | "WesselmanItgcDetailed"
      | "ProcessUnderstanding"
      | "ProcessUnderstandingDe"
      | "HlbIntercontrolClientFacingFindingsDocx"
      | "HlbIntercontrolInternalFindingsDocx";
    TprmResponse: {answer: components["schemas"]["TprmAnswer"]};
    TprmScopeId: Nominal<string, "TprmScopeId">;
    TprmScopeMin: {
      deleted?: components["schemas"]["Actioned"] | null;
      engagement: components["schemas"]["EngagementMin"];
      name: string;
      scope_id: components["schemas"]["TprmScopeId"];
      scope_type: components["schemas"]["TprmScopeType"];
    };
    TprmScopeType: "Global" | "InternalApplication" | "ExternalApplication" | "DataFlow";
    /** @enum {string} */
    TprmScopeVisibility: "Risk" | "Control" | "All";
    TprmSectionTemplate: {
      deleted?: components["schemas"]["Actioned"] | null;
      description?: string | null;
      questions: components["schemas"]["TprmQuestionTemplate"][];
      section_template_id: components["schemas"]["TprmSectionTemplateId"];
      title: string;
    };
    TprmSectionTemplateId: Nominal<string, "TprmSectionTemplateId">;
    TprmSelectAnswer: {selected: string[]};
    TprmSelectAnswerConfig: {
      /**
       * Format: int32
       * @description Maximum number of options that may be selected; omit to allow selecting all options.
       */
      max_number?: number | null;
      /**
       * Format: int32
       * @description Minimum number of options that must be selected; omit for no lower bound.
       */
      min_number?: number | null;
      /** @description The set of selectable options the respondent may choose from. */
      options: components["schemas"]["TprmSelectAnswerConfigOption"][];
    };
    TprmSelectAnswerConfigOption: {
      /** @description The human-readable text shown to the respondent for this option. */
      label: string;
      /** @description The stable value stored when this option is selected and referenced by select-matching conditions. */
      value: string;
    };
    TprmSubQuestionnairesAnswer: {source_ids: components["schemas"]["SourceId"][]};
    TprmSubQuestionnairesAnswerConfig: {
      questionnaire_template_id: components["schemas"]["TprmQuestionnaireTemplateId"];
      /**
       * @description On questionnaire submissino, the sub questionnaires will each be
       *     extracted to a scope of this type.
       */
      scope_type: components["schemas"]["TprmScopeType"];
    };
    /** @description A table answer for a single question: an ordered list of rows. */
    TprmTableAnswer: {rows: components["schemas"]["TprmTableRow"][]};
    TprmTableAnswerConfig: {
      /** @description The configurable set of columns collected for every row of this question. */
      columns: components["schemas"]["TprmTableColumn"][];
      /**
       * @description The framework the process this table describes is assessed against.
       *     Only valid on a process-steps table (`row_noun` "step"). Omit to leave
       *     the process to be added by hand.
       */
      framework_id?: components["schemas"]["FrameworkId"] | null;
      /**
       * @description `key` of a `columns` entry whose value groups rows under headers in the
       *     table; omit for a flat, ungrouped list of rows.
       */
      group_by_column_key?: string | null;
      /**
       * @description `key` of a `columns` entry whose value labels each row (its "title"),
       *     shown as the row heading; omit to identify rows by number only.
       */
      primary_column_key?: string | null;
      /**
       * @description Singular, lowercase noun for one row (e.g. "step", "asset"), used to label
       *     the add button, empty state and row heading. Omit to fall back to the
       *     generic "row".
       */
      row_noun?: string | null;
      /**
       * @description Plural form of `row_noun`, used wherever the count is not exactly one
       *     (e.g. "steps", "assets"). Supply this for irregular English plurals
       *     ("entry" → "entries") and for non-English nouns, where appending "s" is
       *     wrong. Omit to default to `row_noun` with an "s" appended; ignored when
       *     `row_noun` itself is omitted.
       */
      row_noun_plural?: string | null;
    };
    /**
     * @description One configurable column collected on every row of a table question. A column
     *     is a strict, name-aligned subset of a regular question (`text`, `guidance`,
     *     `is_required`, `answer_config`). Authored per account in presets.
     */
    TprmTableColumn: {
      /** @description The input type and its configuration for this column. */
      answer_config: components["schemas"]["TprmColumnConfig"];
      /** @description Optional helper text shown under the column's prompt in the row editor. */
      guidance?: string | null;
      /**
       * @description Whether every row must provide a non-empty value for this column before
       *     the questionnaire can be submitted.
       * @default false
       */
      is_required: boolean;
      /**
       * @description Stable key identifying this column within a row's `values` map and
       *     referenced by `group_by_column_key` / `primary_column_key`.
       */
      key: string;
      /** @description Human-readable column prompt shown to respondents. */
      text: string;
    };
    /**
     * @description One row of a table. `values` is keyed by the `key` of a `TprmTableColumn` on
     *     the question's config; unset columns are omitted.
     */
    TprmTableRow: {
      id: components["schemas"]["TprmTableRowId"];
      values: {[key: string]: components["schemas"]["TprmColumnValue"]};
    };
    TprmTableRowId: Nominal<string, "TprmTableRowId">;
    TprmTextAnswer: {text: string};
    TprmTextAnswerConfig: {
      /** @description If `true`, the answer is entered as a single-line text input rather than a multi-line text area. */
      is_single_line?: boolean | null;
      /**
       * Format: int32
       * @description Maximum number of characters the text answer may contain; omit for no upper bound.
       */
      max_length?: number | null;
      /**
       * Format: int32
       * @description Minimum number of characters the text answer must contain; omit for no lower bound.
       */
      min_length?: number | null;
      /**
       * @description If `true`, the answer to this question will be used as the label for the
       *     questionnaire. (e.g. "IT Application name").
       */
      use_as_questionnaire_label?: boolean | null;
    };
    TprmTierCriterion: {
      /** @description The condition over the questionnaire's answers that, when true, selects this tier. */
      condition: components["schemas"]["TprmCondition"];
      /** @description The tier assigned to the questionnaire when `condition` evaluates to true. */
      tier: string;
    };
    Trigger:
      | {
          /** @enum {string} */
          type: "Manual";
        }
      | {
          /** @enum {string} */
          type: "Autorun";
        };
    /** @enum {string} */
    TrustCenterAccess: "Allowed" | "GeneralGrant" | "SpecificGrant" | "Denied";
    TrustCenterAiCheckItemConfig: {description: string; title: string};
    TrustCenterAiConfig: {
      /** @default [] */
      check_items: components["schemas"]["TrustCenterAiCheckItemConfig"][];
      /** @default [] */
      data_use_items: components["schemas"]["TrustCenterAiDataUseItemConfig"][];
      /** @default false */
      enabled: boolean;
      faq_questionnaire_id?: components["schemas"]["QuestionnaireId"] | null;
      /** @default [] */
      model_providers: components["schemas"]["TrustCenterAiModelProviderConfig"][];
      overview_content_id?: components["schemas"]["ContentId"] | null;
      /** @default [] */
      related_documents: components["schemas"]["TrustCenterRelatedDocumentConfig"][];
    };
    TrustCenterAiDataUseItemConfig: {
      description: string;
      includes_customer_data: boolean;
      is_anonymized: boolean;
      pii: components["schemas"]["TrustCenterDataUseItemPii"];
      title: string;
      used_for_training: boolean;
    };
    TrustCenterAiModelProviderConfig: {
      models_used: string;
      purposes: string;
      subprocessor_entity_id?: components["schemas"]["EntityId"] | null;
    };
    TrustCenterAuth: {is_public: boolean; password?: string | null};
    TrustCenterBusinessInfoContentConfig: {
      content_id?: components["schemas"]["ContentId"] | null;
      /** @default  */
      title: string;
    };
    TrustCenterConfig: {
      document_request_email?: string | null;
      is_public: boolean;
      meta: components["schemas"]["TrustCenterConfigMeta"];
      theme: {[key: string]: IValue};
    };
    TrustCenterConfigMeta: {
      ai?: components["schemas"]["TrustCenterAiConfig"] | null;
      business_info?: components["schemas"]["TrustCenterBusinessInfoContentConfig"][] | null;
      data_protection?: components["schemas"]["TrustCenterDataProtectionConfig"] | null;
      favicon_asset_id?: components["schemas"]["AssetId"] | null;
      /**
       * @default {
       *       "heading": "",
       *       "subheading": null
       *     }
       */
      hero: components["schemas"]["TrustCenterHeroConfig"];
      /** @default  */
      homepage_url: string;
      logo_asset_id?: components["schemas"]["AssetId"] | null;
      /** @default  */
      name: string;
      overview?: components["schemas"]["TrustCenterOverviewConfig"] | null;
      privacy_policy?: string | null;
      standard_terms?: components["schemas"]["TrustCenterStandardTermsConfig"] | null;
      subscribe?: components["schemas"]["TrustCenterSubscribeConfig"] | null;
    };
    TrustCenterConfigMin: {
      is_public: boolean;
      meta: components["schemas"]["TrustCenterConfigMeta"];
      theme: {[key: string]: IValue};
    };
    TrustCenterContent: {content: string; content_id: components["schemas"]["ContentId"]; title: string};
    TrustCenterContentMin: {content_id: components["schemas"]["ContentId"]; title: string};
    TrustCenterDataProtectionConfig: {
      /** @default [] */
      data_use_items: components["schemas"]["TrustCenterDataProtectionDataUseItemConfig"][];
      /** @default false */
      enabled: boolean;
      /** @default [] */
      operating_countries: components["schemas"]["TrustCenterDataProtectionOperatingCountriesConfig"][];
      overview_content_id?: components["schemas"]["ContentId"] | null;
      /** @default [] */
      related_documents: components["schemas"]["TrustCenterRelatedDocumentConfig"][];
      /** @default false */
      sar_enabled: boolean;
      /** @default false */
      subprocessors_enabled: boolean;
    };
    TrustCenterDataProtectionDataUseItemConfig: {
      description: string;
      includes_customer_data: boolean;
      is_anonymized: boolean;
      pii: components["schemas"]["TrustCenterDataUseItemPii"];
      title: string;
    };
    TrustCenterDataProtectionOperatingCountriesConfig: {
      description?: string | null;
      detailed_address?: string | null;
      gdpr_equivalency: boolean;
      gdpr_europe: boolean;
      gdpr_sccs: boolean;
      iso_country_code: string;
    };
    /** @enum {string} */
    TrustCenterDataUseItemPii: "None" | "Pii" | "SpecialCategory";
    TrustCenterFaq: {sections: components["schemas"]["TrustCenterFaqSection"][]};
    TrustCenterFaqQuestion: {question_id: components["schemas"]["QuestionId"]; response: string; text: string};
    TrustCenterFaqSection: {
      questions: components["schemas"]["TrustCenterFaqQuestion"][];
      section_id: components["schemas"]["SectionId"];
      title: string;
    };
    TrustCenterHeroConfig: {
      /** @default  */
      heading: string;
      subheading?: string | null;
    };
    TrustCenterOverviewConfig: {
      content_id?: components["schemas"]["ContentId"] | null;
      /** @default [] */
      trusted_by: components["schemas"]["TrustCenterTrustedByConfig"][];
      /** @default Trusted by */
      trusted_partnered_title: string;
      welcome_id?: components["schemas"]["ContentId"] | null;
    };
    TrustCenterPasswordConfig: {
      /** @default false */
      enabled: boolean;
      /** @default  */
      password: string;
    };
    TrustCenterRelatedDocumentConfig: {document_id?: components["schemas"]["DocumentId"] | null};
    TrustCenterStandardTermsConfig: {
      /** @default [] */
      related_documents: components["schemas"]["TrustCenterRelatedDocumentConfig"][];
    };
    TrustCenterSubscribeConfig: {
      /** @default false */
      enabled: boolean;
    };
    TrustCenterTrustedByConfig: {
      logo_asset_id?: components["schemas"]["AssetId"] | null;
      logo_link_url?: string | null;
    };
    UnarchiveAuditPlanPages: {page_ids: components["schemas"]["AuditPlanPageId"][]};
    /**
     * @description A header of a population's tabular sources that no standing column claims,
     *     with a sample of the values arriving under it.
     *
     *     The sample is what makes the header judgeable: `PYMT_ID` and `Payment ID`
     *     are the same column, and five values in the shape `PAY-001` are the evidence
     *     for saying so.
     */
    UnboundPopulationHeader: {header: string; sample_values: string[]};
    Understanding: {
      activity_stream: components["schemas"]["ActivityStream"];
      /**
       * @description When set, this understanding belongs to an audit area, and its `name`
       *     mirrors `audit_area.name` — direct renames are rejected.
       */
      audit_area?: components["schemas"]["AuditAreaMin"] | null;
      audit_area_type: components["schemas"]["AuditAreaType"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      context?: string | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      engagement: components["schemas"]["EngagementMin"];
      generation_state: components["schemas"]["UnderstandingGenerationState"];
      hidden: boolean;
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      process_step_property_config: components["schemas"]["ProcessStepPropertyConfig"];
      seed_context?: string | null;
      /**
       * @description `true` if the understanding has completed but the data room has changed
       *     since it was generated.
       */
      stale: boolean;
      summary?: string | null;
      understanding_id: components["schemas"]["UnderstandingId"];
      updated_at: components["schemas"]["DateTime"];
    };
    UnderstandingContext:
      | {
          /** @enum {string} */
          type: "ProcessSteps";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Seed";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Expanded";
        };
    /** @enum {string} */
    UnderstandingGenerationError: "NoSources" | "NoRelevantSources";
    UnderstandingGenerationState:
      | {
          /** @enum {string} */
          type: "NotStarted";
        }
      | {
          background_task: components["schemas"]["PendingBackgroundTask"];
          /** @enum {string} */
          type: "Generating";
        }
      | {
          at: components["schemas"]["DateTime"];
          /** @enum {string} */
          type: "Completed";
        }
      | {
          at: components["schemas"]["DateTime"];
          error: components["schemas"]["UnderstandingGenerationError"];
          /** @enum {string} */
          type: "Error";
        };
    UnderstandingId: Nominal<string, "UnderstandingId">;
    UnderstandingIdPath: {understanding_id: components["schemas"]["UnderstandingId"]};
    UnderstandingMin: {
      audit_area?: components["schemas"]["AuditAreaMin"] | null;
      audit_area_type: components["schemas"]["AuditAreaType"];
      audit_plan_page_id?: components["schemas"]["AuditPlanPageId"] | null;
      context?: string | null;
      created_at: components["schemas"]["DateTime"];
      deleted?: components["schemas"]["Actioned"] | null;
      engagement: components["schemas"]["EngagementMin"];
      generation_state: components["schemas"]["UnderstandingGenerationState"];
      hidden: boolean;
      /** @description Derived from the parent audit area if `audit_area` is `Some`. */
      name: string;
      owner?: components["schemas"]["Owner"] | null;
      seed_context?: string | null;
      /**
       * @description `true` if the understanding has completed but the data room has changed
       *     since it was generated.
       */
      stale: boolean;
      understanding_id: components["schemas"]["UnderstandingId"];
      updated_at: components["schemas"]["DateTime"];
    };
    UnderstandingNotificationMin: {
      audit_plan_page_id: components["schemas"]["AuditPlanPageId"];
      engagement: components["schemas"]["EngagementNotificationMin"];
      name: string;
      understanding_id: components["schemas"]["UnderstandingId"];
    };
    UnderstandingReportContentPayload: {
      audit_area_type: components["schemas"]["AuditAreaType"];
      diagram_summaries: components["schemas"]["DiagramSummary"][];
      name: string;
      summary?: string | null;
    };
    UnderstandingSummaryEvidence: {
      source: components["schemas"]["SourceMin"];
      source_context: string;
      understanding_summary_evidence_id: components["schemas"]["UnderstandingSummaryEvidenceId"];
    };
    UnderstandingSummaryEvidenceId: Nominal<string, "UnderstandingSummaryEvidenceId">;
    UnderstandingSummaryEvidenceIdPath: {
      understanding_id: components["schemas"]["UnderstandingId"];
      understanding_summary_evidence_id: components["schemas"]["UnderstandingSummaryEvidenceId"];
    };
    UnlockAuditPlanPages: {
      /**
       * @description Also unlock the descendant subtree of every listed page, so a whole
       *     branch can be reopened at once. Unlocking always cascades to ancestors
       *     regardless of this flag.
       * @default false
       */
      include_children: boolean;
      page_ids: components["schemas"]["AuditPlanPageId"][];
    };
    UnsubscribeRequest: {
      Recipient: string;
      RecordType: string;
      /** Format: int32 */
      ServerID: number;
    };
    UpdateAttributeEvidence: {
      evidence_text: string;
      relevance_explanation: string;
      source_context: string;
      source_ref: components["schemas"]["SourceRef"];
    };
    UpdateAttributeValue:
      | {
          /** @enum {string} */
          action: "set";
          value: IValue;
        }
      | {
          /** @enum {string} */
          action: "clear";
        }
      | {
          /** @enum {string} */
          action: "reset_to_ai";
        }
      | {
          /** @enum {string} */
          action: "reset_to_rolled_forward";
        }
      | {
          /** @enum {string} */
          action: "accept_rolled_forward";
        };
    UpdateAuditPlanPageStatus: {status: components["schemas"]["AuditPlanPageStatus"]};
    UpdateBasisItemSpan: {span: components["schemas"]["DateRange"]};
    UpdateComplexityAttribute: {
      ai_guidance?: string | null;
      attribute_type: components["schemas"]["ValueType"];
      /** Format: int32 */
      default_score?: number | null;
      name: string;
      operator: components["schemas"]["ComplexityAggregationOperator"];
      required: boolean;
      rules: components["schemas"]["ComplexityTierCriterion"][];
      /** Format: int32 */
      weight: number;
    };
    UpdateComplexityModelName: {name: string};
    UpdateComplexityModelVersionName: {version_name: string};
    UpdateComplexityTier: {
      color: string;
      /** Format: int32 */
      lower_bound?: number | null;
      name: string;
    };
    UpdateComplexityTierBody: {
      complexity_tier_id: components["schemas"]["ComplexityTierId"];
      justification?: string | null;
    };
    UpdateControlOePeriod: {period: components["schemas"]["DateRange"]};
    UpdateCrmConnection: {
      config: components["schemas"]["CrmConnectionConfig"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
    };
    UpdateCustomPrompt: {template_text: string};
    UpdateDiagram: {
      delete_connections: components["schemas"]["DiagramConnectionId"][];
      delete_lanes: components["schemas"]["DiagramLaneId"][];
      delete_nodes: components["schemas"]["DiagramNodeId"][];
      upsert_connections: components["schemas"]["DiagramConnection"][];
      upsert_lanes: components["schemas"]["DiagramLane"][];
      upsert_nodes: components["schemas"]["DiagramNode"][];
    };
    UpdateDiagramEvidence: {source_context: string};
    UpdateDocumentContent: {
      authoring_config?: components["schemas"]["Config"] | null;
      authoring_template?: string | null;
      authority: components["schemas"]["DocumentAuthority"];
      file_id?: components["schemas"]["FileId"] | null;
      markdown?: string | null;
    };
    UpdateDocumentSource: {
      config: components["schemas"]["DocumentSourceConfig"];
      default_limited_to_scope_ids?: components["schemas"]["ScopeId"][] | null;
      default_owner_id: components["schemas"]["OwnerId"];
      default_sharing_classification: components["schemas"]["SharingClassification"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      name: string;
    };
    UpdateEsignatureProvider: {
      config: components["schemas"]["EsignatureProviderConfig"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
      external_reference?: components["schemas"]["PopulateExternalAccountReference"] | null;
    };
    UpdateLibrarySection: {description?: string | null; name?: string | null};
    UpdateLoginMethodRequest: {
      login_method: components["schemas"]["AddLoginMethod"];
      /** @description Should the login method also be selected for use immediately? */
      select: boolean;
    };
    UpdateLoginMethodResponse:
      | {
          /** @enum {string} */
          type: "Success";
        }
      | {
          content: string;
          /** @enum {string} */
          type: "Redirect";
        };
    UpdateNotificationPreference: {
      channel_category: components["schemas"]["NotificationChannelCategory"];
      enabled: boolean;
      notification_type: components["schemas"]["NotificationType"];
    };
    UpdateNotificationSink: {
      config: components["schemas"]["NotificationSinkConfig"];
      external_authorization_id?: components["schemas"]["ExternalAuthorizationId"] | null;
    };
    /** @enum {string} */
    UpdateNotificationStatus: "New" | "Draft" | "Sent";
    UpdateOperationalContext: {description?: string | null; name?: string | null};
    /**
     * @description Input for setting a population's description. `None` clears it to NULL; the
     *     database has no empty-string representation of "no description", so a caller
     *     wanting to remove the text sends `null` rather than `""`.
     */
    UpdatePopulationDescription: {description?: string | null};
    /**
     * @description Input for renaming a population. Bounds the name to the same length as
     *     [`CreatePopulation::name`].
     */
    UpdatePopulationName: {name: string};
    UpdateProcessStep: {
      description?: string | null;
      name?: string | null;
      /** @description When set, replaces the whole property-value map. */
      properties?: {[key: string]: string} | null;
    };
    UpdateQuestionSource: {
      config: components["schemas"]["QuestionSourceConfig"];
      external_authorization_id: components["schemas"]["ExternalAuthorizationId"];
    };
    /**
     * @description Input for setting a sample's description. `None` clears it to NULL; the
     *     database has no empty-string representation of "no description", so a caller
     *     wanting to remove the text sends `null` rather than `""`.
     */
    UpdateSampleDescription: {description?: string | null};
    /**
     * @description Input for choosing a sample's method and size, whether or not it has been
     *     drawn.
     */
    UpdateSampleMethod: {method: components["schemas"]["SampleMethod"]};
    /**
     * @description Input for renaming a sample. Bounds the name to the same length as
     *     [`CreateSample::name`].
     */
    UpdateSampleName: {name: string};
    /**
     * @description Input for pointing a sample at a population. A drawn sample's items are
     *     pointers into its population's rows and cannot be re-aimed, so re-pointing
     *     returns the sample to draft for a fresh draw.
     */
    UpdateSamplePopulation: {population_id: components["schemas"]["PopulationId"]};
    UpdateScopeAccess: {reader_ids: components["schemas"]["OwnerId"][]; writer_ids: components["schemas"]["OwnerId"][]};
    UpdateStandardFinding: {
      finding?: string | null;
      implication?: string | null;
      recommendations?: string | null;
      title?: string | null;
    };
    /**
     * @description How an auditor changes a test's conclusion — the human lane of
     *     [`Test::conclusion`]. The generated lane is not reachable from here.
     *
     *     [`Self::Set`] is a changeset over the two halves: an absent field — or an
     *     explicit `null`, there being no per-field withdrawal to confuse it with —
     *     leaves that half as it stands, so either half may be claimed on its own.
     *     Claiming neither is refused; it would restamp the lane for nothing.
     *
     *     [`Self::ResetToAi`] is whole-lane and the only way to unclaim a half.
     */
    UpdateTestConclusion:
      | {
          /** @enum {string} */
          action: "set";
          /**
           * @description `Some("")` is a blank the auditor asserted, which resolves as itself
           *     rather than falling back to the generated prose.
           */
          justification?: string | null;
          /**
           * Format: int32
           * @description 1-based index into the test's *resolved* levels.
           */
          rating?: number | null;
        }
      | {
          /** @enum {string} */
          action: "reset_to_ai";
        };
    /**
     * @description Input for setting a test's description. `None` clears it to NULL; the
     *     database has no empty-string representation of "no description", so a caller
     *     wanting to remove the text sends `null` rather than `""`.
     */
    UpdateTestDescription: {description?: string | null};
    /**
     * @description Input for renaming a test. Bounds the name to the same length as
     *     [`CreateTest::name`].
     */
    UpdateTestName: {name: string};
    UpdateTprmAsset: {description?: string | null; name?: string | null};
    UpdateTwoFa: {
      credentials: components["schemas"]["LoginCredentials"];
      enable?: components["schemas"]["EnableTwoFa"] | null;
    };
    UpdateUnderstandingSummaryEvidence: {source_context: string};
    UpdateWatcherTrigger: {enabled: boolean; trigger: components["schemas"]["WatcherTrigger"]};
    UploadOptions: {
      /** @default false */
      system_wide: boolean;
    };
    UpsertAuditAreaTemplate: {
      /** @description Identifies an existing template to update; omit to create a new one. */
      audit_area_template_id?: components["schemas"]["AuditAreaTemplateId"] | null;
      /** @description Whether this template seeds an entity-level or process-level audit area. */
      audit_area_type: components["schemas"]["AuditAreaType"];
      /** @description Complexity model this template is associated with, or null if not tied to one. */
      complexity_model_id?: components["schemas"]["ComplexityModelId"] | null;
      /** @description Seed context applied to understandings created from this template, guiding what the audit area should cover. */
      context: string;
      /** @description Human-readable explanation of what the template is for. */
      description: string;
      /** @description Framework this template is associated with, or null if not tied to one. */
      framework_id?: components["schemas"]["FrameworkId"] | null;
      /** @description Display name shown to staff when picking the template. */
      name: string;
    };
    UpsertControlCondition: {
      /**
       * Format: int32
       * @description 1-based index into the target's scale; rejected at the write boundary when
       *     it falls outside it.
       */
      min_rating: number;
      provenance?: string | null;
      /**
       * @description The target's OE, not its (control, scope): depending on a control that has
       *     no OE is refused by the foreign key rather than by a check.
       */
      target_control_oe_id: components["schemas"]["ControlOeId"];
    };
    UpsertEngagementTemplate: {
      areas: components["schemas"]["UpsertEngagementTemplateArea"][];
      description: string;
      /**
       * @description Identifies the template within the account; an existing template with
       *     this name is updated in place.
       */
      name: string;
    };
    UpsertEngagementTemplateArea: {
      /** @description References an entity-level audit area template on the account. */
      audit_area_template_id: components["schemas"]["AuditAreaTemplateId"];
      required: boolean;
    };
    /**
     * @description Input for writing a note's text. Rewording an assessed note returns it to
     *     unassessed, as the call was made on the old wording.
     */
    UpsertNoteCondition: {text: string};
    /**
     * @description Input for upserting a single criterion into a test's config override — set as
     *     a present (`Some`) entry keyed by the path's id. Covers both overriding a
     *     template criterion and adding a new one; the criterion id comes from the URL.
     */
    UpsertTestCriterion: {
      ai_hint?: string | null;
      name: string;
      /** Format: int32 */
      sort_order: number;
    };
    /**
     * @description Input for upserting a single extraction field into a test's config override —
     *     set as a present (`Some`) entry keyed by the path's id. Covers both
     *     overriding a template field and adding a new one; the field id comes from the
     *     URL.
     */
    UpsertTestExtractionField: {
      ai_hint?: string | null;
      name: string;
      /** Format: int32 */
      sort_order: number;
      type_: components["schemas"]["ValueType"];
    };
    /** @enum {string} */
    Usage: "Required" | "Optional" | "Omitted";
    Usage2: Record<string, never>;
    /** @description Sum of `platformed_llm::Usage` across multiple events. */
    UsageTotals: {
      /** Format: uint64 */
      cache_creation_input_tokens?: number | null;
      /** Format: uint64 */
      cache_read_input_tokens?: number | null;
      /** Format: uint64 */
      input_tokens: number;
      /** Format: uint64 */
      output_tokens: number;
    };
    UseData: {
      answer: components["schemas"]["Usage"];
      fact: components["schemas"]["Usage"];
      question: components["schemas"]["Usage"];
    };
    User:
      | components["schemas"]["ExternalUser"]
      | components["schemas"]["RegisteredUser"]
      | components["schemas"]["ServiceUser"]
      | components["schemas"]["SystemAgentUser"];
    UserApikeyId: Nominal<string, "UserApikeyId">;
    UserApikeyPath: {user_apikey_id: components["schemas"]["UserApikeyId"]; user_id: components["schemas"]["UserId"]};
    UserAuthBody: {socket_id: string};
    UserAuthBody2: {socket_id: string};
    UserId: Nominal<string, "UserId">;
    UserIdPath: {user_id: components["schemas"]["UserId"]};
    UserIdPath2: {user_id: components["schemas"]["UserId"]};
    UserLoginMethod: {
      is_configured: boolean;
      is_recommended: boolean;
      login_method: components["schemas"]["LoginMethodMin"];
      requires_2fa: boolean;
    };
    UserMessagePayload: {content: components["schemas"]["RichText"]};
    UserMin: {
      avatar_url?: string | null;
      name?: string | null;
      primary_email?: string | null;
      type_: components["schemas"]["UserType"];
      user_id: components["schemas"]["UserId"];
    };
    UserNotificationIdPath: {user_notification_id: components["schemas"]["InAppNotificationId"]};
    UserParts: IValue[];
    UserRegistrationState:
      | {
          content: components["schemas"]["LoginMethodMin"];
          /** @enum {string} */
          type: "Registered";
        }
      | {
          /** @enum {string} */
          type: "PendingVerification";
        }
      | {
          /** @enum {string} */
          type: "UnregisteredCanRegister";
        }
      | {
          /** @enum {string} */
          type: "Unregistered";
        };
    /** @enum {string} */
    UserType: "External" | "Registered" | "Service" | "SystemAgent";
    /** @enum {string} */
    UserTypeExternal: "External";
    /** @enum {string} */
    UserTypeRegistered: "Registered";
    /** @enum {string} */
    UserTypeService: "Service";
    /** @enum {string} */
    UserTypeSystemAgent: "SystemAgent";
    UsernamePasswordLoginRequest: {
      credentials: components["schemas"]["LoginCredentials"];
      email: string;
      remember_me: boolean;
    };
    ValidateLoginMethod: {inner: components["schemas"]["ValidateLoginMethodInner"]; name: string};
    ValidateLoginMethodGenericOauth: Record<string, never>;
    ValidateLoginMethodGenericSaml: {metadata_url: string};
    ValidateLoginMethodInner:
      | {
          content: components["schemas"]["ValidateLoginMethodGenericOauth"];
          /** @enum {string} */
          type: "GenericOauth";
        }
      | {
          content: components["schemas"]["ValidateLoginMethodGenericSaml"];
          /** @enum {string} */
          type: "GenericSaml";
        };
    ValidatePortalInvitePayload: {email?: string | null; token?: string | null};
    ValidatePortalInviteResponse:
      | {
          content: components["schemas"]["PortalInviteInfoExternal"];
          /** @enum {string} */
          type: "Valid";
        }
      | {
          /** @enum {string} */
          type: "InvalidEmail";
        }
      | {
          /** @enum {string} */
          type: "InvalidOrExpiredToken";
        }
      | {
          /** @enum {string} */
          type: "Redirect";
        };
    /** @enum {string} */
    ValueType: "String" | "Boolean" | "Integer" | "IntegerSet" | "StringSet";
    /** @enum {string} */
    VerbosityModifier: "Descriptive" | "Balanced" | "Concise";
    VerifiedDomain: {
      domain: string;
      enable_self_enrollment: boolean;
      verified?: components["schemas"]["Actioned"] | null;
      verified_domain_id: components["schemas"]["VerifiedDomainId"];
    };
    VerifiedDomainId: Nominal<string, "VerifiedDomainId">;
    VerifiedDomainIdPath: {verified_domain_id: components["schemas"]["VerifiedDomainId"]};
    VideoSourceKind: {
      file: components["schemas"]["File"];
      transcript?: components["schemas"]["VideoTranscript"] | null;
    };
    VideoSourceMinKind: {file: components["schemas"]["File"]};
    /**
     * @description This type is stored directly as a JSONB column in the database, be careful
     *     with changes.
     */
    VideoTranscript: {cues: components["schemas"]["VideoTranscriptCue"][]};
    VideoTranscriptCaptionCue: {speaker: string; text: string};
    VideoTranscriptCue: {
      /** Format: double */
      end_time: number;
      kind: components["schemas"]["VideoTranscriptCueKind"];
      /** Format: double */
      start_time: number;
    };
    VideoTranscriptCueKind:
      | {
          content: components["schemas"]["VideoTranscriptCaptionCue"];
          /** @enum {string} */
          type: "Caption";
        }
      | {
          content: components["schemas"]["VideoTranscriptScreenshotCue"];
          /** @enum {string} */
          type: "Screenshot";
        };
    VideoTranscriptScreenshotCue: {
      description: string;
      file_id: components["schemas"]["FileId"];
      label: string;
      /** Format: double */
      representative_time: number;
    };
    WatcherPreferences: WatcherPreferences;
    /** @enum {string} */
    WatcherTrigger:
      | "VTQuestionAsked"
      | "VTQuestionCommented"
      | "VTQuestionMentioned"
      | "VTQuestionAssigned"
      | "VTQuestionReviewed"
      | "VTQuestionReviewRequested";
    WebDocumentSourceConfig: {urls: string[]};
    WhoAmIOnAccountResponse: {
      account: components["schemas"]["Account"];
      apikey?: components["schemas"]["Apikey"] | null;
      associated_owners: components["schemas"]["Owner"][];
      /**
       * @description When set, every chat completion is being forced to this model by a
       *     development-environment override, ignoring per-account AI preferences.
       */
      dev_chat_model_override?: components["schemas"]["AiModel"] | null;
      internal_mode: boolean;
      roles: components["schemas"]["RoleMin"][];
      user_owner?: components["schemas"]["Owner"] | null;
    };
    /** @description Contains information about the user. Does not contain account-specific information. */
    WhoAmIResponse: {
      account?: components["schemas"]["AccountMin"] | null;
      has_portal_access: boolean;
      internal_mode: boolean;
      multi_account: boolean;
      used_2fa: boolean;
      user: components["schemas"]["RegisteredUser"];
    };
    YesNoAnswerConfig: Record<string, never>;
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export type operations = Record<string, never>;

export type AIProvider = components["schemas"]["AIProvider"];
export type Aabb = components["schemas"]["Aabb"];
export type AccessLevel = components["schemas"]["AccessLevel"];
export type AccessScope = components["schemas"]["AccessScope"];
export type AccessToken = components["schemas"]["AccessToken"];
export type Account = components["schemas"]["Account"];
export type AccountArgs = components["schemas"]["AccountArgs"];
export type AccountFeature = components["schemas"]["AccountFeature"];
export type AccountId = components["schemas"]["AccountId"];
export type AccountIdPath = components["schemas"]["AccountIdPath"];
export type AccountIdPath2 = components["schemas"]["AccountIdPath2"];
export type AccountMin = components["schemas"]["AccountMin"];
export type AccountPath = components["schemas"]["AccountPath"];
export type AccountRestriction = components["schemas"]["AccountRestriction"];
export type AccountSlugPath = components["schemas"]["AccountSlugPath"];
export type AccountType = components["schemas"]["AccountType"];
export type AccountUser = components["schemas"]["AccountUser"];
export type AccountWithRestriction = components["schemas"]["AccountWithRestriction"];
export type AcsPayload = components["schemas"]["AcsPayload"];
export type Actioned = components["schemas"]["Actioned"];
export type Activity = components["schemas"]["Activity"];
export type ActivityCluster = components["schemas"]["ActivityCluster"];
export type ActivityKind = components["schemas"]["ActivityKind"];
export type ActivityPayload = components["schemas"]["ActivityPayload"];
export type ActivityStream = components["schemas"]["ActivityStream"];
export type ActivityStreamId = components["schemas"]["ActivityStreamId"];
export type ActivityStreamIdPath = components["schemas"]["ActivityStreamIdPath"];
export type ActivityStreamRef = components["schemas"]["ActivityStreamRef"];
export type ActivitySummary = components["schemas"]["ActivitySummary"];
export type ActivityType = components["schemas"]["ActivityType"];
export type AdHocQuestion = components["schemas"]["AdHocQuestion"];
export type AdHocQuestionTask = components["schemas"]["AdHocQuestionTask"];
export type AddLoginMethod = components["schemas"]["AddLoginMethod"];
export type AddPredefinedControl = components["schemas"]["AddPredefinedControl"];
export type AddRowBody = components["schemas"]["AddRowBody"];
export type AgentConfig = components["schemas"]["AgentConfig"];
export type AgentSessionAiDelta = components["schemas"]["AgentSessionAiDelta"];
export type AgentSessionEvent = components["schemas"]["AgentSessionEvent"];
export type AgentSessionEventPayload = components["schemas"]["AgentSessionEventPayload"];
export type AgentSessionId = components["schemas"]["AgentSessionId"];
export type AgentSessionIdPath = components["schemas"]["AgentSessionIdPath"];
export type AgentSessionMessage = components["schemas"]["AgentSessionMessage"];
export type AgentSessionMessageFilter = components["schemas"]["AgentSessionMessageFilter"];
export type AgentSessionMessagePayload = components["schemas"]["AgentSessionMessagePayload"];
export type AgentSessionMin = components["schemas"]["AgentSessionMin"];
export type AiFeature = components["schemas"]["AiFeature"];
export type AiMessageOutputContent = components["schemas"]["AiMessageOutputContent"];
export type AiMessageOutputFunctionCall = components["schemas"]["AiMessageOutputFunctionCall"];
export type AiMessageOutputFunctionCallOutput = components["schemas"]["AiMessageOutputFunctionCallOutput"];
export type AiMessageOutputItem = components["schemas"]["AiMessageOutputItem"];
export type AiMessagePayload = components["schemas"]["AiMessagePayload"];
export type AiModel = components["schemas"]["AiModel"];
export type AiPromptInfo = components["schemas"]["AiPromptInfo"];
export type AiPromptInputVariable = components["schemas"]["AiPromptInputVariable"];
export type AiPromptKind = components["schemas"]["AiPromptKind"];
export type AiPromptPath = components["schemas"]["AiPromptPath"];
export type AiReview = components["schemas"]["AiReview"];
export type AiStatus = components["schemas"]["AiStatus"];
export type AiTodoItem = components["schemas"]["AiTodoItem"];
export type AiTodoItemStatus = components["schemas"]["AiTodoItemStatus"];
export type AnswerHistoryReason = components["schemas"]["AnswerHistoryReason"];
export type AnswerOption = components["schemas"]["AnswerOption"];
export type AnswerPart = components["schemas"]["AnswerPart"];
export type AnswerPart2 = components["schemas"]["AnswerPart2"];
export type AnswerPart3 = components["schemas"]["AnswerPart3"];
export type AnswerPart4 = components["schemas"]["AnswerPart4"];
export type AnswerParts = components["schemas"]["AnswerParts"];
export type AnswerProvenance = components["schemas"]["AnswerProvenance"];
export type AnswerReviewPart = components["schemas"]["AnswerReviewPart"];
export type AnswerReviewParts = components["schemas"]["AnswerReviewParts"];
export type AnswerSuggestion = components["schemas"]["AnswerSuggestion"];
export type AnswerSuggestionId = components["schemas"]["AnswerSuggestionId"];
export type Apikey = components["schemas"]["Apikey"];
export type ApikeyId = components["schemas"]["ApikeyId"];
export type ApplyConsolidatedSuggestionRequest = components["schemas"]["ApplyConsolidatedSuggestionRequest"];
export type ArchiveAuditPlanPages = components["schemas"]["ArchiveAuditPlanPages"];
export type AssessControlAssessmentFunction = components["schemas"]["AssessControlAssessmentFunction"];
export type AssessControlDesignImplementationFunction =
  components["schemas"]["AssessControlDesignImplementationFunction"];
export type AssessControlRepresentationFunction = components["schemas"]["AssessControlRepresentationFunction"];
export type AssessNoteCondition = components["schemas"]["AssessNoteCondition"];
export type AssessedControlUpdatedPayload = components["schemas"]["AssessedControlUpdatedPayload"];
export type Assessment = components["schemas"]["Assessment"];
export type AssessmentAssistantFunction = components["schemas"]["AssessmentAssistantFunction"];
export type AssessmentContinueOutcome = components["schemas"]["AssessmentContinueOutcome"];
export type AssessmentControlId = components["schemas"]["AssessmentControlId"];
export type AssessmentControlIdPath = components["schemas"]["AssessmentControlIdPath"];
export type AssessmentControlInstance = components["schemas"]["AssessmentControlInstance"];
export type AssessmentControlMode = components["schemas"]["AssessmentControlMode"];
export type AssessmentControlPath = components["schemas"]["AssessmentControlPath"];
export type AssessmentControlPath2 = components["schemas"]["AssessmentControlPath2"];
export type AssessmentDecision = components["schemas"]["AssessmentDecision"];
export type AssessmentDecisionContent = components["schemas"]["AssessmentDecisionContent"];
export type AssessmentDecisionNode = components["schemas"]["AssessmentDecisionNode"];
export type AssessmentDecisionNodeType = components["schemas"]["AssessmentDecisionNodeType"];
export type AssessmentId = components["schemas"]["AssessmentId"];
export type AssessmentIdPath = components["schemas"]["AssessmentIdPath"];
export type AssessmentLock = components["schemas"]["AssessmentLock"];
export type AssessmentMin = components["schemas"]["AssessmentMin"];
export type AssessmentNode = components["schemas"]["AssessmentNode"];
export type AssessmentNodeId = components["schemas"]["AssessmentNodeId"];
export type AssessmentNotificationMin = components["schemas"]["AssessmentNotificationMin"];
export type AssessmentQuestionnaireStats = components["schemas"]["AssessmentQuestionnaireStats"];
export type AssessmentReportPath = components["schemas"]["AssessmentReportPath"];
export type AssessmentStatus = components["schemas"]["AssessmentStatus"];
export type AssessmentSummary = components["schemas"]["AssessmentSummary"];
export type AssessmentTask = components["schemas"]["AssessmentTask"];
export type Asset = components["schemas"]["Asset"];
export type AssetId = components["schemas"]["AssetId"];
export type AssetIdPath = components["schemas"]["AssetIdPath"];
export type AssetIdPath2 = components["schemas"]["AssetIdPath2"];
export type AssetIdPath3 = components["schemas"]["AssetIdPath3"];
export type AssetMin = components["schemas"]["AssetMin"];
export type AssetOwner = components["schemas"]["AssetOwner"];
export type AssistantParts = components["schemas"]["AssistantParts"];
export type AttachQuestions = components["schemas"]["AttachQuestions"];
export type AttachTestEvidence = components["schemas"]["AttachTestEvidence"];
export type Attribute = components["schemas"]["Attribute"];
export type AttributeAnswer = components["schemas"]["AttributeAnswer"];
export type AttributeAnswers = components["schemas"]["AttributeAnswers"];
export type AttributeAssessment = components["schemas"]["AttributeAssessment"];
export type AttributeAssessmentId = components["schemas"]["AttributeAssessmentId"];
export type AttributeAssessmentPath = components["schemas"]["AttributeAssessmentPath"];
export type AttributeAssessmentPath2 = components["schemas"]["AttributeAssessmentPath2"];
export type AttributeEvidence = components["schemas"]["AttributeEvidence"];
export type AttributeEvidenceAction = components["schemas"]["AttributeEvidenceAction"];
export type AttributeEvidenceId = components["schemas"]["AttributeEvidenceId"];
export type AttributeEvidencePath = components["schemas"]["AttributeEvidencePath"];
export type AttributeHistoryEntry = components["schemas"]["AttributeHistoryEntry"];
export type AuditArea = components["schemas"]["AuditArea"];
export type AuditAreaCreatedFrom = components["schemas"]["AuditAreaCreatedFrom"];
export type AuditAreaId = components["schemas"]["AuditAreaId"];
export type AuditAreaLocking = components["schemas"]["AuditAreaLocking"];
export type AuditAreaMin = components["schemas"]["AuditAreaMin"];
export type AuditAreaOverview = components["schemas"]["AuditAreaOverview"];
export type AuditAreaPath = components["schemas"]["AuditAreaPath"];
export type AuditAreaSection = components["schemas"]["AuditAreaSection"];
export type AuditAreaSectionSummary = components["schemas"]["AuditAreaSectionSummary"];
export type AuditAreaTemplate = components["schemas"]["AuditAreaTemplate"];
export type AuditAreaTemplateId = components["schemas"]["AuditAreaTemplateId"];
export type AuditAreaTemplateMin = components["schemas"]["AuditAreaTemplateMin"];
export type AuditAreaType = components["schemas"]["AuditAreaType"];
export type AuditPlan = components["schemas"]["AuditPlan"];
export type AuditPlanPage = components["schemas"]["AuditPlanPage"];
export type AuditPlanPageActivityStreamRefs = components["schemas"]["AuditPlanPageActivityStreamRefs"];
export type AuditPlanPageArchivedPayload = components["schemas"]["AuditPlanPageArchivedPayload"];
export type AuditPlanPageContent = components["schemas"]["AuditPlanPageContent"];
export type AuditPlanPageDeletedPayload = components["schemas"]["AuditPlanPageDeletedPayload"];
export type AuditPlanPageId = components["schemas"]["AuditPlanPageId"];
export type AuditPlanPageLockedPayload = components["schemas"]["AuditPlanPageLockedPayload"];
export type AuditPlanPageMin = components["schemas"]["AuditPlanPageMin"];
export type AuditPlanPageNotificationMin = components["schemas"]["AuditPlanPageNotificationMin"];
export type AuditPlanPageStatus = components["schemas"]["AuditPlanPageStatus"];
export type AuditPlanPageStatusChangedPayload = components["schemas"]["AuditPlanPageStatusChangedPayload"];
export type AuditPlanPageType = components["schemas"]["AuditPlanPageType"];
export type AuditorAnswerPath = components["schemas"]["AuditorAnswerPath"];
export type AutorunTrigger = components["schemas"]["AutorunTrigger"];
export type AxisIdPath = components["schemas"]["AxisIdPath"];
export type BackgroundTask = components["schemas"]["BackgroundTask"];
export type BackgroundTaskId = components["schemas"]["BackgroundTaskId"];
export type BackgroundTaskIdPath = components["schemas"]["BackgroundTaskIdPath"];
export type BackgroundTaskResult = components["schemas"]["BackgroundTaskResult"];
export type BasisEvidence = components["schemas"]["BasisEvidence"];
export type BasisItemExclusion = components["schemas"]["BasisItemExclusion"];
export type BasisItemPath = components["schemas"]["BasisItemPath"];
export type BasisItemStatus = components["schemas"]["BasisItemStatus"];
export type BatchAssessmentNotificationMin = components["schemas"]["BatchAssessmentNotificationMin"];
export type BatchAuditPlanPageNotificationMin = components["schemas"]["BatchAuditPlanPageNotificationMin"];
export type BatchComplexityAssessmentNotificationMin =
  components["schemas"]["BatchComplexityAssessmentNotificationMin"];
export type BatchControlNotificationMin = components["schemas"]["BatchControlNotificationMin"];
export type BatchDocumentNotificationMin = components["schemas"]["BatchDocumentNotificationMin"];
export type BatchQuestionNotificationMin = components["schemas"]["BatchQuestionNotificationMin"];
export type BatchQuestionnaireNotificationMin = components["schemas"]["BatchQuestionnaireNotificationMin"];
export type BatchRiskNotificationMin = components["schemas"]["BatchRiskNotificationMin"];
export type BatchUnderstandingNotificationMin = components["schemas"]["BatchUnderstandingNotificationMin"];
export type BulkNotificationPayload = components["schemas"]["BulkNotificationPayload"];
export type BulkQuestionAction = components["schemas"]["BulkQuestionAction"];
export type BulkQuestionOverrideScopes = components["schemas"]["BulkQuestionOverrideScopes"];
export type BulkQuestionUpdate = components["schemas"]["BulkQuestionUpdate"];
export type BulkQuestionUpdateItem = components["schemas"]["BulkQuestionUpdateItem"];
export type BulkRiskAction = components["schemas"]["BulkRiskAction"];
export type BulkRiskUpdate = components["schemas"]["BulkRiskUpdate"];
export type BulkRiskUpdateItem = components["schemas"]["BulkRiskUpdateItem"];
export type BulkSourceAction = components["schemas"]["BulkSourceAction"];
export type BulkSourceUpdate = components["schemas"]["BulkSourceUpdate"];
export type BulkSourceUpdateItem = components["schemas"]["BulkSourceUpdateItem"];
export type BulkUpdateNotificationPreferences = components["schemas"]["BulkUpdateNotificationPreferences"];
export type CacheDirective = components["schemas"]["CacheDirective"];
export type CandidateFinding = components["schemas"]["CandidateFinding"];
export type CandidateRisk = components["schemas"]["CandidateRisk"];
export type CatalogIdPath = components["schemas"]["CatalogIdPath"];
export type CertificationType = components["schemas"]["CertificationType"];
export type ChangeSampleBody = components["schemas"]["ChangeSampleBody"];
export type ChangeTemplateBody = components["schemas"]["ChangeTemplateBody"];
export type ChannelAuthBody = components["schemas"]["ChannelAuthBody"];
export type ChannelAuthBody2 = components["schemas"]["ChannelAuthBody2"];
export type ChannelAuthBody3 = components["schemas"]["ChannelAuthBody3"];
export type CharacterConfig = components["schemas"]["CharacterConfig"];
export type ChartContentPayload = components["schemas"]["ChartContentPayload"];
export type ChildrenStatusSummary = components["schemas"]["ChildrenStatusSummary"];
export type Citation = components["schemas"]["Citation"];
export type ClientFacingFindingContent = components["schemas"]["ClientFacingFindingContent"];
export type ClusterIdPath = components["schemas"]["ClusterIdPath"];
export type ClusterPageRef = components["schemas"]["ClusterPageRef"];
export type ClusterPages = components["schemas"]["ClusterPages"];
export type ClusteredActivityFeed = components["schemas"]["ClusteredActivityFeed"];
export type ClusteredActivityFeedArgs = components["schemas"]["ClusteredActivityFeedArgs"];
export type ColorPalette = components["schemas"]["ColorPalette"];
export type ColoredText = components["schemas"]["ColoredText"];
export type CombineControlDesignImplementationEvaluationFunction =
  components["schemas"]["CombineControlDesignImplementationEvaluationFunction"];
export type CombineControlRepresentationFunction = components["schemas"]["CombineControlRepresentationFunction"];
export type CommentPayload = components["schemas"]["CommentPayload"];
export type CommentedControlSnapshot = components["schemas"]["CommentedControlSnapshot"];
export type CompleteBackgroundTask = components["schemas"]["CompleteBackgroundTask"];
export type ComplexityAction = components["schemas"]["ComplexityAction"];
export type ComplexityAggregationOperator = components["schemas"]["ComplexityAggregationOperator"];
export type ComplexityAssessment = components["schemas"]["ComplexityAssessment"];
export type ComplexityAssessmentId = components["schemas"]["ComplexityAssessmentId"];
export type ComplexityAssessmentNotificationMin = components["schemas"]["ComplexityAssessmentNotificationMin"];
export type ComplexityAssessmentPath = components["schemas"]["ComplexityAssessmentPath"];
export type ComplexityAssessmentPath2 = components["schemas"]["ComplexityAssessmentPath2"];
export type ComplexityAssessmentTierCount = components["schemas"]["ComplexityAssessmentTierCount"];
export type ComplexityAssessmentUpdatedPayload = components["schemas"]["ComplexityAssessmentUpdatedPayload"];
export type ComplexityAttribute = components["schemas"]["ComplexityAttribute"];
export type ComplexityAttributeId = components["schemas"]["ComplexityAttributeId"];
export type ComplexityAttributeIdPath = components["schemas"]["ComplexityAttributeIdPath"];
export type ComplexityModel = components["schemas"]["ComplexityModel"];
export type ComplexityModelId = components["schemas"]["ComplexityModelId"];
export type ComplexityModelIdPath = components["schemas"]["ComplexityModelIdPath"];
export type ComplexityModelIdPath2 = components["schemas"]["ComplexityModelIdPath2"];
export type ComplexityModelMin = components["schemas"]["ComplexityModelMin"];
export type ComplexityModelVersion = components["schemas"]["ComplexityModelVersion"];
export type ComplexityModelVersionId = components["schemas"]["ComplexityModelVersionId"];
export type ComplexityModelVersionIdPath = components["schemas"]["ComplexityModelVersionIdPath"];
export type ComplexityModelVersionIdPath2 = components["schemas"]["ComplexityModelVersionIdPath2"];
export type ComplexityModelVersionIdPath3 = components["schemas"]["ComplexityModelVersionIdPath3"];
export type ComplexityModelVersionMin = components["schemas"]["ComplexityModelVersionMin"];
export type ComplexityRollForwardRowId = components["schemas"]["ComplexityRollForwardRowId"];
export type ComplexityRollForwardRunId = components["schemas"]["ComplexityRollForwardRunId"];
export type ComplexityScopedAssessment = components["schemas"]["ComplexityScopedAssessment"];
export type ComplexityScopedAssessmentAttributePath = components["schemas"]["ComplexityScopedAssessmentAttributePath"];
export type ComplexityScopedAssessmentMin = components["schemas"]["ComplexityScopedAssessmentMin"];
export type ComplexityScopedAssessmentPath = components["schemas"]["ComplexityScopedAssessmentPath"];
export type ComplexityScopedAssessmentRef = components["schemas"]["ComplexityScopedAssessmentRef"];
export type ComplexityTier = components["schemas"]["ComplexityTier"];
export type ComplexityTierCriterion = components["schemas"]["ComplexityTierCriterion"];
export type ComplexityTierId = components["schemas"]["ComplexityTierId"];
export type ComplexityTierIdPath = components["schemas"]["ComplexityTierIdPath"];
export type ComplexityTierMin = components["schemas"]["ComplexityTierMin"];
export type ComplexityTierRollup = components["schemas"]["ComplexityTierRollup"];
export type ComponentWiseRiskQuantificationModel = components["schemas"]["ComponentWiseRiskQuantificationModel"];
export type ComputedRiskEvaluation = components["schemas"]["ComputedRiskEvaluation"];
export type ConcludeControlOeFunction = components["schemas"]["ConcludeControlOeFunction"];
export type ConcludeTestFunction = components["schemas"]["ConcludeTestFunction"];
export type Condition = components["schemas"]["Condition"];
export type ConditionPath = components["schemas"]["ConditionPath"];
export type ConditionType = components["schemas"]["ConditionType"];
export type Config = components["schemas"]["Config"];
export type ConfluenceDocumentSourceConfig = components["schemas"]["ConfluenceDocumentSourceConfig"];
export type ConfluenceLabel = components["schemas"]["ConfluenceLabel"];
export type ConfluenceSite = components["schemas"]["ConfluenceSite"];
export type ConfluenceSpace = components["schemas"]["ConfluenceSpace"];
export type ConsentArgs = components["schemas"]["ConsentArgs"];
export type ConsentResponse = components["schemas"]["ConsentResponse"];
export type ConsolidatedQuestionnaireContentPayload = components["schemas"]["ConsolidatedQuestionnaireContentPayload"];
export type ConsolidatedQuestionnaireEntry = components["schemas"]["ConsolidatedQuestionnaireEntry"];
export type ConsolidatedSourceRole = components["schemas"]["ConsolidatedSourceRole"];
export type ConsolidatedSuggestion = components["schemas"]["ConsolidatedSuggestion"];
export type ConsolidatedSuggestionId = components["schemas"]["ConsolidatedSuggestionId"];
export type ConsolidatedSuggestionSource = components["schemas"]["ConsolidatedSuggestionSource"];
export type ConsolidatedSuggestionsRequest = components["schemas"]["ConsolidatedSuggestionsRequest"];
export type ContactUsRecord = components["schemas"]["ContactUsRecord"];
export type ContentId = components["schemas"]["ContentId"];
export type ContentIdPath = components["schemas"]["ContentIdPath"];
export type ContentIdPath2 = components["schemas"]["ContentIdPath2"];
export type ContextualizePredefinedRiskFunction = components["schemas"]["ContextualizePredefinedRiskFunction"];
export type ControlAssessmentContent = components["schemas"]["ControlAssessmentContent"];
export type ControlChangedContent = components["schemas"]["ControlChangedContent"];
export type ControlCharacteristicKind = components["schemas"]["ControlCharacteristicKind"];
export type ControlCharacteristicOption = components["schemas"]["ControlCharacteristicOption"];
export type ControlCharacteristicTemplate = components["schemas"]["ControlCharacteristicTemplate"];
export type ControlConditionResolution = components["schemas"]["ControlConditionResolution"];
export type ControlDesignImplementationChanged = components["schemas"]["ControlDesignImplementationChanged"];
export type ControlDesignImplementationContent = components["schemas"]["ControlDesignImplementationContent"];
export type ControlDesignImplementationEvaluated = components["schemas"]["ControlDesignImplementationEvaluated"];
export type ControlDesignImplementationEvaluationContent =
  components["schemas"]["ControlDesignImplementationEvaluationContent"];
export type ControlDesignImplementationModuleTemplate =
  components["schemas"]["ControlDesignImplementationModuleTemplate"];
export type ControlGroup = components["schemas"]["ControlGroup"];
export type ControlGroupId = components["schemas"]["ControlGroupId"];
export type ControlGroupIdPath = components["schemas"]["ControlGroupIdPath"];
export type ControlGroupMin = components["schemas"]["ControlGroupMin"];
export type ControlIdentificationChanged = components["schemas"]["ControlIdentificationChanged"];
export type ControlIdentificationContent = components["schemas"]["ControlIdentificationContent"];
export type ControlMetChangedContent = components["schemas"]["ControlMetChangedContent"];
export type ControlModuleSelection = components["schemas"]["ControlModuleSelection"];
export type ControlNode = components["schemas"]["ControlNode"];
export type ControlNotificationMin = components["schemas"]["ControlNotificationMin"];
export type ControlOEModuleTemplate = components["schemas"]["ControlOEModuleTemplate"];
export type ControlOe = components["schemas"]["ControlOe"];
export type ControlOeBasisItem = components["schemas"]["ControlOeBasisItem"];
export type ControlOeBasisItemId = components["schemas"]["ControlOeBasisItemId"];
export type ControlOeConclusion = components["schemas"]["ControlOeConclusion"];
export type ControlOeCondition = components["schemas"]["ControlOeCondition"];
export type ControlOeConditionId = components["schemas"]["ControlOeConditionId"];
export type ControlOeId = components["schemas"]["ControlOeId"];
export type ControlOeIdPath = components["schemas"]["ControlOeIdPath"];
export type ControlOeMin = components["schemas"]["ControlOeMin"];
export type ControlOeTarget = components["schemas"]["ControlOeTarget"];
export type ControlProcessStepPath = components["schemas"]["ControlProcessStepPath"];
export type ControlRelevanceChangedContent = components["schemas"]["ControlRelevanceChangedContent"];
export type ControlRepresentationChanged = components["schemas"]["ControlRepresentationChanged"];
export type ControlRepresentationContent = components["schemas"]["ControlRepresentationContent"];
export type ControlRepresentationModuleTemplate = components["schemas"]["ControlRepresentationModuleTemplate"];
export type ControlScopeAssessmentContent = components["schemas"]["ControlScopeAssessmentContent"];
export type ControlScopeChangedContent = components["schemas"]["ControlScopeChangedContent"];
export type ControlScopeMetChangedContent = components["schemas"]["ControlScopeMetChangedContent"];
export type ControlScopeNode = components["schemas"]["ControlScopeNode"];
export type ControlScopeSelectionContent = components["schemas"]["ControlScopeSelectionContent"];
export type ConversationAssistantDelta = components["schemas"]["ConversationAssistantDelta"];
export type ConversationAssistantPayload = components["schemas"]["ConversationAssistantPayload"];
export type ConversationCompactionPayload = components["schemas"]["ConversationCompactionPayload"];
export type ConversationConfig = components["schemas"]["ConversationConfig"];
export type ConversationErrorPayload = components["schemas"]["ConversationErrorPayload"];
export type ConversationEvent = components["schemas"]["ConversationEvent"];
export type ConversationEventPayload = components["schemas"]["ConversationEventPayload"];
export type ConversationExecutorKind = components["schemas"]["ConversationExecutorKind"];
export type ConversationFunction = components["schemas"]["ConversationFunction"];
export type ConversationFunctionKind = components["schemas"]["ConversationFunctionKind"];
export type ConversationId = components["schemas"]["ConversationId"];
export type ConversationIdPath = components["schemas"]["ConversationIdPath"];
export type ConversationLiveEvent = components["schemas"]["ConversationLiveEvent"];
export type ConversationRefKind = components["schemas"]["ConversationRefKind"];
export type ConversationStatus = components["schemas"]["ConversationStatus"];
export type ConversationSummaryChanged = components["schemas"]["ConversationSummaryChanged"];
export type ConversationSystemPayload = components["schemas"]["ConversationSystemPayload"];
export type ConversationTerminalPayload = components["schemas"]["ConversationTerminalPayload"];
export type ConversationTimeField = components["schemas"]["ConversationTimeField"];
export type ConversationToolResultPayload = components["schemas"]["ConversationToolResultPayload"];
export type ConversationUserPayload = components["schemas"]["ConversationUserPayload"];
export type CoreResponse = components["schemas"]["CoreResponse"];
export type CoreResponseId = components["schemas"]["CoreResponseId"];
export type CoreResponseIdPath = components["schemas"]["CoreResponseIdPath"];
export type CountResolutionsArgs = components["schemas"]["CountResolutionsArgs"];
export type Counterparty = components["schemas"]["Counterparty"];
export type CounterpartyId = components["schemas"]["CounterpartyId"];
export type CounterpartyIdPath = components["schemas"]["CounterpartyIdPath"];
export type CountersQuery = components["schemas"]["CountersQuery"];
export type CoverageSegment = components["schemas"]["CoverageSegment"];
export type CoverageState = components["schemas"]["CoverageState"];
export type CreateAccessToken = components["schemas"]["CreateAccessToken"];
export type CreateAccount = components["schemas"]["CreateAccount"];
export type CreateAdHocQuestion = components["schemas"]["CreateAdHocQuestion"];
export type CreateAgentSessionUserMessage = components["schemas"]["CreateAgentSessionUserMessage"];
export type CreateAssessment = components["schemas"]["CreateAssessment"];
export type CreateAssessmentDecision = components["schemas"]["CreateAssessmentDecision"];
export type CreateAsset = components["schemas"]["CreateAsset"];
export type CreateAttributeEvidence = components["schemas"]["CreateAttributeEvidence"];
export type CreateAuditArea = components["schemas"]["CreateAuditArea"];
export type CreateAuditAreaAssessment = components["schemas"]["CreateAuditAreaAssessment"];
export type CreateAuditAreaComplexity = components["schemas"]["CreateAuditAreaComplexity"];
export type CreateAuditAreaUnderstanding = components["schemas"]["CreateAuditAreaUnderstanding"];
export type CreateAuditAreasFromQuestionnaireTables = components["schemas"]["CreateAuditAreasFromQuestionnaireTables"];
export type CreateAuditAreasFromTemplates = components["schemas"]["CreateAuditAreasFromTemplates"];
export type CreateAutoComplete = components["schemas"]["CreateAutoComplete"];
export type CreateBasisEvidence = components["schemas"]["CreateBasisEvidence"];
export type CreateBasisItem = components["schemas"]["CreateBasisItem"];
export type CreateComment = components["schemas"]["CreateComment"];
export type CreateComplexityAssessment = components["schemas"]["CreateComplexityAssessment"];
export type CreateComplexityAttribute = components["schemas"]["CreateComplexityAttribute"];
export type CreateComplexityModel = components["schemas"]["CreateComplexityModel"];
export type CreateComplexityModelVersion = components["schemas"]["CreateComplexityModelVersion"];
export type CreateComplexityTier = components["schemas"]["CreateComplexityTier"];
export type CreateControlGroup = components["schemas"]["CreateControlGroup"];
export type CreateControlOe = components["schemas"]["CreateControlOe"];
export type CreateCoreResponse = components["schemas"]["CreateCoreResponse"];
export type CreateCounterparty = components["schemas"]["CreateCounterparty"];
export type CreateCrmConnection = components["schemas"]["CreateCrmConnection"];
export type CreateCustomControlRequest = components["schemas"]["CreateCustomControlRequest"];
export type CreateDataRoomSourceRequest = components["schemas"]["CreateDataRoomSourceRequest"];
export type CreateDiagram = components["schemas"]["CreateDiagram"];
export type CreateDocument = components["schemas"]["CreateDocument"];
export type CreateDocumentSource = components["schemas"]["CreateDocumentSource"];
export type CreateDocumentationAttachment = components["schemas"]["CreateDocumentationAttachment"];
export type CreateEditSystemAgent = components["schemas"]["CreateEditSystemAgent"];
export type CreateEngagementRequest = components["schemas"]["CreateEngagementRequest"];
export type CreateEsignatureProvider = components["schemas"]["CreateEsignatureProvider"];
export type CreateExternalAuthorization = components["schemas"]["CreateExternalAuthorization"];
export type CreateExternalAuthorizationOAuth = components["schemas"]["CreateExternalAuthorizationOAuth"];
export type CreateExternalAuthorizationPayload = components["schemas"]["CreateExternalAuthorizationPayload"];
export type CreateExternalAuthorizationRaw = components["schemas"]["CreateExternalAuthorizationRaw"];
export type CreateExternalNonce = components["schemas"]["CreateExternalNonce"];
export type CreateFileUploadSession = components["schemas"]["CreateFileUploadSession"];
export type CreateFinding = components["schemas"]["CreateFinding"];
export type CreateFramework = components["schemas"]["CreateFramework"];
export type CreateFrameworkProfile = components["schemas"]["CreateFrameworkProfile"];
export type CreateFrameworkVersion = components["schemas"]["CreateFrameworkVersion"];
export type CreateLibrarySection = components["schemas"]["CreateLibrarySection"];
export type CreateMention = components["schemas"]["CreateMention"];
export type CreateNotificationSink = components["schemas"]["CreateNotificationSink"];
export type CreateOperationalContext = components["schemas"]["CreateOperationalContext"];
export type CreateOrUpdateReviewerRole = components["schemas"]["CreateOrUpdateReviewerRole"];
export type CreateOrUpdateShowcaseUpdateMessage = components["schemas"]["CreateOrUpdateShowcaseUpdateMessage"];
export type CreatePageReviewsArgs = components["schemas"]["CreatePageReviewsArgs"];
export type CreatePopulation = components["schemas"]["CreatePopulation"];
export type CreatePredefinedControl = components["schemas"]["CreatePredefinedControl"];
export type CreatePrivateResourceAccessGrant = components["schemas"]["CreatePrivateResourceAccessGrant"];
export type CreateQuestion = components["schemas"]["CreateQuestion"];
export type CreateQuestionDocumentation = components["schemas"]["CreateQuestionDocumentation"];
export type CreateQuestionGroup = components["schemas"]["CreateQuestionGroup"];
export type CreateQuestionGroup2 = components["schemas"]["CreateQuestionGroup2"];
export type CreateQuestionInSection = components["schemas"]["CreateQuestionInSection"];
export type CreateQuestionSource = components["schemas"]["CreateQuestionSource"];
export type CreateQuestionnaire = components["schemas"]["CreateQuestionnaire"];
export type CreateQuestionnaireDocumentation = components["schemas"]["CreateQuestionnaireDocumentation"];
export type CreateRegisteredUser = components["schemas"]["CreateRegisteredUser"];
export type CreateResponseLayer = components["schemas"]["CreateResponseLayer"];
export type CreateReviewAction = components["schemas"]["CreateReviewAction"];
export type CreateRisk = components["schemas"]["CreateRisk"];
export type CreateRiskArea = components["schemas"]["CreateRiskArea"];
export type CreateRiskAreaExampleRisk = components["schemas"]["CreateRiskAreaExampleRisk"];
export type CreateRiskContext = components["schemas"]["CreateRiskContext"];
export type CreateSample = components["schemas"]["CreateSample"];
export type CreateSavedView = components["schemas"]["CreateSavedView"];
export type CreateScimConfig = components["schemas"]["CreateScimConfig"];
export type CreateScope = components["schemas"]["CreateScope"];
export type CreateScopeAxis = components["schemas"]["CreateScopeAxis"];
export type CreateSection = components["schemas"]["CreateSection"];
export type CreateServiceUser = components["schemas"]["CreateServiceUser"];
export type CreateSource = components["schemas"]["CreateSource"];
export type CreateSourceKind = components["schemas"]["CreateSourceKind"];
export type CreateSourcesParams = components["schemas"]["CreateSourcesParams"];
export type CreateStandaloneFile = components["schemas"]["CreateStandaloneFile"];
export type CreateStandardFinding = components["schemas"]["CreateStandardFinding"];
export type CreateTeam = components["schemas"]["CreateTeam"];
export type CreateTest = components["schemas"]["CreateTest"];
export type CreateTestTemplate = components["schemas"]["CreateTestTemplate"];
export type CreateTestTemplateVersion = components["schemas"]["CreateTestTemplateVersion"];
export type CreateThirdParty = components["schemas"]["CreateThirdParty"];
export type CreateThirdPartyTag = components["schemas"]["CreateThirdPartyTag"];
export type CreateThirdPartyTier = components["schemas"]["CreateThirdPartyTier"];
export type CreateTprmAsset = components["schemas"]["CreateTprmAsset"];
export type CreateTprmExternalQuestionnaire = components["schemas"]["CreateTprmExternalQuestionnaire"];
export type CreateTprmQuestionnaireModel = components["schemas"]["CreateTprmQuestionnaireModel"];
export type CreateTprmReportTemplate = components["schemas"]["CreateTprmReportTemplate"];
export type CreateTprmScope = components["schemas"]["CreateTprmScope"];
export type CreateTrustCenterContent = components["schemas"]["CreateTrustCenterContent"];
export type CreateUnderstanding = components["schemas"]["CreateUnderstanding"];
export type CreateUpdateTierAssessmentAutorun = components["schemas"]["CreateUpdateTierAssessmentAutorun"];
export type CreateVerifiedDomain = components["schemas"]["CreateVerifiedDomain"];
export type CreatedAuthorizationMetadata = components["schemas"]["CreatedAuthorizationMetadata"];
export type CreatedExternalAuthorization = components["schemas"]["CreatedExternalAuthorization"];
export type CreatedExternalNonce = components["schemas"]["CreatedExternalNonce"];
export type CreatedUnderstandingDataRoomSource = components["schemas"]["CreatedUnderstandingDataRoomSource"];
export type CriterionResult = components["schemas"]["CriterionResult"];
export type CrmAccountInfo = components["schemas"]["CrmAccountInfo"];
export type CrmConnection = components["schemas"]["CrmConnection"];
export type CrmConnectionConfig = components["schemas"]["CrmConnectionConfig"];
export type CrmConnectionId = components["schemas"]["CrmConnectionId"];
export type CrmConnectionIdPath = components["schemas"]["CrmConnectionIdPath"];
export type CrmConnectionMin = components["schemas"]["CrmConnectionMin"];
export type CrmConnector = components["schemas"]["CrmConnector"];
export type CrmConnectorIdPath = components["schemas"]["CrmConnectorIdPath"];
export type CustomDomain = components["schemas"]["CustomDomain"];
export type CustomDomainType = components["schemas"]["CustomDomainType"];
export type DateRange = components["schemas"]["DateRange"];
export type Deal = components["schemas"]["Deal"];
export type DealId = components["schemas"]["DealId"];
export type DeleteAuditPlanPages = components["schemas"]["DeleteAuditPlanPages"];
export type DeleteDocumentSourceArgs = components["schemas"]["DeleteDocumentSourceArgs"];
export type DesignImplementationMode = components["schemas"]["DesignImplementationMode"];
export type DesignModuleTemplateId = components["schemas"]["DesignModuleTemplateId"];
export type DesignModuleTemplateOption = components["schemas"]["DesignModuleTemplateOption"];
export type DetachQuestions = components["schemas"]["DetachQuestions"];
export type Diagram = components["schemas"]["Diagram"];
export type DiagramConnection = components["schemas"]["DiagramConnection"];
export type DiagramConnectionAnchor = components["schemas"]["DiagramConnectionAnchor"];
export type DiagramConnectionId = components["schemas"]["DiagramConnectionId"];
export type DiagramEvidence = components["schemas"]["DiagramEvidence"];
export type DiagramEvidenceId = components["schemas"]["DiagramEvidenceId"];
export type DiagramEvidenceIdPath = components["schemas"]["DiagramEvidenceIdPath"];
export type DiagramGenerationState = components["schemas"]["DiagramGenerationState"];
export type DiagramId = components["schemas"]["DiagramId"];
export type DiagramIdPath = components["schemas"]["DiagramIdPath"];
export type DiagramLane = components["schemas"]["DiagramLane"];
export type DiagramLaneId = components["schemas"]["DiagramLaneId"];
export type DiagramMin = components["schemas"]["DiagramMin"];
export type DiagramNode = components["schemas"]["DiagramNode"];
export type DiagramNodeId = components["schemas"]["DiagramNodeId"];
export type DiagramPagePayload = components["schemas"]["DiagramPagePayload"];
export type DiagramRegion = components["schemas"]["DiagramRegion"];
export type DiagramRegionId = components["schemas"]["DiagramRegionId"];
export type DiagramSummary = components["schemas"]["DiagramSummary"];
export type DiagramType = components["schemas"]["DiagramType"];
export type DiscoverGenerativeRisksFunction = components["schemas"]["DiscoverGenerativeRisksFunction"];
export type DiscoveredPortal = components["schemas"]["DiscoveredPortal"];
export type DismissConsolidatedSuggestionRequest = components["schemas"]["DismissConsolidatedSuggestionRequest"];
export type Document = components["schemas"]["Document"];
export type DocumentAccessRequest = components["schemas"]["DocumentAccessRequest"];
export type DocumentAccessRequestId = components["schemas"]["DocumentAccessRequestId"];
export type DocumentAuthority = components["schemas"]["DocumentAuthority"];
export type DocumentCategory = components["schemas"]["DocumentCategory"];
export type DocumentExternal = components["schemas"]["DocumentExternal"];
export type DocumentExternalMin = components["schemas"]["DocumentExternalMin"];
export type DocumentId = components["schemas"]["DocumentId"];
export type DocumentIdPath = components["schemas"]["DocumentIdPath"];
export type DocumentIdPath2 = components["schemas"]["DocumentIdPath2"];
export type DocumentMin = components["schemas"]["DocumentMin"];
export type DocumentNotificationMin = components["schemas"]["DocumentNotificationMin"];
export type DocumentRegion = components["schemas"]["DocumentRegion"];
export type DocumentSource = components["schemas"]["DocumentSource"];
export type DocumentSourceConfig = components["schemas"]["DocumentSourceConfig"];
export type DocumentSourceConnector = components["schemas"]["DocumentSourceConnector"];
export type DocumentSourceConnectorIdPath = components["schemas"]["DocumentSourceConnectorIdPath"];
export type DocumentSourceId = components["schemas"]["DocumentSourceId"];
export type DocumentSourceIdPath = components["schemas"]["DocumentSourceIdPath"];
export type DocumentSourceKind = components["schemas"]["DocumentSourceKind"];
export type DocumentSourceMin = components["schemas"]["DocumentSourceMin"];
export type DocumentSourceMinKind = components["schemas"]["DocumentSourceMinKind"];
export type DocumentSuggestion = components["schemas"]["DocumentSuggestion"];
export type DocumentUpdatedPayload = components["schemas"]["DocumentUpdatedPayload"];
export type Documentation = components["schemas"]["Documentation"];
export type DocumentationAttachment = components["schemas"]["DocumentationAttachment"];
export type DocumentationId = components["schemas"]["DocumentationId"];
export type DocusignEsignatureProviderConfig = components["schemas"]["DocusignEsignatureProviderConfig"];
export type DownloadOptions = components["schemas"]["DownloadOptions"];
export type DownloadParams = components["schemas"]["DownloadParams"];
export type DrawnSampleMethod = components["schemas"]["DrawnSampleMethod"];
export type DrivingSource = components["schemas"]["DrivingSource"];
export type DuplicateComplexityModelVersion = components["schemas"]["DuplicateComplexityModelVersion"];
export type EmailPath = components["schemas"]["EmailPath"];
export type EmptyLoginMethodPayload = components["schemas"]["EmptyLoginMethodPayload"];
export type EnableTwoFa = components["schemas"]["EnableTwoFa"];
export type EnableTwoFaTotp = components["schemas"]["EnableTwoFaTotp"];
export type Engagement = components["schemas"]["Engagement"];
export type EngagementAssessmentMin = components["schemas"]["EngagementAssessmentMin"];
export type EngagementExternalQuestionnaireMin = components["schemas"]["EngagementExternalQuestionnaireMin"];
export type EngagementId = components["schemas"]["EngagementId"];
export type EngagementIdPath = components["schemas"]["EngagementIdPath"];
export type EngagementIdPath2 = components["schemas"]["EngagementIdPath2"];
export type EngagementIdPath3 = components["schemas"]["EngagementIdPath3"];
export type EngagementIdPath4 = components["schemas"]["EngagementIdPath4"];
export type EngagementIdPath5 = components["schemas"]["EngagementIdPath5"];
export type EngagementLock = components["schemas"]["EngagementLock"];
export type EngagementMin = components["schemas"]["EngagementMin"];
export type EngagementNotificationMin = components["schemas"]["EngagementNotificationMin"];
export type EngagementReportContentPayload = components["schemas"]["EngagementReportContentPayload"];
export type EngagementReportPath = components["schemas"]["EngagementReportPath"];
export type EngagementStatus = components["schemas"]["EngagementStatus"];
export type EngagementTask = components["schemas"]["EngagementTask"];
export type EngagementTemplate = components["schemas"]["EngagementTemplate"];
export type EngagementTemplateArea = components["schemas"]["EngagementTemplateArea"];
export type EngagementTemplateId = components["schemas"]["EngagementTemplateId"];
export type EngagementUnderstanding = components["schemas"]["EngagementUnderstanding"];
export type EntityId = components["schemas"]["EntityId"];
export type Environment = components["schemas"]["Environment"];
export type ErrorCatalogId = components["schemas"]["ErrorCatalogId"];
export type ErrorResponse = components["schemas"]["ErrorResponse"];
export type EsignatureProvider = components["schemas"]["EsignatureProvider"];
export type EsignatureProviderConfig = components["schemas"]["EsignatureProviderConfig"];
export type EsignatureProviderConnector = components["schemas"]["EsignatureProviderConnector"];
export type EsignatureProviderConnectorType = components["schemas"]["EsignatureProviderConnectorType"];
export type EsignatureProviderConnectorTypePath = components["schemas"]["EsignatureProviderConnectorTypePath"];
export type EsignatureProviderId = components["schemas"]["EsignatureProviderId"];
export type EsignatureProviderIdPath = components["schemas"]["EsignatureProviderIdPath"];
export type EsignatureProviderMin = components["schemas"]["EsignatureProviderMin"];
export type EsignatureTemplate = components["schemas"]["EsignatureTemplate"];
export type EsignatureTemplateId = components["schemas"]["EsignatureTemplateId"];
export type EvaluateControlDesignImplementationFunction =
  components["schemas"]["EvaluateControlDesignImplementationFunction"];
export type Evidence = components["schemas"]["Evidence"];
export type EvidenceMappingBody = components["schemas"]["EvidenceMappingBody"];
export type EvidenceSource = components["schemas"]["EvidenceSource"];
export type ExceptionConfig = components["schemas"]["ExceptionConfig"];
export type ExcludeBasisItem = components["schemas"]["ExcludeBasisItem"];
export type ExistingFinding = components["schemas"]["ExistingFinding"];
export type ExistingRisk = components["schemas"]["ExistingRisk"];
export type ExportedAssessment = components["schemas"]["ExportedAssessment"];
export type ExportedEngagementReport = components["schemas"]["ExportedEngagementReport"];
export type ExportedReportSummary = components["schemas"]["ExportedReportSummary"];
export type ExportedUnderstanding = components["schemas"]["ExportedUnderstanding"];
export type ExternalAccountReferenceId = components["schemas"]["ExternalAccountReferenceId"];
export type ExternalAccountReferenceType = components["schemas"]["ExternalAccountReferenceType"];
export type ExternalAuthorization = components["schemas"]["ExternalAuthorization"];
export type ExternalAuthorizationId = components["schemas"]["ExternalAuthorizationId"];
export type ExternalAuthorizationIdPath = components["schemas"]["ExternalAuthorizationIdPath"];
export type ExternalAuthorizationMin = components["schemas"]["ExternalAuthorizationMin"];
export type ExternalAuthorizationOauth = components["schemas"]["ExternalAuthorizationOauth"];
export type ExternalAuthorizationPayload = components["schemas"]["ExternalAuthorizationPayload"];
export type ExternalAuthorizationProvider = components["schemas"]["ExternalAuthorizationProvider"];
export type ExternalAuthorizationRaw = components["schemas"]["ExternalAuthorizationRaw"];
export type ExternalNonceProvider = components["schemas"]["ExternalNonceProvider"];
export type ExternalQuestionnaireIdPath = components["schemas"]["ExternalQuestionnaireIdPath"];
export type ExternalQuestionnaireIdPath2 = components["schemas"]["ExternalQuestionnaireIdPath2"];
export type ExternalUser = components["schemas"]["ExternalUser"];
export type ExternalWhoAmIResponse = components["schemas"]["ExternalWhoAmIResponse"];
export type ExtractTestDataFunction = components["schemas"]["ExtractTestDataFunction"];
export type ExtractedValue = components["schemas"]["ExtractedValue"];
export type ExtractionField = components["schemas"]["ExtractionField"];
export type FacetCount = components["schemas"]["FacetCount"];
export type Fact = components["schemas"]["Fact"];
export type FactCluster = components["schemas"]["FactCluster"];
export type FactClusterId = components["schemas"]["FactClusterId"];
export type FactCounts = components["schemas"]["FactCounts"];
export type FactGenPrompt = components["schemas"]["FactGenPrompt"];
export type FactId = components["schemas"]["FactId"];
export type FactIdPath = components["schemas"]["FactIdPath"];
export type FactMin = components["schemas"]["FactMin"];
export type FactSearchArgs = components["schemas"]["FactSearchArgs"];
export type FactSourceDocument = components["schemas"]["FactSourceDocument"];
export type FactSourceEntity = components["schemas"]["FactSourceEntity"];
export type FactSourceQuestion = components["schemas"]["FactSourceQuestion"];
export type FactSourceQuestionParent = components["schemas"]["FactSourceQuestionParent"];
export type FactTextId = components["schemas"]["FactTextId"];
export type FactTextMin = components["schemas"]["FactTextMin"];
export type FeaturePath = components["schemas"]["FeaturePath"];
export type FeedPoint = components["schemas"]["FeedPoint"];
export type FeedRow = components["schemas"]["FeedRow"];
export type File = components["schemas"]["File"];
export type FileId = components["schemas"]["FileId"];
export type FileIdPath = components["schemas"]["FileIdPath"];
export type FileUploadSessionId = components["schemas"]["FileUploadSessionId"];
export type FileUploadSessionResponse = components["schemas"]["FileUploadSessionResponse"];
export type FilesAnswerConfig = components["schemas"]["FilesAnswerConfig"];
export type FilterArgs = components["schemas"]["FilterArgs"];
export type FilterAssessments = components["schemas"]["FilterAssessments"];
export type FilterClause = components["schemas"]["FilterClause"];
export type FilterComplexityAssessments = components["schemas"]["FilterComplexityAssessments"];
export type FilterCompositeClause = components["schemas"]["FilterCompositeClause"];
export type FilterCondition = components["schemas"]["FilterCondition"];
export type FilterExpression = components["schemas"]["FilterExpression"];
export type FilterOperator = components["schemas"]["FilterOperator"];
export type FilterValue = components["schemas"]["FilterValue"];
export type FindingContent = components["schemas"]["FindingContent"];
export type FindingId = components["schemas"]["FindingId"];
export type FindingIdPair = components["schemas"]["FindingIdPair"];
export type FindingIdPath = components["schemas"]["FindingIdPath"];
export type FindingMin = components["schemas"]["FindingMin"];
export type FindingNode = components["schemas"]["FindingNode"];
export type FindingRating = components["schemas"]["FindingRating"];
export type FindingUpdatedPayload = components["schemas"]["FindingUpdatedPayload"];
export type FinishReason = components["schemas"]["FinishReason"];
export type FrameworkAutorun = components["schemas"]["FrameworkAutorun"];
export type FrameworkAutorunBackfill = components["schemas"]["FrameworkAutorunBackfill"];
export type FrameworkId = components["schemas"]["FrameworkId"];
export type FrameworkIdPath = components["schemas"]["FrameworkIdPath"];
export type FrameworkMin = components["schemas"]["FrameworkMin"];
export type FrameworkModuleTemplates = components["schemas"]["FrameworkModuleTemplates"];
export type FrameworkProfile = components["schemas"]["FrameworkProfile"];
export type FrameworkProfileId = components["schemas"]["FrameworkProfileId"];
export type FrameworkProfileIdPath = components["schemas"]["FrameworkProfileIdPath"];
export type FrameworkProfileMin = components["schemas"]["FrameworkProfileMin"];
export type FrameworkVersion = components["schemas"]["FrameworkVersion"];
export type FrameworkVersionId = components["schemas"]["FrameworkVersionId"];
export type FrameworkVersionIdPath = components["schemas"]["FrameworkVersionIdPath"];
export type FrameworkVersionMin = components["schemas"]["FrameworkVersionMin"];
export type FrontendEnvironment = components["schemas"]["FrontendEnvironment"];
export type GDriveDocumentSourceConfig = components["schemas"]["GDriveDocumentSourceConfig"];
export type GenerateControlFindingsFunction = components["schemas"]["GenerateControlFindingsFunction"];
export type GenerateDocxRequest = components["schemas"]["GenerateDocxRequest"];
export type GenerateHtmlRequest = components["schemas"]["GenerateHtmlRequest"];
export type GenerateHtmlRequestPayload = components["schemas"]["GenerateHtmlRequestPayload"];
export type GenerateOePlan = components["schemas"]["GenerateOePlan"];
export type GenerateTotpResponse = components["schemas"]["GenerateTotpResponse"];
export type GenerateXlsxRequest = components["schemas"]["GenerateXlsxRequest"];
export type GettingStartedChecklist = components["schemas"]["GettingStartedChecklist"];
export type GraphComponentType = components["schemas"]["GraphComponentType"];
export type GraphOperation = components["schemas"]["GraphOperation"];
export type GraphOperationPropertyValue = components["schemas"]["GraphOperationPropertyValue"];
export type GraphOperationPropertyValueRelationship = components["schemas"]["GraphOperationPropertyValueRelationship"];
export type GraphProperty = components["schemas"]["GraphProperty"];
export type GraphPropertyValueRelationship = components["schemas"]["GraphPropertyValueRelationship"];
export type HistoricRiskEvaluation = components["schemas"]["HistoricRiskEvaluation"];
export type HubspotCrmConnectionConfig = components["schemas"]["HubspotCrmConnectionConfig"];
export type IManageDocumentSourceConfig = components["schemas"]["IManageDocumentSourceConfig"];
export type IRect = components["schemas"]["IRect"];
export type IdValueType = components["schemas"]["IdValueType"];
export type IdentifiedControlSummary = components["schemas"]["IdentifiedControlSummary"];
export type IdentifiedControlsContent = components["schemas"]["IdentifiedControlsContent"];
export type IdentifiedRiskContent = components["schemas"]["IdentifiedRiskContent"];
export type IdentifiedSheetCell = components["schemas"]["IdentifiedSheetCell"];
export type IdentifiedSheetRange = components["schemas"]["IdentifiedSheetRange"];
export type IdentifiedSheetSection = components["schemas"]["IdentifiedSheetSection"];
export type ImageSourceKind = components["schemas"]["ImageSourceKind"];
export type ImageSourceMinKind = components["schemas"]["ImageSourceMinKind"];
export type ImplementationModuleTemplateId = components["schemas"]["ImplementationModuleTemplateId"];
export type ImplementationModuleTemplateOption = components["schemas"]["ImplementationModuleTemplateOption"];
export type ImportQuestions = components["schemas"]["ImportQuestions"];
export type InAppNotification = components["schemas"]["InAppNotification"];
export type InAppNotificationId = components["schemas"]["InAppNotificationId"];
export type InAppNotificationPayload = components["schemas"]["InAppNotificationPayload"];
export type InAppNotificationStream = components["schemas"]["InAppNotificationStream"];
export type InherentRiskChangedContent = components["schemas"]["InherentRiskChangedContent"];
export type InheritedRole = components["schemas"]["InheritedRole"];
export type InputItems = components["schemas"]["InputItems"];
export type InternalConversation = components["schemas"]["InternalConversation"];
export type InternalConversationCounters = components["schemas"]["InternalConversationCounters"];
export type InternalConversationExport = components["schemas"]["InternalConversationExport"];
export type InternalConversationExportRow = components["schemas"]["InternalConversationExportRow"];
export type InternalConversationFilter = components["schemas"]["InternalConversationFilter"];
export type InternalConversationSummary = components["schemas"]["InternalConversationSummary"];
export type InternalFindingContent = components["schemas"]["InternalFindingContent"];
export type InternalLlmShimJournalEntry = components["schemas"]["InternalLlmShimJournalEntry"];
export type InternalLlmShimJournalFilter = components["schemas"]["InternalLlmShimJournalFilter"];
export type InternalLlmShimJournalPayload = components["schemas"]["InternalLlmShimJournalPayload"];
export type Invalidation = components["schemas"]["Invalidation"];
export type InvalidationCause = components["schemas"]["InvalidationCause"];
export type InviteInfo = components["schemas"]["InviteInfo"];
export type InvitePortalUser = components["schemas"]["InvitePortalUser"];
export type InviteUser = components["schemas"]["InviteUser"];
export type ItemStanding = components["schemas"]["ItemStanding"];
export type LayerType = components["schemas"]["LayerType"];
export type LayerTypePath = components["schemas"]["LayerTypePath"];
export type LegacyAreaMapping = components["schemas"]["LegacyAreaMapping"];
export type LegacyEngagementOutcome = components["schemas"]["LegacyEngagementOutcome"];
export type LegacyMigrationReport = components["schemas"]["LegacyMigrationReport"];
export type LegacyMigrationSummary = components["schemas"]["LegacyMigrationSummary"];
export type LegacyPath = components["schemas"]["LegacyPath"];
export type LibrarySectionFilter = components["schemas"]["LibrarySectionFilter"];
export type LibrarySectionId = components["schemas"]["LibrarySectionId"];
export type LibrarySectionIdPath = components["schemas"]["LibrarySectionIdPath"];
export type LibrarySectionMin = components["schemas"]["LibrarySectionMin"];
export type LibrarySectionWithoutScope = components["schemas"]["LibrarySectionWithoutScope"];
export type LinkNotificationSink = components["schemas"]["LinkNotificationSink"];
export type LinkedNotificationSinkMin = components["schemas"]["LinkedNotificationSinkMin"];
export type ListActivitiesArgs = components["schemas"]["ListActivitiesArgs"];
export type ListAssets = components["schemas"]["ListAssets"];
export type ListLibrarySectionFactsArgs = components["schemas"]["ListLibrarySectionFactsArgs"];
export type ListNotificationsArgs = components["schemas"]["ListNotificationsArgs"];
export type ListOwnersQuery = components["schemas"]["ListOwnersQuery"];
export type ListResolutionsArgs = components["schemas"]["ListResolutionsArgs"];
export type ListScopeFactsArgs = components["schemas"]["ListScopeFactsArgs"];
export type ListShowcaseMessageParams = components["schemas"]["ListShowcaseMessageParams"];
export type ListUsersQuery = components["schemas"]["ListUsersQuery"];
export type LlmShimJournalId = components["schemas"]["LlmShimJournalId"];
export type LlmShimJournalIdPath = components["schemas"]["LlmShimJournalIdPath"];
export type LlmShimJournalOutcome = components["schemas"]["LlmShimJournalOutcome"];
export type LockAuditPlanPages = components["schemas"]["LockAuditPlanPages"];
export type LoginCredentials = components["schemas"]["LoginCredentials"];
export type LoginMethod = components["schemas"]["LoginMethod"];
export type LoginMethodGenericOauth = components["schemas"]["LoginMethodGenericOauth"];
export type LoginMethodGenericSaml = components["schemas"]["LoginMethodGenericSaml"];
export type LoginMethodId = components["schemas"]["LoginMethodId"];
export type LoginMethodIdPath = components["schemas"]["LoginMethodIdPath"];
export type LoginMethodIdPath2 = components["schemas"]["LoginMethodIdPath2"];
export type LoginMethodInner = components["schemas"]["LoginMethodInner"];
export type LoginMethodInnerMin = components["schemas"]["LoginMethodInnerMin"];
export type LoginMethodMin = components["schemas"]["LoginMethodMin"];
export type LoginMethodType = components["schemas"]["LoginMethodType"];
export type LoginRedirectRequest = components["schemas"]["LoginRedirectRequest"];
export type LoginRequest = components["schemas"]["LoginRequest"];
export type LoginResponse = components["schemas"]["LoginResponse"];
export type LogoKeyPath = components["schemas"]["LogoKeyPath"];
export type LogoutArgs = components["schemas"]["LogoutArgs"];
export type MailSubscriptionId = components["schemas"]["MailSubscriptionId"];
export type MailSubscriptionIdPath = components["schemas"]["MailSubscriptionIdPath"];
export type MailingList = components["schemas"]["MailingList"];
export type MailingListId = components["schemas"]["MailingListId"];
export type MapRiskRelevantControlsFunction = components["schemas"]["MapRiskRelevantControlsFunction"];
export type MapTestEvidenceFunction = components["schemas"]["MapTestEvidenceFunction"];
export type MapToStandardFindingFunction = components["schemas"]["MapToStandardFindingFunction"];
export type MapToStandardFindingGenerated = components["schemas"]["MapToStandardFindingGenerated"];
export type MemberAttributePath = components["schemas"]["MemberAttributePath"];
export type MemberPath = components["schemas"]["MemberPath"];
export type Mention = components["schemas"]["Mention"];
export type MentionElement = components["schemas"]["MentionElement"];
export type MergeScope = components["schemas"]["MergeScope"];
export type MessageIdPath = components["schemas"]["MessageIdPath"];
export type MicrosoftDocumentSourceConfig = components["schemas"]["MicrosoftDocumentSourceConfig"];
export type MigrateLegacyEngagements = components["schemas"]["MigrateLegacyEngagements"];
export type MigratedArea = components["schemas"]["MigratedArea"];
export type MigratedAssessment = components["schemas"]["MigratedAssessment"];
export type MoveRowBody = components["schemas"]["MoveRowBody"];
export type MoveRowsBody = components["schemas"]["MoveRowsBody"];
export type NarrativePopulationSource = components["schemas"]["NarrativePopulationSource"];
export type NewAccount = components["schemas"]["NewAccount"];
export type NoteAssessment = components["schemas"]["NoteAssessment"];
export type NotificationChannelCategory = components["schemas"]["NotificationChannelCategory"];
export type NotificationChannelConnectorTypePath = components["schemas"]["NotificationChannelConnectorTypePath"];
export type NotificationPayloadType = components["schemas"]["NotificationPayloadType"];
export type NotificationPreferencesConfig = components["schemas"]["NotificationPreferencesConfig"];
export type NotificationRegisteredUserMin = components["schemas"]["NotificationRegisteredUserMin"];
export type NotificationSink = components["schemas"]["NotificationSink"];
export type NotificationSinkConfig = components["schemas"]["NotificationSinkConfig"];
export type NotificationSinkConnector = components["schemas"]["NotificationSinkConnector"];
export type NotificationSinkConnectorType = components["schemas"]["NotificationSinkConnectorType"];
export type NotificationSinkId = components["schemas"]["NotificationSinkId"];
export type NotificationSinkIdPath = components["schemas"]["NotificationSinkIdPath"];
export type NotificationSinkMin = components["schemas"]["NotificationSinkMin"];
export type NotificationStatus = components["schemas"]["NotificationStatus"];
export type NotificationType = components["schemas"]["NotificationType"];
export type NotionDocumentSourceConfig = components["schemas"]["NotionDocumentSourceConfig"];
export type OAuthLoginRequest = components["schemas"]["OAuthLoginRequest"];
export type OAuthRedirectTarget = components["schemas"]["OAuthRedirectTarget"];
export type OauthCallbackParams = components["schemas"]["OauthCallbackParams"];
export type OeDependencyEdge = components["schemas"]["OeDependencyEdge"];
export type OeModuleTemplateId = components["schemas"]["OeModuleTemplateId"];
export type OeModuleTemplateOption = components["schemas"]["OeModuleTemplateOption"];
export type OneTimeTokenInitiator = components["schemas"]["OneTimeTokenInitiator"];
export type OperationalContext = components["schemas"]["OperationalContext"];
export type OperationalContextAssetPath = components["schemas"]["OperationalContextAssetPath"];
export type OperationalContextId = components["schemas"]["OperationalContextId"];
export type OperationalContextIdPath = components["schemas"]["OperationalContextIdPath"];
export type OperationalContextMin = components["schemas"]["OperationalContextMin"];
export type OrderClause = components["schemas"]["OrderClause"];
export type OrderDirection = components["schemas"]["OrderDirection"];
export type OrderedFloat = components["schemas"]["OrderedFloat"];
export type OriginalFile = components["schemas"]["OriginalFile"];
export type OriginalSource = components["schemas"]["OriginalSource"];
export type Owner = components["schemas"]["Owner"];
export type OwnerId = components["schemas"]["OwnerId"];
export type OwnerIdPath = components["schemas"]["OwnerIdPath"];
export type OwnerPayload = components["schemas"]["OwnerPayload"];
export type OwnerType = components["schemas"]["OwnerType"];
export type PageIdPath = components["schemas"]["PageIdPath"];
export type PaginationArgs = components["schemas"]["PaginationArgs"];
export type PassFailUnknown = components["schemas"]["PassFailUnknown"];
export type PasswordConfig = components["schemas"]["PasswordConfig"];
export type PasswordManager = components["schemas"]["PasswordManager"];
export type PasswordPolicyConfig = components["schemas"]["PasswordPolicyConfig"];
export type PastQuestionnaireSuggestion = components["schemas"]["PastQuestionnaireSuggestion"];
export type PendingBackgroundTask = components["schemas"]["PendingBackgroundTask"];
export type PlanControlOeFunction = components["schemas"]["PlanControlOeFunction"];
export type Point = components["schemas"]["Point"];
export type PopulateExternalAccountReference = components["schemas"]["PopulateExternalAccountReference"];
export type PopulateRegisteredUser = components["schemas"]["PopulateRegisteredUser"];
export type Population = components["schemas"]["Population"];
export type PopulationColumnId = components["schemas"]["PopulationColumnId"];
export type PopulationExtractionFunction = components["schemas"]["PopulationExtractionFunction"];
export type PopulationExtractionReport = components["schemas"]["PopulationExtractionReport"];
export type PopulationField = components["schemas"]["PopulationField"];
export type PopulationId = components["schemas"]["PopulationId"];
export type PopulationIdPath = components["schemas"]["PopulationIdPath"];
export type PopulationMin = components["schemas"]["PopulationMin"];
export type PopulationProcessingState = components["schemas"]["PopulationProcessingState"];
export type PopulationRow = components["schemas"]["PopulationRow"];
export type PopulationRowId = components["schemas"]["PopulationRowId"];
export type PopulationSourceMechanism = components["schemas"]["PopulationSourceMechanism"];
export type PopulationSourceMin = components["schemas"]["PopulationSourceMin"];
export type PopulationSourceOutcome = components["schemas"]["PopulationSourceOutcome"];
export type PopulationSourcePath = components["schemas"]["PopulationSourcePath"];
export type PopulationSourceReport = components["schemas"]["PopulationSourceReport"];
export type Portal = components["schemas"]["Portal"];
export type PortalEngagementOutstanding = components["schemas"]["PortalEngagementOutstanding"];
export type PortalInviteInfoExternal = components["schemas"]["PortalInviteInfoExternal"];
export type PortalReport = components["schemas"]["PortalReport"];
export type PortalReportSnapshot = components["schemas"]["PortalReportSnapshot"];
export type PortalReportSnapshotId = components["schemas"]["PortalReportSnapshotId"];
export type PortalReportSnapshotPath = components["schemas"]["PortalReportSnapshotPath"];
export type PortalSummary = components["schemas"]["PortalSummary"];
export type PortalUserInfo = components["schemas"]["PortalUserInfo"];
export type PortalUserMin = components["schemas"]["PortalUserMin"];
export type PovModifier = components["schemas"]["PovModifier"];
export type PreLoginResponse = components["schemas"]["PreLoginResponse"];
export type PredefinedControl = components["schemas"]["PredefinedControl"];
export type PredefinedControlId = components["schemas"]["PredefinedControlId"];
export type PredefinedControlIdPath = components["schemas"]["PredefinedControlIdPath"];
export type PredefinedControlMin = components["schemas"]["PredefinedControlMin"];
export type PresetAnswerConfig = components["schemas"]["PresetAnswerConfig"];
export type PresetAutorunAuditArea = components["schemas"]["PresetAutorunAuditArea"];
export type PresetComplexityAutorun = components["schemas"]["PresetComplexityAutorun"];
export type PresetConfig = components["schemas"]["PresetConfig"];
export type PresetControl = components["schemas"]["PresetControl"];
export type PresetControlGroup = components["schemas"]["PresetControlGroup"];
export type PresetCreatePredefinedRisk = components["schemas"]["PresetCreatePredefinedRisk"];
export type PresetDiagram = components["schemas"]["PresetDiagram"];
export type PresetDiagramConnection = components["schemas"]["PresetDiagramConnection"];
export type PresetDiagramConnectionAnchor = components["schemas"]["PresetDiagramConnectionAnchor"];
export type PresetDiagramLane = components["schemas"]["PresetDiagramLane"];
export type PresetDiagramNode = components["schemas"]["PresetDiagramNode"];
export type PresetFramework = components["schemas"]["PresetFramework"];
export type PresetFrameworkAutorun = components["schemas"]["PresetFrameworkAutorun"];
export type PresetFrameworkProfile = components["schemas"]["PresetFrameworkProfile"];
export type PresetFrameworkVersion = components["schemas"]["PresetFrameworkVersion"];
export type PresetModuleTemplates = components["schemas"]["PresetModuleTemplates"];
export type PresetNamedConfig = components["schemas"]["PresetNamedConfig"];
export type PresetNamedConfig2 = components["schemas"]["PresetNamedConfig2"];
export type PresetNamedConfig3 = components["schemas"]["PresetNamedConfig3"];
export type PresetOption = components["schemas"]["PresetOption"];
export type PresetPredefinedRisk = components["schemas"]["PresetPredefinedRisk"];
export type PresetQuestionTemplate = components["schemas"]["PresetQuestionTemplate"];
export type PresetQuestionnaireTemplate = components["schemas"]["PresetQuestionnaireTemplate"];
export type PresetSchemaKind = components["schemas"]["PresetSchemaKind"];
export type PresetSchemaPath = components["schemas"]["PresetSchemaPath"];
export type PresetSectionTemplate = components["schemas"]["PresetSectionTemplate"];
export type PresetSubQuestionnairesAnswerConfig = components["schemas"]["PresetSubQuestionnairesAnswerConfig"];
export type PresetTableAnswerConfig = components["schemas"]["PresetTableAnswerConfig"];
export type PresetUnderstandingAutorun = components["schemas"]["PresetUnderstandingAutorun"];
export type PresetUserOverride = components["schemas"]["PresetUserOverride"];
export type PrivateIdPath = components["schemas"]["PrivateIdPath"];
export type PrivateResource = components["schemas"]["PrivateResource"];
export type PrivateResourceAccess = components["schemas"]["PrivateResourceAccess"];
export type PrivateResourceAccessGrant = components["schemas"]["PrivateResourceAccessGrant"];
export type PrivateResourceId = components["schemas"]["PrivateResourceId"];
export type PrivateResourceMin = components["schemas"]["PrivateResourceMin"];
export type ProcessCandidate = components["schemas"]["ProcessCandidate"];
export type ProcessStep = components["schemas"]["ProcessStep"];
export type ProcessStepActivityPayload = components["schemas"]["ProcessStepActivityPayload"];
export type ProcessStepContent = components["schemas"]["ProcessStepContent"];
export type ProcessStepField = components["schemas"]["ProcessStepField"];
export type ProcessStepFieldChanged = components["schemas"]["ProcessStepFieldChanged"];
export type ProcessStepId = components["schemas"]["ProcessStepId"];
export type ProcessStepIdPath = components["schemas"]["ProcessStepIdPath"];
export type ProcessStepOrigin = components["schemas"]["ProcessStepOrigin"];
export type ProcessStepProperty = components["schemas"]["ProcessStepProperty"];
export type ProcessStepPropertyConfig = components["schemas"]["ProcessStepPropertyConfig"];
export type ProcessStepPropertyKind = components["schemas"]["ProcessStepPropertyKind"];
export type ProcessStepPropertyOption = components["schemas"]["ProcessStepPropertyOption"];
export type ProcessStepUpdatedPayload = components["schemas"]["ProcessStepUpdatedPayload"];
export type ProcessUnderstandingReport = components["schemas"]["ProcessUnderstandingReport"];
export type ProductType = components["schemas"]["ProductType"];
export type ProductTypePath = components["schemas"]["ProductTypePath"];
export type ProductTypeStatusPath = components["schemas"]["ProductTypeStatusPath"];
export type PromptCategory = components["schemas"]["PromptCategory"];
export type PromptCategoryInfo = components["schemas"]["PromptCategoryInfo"];
export type PromptModifierType = components["schemas"]["PromptModifierType"];
export type PromptModifiers = components["schemas"]["PromptModifiers"];
export type PromptScope = components["schemas"]["PromptScope"];
export type PropertyConfig = components["schemas"]["PropertyConfig"];
export type PublicCredentials = components["schemas"]["PublicCredentials"];
export type QAMode = components["schemas"]["QAMode"];
export type QuantificationAxisSnapshot = components["schemas"]["QuantificationAxisSnapshot"];
export type QuantifyBasicInherentRiskFunction = components["schemas"]["QuantifyBasicInherentRiskFunction"];
export type QuantifyBasicResidualRiskFunction = components["schemas"]["QuantifyBasicResidualRiskFunction"];
export type QuantifyComponentWiseInherentRiskFunction =
  components["schemas"]["QuantifyComponentWiseInherentRiskFunction"];
export type QuantifyComponentWiseResidualRiskFunction =
  components["schemas"]["QuantifyComponentWiseResidualRiskFunction"];
export type Question = components["schemas"]["Question"];
export type QuestionCreatedPayload = components["schemas"]["QuestionCreatedPayload"];
export type QuestionDocumentation = components["schemas"]["QuestionDocumentation"];
export type QuestionDocumentationPath = components["schemas"]["QuestionDocumentationPath"];
export type QuestionFactSummary = components["schemas"]["QuestionFactSummary"];
export type QuestionGroupId = components["schemas"]["QuestionGroupId"];
export type QuestionGroupMin = components["schemas"]["QuestionGroupMin"];
export type QuestionId = components["schemas"]["QuestionId"];
export type QuestionIdPath = components["schemas"]["QuestionIdPath"];
export type QuestionIdPath2 = components["schemas"]["QuestionIdPath2"];
export type QuestionLayerPath = components["schemas"]["QuestionLayerPath"];
export type QuestionMin = components["schemas"]["QuestionMin"];
export type QuestionNotificationMin = components["schemas"]["QuestionNotificationMin"];
export type QuestionSource = components["schemas"]["QuestionSource"];
export type QuestionSourceAccountInfo = components["schemas"]["QuestionSourceAccountInfo"];
export type QuestionSourceConfig = components["schemas"]["QuestionSourceConfig"];
export type QuestionSourceConnector = components["schemas"]["QuestionSourceConnector"];
export type QuestionSourceConnectorIdPath = components["schemas"]["QuestionSourceConnectorIdPath"];
export type QuestionSourceId = components["schemas"]["QuestionSourceId"];
export type QuestionSourceIdPath = components["schemas"]["QuestionSourceIdPath"];
export type QuestionSourceMin = components["schemas"]["QuestionSourceMin"];
export type QuestionStats = components["schemas"]["QuestionStats"];
export type QuestionStatus = components["schemas"]["QuestionStatus"];
export type QuestionUpdatedPayload = components["schemas"]["QuestionUpdatedPayload"];
export type Questionnaire = components["schemas"]["Questionnaire"];
export type QuestionnaireContentPayload = components["schemas"]["QuestionnaireContentPayload"];
export type QuestionnaireDocumentationPath = components["schemas"]["QuestionnaireDocumentationPath"];
export type QuestionnaireFileIdPath = components["schemas"]["QuestionnaireFileIdPath"];
export type QuestionnaireFilePath = components["schemas"]["QuestionnaireFilePath"];
export type QuestionnaireId = components["schemas"]["QuestionnaireId"];
export type QuestionnaireIdPath = components["schemas"]["QuestionnaireIdPath"];
export type QuestionnaireIdSectionIdPath = components["schemas"]["QuestionnaireIdSectionIdPath"];
export type QuestionnaireIdSectionIdQuestionGroupIdPath =
  components["schemas"]["QuestionnaireIdSectionIdQuestionGroupIdPath"];
export type QuestionnaireLayerDocumentationPath = components["schemas"]["QuestionnaireLayerDocumentationPath"];
export type QuestionnaireLayerPath = components["schemas"]["QuestionnaireLayerPath"];
export type QuestionnaireMin = components["schemas"]["QuestionnaireMin"];
export type QuestionnaireModelAndTemplateIdPath = components["schemas"]["QuestionnaireModelAndTemplateIdPath"];
export type QuestionnaireModelIdPath = components["schemas"]["QuestionnaireModelIdPath"];
export type QuestionnaireModelIdPath2 = components["schemas"]["QuestionnaireModelIdPath2"];
export type QuestionnaireNotificationMin = components["schemas"]["QuestionnaireNotificationMin"];
export type QuestionnaireNotifyClientRequest = components["schemas"]["QuestionnaireNotifyClientRequest"];
export type QuestionnaireQuestionPath = components["schemas"]["QuestionnaireQuestionPath"];
export type QuestionnaireQuestionTask = components["schemas"]["QuestionnaireQuestionTask"];
export type QuestionnaireSectionPath = components["schemas"]["QuestionnaireSectionPath"];
export type QuestionnaireSourceKind = components["schemas"]["QuestionnaireSourceKind"];
export type QuestionnaireSourceMinKind = components["schemas"]["QuestionnaireSourceMinKind"];
export type QuestionnaireSourcePath = components["schemas"]["QuestionnaireSourcePath"];
export type QuestionnaireStatus = components["schemas"]["QuestionnaireStatus"];
export type QuestionnaireTableRef = components["schemas"]["QuestionnaireTableRef"];
export type Rational = components["schemas"]["Rational"];
export type RecordAssessmentDecision = components["schemas"]["RecordAssessmentDecision"];
export type RecordBasicRiskEvaluation = components["schemas"]["RecordBasicRiskEvaluation"];
export type RecordComponentWiseRiskEvaluation = components["schemas"]["RecordComponentWiseRiskEvaluation"];
export type RecordControlAssessment = components["schemas"]["RecordControlAssessment"];
export type RecordControlAssessmentForScope = components["schemas"]["RecordControlAssessmentForScope"];
export type RecordControlCitation = components["schemas"]["RecordControlCitation"];
export type RecordDiagramEvidence = components["schemas"]["RecordDiagramEvidence"];
export type RecordRiskEvaluation = components["schemas"]["RecordRiskEvaluation"];
export type RecordSourceExtract = components["schemas"]["RecordSourceExtract"];
export type RecordUnderstandingSummaryEvidence = components["schemas"]["RecordUnderstandingSummaryEvidence"];
export type Region = components["schemas"]["Region"];
export type RegionPath = components["schemas"]["RegionPath"];
export type RegisterInterestRecord = components["schemas"]["RegisterInterestRecord"];
export type RegisteredUser = components["schemas"]["RegisteredUser"];
export type RegisteredUserMin = components["schemas"]["RegisteredUserMin"];
export type Release = components["schemas"]["Release"];
export type RelevantControl = components["schemas"]["RelevantControl"];
export type RelevantCoreResponse = components["schemas"]["RelevantCoreResponse"];
export type RelevantFact = components["schemas"]["RelevantFact"];
export type Reliance = components["schemas"]["Reliance"];
export type ReminderSchedule = components["schemas"]["ReminderSchedule"];
export type ReportContentPayload = components["schemas"]["ReportContentPayload"];
export type ReportDiagramImage = components["schemas"]["ReportDiagramImage"];
export type ReportPromptDefinition = components["schemas"]["ReportPromptDefinition"];
export type ReportQuestionnaireAnswer = components["schemas"]["ReportQuestionnaireAnswer"];
export type ReportScopeQuestionnaire = components["schemas"]["ReportScopeQuestionnaire"];
export type ReportTemplateIdPath = components["schemas"]["ReportTemplateIdPath"];
export type ReportedError = components["schemas"]["ReportedError"];
export type ReportedErrorCatalogMin = components["schemas"]["ReportedErrorCatalogMin"];
export type RepresentationModuleTemplateId = components["schemas"]["RepresentationModuleTemplateId"];
export type RepresentationModuleTemplateOption = components["schemas"]["RepresentationModuleTemplateOption"];
export type RequestLoginReset = components["schemas"]["RequestLoginReset"];
export type RequestRegistration = components["schemas"]["RequestRegistration"];
export type ResendPortalInvitePayload = components["schemas"]["ResendPortalInvitePayload"];
export type ResendPortalInviteResponse = components["schemas"]["ResendPortalInviteResponse"];
export type ResetLoginInfo = components["schemas"]["ResetLoginInfo"];
export type ResetLoginMethodResponse = components["schemas"]["ResetLoginMethodResponse"];
export type ResidualRiskChangedContent = components["schemas"]["ResidualRiskChangedContent"];
export type Resolution = components["schemas"]["Resolution"];
export type ResolutionId = components["schemas"]["ResolutionId"];
export type ResolutionIdPath = components["schemas"]["ResolutionIdPath"];
export type ResolutionMin = components["schemas"]["ResolutionMin"];
export type ResolutionNotificationMin = components["schemas"]["ResolutionNotificationMin"];
export type ResolutionType = components["schemas"]["ResolutionType"];
export type ResolveOwner = components["schemas"]["ResolveOwner"];
export type ResolvedExtractPosition = components["schemas"]["ResolvedExtractPosition"];
export type ResolvedExtractionField = components["schemas"]["ResolvedExtractionField"];
export type ResponseLayer = components["schemas"]["ResponseLayer"];
export type ResponseOption = components["schemas"]["ResponseOption"];
export type ReuseFindingsFunction = components["schemas"]["ReuseFindingsFunction"];
export type ReuseRisksFunction = components["schemas"]["ReuseRisksFunction"];
export type ReviewAction = components["schemas"]["ReviewAction"];
export type ReviewActionId = components["schemas"]["ReviewActionId"];
export type ReviewActionMin = components["schemas"]["ReviewActionMin"];
export type ReviewActionPayload = components["schemas"]["ReviewActionPayload"];
export type ReviewPayload = components["schemas"]["ReviewPayload"];
export type ReviewPeriod = components["schemas"]["ReviewPeriod"];
export type ReviewStatus = components["schemas"]["ReviewStatus"];
export type ReviewableId = components["schemas"]["ReviewableId"];
export type ReviewableIdPath = components["schemas"]["ReviewableIdPath"];
export type ReviewerRole = components["schemas"]["ReviewerRole"];
export type ReviewerRoleId = components["schemas"]["ReviewerRoleId"];
export type ReviewerRoleIdPath = components["schemas"]["ReviewerRoleIdPath"];
export type RichText = components["schemas"]["RichText"];
export type RichTextAttributes = components["schemas"]["RichTextAttributes"];
export type RichTextElement = components["schemas"]["RichTextElement"];
export type RiskAcceptanceContent = components["schemas"]["RiskAcceptanceContent"];
export type RiskArea = components["schemas"]["RiskArea"];
export type RiskAreaExampleRisk = components["schemas"]["RiskAreaExampleRisk"];
export type RiskAreaExampleRiskId = components["schemas"]["RiskAreaExampleRiskId"];
export type RiskAreaExampleRiskKind = components["schemas"]["RiskAreaExampleRiskKind"];
export type RiskAreaId = components["schemas"]["RiskAreaId"];
export type RiskContext = components["schemas"]["RiskContext"];
export type RiskContextId = components["schemas"]["RiskContextId"];
export type RiskEvaluationContent = components["schemas"]["RiskEvaluationContent"];
export type RiskId = components["schemas"]["RiskId"];
export type RiskIdPair = components["schemas"]["RiskIdPair"];
export type RiskIdPath = components["schemas"]["RiskIdPath"];
export type RiskLevel = components["schemas"]["RiskLevel"];
export type RiskMin = components["schemas"]["RiskMin"];
export type RiskNode = components["schemas"]["RiskNode"];
export type RiskNotificationMin = components["schemas"]["RiskNotificationMin"];
export type RiskQuantificationCombiningFunction = components["schemas"]["RiskQuantificationCombiningFunction"];
export type RiskQuantificationModel = components["schemas"]["RiskQuantificationModel"];
export type RiskQuantificationModelComponent = components["schemas"]["RiskQuantificationModelComponent"];
export type RiskRelevantControlsContent = components["schemas"]["RiskRelevantControlsContent"];
export type RiskSnapshot = components["schemas"]["RiskSnapshot"];
export type RiskSummaryItem = components["schemas"]["RiskSummaryItem"];
export type RiskThreshold = components["schemas"]["RiskThreshold"];
export type RiskUpdatedPayload = components["schemas"]["RiskUpdatedPayload"];
export type Role = components["schemas"]["Role"];
export type RoleId = components["schemas"]["RoleId"];
export type RoleIdPath = components["schemas"]["RoleIdPath"];
export type RoleMin = components["schemas"]["RoleMin"];
export type RoleUserPath = components["schemas"]["RoleUserPath"];
export type RollForwardCandidate = components["schemas"]["RollForwardCandidate"];
export type RollForwardFailure = components["schemas"]["RollForwardFailure"];
export type RollForwardMode = components["schemas"]["RollForwardMode"];
export type RollForwardOutcome = components["schemas"]["RollForwardOutcome"];
export type RollForwardPlan = components["schemas"]["RollForwardPlan"];
export type RollForwardPlanRow = components["schemas"]["RollForwardPlanRow"];
export type RollForwardProvenance = components["schemas"]["RollForwardProvenance"];
export type RollForwardReport = components["schemas"]["RollForwardReport"];
export type RollForwardRequest = components["schemas"]["RollForwardRequest"];
export type RollForwardRow = components["schemas"]["RollForwardRow"];
export type RollForwardRun = components["schemas"]["RollForwardRun"];
export type RollForwardSummary = components["schemas"]["RollForwardSummary"];
export type RollForwardUndoneSummary = components["schemas"]["RollForwardUndoneSummary"];
export type RolledForward = components["schemas"]["RolledForward"];
export type RowRefBody = components["schemas"]["RowRefBody"];
export type RuleCondition = components["schemas"]["RuleCondition"];
export type RunStepArgs = components["schemas"]["RunStepArgs"];
export type RunTestResultsFunction = components["schemas"]["RunTestResultsFunction"];
export type SARRequest = components["schemas"]["SARRequest"];
export type Sample = components["schemas"]["Sample"];
export type SampleId = components["schemas"]["SampleId"];
export type SampleIdPath = components["schemas"]["SampleIdPath"];
export type SampleItem = components["schemas"]["SampleItem"];
export type SampleItemId = components["schemas"]["SampleItemId"];
export type SampleMethod = components["schemas"]["SampleMethod"];
export type SampleMin = components["schemas"]["SampleMin"];
export type SampleProcessingState = components["schemas"]["SampleProcessingState"];
export type SampleSize = components["schemas"]["SampleSize"];
export type SavedView = components["schemas"]["SavedView"];
export type SavedViewGroup = components["schemas"]["SavedViewGroup"];
export type SavedViewId = components["schemas"]["SavedViewId"];
export type SavedViewKeyIdPath = components["schemas"]["SavedViewKeyIdPath"];
export type SavedViewKeyPath = components["schemas"]["SavedViewKeyPath"];
export type SavedViewList = components["schemas"]["SavedViewList"];
export type ScimConfig = components["schemas"]["ScimConfig"];
export type ScimConfigId = components["schemas"]["ScimConfigId"];
export type ScimConfigIdPath = components["schemas"]["ScimConfigIdPath"];
export type ScimConfigList = components["schemas"]["ScimConfigList"];
export type Scope = components["schemas"]["Scope"];
export type ScopeAccess = components["schemas"]["ScopeAccess"];
export type ScopeAxisId = components["schemas"]["ScopeAxisId"];
export type ScopeAxisMin = components["schemas"]["ScopeAxisMin"];
export type ScopeBadge = components["schemas"]["ScopeBadge"];
export type ScopeId = components["schemas"]["ScopeId"];
export type ScopeIdList = components["schemas"]["ScopeIdList"];
export type ScopeIdOrGlobal = components["schemas"]["ScopeIdOrGlobal"];
export type ScopeIdOrGlobalPath = components["schemas"]["ScopeIdOrGlobalPath"];
export type ScopeIdPath = components["schemas"]["ScopeIdPath"];
export type ScopeIdPath2 = components["schemas"]["ScopeIdPath2"];
export type ScopeMatrix = components["schemas"]["ScopeMatrix"];
export type ScopeMin = components["schemas"]["ScopeMin"];
export type ScopeVisibilityPath = components["schemas"]["ScopeVisibilityPath"];
export type ScopedLibrarySection = components["schemas"]["ScopedLibrarySection"];
export type ScopedLibrarySectionId = components["schemas"]["ScopedLibrarySectionId"];
export type SearchIndexStats = components["schemas"]["SearchIndexStats"];
export type SearchStats = components["schemas"]["SearchStats"];
export type Section = components["schemas"]["Section"];
export type SectionId = components["schemas"]["SectionId"];
export type SectionMin = components["schemas"]["SectionMin"];
export type SelectAnswerConfig = components["schemas"]["SelectAnswerConfig"];
export type SendSupportEmail = components["schemas"]["SendSupportEmail"];
export type ServiceUser = components["schemas"]["ServiceUser"];
export type ServiceUserApikey = components["schemas"]["ServiceUserApikey"];
export type ServiceUserApikeyMin = components["schemas"]["ServiceUserApikeyMin"];
export type SessionLog = components["schemas"]["SessionLog"];
export type SetBasisItemCitations = components["schemas"]["SetBasisItemCitations"];
export type SetBasisItemTest = components["schemas"]["SetBasisItemTest"];
export type SetColumnBody = components["schemas"]["SetColumnBody"];
export type SetControlOeConclusion = components["schemas"]["SetControlOeConclusion"];
export type SetPassword = components["schemas"]["SetPassword"];
export type SetPriorConclusion = components["schemas"]["SetPriorConclusion"];
export type SetReliance = components["schemas"]["SetReliance"];
export type SetWorkOfOthersSatisfactory = components["schemas"]["SetWorkOfOthersSatisfactory"];
export type SharingClassification = components["schemas"]["SharingClassification"];
export type ShowcaseMessageIds = components["schemas"]["ShowcaseMessageIds"];
export type ShowcaseUpdateMessage = components["schemas"]["ShowcaseUpdateMessage"];
export type ShowcaseUpdateMessageId = components["schemas"]["ShowcaseUpdateMessageId"];
export type SingleNotificationPayload = components["schemas"]["SingleNotificationPayload"];
export type SlackNotificationSinkConfig = components["schemas"]["SlackNotificationSinkConfig"];
export type SlackQuestionSourceConfig = components["schemas"]["SlackQuestionSourceConfig"];
export type SnapshotIdPath = components["schemas"]["SnapshotIdPath"];
export type Source = components["schemas"]["Source"];
export type SourceChunkId = components["schemas"]["SourceChunkId"];
export type SourceCounts = components["schemas"]["SourceCounts"];
export type SourceExtract = components["schemas"]["SourceExtract"];
export type SourceExtractId = components["schemas"]["SourceExtractId"];
export type SourceExtractPosition = components["schemas"]["SourceExtractPosition"];
export type SourceId = components["schemas"]["SourceId"];
export type SourceIdPath = components["schemas"]["SourceIdPath"];
export type SourceKind = components["schemas"]["SourceKind"];
export type SourceMin = components["schemas"]["SourceMin"];
export type SourceMinKind = components["schemas"]["SourceMinKind"];
export type SourceProcessingState = components["schemas"]["SourceProcessingState"];
export type SourceRef = components["schemas"]["SourceRef"];
export type SourceType = components["schemas"]["SourceType"];
export type SourceUsagePath = components["schemas"]["SourceUsagePath"];
export type SourceUsageType = components["schemas"]["SourceUsageType"];
export type SourcedFact = components["schemas"]["SourcedFact"];
export type Sources = components["schemas"]["Sources"];
export type Sso = components["schemas"]["Sso"];
export type StandaloneFile = components["schemas"]["StandaloneFile"];
export type StandaloneFileId = components["schemas"]["StandaloneFileId"];
export type StandardFinding = components["schemas"]["StandardFinding"];
export type StandardFindingCandidate = components["schemas"]["StandardFindingCandidate"];
export type StandardFindingId = components["schemas"]["StandardFindingId"];
export type StandardFindingIdPath = components["schemas"]["StandardFindingIdPath"];
export type SubGraph = components["schemas"]["SubGraph"];
export type SubscribeRecord = components["schemas"]["SubscribeRecord"];
export type SubscribeRequest = components["schemas"]["SubscribeRequest"];
export type Subscriber = components["schemas"]["Subscriber"];
export type SubscriberMetadata = components["schemas"]["SubscriberMetadata"];
export type SubscriptionAction = components["schemas"]["SubscriptionAction"];
export type SuggestExtractionFieldsFunction = components["schemas"]["SuggestExtractionFieldsFunction"];
export type SuggestionConfidence = components["schemas"]["SuggestionConfidence"];
export type SuggestionDocument = components["schemas"]["SuggestionDocument"];
export type SuggestionDocumentId = components["schemas"]["SuggestionDocumentId"];
export type SuggestionDocumentMin = components["schemas"]["SuggestionDocumentMin"];
export type SuggestionDocumentPath = components["schemas"]["SuggestionDocumentPath"];
export type SuggestionDocumentStatus = components["schemas"]["SuggestionDocumentStatus"];
export type SystemAgentDomain = components["schemas"]["SystemAgentDomain"];
export type SystemAgentDomainPath = components["schemas"]["SystemAgentDomainPath"];
export type SystemAgentRole = components["schemas"]["SystemAgentRole"];
export type SystemAgentUser = components["schemas"]["SystemAgentUser"];
export type SystemRole = components["schemas"]["SystemRole"];
export type TabularPopulationSource = components["schemas"]["TabularPopulationSource"];
export type Task = components["schemas"]["Task"];
export type Team = components["schemas"]["Team"];
export type TeamId = components["schemas"]["TeamId"];
export type TeamIdPath = components["schemas"]["TeamIdPath"];
export type TeamMin = components["schemas"]["TeamMin"];
export type TeamParams = components["schemas"]["TeamParams"];
export type TeamPermissionPath = components["schemas"]["TeamPermissionPath"];
export type TeamUserPath = components["schemas"]["TeamUserPath"];
export type TerminalOutcome = components["schemas"]["TerminalOutcome"];
export type Test = components["schemas"]["Test"];
export type TestConclusion = components["schemas"]["TestConclusion"];
export type TestConclusionOverride = components["schemas"]["TestConclusionOverride"];
export type TestCriterion = components["schemas"]["TestCriterion"];
export type TestCriterionId = components["schemas"]["TestCriterionId"];
export type TestCriterionPath = components["schemas"]["TestCriterionPath"];
export type TestEvidence = components["schemas"]["TestEvidence"];
export type TestEvidenceId = components["schemas"]["TestEvidenceId"];
export type TestEvidencePath = components["schemas"]["TestEvidencePath"];
export type TestExtractionFieldId = components["schemas"]["TestExtractionFieldId"];
export type TestExtractionFieldPath = components["schemas"]["TestExtractionFieldPath"];
export type TestId = components["schemas"]["TestId"];
export type TestIdPath = components["schemas"]["TestIdPath"];
export type TestItemId = components["schemas"]["TestItemId"];
export type TestMaterializedItem = components["schemas"]["TestMaterializedItem"];
export type TestMin = components["schemas"]["TestMin"];
export type TestResultCounts = components["schemas"]["TestResultCounts"];
export type TestStepProgress = components["schemas"]["TestStepProgress"];
export type TestStepState = components["schemas"]["TestStepState"];
export type TestStepStates = components["schemas"]["TestStepStates"];
export type TestTemplate = components["schemas"]["TestTemplate"];
export type TestTemplateConfig = components["schemas"]["TestTemplateConfig"];
export type TestTemplateId = components["schemas"]["TestTemplateId"];
export type TestTemplateIdPath = components["schemas"]["TestTemplateIdPath"];
export type TestTemplateRef = components["schemas"]["TestTemplateRef"];
export type TestTemplateVersionId = components["schemas"]["TestTemplateVersionId"];
export type TestTemplateVersionMin = components["schemas"]["TestTemplateVersionMin"];
export type TextAnswerConfig = components["schemas"]["TextAnswerConfig"];
export type TextElement = components["schemas"]["TextElement"];
export type ThirdParty = components["schemas"]["ThirdParty"];
export type ThirdPartyId = components["schemas"]["ThirdPartyId"];
export type ThirdPartyIdPath = components["schemas"]["ThirdPartyIdPath"];
export type ThirdPartyIdPath2 = components["schemas"]["ThirdPartyIdPath2"];
export type ThirdPartyIdUserIdPath = components["schemas"]["ThirdPartyIdUserIdPath"];
export type ThirdPartyMin = components["schemas"]["ThirdPartyMin"];
export type ThirdPartyNotificationMin = components["schemas"]["ThirdPartyNotificationMin"];
export type ThirdPartyTagId = components["schemas"]["ThirdPartyTagId"];
export type ThirdPartyTagIdPath = components["schemas"]["ThirdPartyTagIdPath"];
export type ThirdPartyTagMin = components["schemas"]["ThirdPartyTagMin"];
export type ThirdPartyTierId = components["schemas"]["ThirdPartyTierId"];
export type ThirdPartyTierIdPath = components["schemas"]["ThirdPartyTierIdPath"];
export type ThirdPartyTierMin = components["schemas"]["ThirdPartyTierMin"];
export type Tier = components["schemas"]["Tier"];
export type TierAnswer = components["schemas"]["TierAnswer"];
export type TierAnswers = components["schemas"]["TierAnswers"];
export type TierAssessmentAutorun = components["schemas"]["TierAssessmentAutorun"];
export type TierAssessmentAutorunId = components["schemas"]["TierAssessmentAutorunId"];
export type TierAssessmentAutorunIdPath = components["schemas"]["TierAssessmentAutorunIdPath"];
export type TierHistoryEntry = components["schemas"]["TierHistoryEntry"];
export type TodoFunctionArgs = components["schemas"]["TodoFunctionArgs"];
export type ToolsConfig = components["schemas"]["ToolsConfig"];
export type TprmAccountPreferences = components["schemas"]["TprmAccountPreferences"];
export type TprmAiSuggestionSensitivity = components["schemas"]["TprmAiSuggestionSensitivity"];
export type TprmAiSuggestionsConfig = components["schemas"]["TprmAiSuggestionsConfig"];
export type TprmAnswer = components["schemas"]["TprmAnswer"];
export type TprmAnswerConfig = components["schemas"]["TprmAnswerConfig"];
export type TprmAppliedSuggestion = components["schemas"]["TprmAppliedSuggestion"];
export type TprmAsset = components["schemas"]["TprmAsset"];
export type TprmAssetId = components["schemas"]["TprmAssetId"];
export type TprmColumnConfig = components["schemas"]["TprmColumnConfig"];
export type TprmColumnValue = components["schemas"]["TprmColumnValue"];
export type TprmCondition = components["schemas"]["TprmCondition"];
export type TprmConditionComparisonOperator = components["schemas"]["TprmConditionComparisonOperator"];
export type TprmConditionSelectMatchesCriteria = components["schemas"]["TprmConditionSelectMatchesCriteria"];
export type TprmExternalAnswer = components["schemas"]["TprmExternalAnswer"];
export type TprmExternalColumnValue = components["schemas"]["TprmExternalColumnValue"];
export type TprmExternalFilesAnswer = components["schemas"]["TprmExternalFilesAnswer"];
export type TprmExternalQuestionnaire = components["schemas"]["TprmExternalQuestionnaire"];
export type TprmExternalQuestionnaireExternal = components["schemas"]["TprmExternalQuestionnaireExternal"];
export type TprmExternalQuestionnaireId = components["schemas"]["TprmExternalQuestionnaireId"];
export type TprmExternalQuestionnaireMin = components["schemas"]["TprmExternalQuestionnaireMin"];
export type TprmExternalQuestionnairePhase = components["schemas"]["TprmExternalQuestionnairePhase"];
export type TprmExternalResponse = components["schemas"]["TprmExternalResponse"];
export type TprmExternalSelectAnswer = components["schemas"]["TprmExternalSelectAnswer"];
export type TprmExternalSubQuestionnairesAnswer = components["schemas"]["TprmExternalSubQuestionnairesAnswer"];
export type TprmExternalTableAnswer = components["schemas"]["TprmExternalTableAnswer"];
export type TprmExternalTableRow = components["schemas"]["TprmExternalTableRow"];
export type TprmExternalTextAnswer = components["schemas"]["TprmExternalTextAnswer"];
export type TprmFilesAnswer = components["schemas"]["TprmFilesAnswer"];
export type TprmFilesAnswerConfig = components["schemas"]["TprmFilesAnswerConfig"];
export type TprmQuestionAudience = components["schemas"]["TprmQuestionAudience"];
export type TprmQuestionTemplate = components["schemas"]["TprmQuestionTemplate"];
export type TprmQuestionTemplateId = components["schemas"]["TprmQuestionTemplateId"];
export type TprmQuestionnaire = components["schemas"]["TprmQuestionnaire"];
export type TprmQuestionnaireId = components["schemas"]["TprmQuestionnaireId"];
export type TprmQuestionnaireMin = components["schemas"]["TprmQuestionnaireMin"];
export type TprmQuestionnaireModel = components["schemas"]["TprmQuestionnaireModel"];
export type TprmQuestionnaireModelId = components["schemas"]["TprmQuestionnaireModelId"];
export type TprmQuestionnaireModelMin = components["schemas"]["TprmQuestionnaireModelMin"];
export type TprmQuestionnaireNumberingMode = components["schemas"]["TprmQuestionnaireNumberingMode"];
export type TprmQuestionnaireTemplate = components["schemas"]["TprmQuestionnaireTemplate"];
export type TprmQuestionnaireTemplateId = components["schemas"]["TprmQuestionnaireTemplateId"];
export type TprmQuestionnaireTemplateMin = components["schemas"]["TprmQuestionnaireTemplateMin"];
export type TprmRelatedQuestionSummary = components["schemas"]["TprmRelatedQuestionSummary"];
export type TprmReportChartKind = components["schemas"]["TprmReportChartKind"];
export type TprmReportTemplate = components["schemas"]["TprmReportTemplate"];
export type TprmReportTemplateId = components["schemas"]["TprmReportTemplateId"];
export type TprmReportTemplateType = components["schemas"]["TprmReportTemplateType"];
export type TprmResponse = components["schemas"]["TprmResponse"];
export type TprmScopeId = components["schemas"]["TprmScopeId"];
export type TprmScopeMin = components["schemas"]["TprmScopeMin"];
export type TprmScopeType = components["schemas"]["TprmScopeType"];
export type TprmScopeVisibility = components["schemas"]["TprmScopeVisibility"];
export type TprmSectionTemplate = components["schemas"]["TprmSectionTemplate"];
export type TprmSectionTemplateId = components["schemas"]["TprmSectionTemplateId"];
export type TprmSelectAnswer = components["schemas"]["TprmSelectAnswer"];
export type TprmSelectAnswerConfig = components["schemas"]["TprmSelectAnswerConfig"];
export type TprmSelectAnswerConfigOption = components["schemas"]["TprmSelectAnswerConfigOption"];
export type TprmSubQuestionnairesAnswer = components["schemas"]["TprmSubQuestionnairesAnswer"];
export type TprmSubQuestionnairesAnswerConfig = components["schemas"]["TprmSubQuestionnairesAnswerConfig"];
export type TprmTableAnswer = components["schemas"]["TprmTableAnswer"];
export type TprmTableAnswerConfig = components["schemas"]["TprmTableAnswerConfig"];
export type TprmTableColumn = components["schemas"]["TprmTableColumn"];
export type TprmTableRow = components["schemas"]["TprmTableRow"];
export type TprmTableRowId = components["schemas"]["TprmTableRowId"];
export type TprmTextAnswer = components["schemas"]["TprmTextAnswer"];
export type TprmTextAnswerConfig = components["schemas"]["TprmTextAnswerConfig"];
export type TprmTierCriterion = components["schemas"]["TprmTierCriterion"];
export type Trigger = components["schemas"]["Trigger"];
export type TrustCenterAccess = components["schemas"]["TrustCenterAccess"];
export type TrustCenterAiCheckItemConfig = components["schemas"]["TrustCenterAiCheckItemConfig"];
export type TrustCenterAiConfig = components["schemas"]["TrustCenterAiConfig"];
export type TrustCenterAiDataUseItemConfig = components["schemas"]["TrustCenterAiDataUseItemConfig"];
export type TrustCenterAiModelProviderConfig = components["schemas"]["TrustCenterAiModelProviderConfig"];
export type TrustCenterAuth = components["schemas"]["TrustCenterAuth"];
export type TrustCenterBusinessInfoContentConfig = components["schemas"]["TrustCenterBusinessInfoContentConfig"];
export type TrustCenterConfig = components["schemas"]["TrustCenterConfig"];
export type TrustCenterConfigMeta = components["schemas"]["TrustCenterConfigMeta"];
export type TrustCenterConfigMin = components["schemas"]["TrustCenterConfigMin"];
export type TrustCenterContent = components["schemas"]["TrustCenterContent"];
export type TrustCenterContentMin = components["schemas"]["TrustCenterContentMin"];
export type TrustCenterDataProtectionConfig = components["schemas"]["TrustCenterDataProtectionConfig"];
export type TrustCenterDataProtectionDataUseItemConfig =
  components["schemas"]["TrustCenterDataProtectionDataUseItemConfig"];
export type TrustCenterDataProtectionOperatingCountriesConfig =
  components["schemas"]["TrustCenterDataProtectionOperatingCountriesConfig"];
export type TrustCenterDataUseItemPii = components["schemas"]["TrustCenterDataUseItemPii"];
export type TrustCenterFaq = components["schemas"]["TrustCenterFaq"];
export type TrustCenterFaqQuestion = components["schemas"]["TrustCenterFaqQuestion"];
export type TrustCenterFaqSection = components["schemas"]["TrustCenterFaqSection"];
export type TrustCenterHeroConfig = components["schemas"]["TrustCenterHeroConfig"];
export type TrustCenterOverviewConfig = components["schemas"]["TrustCenterOverviewConfig"];
export type TrustCenterPasswordConfig = components["schemas"]["TrustCenterPasswordConfig"];
export type TrustCenterRelatedDocumentConfig = components["schemas"]["TrustCenterRelatedDocumentConfig"];
export type TrustCenterStandardTermsConfig = components["schemas"]["TrustCenterStandardTermsConfig"];
export type TrustCenterSubscribeConfig = components["schemas"]["TrustCenterSubscribeConfig"];
export type TrustCenterTrustedByConfig = components["schemas"]["TrustCenterTrustedByConfig"];
export type UnarchiveAuditPlanPages = components["schemas"]["UnarchiveAuditPlanPages"];
export type UnboundPopulationHeader = components["schemas"]["UnboundPopulationHeader"];
export type Understanding = components["schemas"]["Understanding"];
export type UnderstandingContext = components["schemas"]["UnderstandingContext"];
export type UnderstandingGenerationError = components["schemas"]["UnderstandingGenerationError"];
export type UnderstandingGenerationState = components["schemas"]["UnderstandingGenerationState"];
export type UnderstandingId = components["schemas"]["UnderstandingId"];
export type UnderstandingIdPath = components["schemas"]["UnderstandingIdPath"];
export type UnderstandingMin = components["schemas"]["UnderstandingMin"];
export type UnderstandingNotificationMin = components["schemas"]["UnderstandingNotificationMin"];
export type UnderstandingReportContentPayload = components["schemas"]["UnderstandingReportContentPayload"];
export type UnderstandingSummaryEvidence = components["schemas"]["UnderstandingSummaryEvidence"];
export type UnderstandingSummaryEvidenceId = components["schemas"]["UnderstandingSummaryEvidenceId"];
export type UnderstandingSummaryEvidenceIdPath = components["schemas"]["UnderstandingSummaryEvidenceIdPath"];
export type UnlockAuditPlanPages = components["schemas"]["UnlockAuditPlanPages"];
export type UnsubscribeRequest = components["schemas"]["UnsubscribeRequest"];
export type UpdateAttributeEvidence = components["schemas"]["UpdateAttributeEvidence"];
export type UpdateAttributeValue = components["schemas"]["UpdateAttributeValue"];
export type UpdateAuditPlanPageStatus = components["schemas"]["UpdateAuditPlanPageStatus"];
export type UpdateBasisItemSpan = components["schemas"]["UpdateBasisItemSpan"];
export type UpdateComplexityAttribute = components["schemas"]["UpdateComplexityAttribute"];
export type UpdateComplexityModelName = components["schemas"]["UpdateComplexityModelName"];
export type UpdateComplexityModelVersionName = components["schemas"]["UpdateComplexityModelVersionName"];
export type UpdateComplexityTier = components["schemas"]["UpdateComplexityTier"];
export type UpdateComplexityTierBody = components["schemas"]["UpdateComplexityTierBody"];
export type UpdateControlOePeriod = components["schemas"]["UpdateControlOePeriod"];
export type UpdateCrmConnection = components["schemas"]["UpdateCrmConnection"];
export type UpdateCustomPrompt = components["schemas"]["UpdateCustomPrompt"];
export type UpdateDiagram = components["schemas"]["UpdateDiagram"];
export type UpdateDiagramEvidence = components["schemas"]["UpdateDiagramEvidence"];
export type UpdateDocumentContent = components["schemas"]["UpdateDocumentContent"];
export type UpdateDocumentSource = components["schemas"]["UpdateDocumentSource"];
export type UpdateEsignatureProvider = components["schemas"]["UpdateEsignatureProvider"];
export type UpdateLibrarySection = components["schemas"]["UpdateLibrarySection"];
export type UpdateLoginMethodRequest = components["schemas"]["UpdateLoginMethodRequest"];
export type UpdateLoginMethodResponse = components["schemas"]["UpdateLoginMethodResponse"];
export type UpdateNotificationPreference = components["schemas"]["UpdateNotificationPreference"];
export type UpdateNotificationSink = components["schemas"]["UpdateNotificationSink"];
export type UpdateNotificationStatus = components["schemas"]["UpdateNotificationStatus"];
export type UpdateOperationalContext = components["schemas"]["UpdateOperationalContext"];
export type UpdatePopulationDescription = components["schemas"]["UpdatePopulationDescription"];
export type UpdatePopulationName = components["schemas"]["UpdatePopulationName"];
export type UpdateProcessStep = components["schemas"]["UpdateProcessStep"];
export type UpdateQuestionSource = components["schemas"]["UpdateQuestionSource"];
export type UpdateSampleDescription = components["schemas"]["UpdateSampleDescription"];
export type UpdateSampleMethod = components["schemas"]["UpdateSampleMethod"];
export type UpdateSampleName = components["schemas"]["UpdateSampleName"];
export type UpdateSamplePopulation = components["schemas"]["UpdateSamplePopulation"];
export type UpdateScopeAccess = components["schemas"]["UpdateScopeAccess"];
export type UpdateStandardFinding = components["schemas"]["UpdateStandardFinding"];
export type UpdateTestConclusion = components["schemas"]["UpdateTestConclusion"];
export type UpdateTestDescription = components["schemas"]["UpdateTestDescription"];
export type UpdateTestName = components["schemas"]["UpdateTestName"];
export type UpdateTprmAsset = components["schemas"]["UpdateTprmAsset"];
export type UpdateTwoFa = components["schemas"]["UpdateTwoFa"];
export type UpdateUnderstandingSummaryEvidence = components["schemas"]["UpdateUnderstandingSummaryEvidence"];
export type UpdateWatcherTrigger = components["schemas"]["UpdateWatcherTrigger"];
export type UploadOptions = components["schemas"]["UploadOptions"];
export type UpsertAuditAreaTemplate = components["schemas"]["UpsertAuditAreaTemplate"];
export type UpsertControlCondition = components["schemas"]["UpsertControlCondition"];
export type UpsertEngagementTemplate = components["schemas"]["UpsertEngagementTemplate"];
export type UpsertEngagementTemplateArea = components["schemas"]["UpsertEngagementTemplateArea"];
export type UpsertNoteCondition = components["schemas"]["UpsertNoteCondition"];
export type UpsertTestCriterion = components["schemas"]["UpsertTestCriterion"];
export type UpsertTestExtractionField = components["schemas"]["UpsertTestExtractionField"];
export type Usage = components["schemas"]["Usage"];
export type Usage2 = components["schemas"]["Usage2"];
export type UsageTotals = components["schemas"]["UsageTotals"];
export type UseData = components["schemas"]["UseData"];
export type User = components["schemas"]["User"];
export type UserApikeyId = components["schemas"]["UserApikeyId"];
export type UserApikeyPath = components["schemas"]["UserApikeyPath"];
export type UserAuthBody = components["schemas"]["UserAuthBody"];
export type UserAuthBody2 = components["schemas"]["UserAuthBody2"];
export type UserId = components["schemas"]["UserId"];
export type UserIdPath = components["schemas"]["UserIdPath"];
export type UserIdPath2 = components["schemas"]["UserIdPath2"];
export type UserLoginMethod = components["schemas"]["UserLoginMethod"];
export type UserMessagePayload = components["schemas"]["UserMessagePayload"];
export type UserMin = components["schemas"]["UserMin"];
export type UserNotificationIdPath = components["schemas"]["UserNotificationIdPath"];
export type UserParts = components["schemas"]["UserParts"];
export type UserRegistrationState = components["schemas"]["UserRegistrationState"];
export type UserType = components["schemas"]["UserType"];
export type UserTypeExternal = components["schemas"]["UserTypeExternal"];
export type UserTypeRegistered = components["schemas"]["UserTypeRegistered"];
export type UserTypeService = components["schemas"]["UserTypeService"];
export type UserTypeSystemAgent = components["schemas"]["UserTypeSystemAgent"];
export type UsernamePasswordLoginRequest = components["schemas"]["UsernamePasswordLoginRequest"];
export type ValidateLoginMethod = components["schemas"]["ValidateLoginMethod"];
export type ValidateLoginMethodGenericOauth = components["schemas"]["ValidateLoginMethodGenericOauth"];
export type ValidateLoginMethodGenericSaml = components["schemas"]["ValidateLoginMethodGenericSaml"];
export type ValidateLoginMethodInner = components["schemas"]["ValidateLoginMethodInner"];
export type ValidatePortalInvitePayload = components["schemas"]["ValidatePortalInvitePayload"];
export type ValidatePortalInviteResponse = components["schemas"]["ValidatePortalInviteResponse"];
export type ValueType = components["schemas"]["ValueType"];
export type VerbosityModifier = components["schemas"]["VerbosityModifier"];
export type VerifiedDomain = components["schemas"]["VerifiedDomain"];
export type VerifiedDomainId = components["schemas"]["VerifiedDomainId"];
export type VerifiedDomainIdPath = components["schemas"]["VerifiedDomainIdPath"];
export type VideoSourceKind = components["schemas"]["VideoSourceKind"];
export type VideoSourceMinKind = components["schemas"]["VideoSourceMinKind"];
export type VideoTranscript = components["schemas"]["VideoTranscript"];
export type VideoTranscriptCaptionCue = components["schemas"]["VideoTranscriptCaptionCue"];
export type VideoTranscriptCue = components["schemas"]["VideoTranscriptCue"];
export type VideoTranscriptCueKind = components["schemas"]["VideoTranscriptCueKind"];
export type VideoTranscriptScreenshotCue = components["schemas"]["VideoTranscriptScreenshotCue"];
export type WatcherTrigger = components["schemas"]["WatcherTrigger"];
export type WebDocumentSourceConfig = components["schemas"]["WebDocumentSourceConfig"];
export type WhoAmIOnAccountResponse = components["schemas"]["WhoAmIOnAccountResponse"];
export type WhoAmIResponse = components["schemas"]["WhoAmIResponse"];
export type YesNoAnswerConfig = components["schemas"]["YesNoAnswerConfig"];
